const metadata = {
    "knowledgebase.dev.excent.capital": {
        // English 
        "/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.dev.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en",
                es: "https://knowledgebase.dev.excent.capital/es",
                pt: "https://knowledgebase.dev.excent.capital/pt",
                fr: "https://knowledgebase.dev.excent.capital/fr",
                it: "https://knowledgebase.dev.excent.capital/it",
                zh: "https://knowledgebase.dev.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.dev.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.dev.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en",
                es: "https://knowledgebase.dev.excent.capital/es",
                pt: "https://knowledgebase.dev.excent.capital/pt",
                fr: "https://knowledgebase.dev.excent.capital/fr",
                it: "https://knowledgebase.dev.excent.capital/it",
                zh: "https://knowledgebase.dev.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.dev.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/inside-about-us/": {
            lang: "en",
            title: "Inside About Us: What You'll Discover",
            description:
                "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
            keywords: "About Excent Capital, Company Mission, Trading Company Values, Meet the Team, Who is Excent Capital, Our Story, Financial Services Company, Excent Capital Overview",
            canonical: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                url: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/about-excent-capital/": {
            lang: "en",
            title: "About Excent Capital",
            description:
                "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
            keywords: "Excent Capital, About Us, Company Overview, Trading Company, Financial Services, Trading Firm, Our Mission, Who We Are, Global Trading Support",
            canonical: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                url: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/build-your-portfolio/": {
            lang: "en",
            title: "Build Your Portfolio: Diverse Options on Excent Capital",
            description:
                "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
            keywords: "Build Portfolio, Trading Instruments, Forex Trading, Stock Market, Indices Trading, Commodities Trading, Diversified Portfolio, Excent Capital Assets",
            canonical: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                url: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-your-trusted-partner/": {
            lang: "en",
            title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
            description:
                "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
            keywords: "Excent Capital, International Investments, Diversify Portfolio, Global Markets, Trusted Trading Partner, Forex Trading, International Trading Platform, Investment Opportunities",

            canonical: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                url: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-education-center/": {
            lang: "en",
            title: "Level Up Your Trading: Excent Capital's Education Center",
            description:
                "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
            keywords: "Trading Education, Learn to Trade, Trading Tutorials, Trading Courses, Excent Capital Education, Beginner Trading Guide, Advanced Trading Strategies, Trading Resources",

            canonical: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                url: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/invest-with-confidence/": {
            lang: "en",
            title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
            description:
                "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
            keywords: "Risk Management, Trading Risk Tools, Investment Protection, Excent Capital Strategies, Confident Trading, Market Volatility, Trading Tools, Manage Risk in Trading",

            canonical: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                url: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/inside-trading/": {
            lang: "en",
            title: "Inside Trading: What You'll Discover",
            description:
                "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
            keywords: "Trading Guide, Market Insights, Trading Concepts, How to Trade, Excent Capital Platform, Trading Features, Learn Trading, Trading Knowledge Base",

            canonical: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/instruments-in-excent-capital/": {
            lang: "en",
            title: "Instruments in Excent Capital",
            description:
                "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
            keywords: "Trading Instruments, Forex, Stocks, Commodities, Indices, Excent Capital Assets, Financial Instruments, Investment Options, Trade Markets",

            canonical: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/leverage-offered-at-excent-capital/": {
            lang: "en",
            title: "Leverage Offered at Excent Capital",
            description:
                "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
            keywords: "Leverage Trading, Trading with Leverage, Excent Capital Leverage, Margin Trading, Leverage Options, Amplify Trading, Forex Leverage, Responsible Trading",

            canonical: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/micro-lots-at-excent-capital/": {
            lang: "en",
            title: "Micro Lots at Excent Capital",
            description:
                "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
            keywords: "Micro Lots Trading, Excent Capital Micro Lots, Small Lot Trading, Beginner Trading, Risk Management, Flexible Trading, Forex Micro Lots, Low Exposure Trading",

            canonical: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-hours/": {
            lang: "en",
            title: "Trading Hours",
            description:
                "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
            keywords: "Trading Hours, Market Hours, Forex Trading Times, Stock Market Hours, Excent Capital Schedule, Trading Sessions, Trading Times, Financial Market Hours",

            canonical: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-tools/": {
            lang: "en",
            title: "Trading Tools",
            description:
                "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
            keywords: "Trading Tools, Market Analysis Tools, Trading Calculators, Forex Tools, Excent Capital Platform, Trading Resources, Charting Tools, Informed Trading",

            canonical: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "en/trading/acuity-trading-tools/": {
            lang: "en",
            title: "Acuity Trading Tools",
            description:
                "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
            keywords: "Acuity Trading Tools, AI Trading Tools, Market Sentiment Analysis, Real-Time Market Insights, Excent Capital Tools, Acuity Insights, Smart Trading, Trading Analytics",

            canonical: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "en/trading/margin-calls/": {
            lang: "en",
            title: "Margin Calls",
            description:
                "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
            keywords: "Margin Calls, What is a Margin Call, Excent Capital Margin, Trading Margin, Forced Liquidation, Account Protection, Margin Trading, Risk Management",
            canonical: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/cfd-trading/": {
            lang: "en",
            title: "CFD Trading",
            description:
                "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
            keywords: "CFD Trading, Contracts for Difference, Trade CFDs, Excent Capital CFDs, Leverage Trading, Derivatives Trading, CFD Markets, How to Trade CFDs",
            canonical: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/pending-orders/": {
            lang: "en",
            title: "Pending Orders",
            description:
                "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
            keywords: "Pending Orders, Trading Orders, Buy Stop, Sell Stop, Limit Orders, Automated Trading, Excent Capital Orders, Entry Points, Trading Strategy",
            canonical: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/spreads-offered/": {
            lang: "en",
            title: "Spreads Offered",
            description:
                "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/base-currencies/": {
            lang: "en",
            title: "Base Currencies",
            description:
                "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
            keywords: "Base Currencies, Supported Currencies, Excent Capital Account, Account Currency Options, Currency Selection, Trading Currency, Forex Base Currency, Funding Options",
            canonical: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                url: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/inside-resources/": {
            lang: "en",
            title: "Inside Resources: What You'll Discover",
            description:
                "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
            keywords: "Trading Resources, Excent Capital Tools, Market Updates, Economic Calendar, Trading Education, Resource Center, Learn to Trade, Trading Support Materials",
            canonical: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                url: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/basic-concepts/": {
            lang: "en",
            title: "Basic Concepts",
            description:
                "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
            keywords: "Basic Trading Concepts, Trading for Beginners, Market Basics, Excent Capital Education, Trading Terminology, Beginner Guide, Learn Trading, Fundamental Concepts",
            canonical: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                url: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/advanced-concepts/": {
            lang: "en",
            title: "Advanced Concepts",
            description:
                "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
            keywords: "Advanced Trading Concepts, Trading Strategies, Technical Indicators, Expert Trading, Excent Capital Education, Market Analysis, Pro Trader Tools, Trading Techniques",
            canonical: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                url: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/additional-resources/": {
            lang: "en",
            title: "Additional Resources",
            description:
                "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
            keywords: "Trading Resources, Excent Capital Tools, Glossary of Terms, Platform Guides, Trading Help, Market Tools, Educational Resources, Trading Support",
            canonical: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                url: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/inside-my-account/": {
            lang: "en",
            title: "Inside My Account: What You'll Discover",
            description:
                "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
            keywords: "My Account, Account Management, Excent Capital Profile, Trading Account Settings, Account Security, User Dashboard, Profile Updates, Manage Trading Account",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-to-create-a-demo-account/": {
            lang: "en",
            title: "Can I Create a Demo Account?",
            description:
                "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
            keywords: "Demo Account, Practice Trading, Excent Capital Demo, Risk-Free Trading, Create Demo Account, Trading Simulator, Beginner Trading, Learn to Trade",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-to-create-a-live-account/": {
            lang: "en",
            title: "How to Create a Live Account?",
            description:
                "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
            keywords: "Live Account, Create Trading Account, Excent Capital Registration, Open Live Account, Start Trading, Real Trading Account, Trading Signup, Account Setup",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/why-verify-your-account/": {
            lang: "en",
            title: "Why Verify Your Account?",
            description:
                "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
            keywords: "Account Verification, Verify Trading Account, Excent Capital KYC, Trading Security, Compliance Process, Identity Verification, Secure Trading, Full Account Access",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account.how-do-i-access-the-platform/": {
            lang: "en",
            title: "How Do I Access the Platform?",
            description:
                "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
            keywords: "Access Trading Platform, Excent Capital Login, Trading App, Web Trading Platform, Mobile Trading, How to Log In, Start Trading, Platform Access Guide",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-long-does-it-take-to-create-an-account/": {
            lang: "en",
            title: "How Long Does it Take to Create an Account?",
            description:
                "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
            keywords: "Account Creation Time, Excent Capital Signup, How to Create Account, Trading Account Setup, Registration Process, Open Account Fast, Trading Onboarding",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/do-you-offer-corporate-accounts/": {
            lang: "en",
            title: "Do You Offer Corporate Accounts?",
            description:
                "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
            keywords: "Corporate Trading Account, Business Account, Excent Capital Corporate, Institutional Trading, Open Corporate Account, Company Trading, Business Investment Account",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-open-multiple-accounts/": {
            lang: "en",
            title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
            description:
                "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
            keywords: "Multiple Accounts, Same Email Accounts, Excent Capital Roles, User Roles, Account Management, Trading Account Access, Role-Based Access, Email Registration Policy",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-update-my-account-information/": {
            lang: "en",
            title: "How Do I Update My Account Information?",
            description:
                "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
            keywords: "Update Account Info, Edit Personal Details, Excent Capital Profile, Account Settings, Change Account Information, Trading Profile Update, User Information",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-happens-if-i-forget-my-password/": {
            lang: "en",
            title: "What Happens If I Forget My Password?",
            description:
                "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
            keywords: "Forgot Password, Password Recovery, Reset Trading Password, Excent Capital Login Help, Account Access, Recover Password, Lost Password, Trading Account Login",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-documents-are-required-for-account-verification/": {
            lang: "en",
            title: "What Documents Are Required for Account Verification?",
            description:
                "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
            keywords: "Account Verification Documents, KYC Requirements, Excent Capital Verification, Proof of Identity, Proof of Address, Upload Documents, Secure Verification, Trading Compliance",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-my-friends-or-family-use-my-excent-capital-account/": {
            lang: "en",
            title: "Can My Friends or Family Use My Excent Capital Account?",
            description:
                "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
            keywords: "Account Sharing, Excent Capital Policy, Personal Account Use, Trading Account Security, Shared Access, Family Account Use, Account Safety, Trading Compliance",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-cancel-my-account/": {
            lang: "en",
            title: "How do I Cancel My Account",
            description:
                "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
            keywords: "Cancel Trading Account, Close Excent Capital Account, Account Termination, Delete Account, Trading Account Closure, End Account, Excent Capital Support, Account Cancellation Process",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-verify-my-account-from-a-foreign-country/": {
            lang: "en",
            title: "Can I Verify My Account From a Foreign Country?",
            description:
                "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
            keywords: "Verify Account Abroad, Excent Capital Verification, Foreign Country Account Setup, International KYC, Remote Account Verification, Account Documents, Overseas Verification",
            canonical: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                url: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/inside-deposits-withdrawals/": {
            lang: "en",
            title: "Inside Deposits & Withdrawals: What You'll Discover",
            description:
                "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
            keywords: "Deposits and Withdrawals, Excent Capital Funding, Withdraw Profits, Payment Methods, Deposit Options, Withdrawal Times, Trading Account Funding, Financial Transactions",
            canonical: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                url: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-do-a-first-time-deposit/": {
            lang: "en",
            title: "How Do I Make a First-Time Deposit?",
            description:
                "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                url: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-make-a-deposit/": {
            lang: "en",
            title: "How Do I Make a Deposit?",
            description:
                "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
            keywords: "Deposit Funds, How to Deposit, Excent Capital Payment Methods, Trading Account Funding, Make a Deposit, Secure Deposit, Account Top-Up, Deposit Process",
            canonical: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                url: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-can-i-make-a-withdrawal/": {
            lang: "en",
            title: "How Can I Make a Withdrawal?",
            description:
                "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
            keywords: "Withdraw Funds, Excent Capital Withdrawal, How to Withdraw, Trading Account Payout, Withdrawal Process, Secure Withdrawal, Access Earnings, Payment Methods",
            canonical: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                url: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails/": {
            lang: "en",
            title: "What Do I Do If My Withdrawal Fails?",
            description:
                "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
            keywords: "Withdrawal Failed, Excent Capital Help, Failed Transaction, Troubleshoot Withdrawal, Withdrawal Issue, Payment Error, Trading Account Support, Fix Withdrawal Problem",
            canonical: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                url: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/inside-payments/": {
            lang: "en",
            title: "Inside Payments: What You'll Discover",
            description:
                "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
            keywords: "Excent Capital Payments, Accepted Payment Methods, Transaction Management, Payment Processing Time, Supported Currencies, Trading Payments, Deposit and Withdrawal Options, Account Funding",
            canonical: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                url: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-do-i-see-my-payment-history/": {
            lang: "en",
            title: "How Do I See My Payment History?",
            description:
                "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
            keywords: "Payment History, Transaction History, View Deposits, View Withdrawals, Excent Capital Payments, Account Transactions, Trading Account History, Financial Records",
            canonical: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                url: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-long-can-a-transaction-take/": {
            lang: "en",
            title: "How Long Can a Transaction Take?",
            description:
                "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
            keywords: "Transaction Time, Processing Time, Deposit Duration, Withdrawal Duration, Excent Capital Payments, Payment Speed, Trading Account Transactions, Delay in Transactions",
            canonical: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                url: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Español
        "es/": {
            lang: "es",
            title: "Base de Conocimientos | Excent Capital",
            description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
            keywords: "Centro de Ayuda Excent Capital, Soporte de Plataforma de Trading, Preguntas Frecuentes sobre Trading, Cómo Operar, Tutoriales de FX, Gestión de Cuentas, Guías de Trading, Ayuda para Depósitos, Ayuda para Retiros",
            canonical: "https://knowledgebase.dev.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en",
                es: "https://knowledgebase.dev.excent.capital/es",
                pt: "https://knowledgebase.dev.excent.capital/pt",
                fr: "https://knowledgebase.dev.excent.capital/fr",
                it: "https://knowledgebase.dev.excent.capital/it",
                zh: "https://knowledgebase.dev.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.dev.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/dentro-de-acerca-de-nosotros/": {
            lang: "es",
            title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
            description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
            keywords: "Sobre Excent Capital, Misión de la Empresa, Valores de Empresa de Trading, Conoce al Equipo, Quién es Excent Capital, Nuestra Historia, Empresa de Servicios Financieros, Visión General de Excent Capital", canonical: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            canonical: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/acerca-de-excent-capital/": {
            lang: "es",
            title: "Sobre Excent Capital",
            description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
            keywords: "Excent Capital, Sobre Nosotros, Visión General de la Empresa, Empresa de Trading, Servicios Financieros, Firma de Trading, Nuestra Misión, Quiénes Somos, Soporte Global de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/construye-tu-portafolio/": {
            lang: "es",
            title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
            description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
            keywords: "Construir Portafolio, Instrumentos de Trading, Trading en Forex, Mercado de Acciones, Trading de Índices, Trading de Commodities, Portafolio Diversificado, Activos de Excent Capital",
            canonical: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/excent-capital-tu-socio-de-confianza/": {
            lang: "es",
            title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
            description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
            keywords: "Excent Capital, Inversiones Internacionales, Diversificar Portafolio, Mercados Globales, Socio de Trading Confiable, Trading en Forex, Plataforma de Trading Internacional, Oportunidades de Inversión",

            canonical: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/centro-educativo-excent-capital/": {
            lang: "es",
            title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
            description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
            keywords: "Educación en Trading, Aprender a Operar, Tutoriales de Trading, Cursos de Trading, Educación Excent Capital, Guía para Principiantes en Trading, Estrategias Avanzadas de Trading, Recursos de Trading",

            canonical: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/invierte-con-confianza/": {
            lang: "es",
            title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
            description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
            keywords: "Gestión de Riesgo, Herramientas de Riesgo en Trading, Protección de Inversiones, Estrategias de Excent Capital, Trading con Confianza, Volatilidad del Mercado, Herramientas de Trading, Gestionar Riesgo en Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/invierte-con-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/trading/dentro-del-trading/": {
            lang: "es",
            title: "Dentro del Trading: Lo que Descubrirás",
            description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
            keywords: "Guía de Trading, Perspectivas del Mercado, Conceptos de Trading, Cómo Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conocimientos de Trading", canonical: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/instrumentos-en-excent-capital/": {
            lang: "es",
            title: "Instrumentos en Excent Capital",
            description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
            keywords: "Instrumentos de Trading, Forex, Acciones, Commodities, Índices, Activos de Excent Capital, Instrumentos Financieros, Opciones de Inversión, Mercados de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/instrumentos-en-excent-capital",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/instrumentos-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/apalancamiento-en-excent-capital/": {
            lang: "es",
            title: "Apalancamiento Ofrecido en Excent Capital",
            description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
            keywords: "Trading con Apalancamiento, Operar con Apalancamiento, Apalancamiento en Excent Capital, Trading con Margen, Opciones de Apalancamiento, Potenciar el Trading, Apalancamiento en Forex, Trading Responsable",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/apalancamiento-en-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/apalancamiento-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/micro-lotes-excent-capital/": {
            lang: "es",
            title: "Micro Lotes en Excent Capital",
            description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
            keywords: "Trading con Micro Lotes, Micro Lotes Excent Capital, Trading con Lotes Pequeños, Trading para Principiantes, Gestión de Riesgo, Trading Flexible, Micro Lotes en Forex, Trading con Baja Exposición",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/horario-de-trading/": {
            lang: "es",
            title: "Horarios de Trading",
            description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
            keywords: "Horarios de Trading, Horarios de Mercado, Horarios de Forex, Horarios del Mercado de Acciones, Calendario Excent Capital, Sesiones de Trading, Tiempos de Trading, Horarios del Mercado Financiero",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.dev.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/herramientas-de-trading/": {
            lang: "es",
            title: "Herramientas de Trading",
            description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
            keywords: "Herramientas de Trading, Herramientas de Análisis de Mercado, Calculadoras de Trading, Herramientas de Forex, Plataforma Excent Capital, Recursos de Trading, Herramientas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "es/trading/herramientas-de-trading-acuity/": {
            lang: "es",
            title: "Herramientas de Trading de Acuity",
            description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
            keywords: "Herramientas de Trading de Acuity, Herramientas de Trading con IA, Análisis de Sentimiento del Mercado, Perspectivas del Mercado en Tiempo Real, Herramientas de Excent Capital, Insights de Acuity, Trading Inteligente, Analítica de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "es/trading/llamadas-de-margen/": {
            lang: "es",
            title: "Llamadas de Margen",
            description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
            keywords: "Llamadas de Margen, Qué es una Llamada de Margen, Margen en Excent Capital, Trading con Margen, Liquidación Forzada, Protección de Cuenta, Trading con Margen, Gestión de Riesgo",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/llamadas-de-margen",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.dev.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/llamadas-de-margen",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/trading-de-cfd/": {
            lang: "es",
            title: "Trading de CFDs",
            description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
            keywords: "Trading de CFDs, Contratos por Diferencia, Operar CFDs, CFDs en Excent Capital, Trading con Apalancamiento, Trading de Derivados, Mercados de CFD, Cómo Operar CFDs",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/ordenes-pendientes/": {
            lang: "es",
            title: "Órdenes Pendientes",
            description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
            keywords: "Órdenes Pendientes, Órdenes de Trading, Buy Stop, Sell Stop, Órdenes Limitadas, Trading Automatizado, Órdenes en Excent Capital, Puntos de Entrada, Estrategia de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/ordenes-pendientes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.dev.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/ordenes-pendientes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/spreads-ofrecidos/": {
            lang: "es",
            title: "Spreads Ofrecidos",
            description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
            keywords: "Spreads, Spreads por Volatilidad, Mercados Financieros, Spreads de Trading, Minimizar Costos de Trading, Optimizar Rentabilidad, Estrategias de Trading, Análisis de Spreads, Spreads en Forex, Spreads en el Mercado de Acciones",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/spreads-ofrecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/spreads-ofrecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/monedas-base/": {
            lang: "es",
            title: "Monedas Base",
            description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
            keywords: "Monedas Base, Divisas Compatibles, Cuenta en Excent Capital, Opciones de Divisa de Cuenta, Selección de Moneda, Moneda de Trading, Divisa Base en Forex, Opciones de Fondeo",
            canonical: "https://knowledgebase.dev.excent.capital/es/trading/monedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.dev.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.dev.excent.capital/es/trading/monedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/recursos/dentro-de-recursos/": {
            lang: "es",
            title: "Dentro de Recursos: Lo que Descubrirás",
            description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Actualizaciones del Mercado, Calendario Económico, Educación en Trading, Centro de Recursos, Aprender a Operar, Material de Apoyo para Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.dev.excent.capital/es/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-basicos/": {
            lang: "es",
            title: "Conceptos Básicos",
            description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
            keywords: "Conceptos Básicos de Trading, Trading para Principiantes, Fundamentos del Mercado, Educación de Excent Capital, Terminología de Trading, Guía para Principiantes, Aprender a Operar, Conceptos Fundamentales",
            canonical: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-avanzados/": {
            lang: "es",
            title: "Conceptos Avanzados",
            description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
            keywords: "Conceptos Avanzados de Trading, Estrategias de Trading, Indicadores Técnicos, Trading Experto, Educación de Excent Capital, Análisis de Mercado, Herramientas de Trader Profesional, Técnicas de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-avanzados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-avanzados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/recursos-adicionales/": {
            lang: "es",
            title: "Recursos Adicionales",
            description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Glosario de Términos, Guías de Plataforma, Ayuda para Trading, Herramientas de Mercado, Recursos Educativos, Soporte de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/recursos/recursos-adicionales",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.dev.excent.capital/es/recursos/recursos-adicionales",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/mi-cuenta/dentro-de-mi-cuenta/": {
            lang: "es",
            title: "Dentro de Mi Cuenta: Lo que Descubrirás",
            description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
            keywords: "Mi Cuenta, Gestión de Cuenta, Perfil en Excent Capital, Configuración de Cuenta de Trading, Seguridad de Cuenta, Panel de Usuario, Actualización de Perfil, Administrar Cuenta de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-demo/": {
            lang: "es",
            title: "¿Puedo Crear una Cuenta Demo?",
            description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
            keywords: "Cuenta Demo, Practicar Trading, Demo de Excent Capital, Trading sin Riesgo, Crear Cuenta Demo, Simulador de Trading, Trading para Principiantes, Aprender a Operar",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-real/": {
            lang: "es",
            title: "¿Cómo Crear una Cuenta Real?",
            description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
            keywords: "Cuenta Real, Crear Cuenta de Trading, Registro en Excent Capital, Abrir Cuenta Real, Comenzar a Operar, Cuenta de Trading Real, Registro de Trading, Configuración de Cuenta",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta/": {
            lang: "es",
            title: "¿Por Qué Verificar tu Cuenta?",
            description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
            keywords: "Verificación de Cuenta, Verificar Cuenta de Trading, KYC de Excent Capital, Seguridad en Trading, Proceso de Cumplimiento, Verificación de Identidad, Trading Seguro, Acceso Completo a la Cuenta",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/acceder-a-la-plataforma/": {
            lang: "es",
            title: "¿Cómo Accedo a la Plataforma?",
            description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
            keywords: "Acceder a la Plataforma de Trading, Inicio de Sesión en Excent Capital, App de Trading, Plataforma Web de Trading, Trading Móvil, Cómo Iniciar Sesión, Comenzar a Operar, Guía de Acceso a la Plataforma",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/tiempo-para-crear-cuenta/": {
            lang: "es",
            title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
            description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
            keywords: "Tiempo de Creación de Cuenta, Registro en Excent Capital, Cómo Crear una Cuenta, Configuración de Cuenta de Trading, Proceso de Registro, Abrir Cuenta Rápidamente, Inicio en Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuentas-corporativas/": {
            lang: "es",
            title: "¿Ofrecen Cuentas Corporativas?",
            description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
            keywords: "Cuenta Corporativa de Trading, Cuenta Empresarial, Corporativo en Excent Capital, Trading Institucional, Abrir Cuenta Corporativa, Trading Empresarial, Cuenta de Inversión para Empresas",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuentas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuentas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/varias-cuentas-mismo-correo/": {
            lang: "es",
            title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
            description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
            keywords: "Múltiples Cuentas, Cuentas con el Mismo Correo, Roles en Excent Capital, Roles de Usuario, Gestión de Cuentas, Acceso a Cuenta de Trading, Acceso Basado en Roles, Política de Registro de Correo",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/actualizar-informacion-cuenta/": {
            lang: "es",
            title: "¿Cómo Actualizo la Información de Mi Cuenta?",
            description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
            keywords: "Actualizar Información de Cuenta, Editar Datos Personales, Perfil de Excent Capital, Configuración de Cuenta, Cambiar Información de Cuenta, Actualización de Perfil de Trading, Información del Usuario",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/olvide-mi-contrasena/": {
            lang: "es",
            title: "¿Qué Sucede si Olvido Mi Contraseña?",
            description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
            keywords: "Olvidé la Contraseña, Recuperación de Contraseña, Restablecer Contraseña de Trading, Ayuda para Iniciar Sesión en Excent Capital, Acceso a la Cuenta, Recuperar Contraseña, Contraseña Perdida, Inicio de Sesión en Cuenta de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/documentos-para-verificacion/": {
            lang: "es",
            title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
            description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
            keywords: "Documentos para Verificación de Cuenta, Requisitos KYC, Verificación en Excent Capital, Comprobante de Identidad, Comprobante de Domicilio, Subir Documentos, Verificación Segura, Cumplimiento en Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/documentos-para-verificacion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuenta-usada-por-otros/": {
            lang: "es",
            title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
            description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
            keywords: "Compartir Cuenta, Política de Excent Capital, Uso Personal de Cuenta, Seguridad de Cuenta de Trading, Acceso Compartido, Uso Familiar de Cuenta, Seguridad de Cuenta, Cumplimiento en Trading",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cancelar-cuenta/": {
            lang: "es",
            title: "¿Cómo Cancelo Mi Cuenta?",
            description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
            keywords: "Cancelar Cuenta de Trading, Cerrar Cuenta de Excent Capital, Terminación de Cuenta, Eliminar Cuenta, Cierre de Cuenta de Trading, Finalizar Cuenta, Soporte de Excent Capital, Proceso de Cancelación de Cuenta",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cancelar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cancelar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta-extranjero/": {
            lang: "es",
            title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
            description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
            keywords: "Verificar Cuenta en el Extranjero, Verificación en Excent Capital, Crear Cuenta Desde el Exterior, KYC Internacional, Verificación Remota de Cuenta, Documentos para Cuenta, Verificación Desde el Exterior",
            canonical: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                url: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/depositos-retiros/dentro-depositos-retiros/": {
            lang: "es",
            title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
            description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
            keywords: "Depósitos y Retiros, Fondeo en Excent Capital, Retirar Ganancias, Métodos de Pago, Opciones de Depósito, Tiempos de Retiro, Fondeo de Cuenta de Trading, Transacciones Financieras",
            canonical: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                url: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/primer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito por Primera Vez?",
            description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
            keywords: "Primer Depósito, Hacer un Depósito, Fondeo en Excent Capital, Depósito en Cuenta de Trading, Cómo Depositar, Métodos de Pago, Comenzar a Operar, Fondear tu Cuenta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/primer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                url: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/primer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito?",
            description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
            keywords: "Depositar Fondos, Cómo Depositar, Métodos de Pago en Excent Capital, Fondeo de Cuenta de Trading, Realizar un Depósito, Depósito Seguro, Recargar Cuenta, Proceso de Depósito",
            canonical: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                url: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-retiro/": {
            lang: "es",
            title: "¿Cómo Puedo Hacer un Retiro?",
            description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
            keywords: "Retirar Fondos, Retiro en Excent Capital, Cómo Retirar, Pago de Cuenta de Trading, Proceso de Retiro, Retiro Seguro, Acceder a Ganancias, Métodos de Pago",
            canonical: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-retiro",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                url: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-retiro",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/retiro-fallido/": {
            lang: "es",
            title: "¿Qué Hago si Falla Mi Retiro?",
            description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
            keywords: "Retiro Fallido, Ayuda de Excent Capital, Transacción Fallida, Solución de Problemas de Retiro, Problema de Retiro, Error de Pago, Soporte de Cuenta de Trading, Corregir Problema de Retiro",
            canonical: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/retiro-fallido",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                url: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/retiro-fallido",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/pagos/dentro-de-pagos/": {
            lang: "es",
            title: "Dentro de Pagos: Lo que Descubrirás",
            description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
            keywords: "Pagos en Excent Capital, Métodos de Pago Aceptados, Gestión de Transacciones, Tiempo de Procesamiento de Pagos, Divisas Soportadas, Pagos de Trading, Opciones de Depósito y Retiro, Fondeo de Cuenta",
            canonical: "https://knowledgebase.dev.excent.capital/es/pagos/dentro-de-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                url: "https://knowledgebase.dev.excent.capital/es/pagos/dentro-de-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/ver-historial-pagos/": {
            lang: "es",
            title: "¿Cómo Veo Mi Historial de Pagos?",
            description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
            keywords: "Historial de Pagos, Historial de Transacciones, Ver Depósitos, Ver Retiros, Pagos en Excent Capital, Transacciones de Cuenta, Historial de Cuenta de Trading, Registros Financieros",
            canonical: "https://knowledgebase.dev.excent.capital/es/pagos/ver-historial-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                url: "https://knowledgebase.dev.excent.capital/es/pagos/ver-historial-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/tiempo-transaccion/": {
            lang: "es",
            title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
            description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
            keywords: "Tiempo de Transacción, Tiempo de Procesamiento, Duración del Depósito, Duración del Retiro, Pagos en Excent Capital, Velocidad de Pago, Transacciones de Cuenta de Trading, Retrasos en Transacciones",
            canonical: "https://knowledgebase.dev.excent.capital/es/pagos/tiempo-transaccion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                url: "https://knowledgebase.dev.excent.capital/es/pagos/tiempo-transaccion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Potugues
        "pt/": {
            lang: "pt",
            title: "Base de Conhecimento | Excent Capital",
            description: "Explore a Base de Conhecimento da Excent Capital com guias especializados, tutoriais da plataforma, perguntas frequentes sobre trading e recursos desenvolvidos para ajudá-lo a operar com confiança.",
            keywords: "Central de Ajuda Excent Capital, Suporte da Plataforma de Trading, Perguntas Frequentes de Trading, Como Operar, Tutoriais de FX, Gestão de Conta, Guias de Trading, Ajuda com Depósitos, Ajuda com Saques",
            canonical: "https://knowledgebase.dev.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en",
                es: "https://knowledgebase.dev.excent.capital/es",
                pt: "https://knowledgebase.dev.excent.capital/pt",
                fr: "https://knowledgebase.dev.excent.capital/fr",
                it: "https://knowledgebase.dev.excent.capital/it",
                zh: "https://knowledgebase.dev.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.dev.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/dentro-sobre-nos/": {
            lang: "pt",
            title: "Dentro de Sobre Nós: O Que Você Vai Descobrir",
            description: "Saiba mais sobre a missão, os valores e a presença global da Excent Capital. Descubra quem somos, o que nos motiva e como capacitamos traders ao redor do mundo.",
            keywords: "Sobre a Excent Capital, Missão da Empresa, Valores da Empresa de Trading, Conheça a Equipe, Quem é a Excent Capital, Nossa História, Empresa de Serviços Financeiros, Visão Geral da Excent Capital",
            canonical: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/dentro-sobre-nos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/sobre-a-excent-capital/": {
            lang: "pt",
            title: "Sobre a Excent Capital",
            description: "Conheça a Excent Capital — nossa história, missão e os princípios que orientam nossa abordagem para capacitar traders nos mercados globais.",
            keywords: "Excent Capital, Sobre Nós, Visão Geral da Empresa, Empresa de Trading, Serviços Financeiros, Firma de Trading, Nossa Missão, Quem Somos, Suporte Global de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/construa-seu-portfolio/": {
            lang: "pt",
            title: "Construa Seu Portfólio: Opções Diversificadas na Excent Capital",
            description: "Descubra uma ampla variedade de instrumentos de trading na Excent Capital, incluindo Forex, ações, índices e commodities — tudo o que você precisa para montar um portfólio sólido e diversificado.",
            keywords: "Construir Portfólio, Instrumentos de Trading, Trading de Forex, Mercado de Ações, Trading de Índices, Trading de Commodities, Portfólio Diversificado, Ativos da Excent Capital",
            canonical: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/construa-seu-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/excent-capital-seu-parceiro-de-confianca/": {
            lang: "pt",
            title: "Excent Capital: Seu Parceiro de Confiança para Diversificar Seus Investimentos nos Mercados Internacionais",
            description: "Associe-se à Excent Capital para expandir globalmente suas oportunidades de investimento. Acesse os mercados internacionais com confiança através de nossa plataforma de trading segura e profissional.",
            keywords: "Excent Capital, Investimentos Internacionais, Diversificar Portfólio, Mercados Globais, Parceiro Confiável de Trading, Trading de Forex, Plataforma Internacional de Trading, Oportunidades de Investimento",
            canonical: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/centro-educacional-excent-capital/": {
            lang: "pt",
            title: "Eleve Seu Trading: Centro Educacional da Excent Capital",
            description: "Acesse cursos, tutoriais e recursos conduzidos por especialistas no Centro Educacional da Excent Capital. Aprenda estratégias de trading e desenvolva suas habilidades — seja você iniciante ou trader avançado.",
            keywords: "Educação em Trading, Aprenda a Operar, Tutoriais de Trading, Cursos de Trading, Educação Excent Capital, Guia de Trading para Iniciantes, Estratégias Avançadas de Trading, Recursos de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/invista-com-confianca/": {
            lang: "pt",
            title: "Invista com Confiança: Estratégias e Ferramentas de Gestão de Risco na Excent Capital",
            description: "Domine a gestão de risco com a Excent Capital. Explore ferramentas e estratégias essenciais para proteger seus investimentos e operar com mais confiança em mercados voláteis.",
            keywords: "Gestão de Risco, Ferramentas de Risco em Trading, Proteção de Investimentos, Estratégias da Excent Capital, Trading com Confiança, Volatilidade do Mercado, Ferramentas de Trading, Gerenciar Risco no Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/invista-com-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/invista-com-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/trading/dentro-do-trading/": {
            lang: "pt",
            title: "Dentro do Trading: O Que Você Vai Descobrir",
            description: "Explore conceitos-chave de trading, insights de mercado e funcionalidades da plataforma no centro de trading da Excent Capital. Obtenha o conhecimento necessário para tomar decisões informadas.",
            keywords: "Guia de Trading, Insights de Mercado, Conceitos de Trading, Como Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conhecimento de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/dentro-do-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/dentro-do-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/instrumentos-na-excent-capital/": {
            lang: "pt",
            title: "Instrumentos na Excent Capital",
            description: "Explore toda a gama de instrumentos de trading oferecidos pela Excent Capital, incluindo FX, ações, commodities, índices e muito mais — desenvolvidos para atender aos seus objetivos de investimento.",
            keywords: "Instrumentos de Trading, Forex, Ações, Commodities, Índices, Ativos da Excent Capital, Instrumentos Financeiros, Opções de Investimento, Mercados de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/instrumentos-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/instrumentos-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/alavancagem-na-excent-capital/": {
            lang: "pt",
            title: "Alavancagem Oferecida pela Excent Capital",
            description: "Entenda como funciona a alavancagem na Excent Capital e como ela pode ampliar seu potencial de trading. Conheça nossas opções de alavancagem flexíveis e práticas de operação responsável.",
            keywords: "Trading com Alavancagem, Operar com Alavancagem, Alavancagem na Excent Capital, Trading com Margem, Opções de Alavancagem, Ampliar Trading, Alavancagem em Forex, Trading Responsável",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/alavancagem-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/alavancagem-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/micro-lotes-excent-capital/": {
            lang: "pt",
            title: "Micro Lotes na Excent Capital",
            description: "Opere com mais flexibilidade utilizando micro lotes na Excent Capital. Ideal para iniciantes e traders cautelosos que buscam controlar a exposição e testar estratégias.",
            keywords: "Trading com Micro Lotes, Micro Lotes Excent Capital, Trading com Lotes Pequenos, Trading para Iniciantes, Gestão de Risco, Trading Flexível, Micro Lotes de Forex, Trading com Baixa Exposição",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/horario-de-trading/": {
            lang: "pt",
            title: "Horários de Trading",
            description: "Fique informado sobre os horários oficiais de trading para todos os mercados disponíveis na Excent Capital. Saiba quando operar Forex, ações, índices e commodities.",
            keywords: "Horários de Trading, Horários de Mercado, Horários de Forex, Horário do Mercado de Ações, Agenda da Excent Capital, Sessões de Trading, Tempos de Trading, Horários do Mercado Financeiro",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.dev.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ferramentas-de-trading/": {
            lang: "pt",
            title: "Ferramentas de Trading",
            description: "Melhore sua experiência de trading com as poderosas ferramentas da Excent Capital. Acesse gráficos, calculadoras, análises de mercado e muito mais para tomar decisões informadas.",
            keywords: "Ferramentas de Trading, Ferramentas de Análise de Mercado, Calculadoras de Trading, Ferramentas de Forex, Plataforma Excent Capital, Recursos de Trading, Ferramentas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "pt/trading/ferramentas-de-trading-acuity/": {
            lang: "pt",
            title: "Ferramentas de Trading da Acuity",
            description: "Aproveite as ferramentas com IA da Acuity na Excent Capital para obter insights de mercado, análise de sentimento e decisões de trading mais inteligentes com dados em tempo real.",
            keywords: "Ferramentas de Trading Acuity, Ferramentas de Trading com IA, Análise de Sentimento de Mercado, Insights de Mercado em Tempo Real, Ferramentas da Excent Capital, Insights da Acuity, Trading Inteligente, Análise de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "pt/trading/chamadas-de-margem/": {
            lang: "pt",
            title: "Chamadas de Margem",
            description: "Entenda como funcionam as chamadas de margem na Excent Capital. Saiba quando elas ocorrem, como gerenciá-las e como proteger sua conta contra liquidações forçadas.",
            keywords: "Chamadas de Margem, O que é uma Chamada de Margem, Margem Excent Capital, Margem de Trading, Liquidação Forçada, Proteção da Conta, Trading com Margem, Gestão de Risco",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/chamadas-de-margem",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.dev.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/chamadas-de-margem",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/trading-de-cfd/": {
            lang: "pt",
            title: "Trading de CFDs",
            description: "Aprenda como operar Contratos por Diferença (CFDs) com a Excent Capital. Acesse mercados globais, opere com alavancagem e posicione-se sobre movimentos de preço sem possuir os ativos.",
            keywords: "Trading de CFDs, Contratos por Diferença, Operar CFDs, CFDs da Excent Capital, Trading com Alavancagem, Trading de Derivativos, Mercados de CFD, Como Operar CFDs",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ordens-pendentes/": {
            lang: "pt",
            title: "Ordens Pendentes",
            description: "Descubra como funcionam as ordens pendentes na Excent Capital. Aprenda a definir pontos de entrada com antecedência e automatizar sua estratégia de trading com precisão.",
            keywords: "Ordens Pendentes, Ordens de Trading, Buy Stop, Sell Stop, Ordens Limitadas, Trading Automatizado, Ordens Excent Capital, Pontos de Entrada, Estratégia de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/ordens-pendentes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.dev.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/ordens-pendentes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/spreads-oferecidos/": {
            lang: "pt",
            title: "Spreads Oferecidos",
            description: "Descubra a importância dos spreads e dos spreads de volatilidade nos mercados financeiros. Aprenda a minimizar custos e otimizar sua lucratividade como trader.",
            keywords: "Spreads, Spreads de Volatilidade, Mercados Financeiros, Spreads de Trading, Minimizar Custos de Trading, Otimizar Lucros, Estratégias de Trading, Análise de Spreads, Spreads de Forex, Spreads no Mercado de Ações",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/spreads-oferecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/spreads-oferecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/moedas-base/": {
            lang: "pt",
            title: "Moedas Base",
            description: "Descubra quais moedas base são aceitas na Excent Capital. Escolha a moeda certa para sua conta e simplifique sua experiência de trading e de financiamento.",
            keywords: "Moedas Base, Moedas Suportadas, Conta na Excent Capital, Opções de Moeda de Conta, Seleção de Moeda, Moeda para Trading, Moeda Base em Forex, Opções de Financiamento",
            canonical: "https://knowledgebase.dev.excent.capital/pt/trading/moedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.dev.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.dev.excent.capital/pt/trading/moedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/recursos/dentro-de-recursos/": {
            lang: "pt",
            title: "Dentro de Recursos: O Que Você Vai Descobrir",
            description: "Explore o centro de recursos da Excent Capital com atualizações de mercado, calendários econômicos, ferramentas de trading e conteúdo educacional para apoiar sua jornada como trader.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Atualizações de Mercado, Calendário Econômico, Educação em Trading, Centro de Recursos, Aprenda a Operar, Materiais de Apoio ao Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.dev.excent.capital/pt/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-basicos/": {
            lang: "pt",
            title: "Conceitos Básicos",
            description: "Aprenda os conceitos fundamentais do trading com a Excent Capital. Entenda os termos-chave, a mecânica do mercado e o conhecimento essencial para começar sua jornada no trading.",
            keywords: "Conceitos Básicos de Trading, Trading para Iniciantes, Fundamentos do Mercado, Educação Excent Capital, Terminologia de Trading, Guia para Iniciantes, Aprender a Operar, Conceitos Fundamentais",
            canonical: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-avancados/": {
            lang: "pt",
            title: "Conceitos Avançados",
            description: "Aprofunde seus conhecimentos de trading com os conceitos avançados da Excent Capital. Explore estratégias, indicadores e técnicas usadas por traders experientes.",
            keywords: "Conceitos Avançados de Trading, Estratégias de Trading, Indicadores Técnicos, Trading Avançado, Educação Excent Capital, Análise de Mercado, Ferramentas para Traders Profissionais, Técnicas de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-avancados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-avancados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/recursos-adicionais/": {
            lang: "pt",
            title: "Recursos Adicionais",
            description: "Acesse uma variedade de recursos adicionais na Excent Capital, incluindo glossários de trading, guias da plataforma e ferramentas de mercado para melhorar sua experiência de operação.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Glossário de Termos, Guias da Plataforma, Ajuda de Trading, Ferramentas de Mercado, Recursos Educacionais, Suporte ao Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/recursos/recursos-adicionais",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.dev.excent.capital/pt/recursos/recursos-adicionais",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/minha-conta/dentro-da-minha-conta/": {
            lang: "pt",
            title: "Dentro da Minha Conta: O Que Você Vai Descobrir",
            description: "Gerencie sua conta de trading com facilidade na Excent Capital. Aprenda como atualizar seu perfil, acessar configurações da conta, monitorar atividades e manter a segurança.",
            keywords: "Minha Conta, Gestão de Conta, Perfil da Excent Capital, Configurações da Conta de Trading, Segurança da Conta, Painel do Usuário, Atualizações de Perfil, Gerenciar Conta de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/dentro-da-minha-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-demo/": {
            lang: "pt",
            title: "Posso Criar uma Conta Demo?",
            description: "Sim, a Excent Capital oferece contas demo para que você possa praticar trading em um ambiente sem riscos. Saiba como abrir uma e começar a explorar a plataforma.",
            keywords: "Conta Demo, Praticar Trading, Demo da Excent Capital, Trading Sem Risco, Criar Conta Demo, Simulador de Trading, Trading para Iniciantes, Aprender a Operar",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-real/": {
            lang: "pt",
            title: "Como Criar uma Conta Real?",
            description: "Abra sua conta de trading real na Excent Capital em apenas alguns passos. Siga nosso guia para começar a operar nos mercados reais com segurança e eficiência.",
            keywords: "Conta Real, Criar Conta de Trading, Registro na Excent Capital, Abrir Conta Real, Começar a Operar, Conta Real de Trading, Cadastro de Trading, Configuração de Conta",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta/": {
            lang: "pt",
            title: "Por Que Verificar Sua Conta?",
            description: "A verificação da conta na Excent Capital garante segurança, conformidade e acesso completo às funcionalidades de trading. Saiba por que é importante e como concluí-la.",
            keywords: "Verificação de Conta, Verificar Conta de Trading, KYC da Excent Capital, Segurança no Trading, Processo de Conformidade, Verificação de Identidade, Trading Seguro, Acesso Completo à Conta",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/acessar-a-plataforma/": {
            lang: "pt",
            title: "Como Acessar a Plataforma?",
            description: "Acesse a plataforma de trading da Excent Capital facilmente pelo navegador ou dispositivo móvel. Saiba como fazer login e começar a operar a qualquer hora e em qualquer lugar.",
            keywords: "Acessar Plataforma de Trading, Login Excent Capital, Aplicativo de Trading, Plataforma Web de Trading, Trading Móvel, Como Fazer Login, Começar a Operar, Guia de Acesso à Plataforma",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/acessar-a-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/acessar-a-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/tempo-para-criar-conta/": {
            lang: "pt",
            title: "Quanto Tempo Leva para Criar uma Conta?",
            description: "Criar uma conta na Excent Capital é rápido e simples. Descubra quanto tempo leva o processo e quais etapas são necessárias para começar.",
            keywords: "Tempo de Criação de Conta, Cadastro na Excent Capital, Como Criar Conta, Configuração de Conta de Trading, Processo de Registro, Abrir Conta Rápido, Onboarding de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/tempo-para-criar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/tempo-para-criar-contas",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/contas-corporativas/": {
            lang: "pt",
            title: "Vocês Oferecem Contas Corporativas?",
            description: "Sim, a Excent Capital oferece contas corporativas de trading para empresas e instituições. Descubra os benefícios e os requisitos para abrir uma conta corporativa.",
            keywords: "Conta Corporativa de Trading, Conta Empresarial, Corporativo na Excent Capital, Trading Institucional, Abrir Conta Corporativa, Trading para Empresas, Conta de Investimento Corporativa",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/contas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/contas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/varias-contas-mesmo-email/": {
            lang: "pt",
            title: "Posso Abrir Múltiplas Contas com Diferentes Funções Usando o Mesmo E-mail?",
            description: "Descubra se é possível registrar várias contas da Excent Capital com diferentes funções usando um único endereço de e-mail, e como funciona a gestão de funções na plataforma.",
            keywords: "Múltiplas Contas, Contas com o Mesmo E-mail, Funções na Excent Capital, Funções de Usuário, Gestão de Conta, Acesso à Conta de Trading, Acesso Baseado em Funções, Política de Registro de E-mail",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/atualizar-informacoes-da-conta/": {
            lang: "pt",
            title: "Como Atualizo as Informações da Minha Conta?",
            description: "Atualize facilmente seus dados pessoais e informações da conta na Excent Capital. Siga nosso guia passo a passo para manter suas informações precisas e atualizadas.",
            keywords: "Atualizar Informações da Conta, Editar Dados Pessoais, Perfil Excent Capital, Configurações da Conta, Alterar Informações da Conta, Atualização do Perfil de Trading, Informações do Usuário",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/esqueci-minha-senha/": {
            lang: "pt",
            title: "O Que Acontece se Eu Esquecer Minha Senha?",
            description: "Se você esquecer sua senha, a Excent Capital oferece um processo de recuperação simples e seguro. Aprenda como redefinir sua senha e recuperar o acesso à sua conta.",
            keywords: "Esqueci a Senha, Recuperação de Senha, Redefinir Senha de Trading, Ajuda para Login Excent Capital, Acesso à Conta, Recuperar Senha, Senha Perdida, Login na Conta de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/esqueci-minha-senha",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/esqueci-minha-senha",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/documentos-para-verificacao/": {
            lang: "pt",
            title: "Quais Documentos São Necessários para Verificação de Conta?",
            description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
            keywords: "Documentos para Verificação de Conta, Requisitos KYC, Verificação na Excent Capital, Comprovante de Identidade, Comprovante de Endereço, Enviar Documentos, Verificação Segura, Conformidade no Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/documentos-para-verificacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/documentos-para-verificacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/amigos-familia-usar-conta/": {
            lang: "pt",
            title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
            description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
            keywords: "Compartilhamento de Conta, Política da Excent Capital, Uso Pessoal da Conta, Segurança da Conta de Trading, Acesso Compartilhado, Uso por Familiares, Segurança da Conta, Conformidade em Trading",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/cancelar-conta/": {
            lang: "pt",
            title: "Como Cancelo Minha Conta?",
            description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
            keywords: "Cancelar Conta de Trading, Encerrar Conta na Excent Capital, Cancelamento de Conta, Excluir Conta, Fechamento de Conta de Trading, Finalizar Conta, Suporte da Excent Capital, Processo de Cancelamento de Conta",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/cancelar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/cancelar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta-no-exterior/": {
            lang: "pt",
            title: "Posso Verificar Minha Conta Estando no Exterior?",
            description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
            keywords: "Verificar Conta no Exterior, Verificação Excent Capital, Conta em País Estrangeiro, KYC Internacional, Verificação Remota de Conta, Documentos para Conta, Verificação no Exterior",
            canonical: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                url: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/depositos-saques/dentro-depositos-retiradas/": {
            lang: "pt",
            title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
            description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
            keywords: "Depósitos e Saques, Fondeamento na Excent Capital, Sacar Lucros, Métodos de Pagamento, Opções de Depósito, Prazos de Saque, Fondeamento da Conta de Trading, Transações Financeiras",
            canonical: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                url: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/primeiro-deposito/": {
            lang: "pt",
            title: "Como Faço Meu Primeiro Depósito?",
            description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
            keywords: "Primeiro Depósito, Fazer um Depósito, Fondeamento Excent Capital, Depósito na Conta de Trading, Como Depositar, Métodos de Pagamento, Começar a Operar, Adicionar Fundos à Conta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/primeiro-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                url: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/primeiro-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-deposito/": {
            lang: "pt",
            title: "Como Faço um Depósito?",
            description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
            keywords: "Depositar Fundos, Como Depositar, Métodos de Pagamento Excent Capital, Fondeamento da Conta de Trading, Fazer um Depósito, Depósito Seguro, Recarga da Conta, Processo de Depósito",
            canonical: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                url: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-saque/": {
            lang: "pt",
            title: "Como Posso Fazer um Saque?",
            description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
            keywords: "Sacar Fundos, Saque na Excent Capital, Como Sacar, Pagamento da Conta de Trading, Processo de Saque, Saque Seguro, Acessar Ganhos, Métodos de Pagamento",
            canonical: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-saque",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                url: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-saque",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/saque-falhou/": {
            lang: "pt",
            title: "O Que Fazer se Meu Saque Falhar?",
            description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
            keywords: "Saque Falhou, Ajuda Excent Capital, Transação Falhada, Resolver Problemas de Saque, Problema no Saque, Erro de Pagamento, Suporte da Conta de Trading, Corrigir Problema de Saque",
            canonical: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/saque-falhou",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                url: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/saque-falhou",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/pagamentos/dentro-de-pagamentos/": {
            lang: "pt",
            title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
            description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
            keywords: "Pagamentos Excent Capital, Métodos de Pagamento Aceitos, Gestão de Transações, Tempo de Processamento de Pagamento, Moedas Suportadas, Pagamentos de Trading, Opções de Depósito e Saque, Fondeamento de Conta",
            canonical: "https://knowledgebase.dev.excent.capital/pt/pagamentos/dentro-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                url: "https://knowledgebase.dev.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/ver-historico-de-pagamentos/": {
            lang: "pt",
            title: "Como Vejo Meu Histórico de Pagamentos?",
            description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
            keywords: "Histórico de Pagamentos, Histórico de Transações, Ver Depósitos, Ver Saques, Pagamentos Excent Capital, Transações da Conta, Histórico da Conta de Trading, Registros Financeiros",
            canonical: "https://knowledgebase.dev.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                url: "https://knowledgebase.dev.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/tempo-de-transacao/": {
            lang: "pt",
            title: "Quanto Tempo Pode Levar uma Transação?",
            description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
            keywords: "Tempo de Transação, Tempo de Processamento, Duração do Depósito, Duração do Saque, Pagamentos Excent Capital, Velocidade de Pagamento, Transações da Conta de Trading, Atrasos em Transações",
            canonical: "https://knowledgebase.dev.excent.capital/pt/pagamentos/tempo-de-transacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                url: "https://knowledgebase.dev.excent.capital/pt/pagamentos/tempo-de-transacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        // Frances
        "fr/": {
            lang: "fr",
            title: "Base de connaissances | Excent Capital",
            description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
            keywords: "Centre d’aide Excent Capital, Support de plateforme de trading, FAQ Trading, Comment Trader, Tutoriels FX, Gestion de compte, Guides de Trading, Aide au dépôt, Aide au retrait",
            canonical: "https://knowledgebase.dev.excent.capital/fr/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en",
                es: "https://knowledgebase.dev.excent.capital/es",
                pt: "https://knowledgebase.dev.excent.capital/pt",
                fr: "https://knowledgebase.dev.excent.capital/fr",
                it: "https://knowledgebase.dev.excent.capital/it",
                zh: "https://knowledgebase.dev.excent.capital/zh",
            },
            openGraph: {
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                url: "https://knowledgebase.dev.excent.capital/fr/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-de-nous/": {
            lang: "fr",
            title: "Dans la section À propos : Ce que vous allez découvrir",
            description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
            keywords: "À propos d’Excent Capital, Mission de l’entreprise, Valeurs d’une société de trading, Rencontrer l’équipe, Qui est Excent Capital, Notre histoire, Société de services financiers, Vue d’ensemble d’Excent Capital",
            canonical: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                url: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-d-excent-capital/": {
            lang: "fr",
            title: "À propos d’Excent Capital",
            description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
            keywords: "Excent Capital, À propos de nous, Présentation de l’entreprise, Société de trading, Services financiers, Société de courtage, Notre mission, Qui nous sommes, Support global au trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                url: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/construisez-votre-portefeuille/": {
            lang: "fr",
            title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
            description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
            keywords: "Construire un portefeuille, Instruments de trading, Trading Forex, Marché boursier, Trading d’indices, Trading de matières premières, Portefeuille diversifié, Actifs Excent Capital",
            canonical: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                url: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance/": {
            lang: "fr",
            title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
            description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
            keywords: "Excent Capital, Investissements internationaux, Diversifier son portefeuille, Marchés mondiaux, Partenaire de trading fiable, Trading Forex, Plateforme de trading internationale, Opportunités d’investissement",
            canonical: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                url: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/centre-educatif-excent-capital/": {
            lang: "fr",
            title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
            description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
            keywords: "Formation en Trading, Apprendre à Trader, Tutoriels de Trading, Cours de Trading, Formation Excent Capital, Guide de Trading Débutant, Stratégies de Trading Avancées, Ressources de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                url: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/investissez-en-confiance/": {
            lang: "fr",
            title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
            description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
            keywords: "Gestion des Risques, Outils de Risque en Trading, Protection des Investissements, Stratégies Excent Capital, Trading en Confiance, Volatilité du Marché, Outils de Trading, Gérer le Risque en Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                url: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/trading/a-linterieur-du-trading/": {
            lang: "fr",
            title: "Dans le monde du Trading : Ce que vous allez découvrir",
            description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
            keywords: "Guide de Trading, Perspectives de Marché, Concepts de Trading, Comment Trader, Plateforme Excent Capital, Fonctionnalités de Trading, Apprendre à Trader, Base de Connaissances en Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/a-linterieur-du-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/a-linterieur-du-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/instruments-chez-excent-capital/": {
            lang: "fr",
            title: "Instruments chez Excent Capital",
            description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
            keywords: "Instruments de Trading, Forex, Actions, Matières Premières, Indices, Actifs Excent Capital, Instruments Financiers, Options d’Investissement, Marchés de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/instruments-chez-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/instruments-chez-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/effet-de-levier-excent-capital/": {
            lang: "fr",
            title: "Effet de levier proposé par Excent Capital",
            description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
            keywords: "Trading avec Effet de Levier, Trading avec Levier, Levier Excent Capital, Trading sur Marge, Options de Levier, Amplifier le Trading, Levier Forex, Trading Responsable",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/effet-de-levier-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/effet-de-levier-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/micro-lots-at-excent-capital/": {
            lang: "fr",
            title: "Micro lots chez Excent Capital",
            description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
            keywords: "Trading en Micro Lots, Micro Lots Excent Capital, Trading en Petits Lots, Trading Débutant, Gestion des Risques, Trading Flexible, Micro Lots Forex, Trading à Faible Exposition",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/horaires-de-trading/": {
            lang: "fr",
            title: "Heures de Trading",
            description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
            keywords: "Heures de Trading, Horaires de Marché, Horaires de Trading Forex, Heures du Marché Boursier, Calendrier Excent Capital, Sessions de Trading, Périodes de Trading, Horaires des Marchés Financiers",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/horaires-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.dev.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/horaires-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/outils-de-trading/": {
            lang: "fr",
            title: "Outils de Trading",
            description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
            keywords: "Outils de Trading, Outils d’Analyse de Marché, Calculateurs de Trading, Outils Forex, Plateforme Excent Capital, Ressources de Trading, Outils de Graphiques, Trading Informé",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "fr/trading/outils-de-trading-acuity/": {
            lang: "fr",
            title: "Outils de Trading Acuity",
            description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
            keywords: "Outils de Trading Acuity, Outils de Trading IA, Analyse du Sentiment de Marché, Insights de Marché en Temps Réel, Outils Excent Capital, Insights Acuity, Trading Intelligent, Analytique de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "fr/trading/appels-de-marge/": {
            lang: "fr",
            title: "Appels de Marge",
            description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
            keywords: "Appels de Marge, Qu’est-ce qu’un Appel de Marge, Marge Excent Capital, Trading sur Marge, Liquidation Forcée, Protection de Compte, Trading avec Marge, Gestion des Risques",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/appels-de-marge",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.dev.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/appels-de-marge",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/trading-de-cfd/": {
            lang: "fr",
            title: "Trading de CFD",
            description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
            keywords: "Trading de CFD, Contrats sur la Différence, Trader les CFD, CFD Excent Capital, Trading avec Effet de Levier, Trading de Produits Dérivés, Marchés CFD, Comment Trader les CFD",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/ordres-en-attente/": {
            lang: "fr",
            title: "Ordres en Attente",
            description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
            keywords: "Ordres en Attente, Ordres de Trading, Buy Stop, Sell Stop, Ordres Limites, Trading Automatisé, Ordres Excent Capital, Points d’Entrée, Stratégie de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/ordres-en-attente",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.dev.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/ordres-en-attente",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/spreads-offerts/": {
            lang: "fr",
            title: "Spreads Proposés",
            description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
            keywords: "Spreads, Spreads de Volatilité, Marchés Financiers, Spreads de Trading, Réduire les Coûts de Trading, Optimiser la Rentabilité, Stratégies de Trading, Analyse des Spreads, Spreads Forex, Spreads Boursiers",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/spreads-offerts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/spreads-offerts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/devises-de-base/": {
            lang: "fr",
            title: "Devises de Base",
            description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
            keywords: "Devises de Base, Devises Acceptées, Compte Excent Capital, Options de Devise de Compte, Sélection de Devise, Devise de Trading, Devise de Base Forex, Options de Financement",
            canonical: "https://knowledgebase.dev.excent.capital/fr/trading/devises-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.dev.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                url: "https://knowledgebase.dev.excent.capital/fr/trading/devises-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/ressources/a-linterieur-des-ressources/": {
            lang: "fr",
            title: "Dans la section Ressources : Ce que vous allez découvrir",
            description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Mises à Jour du Marché, Calendrier Économique, Formation au Trading, Centre de Ressources, Apprendre à Trader, Supports de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/ressources/a-linterieur-des-ressources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                url: "https://knowledgebase.dev.excent.capital/fr/ressources/a-linterieur-des-ressources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-de-base/": {
            lang: "fr",
            title: "Concepts de Base",
            description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
            keywords: "Concepts de Base en Trading, Trading pour Débutants, Bases du Marché, Formation Excent Capital, Terminologie du Trading, Guide Débutant, Apprendre à Trader, Concepts Fondamentaux",
            canonical: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                url: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-avances/": {
            lang: "fr",
            title: "Concepts Avancés",
            description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
            keywords: "Concepts Avancés en Trading, Stratégies de Trading, Indicateurs Techniques, Trading Expert, Formation Excent Capital, Analyse de Marché, Outils pour Traders Pros, Techniques de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-avances",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                url: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-avances",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/ressources-supplementaires/": {
            lang: "fr",
            title: "Ressources Supplémentaires",
            description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Glossaire de Termes, Guides de Plateforme, Aide au Trading, Outils de Marché, Ressources Éducatives, Support de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/ressources/ressources-supplementaires",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                url: "https://knowledgebase.dev.excent.capital/fr/ressources/ressources-supplementaires",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/mon-compte/a-linterieur-de-mon-compte/": {
            lang: "fr",
            title: "Dans Mon Compte : Ce que vous allez découvrir",
            description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
            keywords: "Mon Compte, Gestion de Compte, Profil Excent Capital, Paramètres de Compte de Trading, Sécurité du Compte, Tableau de Bord Utilisateur, Mise à Jour de Profil, Gérer un Compte de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-demo/": {
            lang: "fr",
            title: "Puis-je Créer un Compte Démo ?",
            description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
            keywords: "Compte Démo, Pratique de Trading, Démo Excent Capital, Trading Sans Risque, Créer un Compte Démo, Simulateur de Trading, Trading Débutant, Apprendre à Trader",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-reel/": {
            lang: "fr",
            title: "Comment créer un compte réel ?",
            description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
            keywords: "Compte Réel, Créer un Compte de Trading, Inscription Excent Capital, Ouvrir un Compte Réel, Commencer à Trader, Compte de Trading Réel, Inscription au Trading, Configuration de Compte",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-reel",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-reel",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-votre-compte/": {
            lang: "fr",
            title: "Pourquoi vérifier votre compte ?",
            description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
            keywords: "Vérification de Compte, Vérifier un Compte de Trading, KYC Excent Capital, Sécurité du Trading, Processus de Conformité, Vérification d’Identité, Trading Sécurisé, Accès Complet au Compte",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-votre-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-votre-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/acceder-a-la-plateforme/": {
            lang: "fr",
            title: "Comment accéder à la plateforme ?",
            description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
            keywords: "Accès à la Plateforme de Trading, Connexion Excent Capital, Application de Trading, Plateforme Web de Trading, Trading Mobile, Comment Se Connecter, Commencer à Trader, Guide d’Accès à la Plateforme",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/delai-pour-creer-un-compte/": {
            lang: "fr",
            title: "Combien de temps faut-il pour créer un compte ?",
            description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
            keywords: "Temps de Création de Compte, Inscription Excent Capital, Comment Créer un Compte, Configuration du Compte de Trading, Processus d’Enregistrement, Ouvrir un Compte Rapidement, Intégration au Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/comptes-corporatifs/": {
            lang: "fr",
            title: "Proposez-vous des comptes professionnels ?",
            description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
            keywords: "Compte de Trading Professionnel, Compte Entreprise, Compte Corporate Excent Capital, Trading Institutionnel, Ouvrir un Compte Corporate, Trading pour Entreprises, Compte d’Investissement Professionnel",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/comptes-corporatifs",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/comptes-corporatifs",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/plusieurs-comptes-meme-email/": {
            lang: "fr",
            title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
            description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
            keywords: "Comptes Multiples, Comptes avec le Même E-mail, Rôles Excent Capital, Rôles Utilisateur, Gestion de Compte, Accès au Compte de Trading, Accès Basé sur les Rôles, Politique d’Enregistrement par E-mail",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mettre-a-jour-informations-compte/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mot-de-passe-oublie/": {
            lang: "fr",
            title: "Que se passe-t-il si j’oublie mon mot de passe ?",
            description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
            keywords: "Mot de Passe Oublié, Récupération de Mot de Passe, Réinitialiser Mot de Passe Trading, Aide Connexion Excent Capital, Accès au Compte, Récupérer Mot de Passe, Mot de Passe Perdu, Connexion Compte de Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mot-de-passe-oublie",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/documents-pour-verification/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/documents-pour-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/documents-pour-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/amis-famille-utiliser-compte/": {
            lang: "fr",
            title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
            description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
            keywords: "Partage de Compte, Politique Excent Capital, Utilisation Personnelle du Compte, Sécurité du Compte de Trading, Accès Partagé, Utilisation Familiale du Compte, Sécurité du Compte, Conformité en Trading",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/annuler-mon-compte/": {
            lang: "fr",
            title: "Comment annuler mon compte",
            description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
            keywords: "Annuler Compte de Trading, Fermer Compte Excent Capital, Résiliation de Compte, Supprimer Compte, Clôture de Compte de Trading, Fermer Compte, Support Excent Capital, Processus d’Annulation de Compte",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/annuler-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/annuler-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-compte-depuis-etranger/": {
            lang: "fr",
            title: "Puis-je vérifier mon compte depuis un pays étranger ?",
            description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
            keywords: "Vérifier Compte à l’Étranger, Vérification Excent Capital, Création de Compte depuis l’Étranger, KYC International, Vérification de Compte à Distance, Documents de Compte, Vérification Hors Pays",
            canonical: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                url: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/depots-retraits/a-linterieur-depots-retraits/": {
            lang: "fr",
            title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
            description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
            keywords: "Dépôts et Retraits, Financement Excent Capital, Retirer des Gains, Méthodes de Paiement, Options de Dépôt, Délais de Retrait, Financement du Compte de Trading, Transactions Financières",
            canonical: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                url: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/premier-depot/": {
            lang: "fr",
            title: "Comment effectuer un premier dépôt ?",
            description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
            keywords: "Premier Dépôt, Effectuer un Dépôt, Financement Excent Capital, Dépôt Compte de Trading, Comment Déposer, Méthodes de Paiement, Commencer à Trader, Approvisionner Compte",
            canonical: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/premier-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                url: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/premier-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-depot/": {
            lang: "fr",
            title: "Comment effectuer un dépôt ?",
            description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
            keywords: "Déposer des Fonds, Comment Déposer, Méthodes de Paiement Excent Capital, Financement Compte de Trading, Effectuer un Dépôt, Dépôt Sécurisé, Recharger Compte, Processus de Dépôt",
            canonical: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                url: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-retrait/": {
            lang: "fr",
            title: "Comment effectuer un retrait ?",
            description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
            keywords: "Retirer des Fonds, Retrait Excent Capital, Comment Retirer, Paiement Compte de Trading, Processus de Retrait, Retrait Sécurisé, Accéder aux Gains, Méthodes de Paiement",
            canonical: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                url: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/echec-du-retrait/": {
            lang: "fr",
            title: "Que faire si mon retrait échoue ?",
            description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
            keywords: "Retrait Échoué, Aide Excent Capital, Transaction Échouée, Résoudre un Problème de Retrait, Problème de Retrait, Erreur de Paiement, Support Compte de Trading, Corriger un Problème de Retrait",
            canonical: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/echec-du-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                url: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/echec-du-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/paiements/a-linterieur-des-paiements/": {
            lang: "fr",
            title: "Dans la section Paiements : Ce que vous allez découvrir",
            description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
            keywords: "Paiements Excent Capital, Méthodes de Paiement Acceptées, Gestion des Transactions, Délai de Traitement des Paiements, Devises Supportées, Paiements de Trading, Options de Dépôt et de Retrait, Financement de Compte",
            canonical: "https://knowledgebase.dev.excent.capital/fr/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                url: "https://knowledgebase.dev.excent.capital/fr/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/voir-historique-paiements/": {
            lang: "fr",
            title: "Comment voir mon historique de paiements ?",
            description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
            keywords: "Historique des Paiements, Historique des Transactions, Voir les Dépôts, Voir les Retraits, Paiements Excent Capital, Transactions du Compte, Historique Compte de Trading, Relevés Financiers",
            canonical: "https://knowledgebase.dev.excent.capital/fr/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                url: "https://knowledgebase.dev.excent.capital/fr/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/delai-de-transaction/": {
            lang: "fr",
            title: "Combien de temps une transaction peut-elle prendre ?",
            description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
            keywords: "Délai de Transaction, Temps de Traitement, Durée du Dépôt, Durée du Retrait, Paiements Excent Capital, Vitesse de Paiement, Transactions Compte de Trading, Retard de Transactions",
            canonical: "https://knowledgebase.dev.excent.capital/fr/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                url: "https://knowledgebase.dev.excent.capital/fr/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Italiano
        "it/": {
            lang: "it",
            title: "Knowledgebase | Excent Capital",
            description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
            keywords: "Centro Assistenza Excent Capital, Supporto Piattaforma di Trading, FAQ Trading, Come Fare Trading, Tutorial FX, Gestione Account, Guide al Trading, Assistenza Depositi, Assistenza Prelievi",
            canonical: "https://knowledgebase.dev.excent.capital/it/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en",
                es: "https://knowledgebase.dev.excent.capital/es",
                pt: "https://knowledgebase.dev.excent.capital/pt",
                fr: "https://knowledgebase.dev.excent.capital/fr",
                it: "https://knowledgebase.dev.excent.capital/it",
                zh: "https://knowledgebase.dev.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                url: "https://knowledgebase.dev.excent.capital/it/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/dentro-di-noi/": {
            lang: "it",
            title: "Dentro Chi Siamo: Cosa Scoprirai",
            description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
            keywords: "Chi è Excent Capital, Missione Aziendale, Valori Società di Trading, Conosci il Team, Chi è Excent Capital, La Nostra Storia, Società di Servizi Finanziari, Panoramica Excent Capital",
            canonical: "https://knowledgebase.dev.excent.capital/it/chi-siamo/dentro-di-noi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                url: "https://knowledgebase.dev.excent.capital/it/chi-siamo/dentro-di-noi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/su-excent-capital/": {
            lang: "it",
            title: "Chi è Excent Capital",
            description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
            keywords: "Excent Capital, Chi Siamo, Panoramica Aziendale, Società di Trading, Servizi Finanziari, Società di Investimenti, La Nostra Missione, Chi Siamo Noi, Supporto al Trading Globale",
            canonical: "https://knowledgebase.dev.excent.capital/it/chi-siamo/su-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                url: "https://knowledgebase.dev.excent.capital/it/chi-siamo/su-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/costruisci-il-tuo-portafoglio/": {
            lang: "it",
            title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
            description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
            keywords: "Costruire Portafoglio, Strumenti di Trading, Trading Forex, Mercato Azionario, Trading Indici, Trading Materie Prime, Portafoglio Diversificato, Asset di Excent Capital",
            canonical: "https://knowledgebase.dev.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                url: "https://knowledgebase.dev.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia/": {
            lang: "it",
            title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
            description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
            keywords: "Excent Capital, Investimenti Internazionali, Diversificare Portafoglio, Mercati Globali, Partner Affidabile per il Trading, Trading Forex, Piattaforma di Trading Internazionale, Opportunità di Investimento",
            canonical: "https://knowledgebase.dev.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                url: "https://knowledgebase.dev.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/centro-educativo-excent-capital/": {
            lang: "it",
            title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
            description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
            keywords: "Formazione sul Trading, Imparare a Fare Trading, Tutorial di Trading, Corsi di Trading, Formazione Excent Capital, Guida al Trading per Principianti, Strategie Avanzate di Trading, Risorse di Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                url: "https://knowledgebase.dev.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/investi-con-fiducia/": {
            lang: "it",
            title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
            description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
            keywords: "Gestione del Rischio, Strumenti per il Rischio di Trading, Protezione degli Investimenti, Strategie Excent Capital, Trading con Fiducia, Volatilità di Mercato, Strumenti di Trading, Gestire il Rischio nel Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/chi-siamo/investi-con-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                url: "https://knowledgebase.dev.excent.capital/it/chi-siamo/investi-con-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/trading/dentro-del-trading-it/": {
            lang: "it",
            title: "Dentro il Trading: Cosa Scoprirai",
            description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
            keywords: "Guida al Trading, Approfondimenti di Mercato, Concetti di Trading, Come Fare Trading, Piattaforma Excent Capital, Funzionalità di Trading, Imparare il Trading, Base di Conoscenza del Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/dentro-del-trading-it",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/dentro-del-trading-it",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-excent-capital/": {
            lang: "it",
            title: "Strumenti su Excent Capital",
            description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
            keywords: "Strumenti di Trading, Forex, Azioni, Materie Prime, Indici, Asset Excent Capital, Strumenti Finanziari, Opzioni di Investimento, Mercati di Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/leva-excent-capital/": {
            lang: "it",
            title: "Leva Finanziaria Offerta da Excent Capital",
            description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
            keywords: "Trading con Leva, Trading a Leva, Leva Excent Capital, Trading con Margine, Opzioni di Leva, Amplificare il Trading, Leva Forex, Trading Responsabile",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/leva-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/leva-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/micro-lotti-excent-capital/": {
            lang: "it",
            title: "Micro Lotti su Excent Capital",
            description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
            keywords: "Trading con Micro Lotti, Micro Lotti Excent Capital, Trading con Lotti Piccoli, Trading per Principianti, Gestione del Rischio, Trading Flessibile, Micro Lotti Forex, Trading a Bassa Esposizione",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/micro-lotti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/micro-lotti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/orari-di-trading/": {
            lang: "it",
            title: "Orari di Trading",
            description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
            keywords: "Orari di Trading, Orari di Mercato, Orari Forex, Orari Mercato Azionario, Calendario Excent Capital, Sessioni di Trading, Tempi di Trading, Orari Mercati Finanziari",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/orari-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.dev.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/orari-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-di-trading/": {
            lang: "it",
            title: "Strumenti di Trading",
            description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
            keywords: "Strumenti di Trading, Strumenti di Analisi di Mercato, Calcolatori di Trading, Strumenti Forex, Piattaforma Excent Capital, Risorse per il Trading, Strumenti di Analisi Grafica, Trading Informato",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "it/trading/strumenti-di-trading-acuity/": {
            lang: "it",
            title: "Strumenti Acuity per il Trading",
            description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
            keywords: "Strumenti Acuity per il Trading, Strumenti di Trading AI, Analisi del Sentiment di Mercato, Approfondimenti di Mercato in Tempo Reale, Strumenti Excent Capital, Approfondimenti Acuity, Trading Intelligente, Analisi di Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "it/trading/chiamate-di-margine/": {
            lang: "it",
            title: "Chiamate di Margine",
            description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
            keywords: "Chiamate di Margine, Cos’è una Chiamata di Margine, Margine Excent Capital, Margine di Trading, Liquidazione Forzata, Protezione dell’Account, Trading con Margine, Gestione del Rischio",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/chiamate-di-margine",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.dev.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.dev.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/chiamate-di-margine",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/trading-di-cfd/": {
            lang: "it",
            title: "Trading CFD",
            description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
            keywords: "Trading CFD, Contratti per Differenza, Fare Trading con i CFD, CFD Excent Capital, Trading con Leva, Trading di Derivati, Mercati CFD, Come Fare Trading con i CFD",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/trading-di-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.dev.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/trading-di-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/ordini-pendenti/": {
            lang: "it",
            title: "Ordini Pendenti",
            description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
            keywords: "Ordini Pendenti, Ordini di Trading, Buy Stop, Sell Stop, Ordini Limit, Trading Automatizzato, Ordini Excent Capital, Punti di Ingresso, Strategia di Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/ordini-pendenti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.dev.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.dev.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/ordini-pendenti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/spreads-offerti/": {
            lang: "it",
            title: "Spread Offerti",
            description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
            keywords: "Spread, Spread di Volatilità, Mercati Finanziari, Spread di Trading, Ridurre i Costi di Trading, Ottimizzare la Redditività, Strategie di Trading, Analisi degli Spread, Spread Forex, Spread Azionari",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/spreads-offerti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/spreads-offerti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/valute-di-base/": {
            lang: "it",
            title: "Valute di Base",
            description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
            keywords: "Valute di Base, Valute Supportate, Conto Excent Capital, Opzioni di Valuta del Conto, Selezione della Valuta, Valuta di Trading, Valuta Base Forex, Opzioni di Finanziamento",
            canonical: "https://knowledgebase.dev.excent.capital/it/trading/valute-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.dev.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.dev.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                url: "https://knowledgebase.dev.excent.capital/it/trading/valute-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/risorse/dentro-dei-risorse/": {
            lang: "it",
            title: "Risorse Interne: Cosa Scoprirai",
            description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Aggiornamenti di Mercato, Calendario Economico, Formazione al Trading, Centro Risorse, Impara a Fare Trading, Materiali di Supporto al Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/risorse/dentro-dei-risorse",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                url: "https://knowledgebase.dev.excent.capital/it/risorse/dentro-dei-risorse",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-di-base/": {
            lang: "it",
            title: "Concetti di Base",
            description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
            keywords: "Concetti Base di Trading, Trading per Principianti, Basi di Mercato, Formazione Excent Capital, Terminologia del Trading, Guida per Principianti, Imparare il Trading, Concetti Fondamentali",
            canonical: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-avanzati/": {
            lang: "it",
            title: "Concetti Avanzati",
            description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
            keywords: "Concetti Avanzati di Trading, Strategie di Trading, Indicatori Tecnici, Trading Esperto, Formazione Excent Capital, Analisi di Mercato, Strumenti per Trader Professionisti, Tecniche di Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-avanzati",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                url: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-avanzati",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/risorse-addizionali/": {
            lang: "it",
            title: "Risorse Aggiuntive",
            description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Glossario dei Termini, Guide alla Piattaforma, Aiuto Trading, Strumenti di Mercato, Risorse Educative, Supporto al Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/risorse/risorse-addizionali",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                url: "https://knowledgebase.dev.excent.capital/it/risorse/risorse-addizionali",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/il-mio-conto/dentro-del-mio-conto/": {
            lang: "it",
            title: "Dentro il Mio Account: Cosa Scoprirai",
            description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
            keywords: "Il Mio Account, Gestione Account, Profilo Excent Capital, Impostazioni Account Trading, Sicurezza Account, Dashboard Utente, Aggiornamento Profilo, Gestire Account Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-demo/": {
            lang: "it",
            title: "Posso Creare un Account Demo?",
            description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
            keywords: "Account Demo, Trading di Prova, Demo Excent Capital, Trading Senza Rischi, Creare Account Demo, Simulatore di Trading, Trading per Principianti, Impara a Fare Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-reale/": {
            lang: "it",
            title: "Come Creare un Account Reale?",
            description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
            keywords: "Account Reale, Creare Account di Trading, Registrazione Excent Capital, Apri Account Reale, Inizia a Fare Trading, Account di Trading Reale, Iscrizione al Trading, Configurazione Account",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-reale",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/perche-verificare-il-conto/": {
            lang: "it",
            title: "Perché Verificare il Tuo Account?",
            description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
            keywords: "Verifica Account, Verificare Account di Trading, KYC Excent Capital, Sicurezza del Trading, Processo di Conformità, Verifica Identità, Trading Sicuro, Accesso Completo Account",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/accedere-alla-piattaforma/": {
            lang: "it",
            title: "Come Accedere alla Piattaforma?",
            description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
            keywords: "Accedere alla Piattaforma di Trading, Login Excent Capital, App di Trading, Piattaforma Web di Trading, Trading Mobile, Come Effettuare il Login, Inizia a Fare Trading, Guida Accesso Piattaforma",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/tempo-per-creare-un-conto/": {
            lang: "it",
            title: "Quanto Tempo Ci Vuole per Creare un Account?",
            description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
            keywords: "Tempo Creazione Account, Iscrizione Excent Capital, Come Creare un Account, Configurazione Account di Trading, Processo di Registrazione, Apri un Account Velocemente, Onboarding Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conti-corporativi/": {
            lang: "it",
            title: "Offrite Account Aziendali?",
            description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
            keywords: "Account di Trading Aziendale, Account Business, Corporate Excent Capital, Trading Istituzionale, Apri Account Aziendale, Trading per Aziende, Account Investimenti Aziendali",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conti-corporativi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conti-corporativi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/piu-conti-stessa-email/": {
            lang: "it",
            title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
            description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
            keywords: "Più Account, Account con Stessa Email, Ruoli Excent Capital, Ruoli Utente, Gestione Account, Accesso Account Trading, Accesso Basato su Ruoli, Politica di Registrazione Email",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/aggiornare-informazioni-del-conto/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/password-dimenticata/": {
            lang: "it",
            title: "Cosa Succede se Dimentico la Password?",
            description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
            keywords: "Password Dimenticata, Recupero Password, Reimposta Password Trading, Aiuto Accesso Excent Capital, Accesso Account, Recuperare Password, Password Persa, Login Account Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/password-dimenticata",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/password-dimenticata",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/documenti-per-verifica/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/documenti-per-verifica",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/documenti-per-verifica",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conto-utilizzato-da-terzi/": {
            lang: "it",
            title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
            description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
            keywords: "Condivisione Account, Politica Excent Capital, Uso Personale Account, Sicurezza Account Trading, Accesso Condiviso, Uso da Parte della Famiglia, Sicurezza Account, Conformità nel Trading",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/cancellare-il-conto/": {
            lang: "it",
            title: "Come Posso Cancellare il Mio Account?",
            description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
            keywords: "Cancellare Account Trading, Chiudere Account Excent Capital, Terminazione Account, Eliminare Account, Chiusura Account Trading, Disattivazione Account, Supporto Excent Capital, Processo di Cancellazione Account",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/cancellare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/cancellare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/verificare-conto-dall-estero/": {
            lang: "it",
            title: "Posso Verificare il Mio Account da un Paese Straniero?",
            description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
            keywords: "Verificare Account dall’Estero, Verifica Excent Capital, Configurazione Account da Paese Straniero, KYC Internazionale, Verifica Remota Account, Documenti Account, Verifica Estera",
            canonical: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                url: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/depositi-prelievi/dentro-depositi-prelievi/": {
            lang: "it",
            title: "Scopri Depositi e Prelievi: Cosa Troverai",
            description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
            keywords: "Depositi e Prelievi, Finanziamento Excent Capital, Prelevare Profitti, Metodi di Pagamento, Opzioni di Deposito, Tempi di Prelievo, Finanziamento Conto Trading, Transazioni Finanziarie",
            canonical: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                url: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/primo-deposito/": {
            lang: "it",
            title: "Come Effettuare un Primo Deposito?",
            description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
            keywords: "Primo Deposito, Effettuare un Deposito, Finanziamento Excent Capital, Deposito Conto Trading, Come Depositare, Metodi di Pagamento, Inizia a Fare Trading, Finanzia il Tuo Conto",
            canonical: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/primo-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/primo-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-deposito/": {
            lang: "it",
            title: "Come Effettuare un Deposito?",
            description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
            keywords: "Deposita Fondi, Come Depositare, Metodi di Pagamento Excent Capital, Finanziamento Conto Trading, Effettuare un Deposito, Deposito Sicuro, Ricarica Account, Processo di Deposito",
            canonical: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                url: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-prelievo/": {
            lang: "it",
            title: "Come Posso Effettuare un Prelievo?",
            description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
            keywords: "Preleva Fondi, Prelievo Excent Capital, Come Prelevare, Pagamento Conto Trading, Processo di Prelievo, Prelievo Sicuro, Accedere ai Guadagni, Metodi di Pagamento",
            canonical: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                url: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/prelievo-non-riuscito/": {
            lang: "it",
            title: "Cosa Fare se il Mio Prelievo Fallisce?",
            description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
            keywords: "Prelievo Fallito, Aiuto Excent Capital, Transazione Fallita, Risoluzione Problema Prelievo, Problemi di Prelievo, Errore di Pagamento, Supporto Conto Trading, Correggere Problema di Prelievo",
            canonical: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                url: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/paiements/a-linterieur-des-paiements/": {
            lang: "it",
            title: "Scopri i Pagamenti: Cosa Troverai",
            description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
            keywords: "Pagamenti Excent Capital, Metodi di Pagamento Accettati, Gestione Transazioni, Tempo di Elaborazione Pagamenti, Valute Supportate, Pagamenti di Trading, Opzioni di Deposito e Prelievo, Finanziamento Conto",
            canonical: "https://knowledgebase.dev.excent.capital/it/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.dev.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                url: "https://knowledgebase.dev.excent.capital/it/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/voir-historique-paiements/": {
            lang: "it",
            title: "Come Vedo lo Storico dei Pagamenti?",
            description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
            keywords: "Storico Pagamenti, Storico Transazioni, Visualizza Depositi, Visualizza Prelievi, Pagamenti Excent Capital, Transazioni Conto, Storico Conto Trading, Registrazioni Finanziarie",
            canonical: "https://knowledgebase.dev.excent.capital/it/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.dev.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                url: "https://knowledgebase.dev.excent.capital/it/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/delai-de-transaction/": {
            lang: "it",
            title: "Quanto Può Durare una Transazione?",
            description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
            keywords: "Tempo Transazione, Tempo di Elaborazione, Durata Deposito, Durata Prelievo, Pagamenti Excent Capital, Velocità di Pagamento, Transazioni Conto Trading, Ritardi nelle Transazioni",
            canonical: "https://knowledgebase.dev.excent.capital/it/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.dev.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                url: "https://knowledgebase.dev.excent.capital/it/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Cantones
        //Italiano
        "zh/": {
            lang: "zh-HK",
            title: "知識庫 | Excent Capital",
            description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
            keywords: "Excent Capital 幫助中心, 交易平台支援, 交易常見問題, 如何交易, 外匯教學, 帳戶管理, 交易指南, 存款協助, 提款協助",
            canonical: "https://knowledgebase.dev.excent.capital/zh/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en",
                es: "https://knowledgebase.dev.excent.capital/es",
                pt: "https://knowledgebase.dev.excent.capital/pt",
                fr: "https://knowledgebase.dev.excent.capital/fr",
                it: "https://knowledgebase.dev.excent.capital/it",
                zh: "https://knowledgebase.dev.excent.capital/zh",
            },
            openGraph: {
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                url: "https://knowledgebase.dev.excent.capital/zh/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/inside-about-us-zh/": {
            lang: "zh-HK",
            title: "關於我們：你將發現什麼",
            description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
            keywords: "關於 Excent Capital, 公司使命, 交易公司價值觀, 認識團隊, 誰是 Excent Capital, 我們的故事, 金融服務公司, Excent Capital 概覽",
            canonical: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/inside-about-us-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/inside-about-us-zh",
            },
            openGraph: {
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                url: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/inside-about-us-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/about-excent-capital-zh/": {
            lang: "zh-HK",
            title: "關於 Excent Capital",
            description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
            keywords: "Excent Capital, 關於我們, 公司概況, 交易公司, 金融服務, 交易機構, 我們的使命, 我們是誰, 全球交易支援",
            canonical: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            },
            openGraph: {
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                url: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/about-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/build-your-portfolio-zh/": {
            lang: "zh-HK",
            title: "建立您的投資組合：Excent Capital 的多樣化選擇",
            description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
            keywords: "建立投資組合, 交易工具, 外匯交易, 股市, 指數交易, 商品交易, 多元化投資組合, Excent Capital 資產",
            canonical: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            },
            openGraph: {
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                url: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-your-trusted-partner-zh/": {
            lang: "zh-HK",
            title: "Excent Capital：助您分散國際市場投資的可信伙伴",
            description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
            keywords: "Excent Capital, 國際投資, 分散投資組合, 全球市場, 可信交易伙伴, 外匯交易, 國際交易平台, 投資機會",
            canonical: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            },
            openGraph: {
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                url: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-education-center-zh/": {
            lang: "zh-HK",
            title: "提升你的交易能力：Excent Capital 教育中心",
            description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
            keywords: "交易教育, 學習交易, 交易教學, 交易課程, Excent Capital 教育, 初學者交易指南, 高級交易策略, 交易資源",
            canonical: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            },
            openGraph: {
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                url: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/invest-with-confidence-zh/": {
            lang: "zh-HK",
            title: "自信投資：Excent Capital 的風險管理策略與工具",
            description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
            keywords: "風險管理, 交易風險工具, 投資保護, Excent Capital 策略, 自信交易, 市場波動性, 交易工具, 管理交易風險",
            canonical: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.dev.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.dev.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.dev.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.dev.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            },
            openGraph: {
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                url: "https://knowledgebase.dev.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/trading-zh/inside-trading-zh/": {
            lang: "zh-HK",
            title: "交易內幕：你將發現的內容",
            description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
            keywords: "交易指南, 市場見解, 交易概念, 如何交易, Excent Capital 平台, 交易功能, 學習交易, 交易知識庫",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/inside-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/inside-trading-zh",
            },
            openGraph: {
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/inside-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/instruments-in-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的交易工具",
            description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
            keywords: "交易工具, 外匯, 股票, 商品, 指數, Excent Capital 資產, 金融工具, 投資選項, 交易市場",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/leverage-offered-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的槓桿",
            description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
            keywords: "槓桿交易, 使用槓桿進行交易, Excent Capital 槓桿, 保證金交易, 槓桿選項, 放大交易, 外匯槓桿, 負責任交易",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/micro-lots-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 的微型手數交易",
            description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
            keywords: "微型手數交易, Excent Capital 微型手數, 小手數交易, 初學者交易, 風險管理, 靈活交易, 外匯微型手數, 低風險交易",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.dev.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.dev.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-hours-zh/": {
            lang: "zh-HK",
            title: "交易時間",
            description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
            keywords: "交易時間, 市場開市時間, 外匯交易時間, 股票市場時間, Excent Capital 時間表, 交易時段, 交易時機, 金融市場時間",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/trading-hours-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.dev.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/trading-hours-zh",
            },
            openGraph: {
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/trading-hours-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-tools-zh/": {
            lang: "zh-HK",
            title: "交易工具",
            description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
            keywords: "交易工具, 市場分析工具, 交易計算機, 外匯工具, Excent Capital 平台, 交易資源, 繪圖工具, 明智交易",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/trading-tools-zh",
            },
            openGraph: {
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "zh/trading-zh/acuity-trading-tools-zh/": {
            lang: "zh-HK",
            title: "Acuity 交易工具",
            description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
            keywords: "Acuity 交易工具, AI 交易工具, 市場情緒分析, 即時市場洞察, Excent Capital 工具, Acuity 洞察, 智能交易, 交易分析",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.dev.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.dev.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            },
            openGraph: {
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "zh/trading-zh/margin-calls-zh/": {
            lang: "zh-HK",
            title: "追加保證金通知（Margin Calls）",
            description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
            keywords: "追加保證金通知, 什麼是追加保證金, Excent Capital 保證金, 交易保證金, 強制平倉, 帳戶保護, 保證金交易, 風險管理",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/margin-calls-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.dev.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.dev.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/margin-calls-zh",
            },
            openGraph: {
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/margin-calls-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/cfd-trading-zh/": {
            lang: "zh-HK",
            title: "差價合約（CFD）交易",
            description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
            keywords: "CFD 交易, 差價合約, 交易 CFD, Excent Capital CFD, 槓桿交易, 衍生工具交易, CFD 市場, 如何交易 CFD",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/cfd-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.dev.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.dev.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/cfd-trading-zh",
            },
            openGraph: {
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/cfd-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/pending-orders-zh/": {
            lang: "zh-HK",
            title: "掛單交易（Pending Orders）",
            description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
            keywords: "掛單交易, 交易指令, 買入止損, 賣出止損, 限價單, 自動化交易, Excent Capital 指令, 入市點, 交易策略",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/pending-orders-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.dev.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.dev.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/pending-orders-zh",
            },
            openGraph: {
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/pending-orders-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/spreads-offered-zh/": {
            lang: "zh-HK",
            title: "點差介紹",
            description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
            keywords: "點差, 波動點差, 金融市場, 交易點差, 降低交易成本, 提高盈利能力, 交易策略, 點差分析, 外匯點差, 股票市場點差",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/spreads-offered-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.dev.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.dev.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/spreads-offered-zh",
            },
            openGraph: {
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/spreads-offered-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/base-currencies-zh/": {
            lang: "zh-HK",
            title: "基礎貨幣",
            description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
            keywords: "基礎貨幣, 支援貨幣, Excent Capital 帳戶, 帳戶貨幣選項, 貨幣選擇, 交易貨幣, 外匯基礎貨幣, 資金選項",
            canonical: "https://knowledgebase.dev.excent.capital/zh/trading-zh/base-currencies-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.dev.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.dev.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.dev.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.dev.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.dev.excent.capital/zh/trading-zh/base-currencies-zh",
            },
            openGraph: {
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                url: "https://knowledgebase.dev.excent.capital/zh/trading-zh/base-currencies-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/resources-zh/inside-resources-zh/": {
            lang: "zh-HK",
            title: "資源中心導覽",
            description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
            keywords: "交易資源, Excent Capital 工具, 市場更新, 經濟日曆, 交易教學, 資源中心, 學習交易, 交易輔助材料",
            canonical: "https://knowledgebase.dev.excent.capital/zh/resources-zh/inside-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.dev.excent.capital/zh/resources-zh/inside-resources-zh",
            },
            openGraph: {
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                url: "https://knowledgebase.dev.excent.capital/zh/resources-zh/inside-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/basic-concepts-zh/": {
            lang: "zh-HK",
            title: "基礎概念",
            description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
            keywords: "交易基礎概念, 初學者交易, 市場基礎知識, Excent Capital 教育, 交易術語, 初學者指南, 學習交易, 基礎知識",
            canonical: "https://knowledgebase.dev.excent.capital/zh/resources-zh/basic-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.dev.excent.capital/zh/resources-zh/basic-concepts-zh",
            },
            openGraph: {
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                url: "https://knowledgebase.dev.excent.capital/zh/resources-zh/basic-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/advanced-concepts-zh/": {
            lang: "zh-HK",
            title: "進階概念",
            description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
            keywords: "進階交易概念, 交易策略, 技術指標, 專業交易, Excent Capital 教育, 市場分析, 專業交易工具, 交易技巧",
            canonical: "https://knowledgebase.dev.excent.capital/zh/resources-zh/advanced-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.dev.excent.capital/zh/resources-zh/advanced-concepts-zh",
            },
            openGraph: {
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                url: "https://knowledgebase.dev.excent.capital/zh/resources-zh/advanced-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/additional-resources-zh/": {
            lang: "zh-HK",
            title: "額外資源",
            description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
            keywords: "交易資源, Excent Capital 工具, 詞彙表, 平台指南, 交易協助, 市場工具, 教育資源, 交易支援",
            canonical: "https://knowledgebase.dev.excent.capital/zh/resources-zh/additional-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.dev.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.dev.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.dev.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.dev.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.dev.excent.capital/zh/resources-zh/additional-resources-zh",
            },
            openGraph: {
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                url: "https://knowledgebase.dev.excent.capital/zh/resources-zh/additional-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/my-account-zh/inside-my-account-zh/": {
            lang: "zh-HK",
            title: "我的帳戶導覽",
            description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
            keywords: "我的帳戶, 帳戶管理, Excent Capital 個人資料, 交易帳戶設定, 帳戶安全, 使用者儀表板, 資料更新, 管理交易帳戶",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/inside-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/inside-my-account-zh",
            },
            openGraph: {
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/inside-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-to-create-a-demo-account-zh/": {
            lang: "zh-HK",
            title: "我可以開設模擬帳戶嗎？",
            description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
            keywords: "模擬帳戶, 練習交易, Excent Capital 模擬, 無風險交易, 建立模擬帳戶, 交易模擬器, 初學者交易, 學習交易",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            },
            openGraph: {
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-to-create-a-live-account-zh/": {
            lang: "zh-HK",
            title: "如何開立真實帳戶？",
            description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
            keywords: "真實帳戶, 建立交易帳戶, Excent Capital 註冊, 開立真實帳戶, 開始交易, 真實交易帳戶, 交易註冊, 帳戶設置",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            },
            openGraph: {
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/why-verify-your-account-zh/": {
            lang: "zh-HK",
            title: "為什麼要驗證你的帳戶？",
            description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
            keywords: "帳戶驗證, 驗證交易帳戶, Excent Capital KYC, 交易安全, 合規程序, 身份驗證, 安全交易, 完整帳戶訪問",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            },
            openGraph: {
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-access-the-platform-zh/": {
            lang: "zh-HK",
            title: "如何登入平台？",
            description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
            keywords: "登入交易平台, Excent Capital 登入, 交易應用程式, 網絡交易平台, 手機交易, 如何登入, 開始交易, 平台訪問指南",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            },
            openGraph: {
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh/": {
            lang: "zh-HK",
            title: "開立帳戶需時多久？",
            description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
            keywords: "帳戶建立時間, Excent Capital 註冊, 如何開立帳戶, 交易帳戶設置, 註冊流程, 快速開戶, 交易入門",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            },
            openGraph: {
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/do-you-offer-corporate-accounts-zh/": {
            lang: "zh-HK",
            title: "是否提供企業帳戶？",
            description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
            keywords: "企業交易帳戶, 商業帳戶, Excent Capital 企業服務, 機構交易, 開設企業帳戶, 公司交易, 商業投資帳戶",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            },
            openGraph: {
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-open-multiple-accounts-zh/": {
            lang: "zh-HK",
            title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
            description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
            keywords: "多個帳戶, 相同電郵帳戶, Excent Capital 角色, 使用者角色, 帳戶管理, 交易帳戶存取, 角色型訪問, 電郵註冊政策",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            },
            openGraph: {
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-update-my-account-information-zh/": {
            lang: "zh-HK",
            title: "如何更新我的帳戶資料？",
            description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 修改帳戶資訊, 更新交易檔案, 使用者資訊",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            },
            openGraph: {
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-happens-if-i-forget-my-password-zh/": {
            lang: "zh-HK",
            title: "如果我忘記密碼會發生什麼事？",
            description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
            keywords: "忘記密碼, 密碼恢復, 重設交易密碼, Excent Capital 登入幫助, 帳戶存取, 找回密碼, 密碼遺失, 交易帳戶登入",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            },
            openGraph: {
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-documents-are-required-for-account-verification-zh/": {
            lang: "zh-HK",
            title: "我如何更新我的帳戶資料？",
            description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 更改帳戶資料, 更新交易資料, 用戶資訊",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            },
            openGraph: {
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh/": {
            lang: "zh-HK",
            title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
            description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
            keywords: "共用帳戶, Excent Capital 政策, 個人帳戶使用, 交易帳戶安全, 帳戶共享, 家人使用帳戶, 帳戶安全, 交易合規",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            },
            openGraph: {
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-cancel-my-account-zh/": {
            lang: "zh-HK",
            title: "我如何取消我的帳戶",
            description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
            keywords: "取消交易帳戶, 關閉 Excent Capital 帳戶, 帳戶終止, 刪除帳戶, 結束帳戶, Excent Capital 支援, 帳戶取消程序",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            },
            openGraph: {
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh/": {
            lang: "zh-HK",
            title: "我可以從外國驗證我的帳戶嗎？",
            description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
            keywords: "海外驗證帳戶, Excent Capital 驗證, 外國帳戶設定, 國際 KYC, 遠程帳戶驗證, 驗證文件, 海外驗證",
            canonical: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.dev.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.dev.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.dev.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.dev.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            },
            openGraph: {
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                url: "https://knowledgebase.dev.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh/": {
            lang: "zh-HK",
            title: "存款與提款：你將會發現什麼",
            description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
            keywords: "存款與提款, Excent Capital 資金, 提取利潤, 付款方式, 存款選項, 提款時間, 交易帳戶資金, 金融交易",
            canonical: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            },
            openGraph: {
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                url: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行首次存款？",
            description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
            keywords: "首次存款, 進行存款, Excent Capital 資金, 交易帳戶存款, 如何存款, 付款方式, 開始交易, 帳戶注資",
            canonical: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            },
            openGraph: {
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                url: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行存款？",
            description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
            keywords: "資金存入, 如何存款, Excent Capital 付款方式, 交易帳戶資金, 進行存款, 安全存款, 帳戶充值, 存款流程",
            canonical: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            },
            openGraph: {
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                url: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh/": {
            lang: "zh-HK",
            title: "我如何提取資金？",
            description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
            keywords: "提取資金, Excent Capital 提款, 如何提款, 交易帳戶提現, 提款流程, 安全提款, 提取收益, 付款方式",
            canonical: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            },
            openGraph: {
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                url: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh/": {
            lang: "zh-HK",
            title: "如果提款失敗，我應該怎麼辦？",
            description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
            keywords: "提款失敗, Excent Capital 幫助, 交易失敗, 排解提款問題, 提款錯誤, 付款失誤, 交易帳戶支援, 解決提款問題",
            canonical: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.dev.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.dev.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.dev.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.dev.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            },
            openGraph: {
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                url: "https://knowledgebase.dev.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/payments-zh/inside-payments-zh/": {
            lang: "zh-HK",
            title: "付款詳情：你將會發現什麼",
            description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
            keywords: "Excent Capital 付款, 可接受的付款方式, 交易管理, 付款處理時間, 支援貨幣, 交易付款, 存款與提款選項, 帳戶注資",
            canonical: "https://knowledgebase.dev.excent.capital/zh/payments-zh/inside-payments-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.dev.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.dev.excent.capital/zh/payments-zh/inside-payments-zh",
            },
            openGraph: {
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                url: "https://knowledgebase.dev.excent.capital/zh/payments-zh/inside-payments-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-do-i-see-my-payment-history-zh/": {
            lang: "zh-HK",
            title: "我如何查看我的付款記錄？",
            description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
            keywords: "付款記錄, 交易歷史, 查看存款, 查看提款, Excent Capital 付款, 帳戶交易, 交易帳戶記錄, 財務紀錄",
            canonical: "https://knowledgebase.dev.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.dev.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.dev.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            },
            openGraph: {
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                url: "https://knowledgebase.dev.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-long-can-a-transaction-take-zh/": {
            lang: "zh-HK",
            title: "一筆交易需要多長時間？",
            description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
            keywords: "交易時間, 處理時間, 存款所需時間, 提款所需時間, Excent Capital 付款, 付款速度, 交易帳戶處理, 交易延誤",
            canonical: "https://knowledgebase.dev.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.dev.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.dev.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.dev.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.dev.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.dev.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.dev.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            },
            openGraph: {
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                url: "https://knowledgebase.dev.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
    },
    "knowledgebase.test.excent.capital": {
        // English 
        "/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.test.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en",
                es: "https://knowledgebase.test.excent.capital/es",
                pt: "https://knowledgebase.test.excent.capital/pt",
                fr: "https://knowledgebase.test.excent.capital/fr",
                it: "https://knowledgebase.test.excent.capital/it",
                zh: "https://knowledgebase.test.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.test.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.test.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en",
                es: "https://knowledgebase.test.excent.capital/es",
                pt: "https://knowledgebase.test.excent.capital/pt",
                fr: "https://knowledgebase.test.excent.capital/fr",
                it: "https://knowledgebase.test.excent.capital/it",
                zh: "https://knowledgebase.test.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.test.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/inside-about-us/": {
            lang: "en",
            title: "Inside About Us: What You'll Discover",
            description:
                "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
            keywords: "About Excent Capital, Company Mission, Trading Company Values, Meet the Team, Who is Excent Capital, Our Story, Financial Services Company, Excent Capital Overview",
            canonical: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                url: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/about-excent-capital/": {
            lang: "en",
            title: "About Excent Capital",
            description:
                "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
            keywords: "Excent Capital, About Us, Company Overview, Trading Company, Financial Services, Trading Firm, Our Mission, Who We Are, Global Trading Support",
            canonical: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                url: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/build-your-portfolio/": {
            lang: "en",
            title: "Build Your Portfolio: Diverse Options on Excent Capital",
            description:
                "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
            keywords: "Build Portfolio, Trading Instruments, Forex Trading, Stock Market, Indices Trading, Commodities Trading, Diversified Portfolio, Excent Capital Assets",
            canonical: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                url: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-your-trusted-partner/": {
            lang: "en",
            title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
            description:
                "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
            keywords: "Excent Capital, International Investments, Diversify Portfolio, Global Markets, Trusted Trading Partner, Forex Trading, International Trading Platform, Investment Opportunities",

            canonical: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                url: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-education-center/": {
            lang: "en",
            title: "Level Up Your Trading: Excent Capital's Education Center",
            description:
                "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
            keywords: "Trading Education, Learn to Trade, Trading Tutorials, Trading Courses, Excent Capital Education, Beginner Trading Guide, Advanced Trading Strategies, Trading Resources",

            canonical: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                url: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/invest-with-confidence/": {
            lang: "en",
            title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
            description:
                "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
            keywords: "Risk Management, Trading Risk Tools, Investment Protection, Excent Capital Strategies, Confident Trading, Market Volatility, Trading Tools, Manage Risk in Trading",

            canonical: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                url: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/inside-trading/": {
            lang: "en",
            title: "Inside Trading: What You'll Discover",
            description:
                "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
            keywords: "Trading Guide, Market Insights, Trading Concepts, How to Trade, Excent Capital Platform, Trading Features, Learn Trading, Trading Knowledge Base",

            canonical: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                url: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/instruments-in-excent-capital/": {
            lang: "en",
            title: "Instruments in Excent Capital",
            description:
                "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
            keywords: "Trading Instruments, Forex, Stocks, Commodities, Indices, Excent Capital Assets, Financial Instruments, Investment Options, Trade Markets",

            canonical: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                url: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/leverage-offered-at-excent-capital/": {
            lang: "en",
            title: "Leverage Offered at Excent Capital",
            description:
                "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
            keywords: "Leverage Trading, Trading with Leverage, Excent Capital Leverage, Margin Trading, Leverage Options, Amplify Trading, Forex Leverage, Responsible Trading",

            canonical: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                url: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/micro-lots-at-excent-capital/": {
            lang: "en",
            title: "Micro Lots at Excent Capital",
            description:
                "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
            keywords: "Micro Lots Trading, Excent Capital Micro Lots, Small Lot Trading, Beginner Trading, Risk Management, Flexible Trading, Forex Micro Lots, Low Exposure Trading",

            canonical: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                url: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-hours/": {
            lang: "en",
            title: "Trading Hours",
            description:
                "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
            keywords: "Trading Hours, Market Hours, Forex Trading Times, Stock Market Hours, Excent Capital Schedule, Trading Sessions, Trading Times, Financial Market Hours",

            canonical: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                url: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-tools/": {
            lang: "en",
            title: "Trading Tools",
            description:
                "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
            keywords: "Trading Tools, Market Analysis Tools, Trading Calculators, Forex Tools, Excent Capital Platform, Trading Resources, Charting Tools, Informed Trading",

            canonical: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                url: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "en/trading/acuity-trading-tools/": {
            lang: "en",
            title: "Acuity Trading Tools",
            description:
                "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
            keywords: "Acuity Trading Tools, AI Trading Tools, Market Sentiment Analysis, Real-Time Market Insights, Excent Capital Tools, Acuity Insights, Smart Trading, Trading Analytics",

            canonical: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                url: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "en/trading/margin-calls/": {
            lang: "en",
            title: "Margin Calls",
            description:
                "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
            keywords: "Margin Calls, What is a Margin Call, Excent Capital Margin, Trading Margin, Forced Liquidation, Account Protection, Margin Trading, Risk Management",
            canonical: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                url: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/cfd-trading/": {
            lang: "en",
            title: "CFD Trading",
            description:
                "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
            keywords: "CFD Trading, Contracts for Difference, Trade CFDs, Excent Capital CFDs, Leverage Trading, Derivatives Trading, CFD Markets, How to Trade CFDs",
            canonical: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                url: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/pending-orders/": {
            lang: "en",
            title: "Pending Orders",
            description:
                "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
            keywords: "Pending Orders, Trading Orders, Buy Stop, Sell Stop, Limit Orders, Automated Trading, Excent Capital Orders, Entry Points, Trading Strategy",
            canonical: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                url: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/spreads-offered/": {
            lang: "en",
            title: "Spreads Offered",
            description:
                "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                url: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/base-currencies/": {
            lang: "en",
            title: "Base Currencies",
            description:
                "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
            keywords: "Base Currencies, Supported Currencies, Excent Capital Account, Account Currency Options, Currency Selection, Trading Currency, Forex Base Currency, Funding Options",
            canonical: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                url: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/inside-resources/": {
            lang: "en",
            title: "Inside Resources: What You'll Discover",
            description:
                "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
            keywords: "Trading Resources, Excent Capital Tools, Market Updates, Economic Calendar, Trading Education, Resource Center, Learn to Trade, Trading Support Materials",
            canonical: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                url: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/basic-concepts/": {
            lang: "en",
            title: "Basic Concepts",
            description:
                "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
            keywords: "Basic Trading Concepts, Trading for Beginners, Market Basics, Excent Capital Education, Trading Terminology, Beginner Guide, Learn Trading, Fundamental Concepts",
            canonical: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                url: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/advanced-concepts/": {
            lang: "en",
            title: "Advanced Concepts",
            description:
                "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
            keywords: "Advanced Trading Concepts, Trading Strategies, Technical Indicators, Expert Trading, Excent Capital Education, Market Analysis, Pro Trader Tools, Trading Techniques",
            canonical: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                url: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/additional-resources/": {
            lang: "en",
            title: "Additional Resources",
            description:
                "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
            keywords: "Trading Resources, Excent Capital Tools, Glossary of Terms, Platform Guides, Trading Help, Market Tools, Educational Resources, Trading Support",
            canonical: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                url: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/inside-my-account/": {
            lang: "en",
            title: "Inside My Account: What You'll Discover",
            description:
                "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
            keywords: "My Account, Account Management, Excent Capital Profile, Trading Account Settings, Account Security, User Dashboard, Profile Updates, Manage Trading Account",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-to-create-a-demo-account/": {
            lang: "en",
            title: "Can I Create a Demo Account?",
            description:
                "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
            keywords: "Demo Account, Practice Trading, Excent Capital Demo, Risk-Free Trading, Create Demo Account, Trading Simulator, Beginner Trading, Learn to Trade",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-to-create-a-live-account/": {
            lang: "en",
            title: "How to Create a Live Account?",
            description:
                "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
            keywords: "Live Account, Create Trading Account, Excent Capital Registration, Open Live Account, Start Trading, Real Trading Account, Trading Signup, Account Setup",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/why-verify-your-account/": {
            lang: "en",
            title: "Why Verify Your Account?",
            description:
                "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
            keywords: "Account Verification, Verify Trading Account, Excent Capital KYC, Trading Security, Compliance Process, Identity Verification, Secure Trading, Full Account Access",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account.how-do-i-access-the-platform/": {
            lang: "en",
            title: "How Do I Access the Platform?",
            description:
                "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
            keywords: "Access Trading Platform, Excent Capital Login, Trading App, Web Trading Platform, Mobile Trading, How to Log In, Start Trading, Platform Access Guide",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                url: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-long-does-it-take-to-create-an-account/": {
            lang: "en",
            title: "How Long Does it Take to Create an Account?",
            description:
                "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
            keywords: "Account Creation Time, Excent Capital Signup, How to Create Account, Trading Account Setup, Registration Process, Open Account Fast, Trading Onboarding",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/do-you-offer-corporate-accounts/": {
            lang: "en",
            title: "Do You Offer Corporate Accounts?",
            description:
                "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
            keywords: "Corporate Trading Account, Business Account, Excent Capital Corporate, Institutional Trading, Open Corporate Account, Company Trading, Business Investment Account",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-open-multiple-accounts/": {
            lang: "en",
            title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
            description:
                "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
            keywords: "Multiple Accounts, Same Email Accounts, Excent Capital Roles, User Roles, Account Management, Trading Account Access, Role-Based Access, Email Registration Policy",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-update-my-account-information/": {
            lang: "en",
            title: "How Do I Update My Account Information?",
            description:
                "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
            keywords: "Update Account Info, Edit Personal Details, Excent Capital Profile, Account Settings, Change Account Information, Trading Profile Update, User Information",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-happens-if-i-forget-my-password/": {
            lang: "en",
            title: "What Happens If I Forget My Password?",
            description:
                "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
            keywords: "Forgot Password, Password Recovery, Reset Trading Password, Excent Capital Login Help, Account Access, Recover Password, Lost Password, Trading Account Login",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-documents-are-required-for-account-verification/": {
            lang: "en",
            title: "What Documents Are Required for Account Verification?",
            description:
                "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
            keywords: "Account Verification Documents, KYC Requirements, Excent Capital Verification, Proof of Identity, Proof of Address, Upload Documents, Secure Verification, Trading Compliance",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-my-friends-or-family-use-my-excent-capital-account/": {
            lang: "en",
            title: "Can My Friends or Family Use My Excent Capital Account?",
            description:
                "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
            keywords: "Account Sharing, Excent Capital Policy, Personal Account Use, Trading Account Security, Shared Access, Family Account Use, Account Safety, Trading Compliance",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-cancel-my-account/": {
            lang: "en",
            title: "How do I Cancel My Account",
            description:
                "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
            keywords: "Cancel Trading Account, Close Excent Capital Account, Account Termination, Delete Account, Trading Account Closure, End Account, Excent Capital Support, Account Cancellation Process",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-verify-my-account-from-a-foreign-country/": {
            lang: "en",
            title: "Can I Verify My Account From a Foreign Country?",
            description:
                "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
            keywords: "Verify Account Abroad, Excent Capital Verification, Foreign Country Account Setup, International KYC, Remote Account Verification, Account Documents, Overseas Verification",
            canonical: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                url: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/inside-deposits-withdrawals/": {
            lang: "en",
            title: "Inside Deposits & Withdrawals: What You'll Discover",
            description:
                "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
            keywords: "Deposits and Withdrawals, Excent Capital Funding, Withdraw Profits, Payment Methods, Deposit Options, Withdrawal Times, Trading Account Funding, Financial Transactions",
            canonical: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                url: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-do-a-first-time-deposit/": {
            lang: "en",
            title: "How Do I Make a First-Time Deposit?",
            description:
                "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                url: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-make-a-deposit/": {
            lang: "en",
            title: "How Do I Make a Deposit?",
            description:
                "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
            keywords: "Deposit Funds, How to Deposit, Excent Capital Payment Methods, Trading Account Funding, Make a Deposit, Secure Deposit, Account Top-Up, Deposit Process",
            canonical: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                url: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-can-i-make-a-withdrawal/": {
            lang: "en",
            title: "How Can I Make a Withdrawal?",
            description:
                "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
            keywords: "Withdraw Funds, Excent Capital Withdrawal, How to Withdraw, Trading Account Payout, Withdrawal Process, Secure Withdrawal, Access Earnings, Payment Methods",
            canonical: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                url: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails/": {
            lang: "en",
            title: "What Do I Do If My Withdrawal Fails?",
            description:
                "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
            keywords: "Withdrawal Failed, Excent Capital Help, Failed Transaction, Troubleshoot Withdrawal, Withdrawal Issue, Payment Error, Trading Account Support, Fix Withdrawal Problem",
            canonical: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                url: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/inside-payments/": {
            lang: "en",
            title: "Inside Payments: What You'll Discover",
            description:
                "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
            keywords: "Excent Capital Payments, Accepted Payment Methods, Transaction Management, Payment Processing Time, Supported Currencies, Trading Payments, Deposit and Withdrawal Options, Account Funding",
            canonical: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                url: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-do-i-see-my-payment-history/": {
            lang: "en",
            title: "How Do I See My Payment History?",
            description:
                "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
            keywords: "Payment History, Transaction History, View Deposits, View Withdrawals, Excent Capital Payments, Account Transactions, Trading Account History, Financial Records",
            canonical: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                url: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-long-can-a-transaction-take/": {
            lang: "en",
            title: "How Long Can a Transaction Take?",
            description:
                "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
            keywords: "Transaction Time, Processing Time, Deposit Duration, Withdrawal Duration, Excent Capital Payments, Payment Speed, Trading Account Transactions, Delay in Transactions",
            canonical: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                url: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Español
        "es/": {
            lang: "es",
            title: "Base de Conocimientos | Excent Capital",
            description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
            keywords: "Centro de Ayuda Excent Capital, Soporte de Plataforma de Trading, Preguntas Frecuentes sobre Trading, Cómo Operar, Tutoriales de FX, Gestión de Cuentas, Guías de Trading, Ayuda para Depósitos, Ayuda para Retiros",
            canonical: "https://knowledgebase.test.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en",
                es: "https://knowledgebase.test.excent.capital/es",
                pt: "https://knowledgebase.test.excent.capital/pt",
                fr: "https://knowledgebase.test.excent.capital/fr",
                it: "https://knowledgebase.test.excent.capital/it",
                zh: "https://knowledgebase.test.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.test.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/dentro-de-acerca-de-nosotros/": {
            lang: "es",
            title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
            description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
            keywords: "Sobre Excent Capital, Misión de la Empresa, Valores de Empresa de Trading, Conoce al Equipo, Quién es Excent Capital, Nuestra Historia, Empresa de Servicios Financieros, Visión General de Excent Capital", canonical: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            canonical: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/acerca-de-excent-capital/": {
            lang: "es",
            title: "Sobre Excent Capital",
            description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
            keywords: "Excent Capital, Sobre Nosotros, Visión General de la Empresa, Empresa de Trading, Servicios Financieros, Firma de Trading, Nuestra Misión, Quiénes Somos, Soporte Global de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/construye-tu-portafolio/": {
            lang: "es",
            title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
            description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
            keywords: "Construir Portafolio, Instrumentos de Trading, Trading en Forex, Mercado de Acciones, Trading de Índices, Trading de Commodities, Portafolio Diversificado, Activos de Excent Capital",
            canonical: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/excent-capital-tu-socio-de-confianza/": {
            lang: "es",
            title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
            description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
            keywords: "Excent Capital, Inversiones Internacionales, Diversificar Portafolio, Mercados Globales, Socio de Trading Confiable, Trading en Forex, Plataforma de Trading Internacional, Oportunidades de Inversión",

            canonical: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/centro-educativo-excent-capital/": {
            lang: "es",
            title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
            description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
            keywords: "Educación en Trading, Aprender a Operar, Tutoriales de Trading, Cursos de Trading, Educación Excent Capital, Guía para Principiantes en Trading, Estrategias Avanzadas de Trading, Recursos de Trading",

            canonical: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/invierte-con-confianza/": {
            lang: "es",
            title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
            description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
            keywords: "Gestión de Riesgo, Herramientas de Riesgo en Trading, Protección de Inversiones, Estrategias de Excent Capital, Trading con Confianza, Volatilidad del Mercado, Herramientas de Trading, Gestionar Riesgo en Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/invierte-con-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/trading/dentro-del-trading/": {
            lang: "es",
            title: "Dentro del Trading: Lo que Descubrirás",
            description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
            keywords: "Guía de Trading, Perspectivas del Mercado, Conceptos de Trading, Cómo Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conocimientos de Trading", canonical: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/instrumentos-en-excent-capital/": {
            lang: "es",
            title: "Instrumentos en Excent Capital",
            description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
            keywords: "Instrumentos de Trading, Forex, Acciones, Commodities, Índices, Activos de Excent Capital, Instrumentos Financieros, Opciones de Inversión, Mercados de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/instrumentos-en-excent-capital",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.test.excent.capital/es/trading/instrumentos-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/apalancamiento-en-excent-capital/": {
            lang: "es",
            title: "Apalancamiento Ofrecido en Excent Capital",
            description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
            keywords: "Trading con Apalancamiento, Operar con Apalancamiento, Apalancamiento en Excent Capital, Trading con Margen, Opciones de Apalancamiento, Potenciar el Trading, Apalancamiento en Forex, Trading Responsable",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/apalancamiento-en-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.test.excent.capital/es/trading/apalancamiento-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/micro-lotes-excent-capital/": {
            lang: "es",
            title: "Micro Lotes en Excent Capital",
            description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
            keywords: "Trading con Micro Lotes, Micro Lotes Excent Capital, Trading con Lotes Pequeños, Trading para Principiantes, Gestión de Riesgo, Trading Flexible, Micro Lotes en Forex, Trading con Baja Exposición",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.test.excent.capital/es/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/horario-de-trading/": {
            lang: "es",
            title: "Horarios de Trading",
            description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
            keywords: "Horarios de Trading, Horarios de Mercado, Horarios de Forex, Horarios del Mercado de Acciones, Calendario Excent Capital, Sesiones de Trading, Tiempos de Trading, Horarios del Mercado Financiero",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.test.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.test.excent.capital/es/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/herramientas-de-trading/": {
            lang: "es",
            title: "Herramientas de Trading",
            description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
            keywords: "Herramientas de Trading, Herramientas de Análisis de Mercado, Calculadoras de Trading, Herramientas de Forex, Plataforma Excent Capital, Recursos de Trading, Herramientas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "es/trading/herramientas-de-trading-acuity/": {
            lang: "es",
            title: "Herramientas de Trading de Acuity",
            description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
            keywords: "Herramientas de Trading de Acuity, Herramientas de Trading con IA, Análisis de Sentimiento del Mercado, Perspectivas del Mercado en Tiempo Real, Herramientas de Excent Capital, Insights de Acuity, Trading Inteligente, Analítica de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "es/trading/llamadas-de-margen/": {
            lang: "es",
            title: "Llamadas de Margen",
            description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
            keywords: "Llamadas de Margen, Qué es una Llamada de Margen, Margen en Excent Capital, Trading con Margen, Liquidación Forzada, Protección de Cuenta, Trading con Margen, Gestión de Riesgo",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/llamadas-de-margen",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.test.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.test.excent.capital/es/trading/llamadas-de-margen",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/trading-de-cfd/": {
            lang: "es",
            title: "Trading de CFDs",
            description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
            keywords: "Trading de CFDs, Contratos por Diferencia, Operar CFDs, CFDs en Excent Capital, Trading con Apalancamiento, Trading de Derivados, Mercados de CFD, Cómo Operar CFDs",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.test.excent.capital/es/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/ordenes-pendientes/": {
            lang: "es",
            title: "Órdenes Pendientes",
            description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
            keywords: "Órdenes Pendientes, Órdenes de Trading, Buy Stop, Sell Stop, Órdenes Limitadas, Trading Automatizado, Órdenes en Excent Capital, Puntos de Entrada, Estrategia de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/ordenes-pendientes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.test.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.test.excent.capital/es/trading/ordenes-pendientes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/spreads-ofrecidos/": {
            lang: "es",
            title: "Spreads Ofrecidos",
            description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
            keywords: "Spreads, Spreads por Volatilidad, Mercados Financieros, Spreads de Trading, Minimizar Costos de Trading, Optimizar Rentabilidad, Estrategias de Trading, Análisis de Spreads, Spreads en Forex, Spreads en el Mercado de Acciones",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/spreads-ofrecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.test.excent.capital/es/trading/spreads-ofrecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/monedas-base/": {
            lang: "es",
            title: "Monedas Base",
            description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
            keywords: "Monedas Base, Divisas Compatibles, Cuenta en Excent Capital, Opciones de Divisa de Cuenta, Selección de Moneda, Moneda de Trading, Divisa Base en Forex, Opciones de Fondeo",
            canonical: "https://knowledgebase.test.excent.capital/es/trading/monedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.test.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.test.excent.capital/es/trading/monedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/recursos/dentro-de-recursos/": {
            lang: "es",
            title: "Dentro de Recursos: Lo que Descubrirás",
            description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Actualizaciones del Mercado, Calendario Económico, Educación en Trading, Centro de Recursos, Aprender a Operar, Material de Apoyo para Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.test.excent.capital/es/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-basicos/": {
            lang: "es",
            title: "Conceptos Básicos",
            description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
            keywords: "Conceptos Básicos de Trading, Trading para Principiantes, Fundamentos del Mercado, Educación de Excent Capital, Terminología de Trading, Guía para Principiantes, Aprender a Operar, Conceptos Fundamentales",
            canonical: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-avanzados/": {
            lang: "es",
            title: "Conceptos Avanzados",
            description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
            keywords: "Conceptos Avanzados de Trading, Estrategias de Trading, Indicadores Técnicos, Trading Experto, Educación de Excent Capital, Análisis de Mercado, Herramientas de Trader Profesional, Técnicas de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-avanzados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-avanzados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/recursos-adicionales/": {
            lang: "es",
            title: "Recursos Adicionales",
            description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Glosario de Términos, Guías de Plataforma, Ayuda para Trading, Herramientas de Mercado, Recursos Educativos, Soporte de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/recursos/recursos-adicionales",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.test.excent.capital/es/recursos/recursos-adicionales",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/mi-cuenta/dentro-de-mi-cuenta/": {
            lang: "es",
            title: "Dentro de Mi Cuenta: Lo que Descubrirás",
            description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
            keywords: "Mi Cuenta, Gestión de Cuenta, Perfil en Excent Capital, Configuración de Cuenta de Trading, Seguridad de Cuenta, Panel de Usuario, Actualización de Perfil, Administrar Cuenta de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-demo/": {
            lang: "es",
            title: "¿Puedo Crear una Cuenta Demo?",
            description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
            keywords: "Cuenta Demo, Practicar Trading, Demo de Excent Capital, Trading sin Riesgo, Crear Cuenta Demo, Simulador de Trading, Trading para Principiantes, Aprender a Operar",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-real/": {
            lang: "es",
            title: "¿Cómo Crear una Cuenta Real?",
            description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
            keywords: "Cuenta Real, Crear Cuenta de Trading, Registro en Excent Capital, Abrir Cuenta Real, Comenzar a Operar, Cuenta de Trading Real, Registro de Trading, Configuración de Cuenta",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta/": {
            lang: "es",
            title: "¿Por Qué Verificar tu Cuenta?",
            description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
            keywords: "Verificación de Cuenta, Verificar Cuenta de Trading, KYC de Excent Capital, Seguridad en Trading, Proceso de Cumplimiento, Verificación de Identidad, Trading Seguro, Acceso Completo a la Cuenta",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/acceder-a-la-plataforma/": {
            lang: "es",
            title: "¿Cómo Accedo a la Plataforma?",
            description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
            keywords: "Acceder a la Plataforma de Trading, Inicio de Sesión en Excent Capital, App de Trading, Plataforma Web de Trading, Trading Móvil, Cómo Iniciar Sesión, Comenzar a Operar, Guía de Acceso a la Plataforma",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/tiempo-para-crear-cuenta/": {
            lang: "es",
            title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
            description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
            keywords: "Tiempo de Creación de Cuenta, Registro en Excent Capital, Cómo Crear una Cuenta, Configuración de Cuenta de Trading, Proceso de Registro, Abrir Cuenta Rápidamente, Inicio en Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuentas-corporativas/": {
            lang: "es",
            title: "¿Ofrecen Cuentas Corporativas?",
            description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
            keywords: "Cuenta Corporativa de Trading, Cuenta Empresarial, Corporativo en Excent Capital, Trading Institucional, Abrir Cuenta Corporativa, Trading Empresarial, Cuenta de Inversión para Empresas",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuentas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuentas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/varias-cuentas-mismo-correo/": {
            lang: "es",
            title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
            description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
            keywords: "Múltiples Cuentas, Cuentas con el Mismo Correo, Roles en Excent Capital, Roles de Usuario, Gestión de Cuentas, Acceso a Cuenta de Trading, Acceso Basado en Roles, Política de Registro de Correo",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/actualizar-informacion-cuenta/": {
            lang: "es",
            title: "¿Cómo Actualizo la Información de Mi Cuenta?",
            description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
            keywords: "Actualizar Información de Cuenta, Editar Datos Personales, Perfil de Excent Capital, Configuración de Cuenta, Cambiar Información de Cuenta, Actualización de Perfil de Trading, Información del Usuario",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/olvide-mi-contrasena/": {
            lang: "es",
            title: "¿Qué Sucede si Olvido Mi Contraseña?",
            description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
            keywords: "Olvidé la Contraseña, Recuperación de Contraseña, Restablecer Contraseña de Trading, Ayuda para Iniciar Sesión en Excent Capital, Acceso a la Cuenta, Recuperar Contraseña, Contraseña Perdida, Inicio de Sesión en Cuenta de Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/documentos-para-verificacion/": {
            lang: "es",
            title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
            description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
            keywords: "Documentos para Verificación de Cuenta, Requisitos KYC, Verificación en Excent Capital, Comprobante de Identidad, Comprobante de Domicilio, Subir Documentos, Verificación Segura, Cumplimiento en Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/documentos-para-verificacion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuenta-usada-por-otros/": {
            lang: "es",
            title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
            description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
            keywords: "Compartir Cuenta, Política de Excent Capital, Uso Personal de Cuenta, Seguridad de Cuenta de Trading, Acceso Compartido, Uso Familiar de Cuenta, Seguridad de Cuenta, Cumplimiento en Trading",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cancelar-cuenta/": {
            lang: "es",
            title: "¿Cómo Cancelo Mi Cuenta?",
            description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
            keywords: "Cancelar Cuenta de Trading, Cerrar Cuenta de Excent Capital, Terminación de Cuenta, Eliminar Cuenta, Cierre de Cuenta de Trading, Finalizar Cuenta, Soporte de Excent Capital, Proceso de Cancelación de Cuenta",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cancelar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cancelar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta-extranjero/": {
            lang: "es",
            title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
            description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
            keywords: "Verificar Cuenta en el Extranjero, Verificación en Excent Capital, Crear Cuenta Desde el Exterior, KYC Internacional, Verificación Remota de Cuenta, Documentos para Cuenta, Verificación Desde el Exterior",
            canonical: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                url: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/depositos-retiros/dentro-depositos-retiros/": {
            lang: "es",
            title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
            description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
            keywords: "Depósitos y Retiros, Fondeo en Excent Capital, Retirar Ganancias, Métodos de Pago, Opciones de Depósito, Tiempos de Retiro, Fondeo de Cuenta de Trading, Transacciones Financieras",
            canonical: "https://knowledgebase.test.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                url: "https://knowledgebase.test.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/primer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito por Primera Vez?",
            description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
            keywords: "Primer Depósito, Hacer un Depósito, Fondeo en Excent Capital, Depósito en Cuenta de Trading, Cómo Depositar, Métodos de Pago, Comenzar a Operar, Fondear tu Cuenta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.test.excent.capital/es/depositos-retiros/primer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                url: "https://knowledgebase.test.excent.capital/es/depositos-retiros/primer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito?",
            description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
            keywords: "Depositar Fondos, Cómo Depositar, Métodos de Pago en Excent Capital, Fondeo de Cuenta de Trading, Realizar un Depósito, Depósito Seguro, Recargar Cuenta, Proceso de Depósito",
            canonical: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                url: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-retiro/": {
            lang: "es",
            title: "¿Cómo Puedo Hacer un Retiro?",
            description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
            keywords: "Retirar Fondos, Retiro en Excent Capital, Cómo Retirar, Pago de Cuenta de Trading, Proceso de Retiro, Retiro Seguro, Acceder a Ganancias, Métodos de Pago",
            canonical: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-retiro",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                url: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-retiro",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/retiro-fallido/": {
            lang: "es",
            title: "¿Qué Hago si Falla Mi Retiro?",
            description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
            keywords: "Retiro Fallido, Ayuda de Excent Capital, Transacción Fallida, Solución de Problemas de Retiro, Problema de Retiro, Error de Pago, Soporte de Cuenta de Trading, Corregir Problema de Retiro",
            canonical: "https://knowledgebase.test.excent.capital/es/depositos-retiros/retiro-fallido",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                url: "https://knowledgebase.test.excent.capital/es/depositos-retiros/retiro-fallido",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/pagos/dentro-de-pagos/": {
            lang: "es",
            title: "Dentro de Pagos: Lo que Descubrirás",
            description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
            keywords: "Pagos en Excent Capital, Métodos de Pago Aceptados, Gestión de Transacciones, Tiempo de Procesamiento de Pagos, Divisas Soportadas, Pagos de Trading, Opciones de Depósito y Retiro, Fondeo de Cuenta",
            canonical: "https://knowledgebase.test.excent.capital/es/pagos/dentro-de-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.test.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                url: "https://knowledgebase.test.excent.capital/es/pagos/dentro-de-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/ver-historial-pagos/": {
            lang: "es",
            title: "¿Cómo Veo Mi Historial de Pagos?",
            description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
            keywords: "Historial de Pagos, Historial de Transacciones, Ver Depósitos, Ver Retiros, Pagos en Excent Capital, Transacciones de Cuenta, Historial de Cuenta de Trading, Registros Financieros",
            canonical: "https://knowledgebase.test.excent.capital/es/pagos/ver-historial-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.test.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                url: "https://knowledgebase.test.excent.capital/es/pagos/ver-historial-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/tiempo-transaccion/": {
            lang: "es",
            title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
            description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
            keywords: "Tiempo de Transacción, Tiempo de Procesamiento, Duración del Depósito, Duración del Retiro, Pagos en Excent Capital, Velocidad de Pago, Transacciones de Cuenta de Trading, Retrasos en Transacciones",
            canonical: "https://knowledgebase.test.excent.capital/es/pagos/tiempo-transaccion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.test.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                url: "https://knowledgebase.test.excent.capital/es/pagos/tiempo-transaccion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Potugues
        "pt/": {
            lang: "pt",
            title: "Base de Conhecimento | Excent Capital",
            description: "Explore a Base de Conhecimento da Excent Capital com guias especializados, tutoriais da plataforma, perguntas frequentes sobre trading e recursos desenvolvidos para ajudá-lo a operar com confiança.",
            keywords: "Central de Ajuda Excent Capital, Suporte da Plataforma de Trading, Perguntas Frequentes de Trading, Como Operar, Tutoriais de FX, Gestão de Conta, Guias de Trading, Ajuda com Depósitos, Ajuda com Saques",
            canonical: "https://knowledgebase.test.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en",
                es: "https://knowledgebase.test.excent.capital/es",
                pt: "https://knowledgebase.test.excent.capital/pt",
                fr: "https://knowledgebase.test.excent.capital/fr",
                it: "https://knowledgebase.test.excent.capital/it",
                zh: "https://knowledgebase.test.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.test.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/dentro-sobre-nos/": {
            lang: "pt",
            title: "Dentro de Sobre Nós: O Que Você Vai Descobrir",
            description: "Saiba mais sobre a missão, os valores e a presença global da Excent Capital. Descubra quem somos, o que nos motiva e como capacitamos traders ao redor do mundo.",
            keywords: "Sobre a Excent Capital, Missão da Empresa, Valores da Empresa de Trading, Conheça a Equipe, Quem é a Excent Capital, Nossa História, Empresa de Serviços Financeiros, Visão Geral da Excent Capital",
            canonical: "https://knowledgebase.test.excent.capital/pt/sobre-nos/dentro-sobre-nos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.test.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/sobre-a-excent-capital/": {
            lang: "pt",
            title: "Sobre a Excent Capital",
            description: "Conheça a Excent Capital — nossa história, missão e os princípios que orientam nossa abordagem para capacitar traders nos mercados globais.",
            keywords: "Excent Capital, Sobre Nós, Visão Geral da Empresa, Empresa de Trading, Serviços Financeiros, Firma de Trading, Nossa Missão, Quem Somos, Suporte Global de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.test.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/construa-seu-portfolio/": {
            lang: "pt",
            title: "Construa Seu Portfólio: Opções Diversificadas na Excent Capital",
            description: "Descubra uma ampla variedade de instrumentos de trading na Excent Capital, incluindo Forex, ações, índices e commodities — tudo o que você precisa para montar um portfólio sólido e diversificado.",
            keywords: "Construir Portfólio, Instrumentos de Trading, Trading de Forex, Mercado de Ações, Trading de Índices, Trading de Commodities, Portfólio Diversificado, Ativos da Excent Capital",
            canonical: "https://knowledgebase.test.excent.capital/pt/sobre-nos/construa-seu-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.test.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/excent-capital-seu-parceiro-de-confianca/": {
            lang: "pt",
            title: "Excent Capital: Seu Parceiro de Confiança para Diversificar Seus Investimentos nos Mercados Internacionais",
            description: "Associe-se à Excent Capital para expandir globalmente suas oportunidades de investimento. Acesse os mercados internacionais com confiança através de nossa plataforma de trading segura e profissional.",
            keywords: "Excent Capital, Investimentos Internacionais, Diversificar Portfólio, Mercados Globais, Parceiro Confiável de Trading, Trading de Forex, Plataforma Internacional de Trading, Oportunidades de Investimento",
            canonical: "https://knowledgebase.test.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.test.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/centro-educacional-excent-capital/": {
            lang: "pt",
            title: "Eleve Seu Trading: Centro Educacional da Excent Capital",
            description: "Acesse cursos, tutoriais e recursos conduzidos por especialistas no Centro Educacional da Excent Capital. Aprenda estratégias de trading e desenvolva suas habilidades — seja você iniciante ou trader avançado.",
            keywords: "Educação em Trading, Aprenda a Operar, Tutoriais de Trading, Cursos de Trading, Educação Excent Capital, Guia de Trading para Iniciantes, Estratégias Avançadas de Trading, Recursos de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.test.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/invista-com-confianca/": {
            lang: "pt",
            title: "Invista com Confiança: Estratégias e Ferramentas de Gestão de Risco na Excent Capital",
            description: "Domine a gestão de risco com a Excent Capital. Explore ferramentas e estratégias essenciais para proteger seus investimentos e operar com mais confiança em mercados voláteis.",
            keywords: "Gestão de Risco, Ferramentas de Risco em Trading, Proteção de Investimentos, Estratégias da Excent Capital, Trading com Confiança, Volatilidade do Mercado, Ferramentas de Trading, Gerenciar Risco no Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/sobre-nos/invista-com-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.test.excent.capital/pt/sobre-nos/invista-com-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/trading/dentro-do-trading/": {
            lang: "pt",
            title: "Dentro do Trading: O Que Você Vai Descobrir",
            description: "Explore conceitos-chave de trading, insights de mercado e funcionalidades da plataforma no centro de trading da Excent Capital. Obtenha o conhecimento necessário para tomar decisões informadas.",
            keywords: "Guia de Trading, Insights de Mercado, Conceitos de Trading, Como Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conhecimento de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/dentro-do-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/dentro-do-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/instrumentos-na-excent-capital/": {
            lang: "pt",
            title: "Instrumentos na Excent Capital",
            description: "Explore toda a gama de instrumentos de trading oferecidos pela Excent Capital, incluindo FX, ações, commodities, índices e muito mais — desenvolvidos para atender aos seus objetivos de investimento.",
            keywords: "Instrumentos de Trading, Forex, Ações, Commodities, Índices, Ativos da Excent Capital, Instrumentos Financeiros, Opções de Investimento, Mercados de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/instrumentos-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/instrumentos-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/alavancagem-na-excent-capital/": {
            lang: "pt",
            title: "Alavancagem Oferecida pela Excent Capital",
            description: "Entenda como funciona a alavancagem na Excent Capital e como ela pode ampliar seu potencial de trading. Conheça nossas opções de alavancagem flexíveis e práticas de operação responsável.",
            keywords: "Trading com Alavancagem, Operar com Alavancagem, Alavancagem na Excent Capital, Trading com Margem, Opções de Alavancagem, Ampliar Trading, Alavancagem em Forex, Trading Responsável",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/alavancagem-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/alavancagem-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/micro-lotes-excent-capital/": {
            lang: "pt",
            title: "Micro Lotes na Excent Capital",
            description: "Opere com mais flexibilidade utilizando micro lotes na Excent Capital. Ideal para iniciantes e traders cautelosos que buscam controlar a exposição e testar estratégias.",
            keywords: "Trading com Micro Lotes, Micro Lotes Excent Capital, Trading com Lotes Pequenos, Trading para Iniciantes, Gestão de Risco, Trading Flexível, Micro Lotes de Forex, Trading com Baixa Exposição",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/horario-de-trading/": {
            lang: "pt",
            title: "Horários de Trading",
            description: "Fique informado sobre os horários oficiais de trading para todos os mercados disponíveis na Excent Capital. Saiba quando operar Forex, ações, índices e commodities.",
            keywords: "Horários de Trading, Horários de Mercado, Horários de Forex, Horário do Mercado de Ações, Agenda da Excent Capital, Sessões de Trading, Tempos de Trading, Horários do Mercado Financeiro",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.test.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ferramentas-de-trading/": {
            lang: "pt",
            title: "Ferramentas de Trading",
            description: "Melhore sua experiência de trading com as poderosas ferramentas da Excent Capital. Acesse gráficos, calculadoras, análises de mercado e muito mais para tomar decisões informadas.",
            keywords: "Ferramentas de Trading, Ferramentas de Análise de Mercado, Calculadoras de Trading, Ferramentas de Forex, Plataforma Excent Capital, Recursos de Trading, Ferramentas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "pt/trading/ferramentas-de-trading-acuity/": {
            lang: "pt",
            title: "Ferramentas de Trading da Acuity",
            description: "Aproveite as ferramentas com IA da Acuity na Excent Capital para obter insights de mercado, análise de sentimento e decisões de trading mais inteligentes com dados em tempo real.",
            keywords: "Ferramentas de Trading Acuity, Ferramentas de Trading com IA, Análise de Sentimento de Mercado, Insights de Mercado em Tempo Real, Ferramentas da Excent Capital, Insights da Acuity, Trading Inteligente, Análise de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "pt/trading/chamadas-de-margem/": {
            lang: "pt",
            title: "Chamadas de Margem",
            description: "Entenda como funcionam as chamadas de margem na Excent Capital. Saiba quando elas ocorrem, como gerenciá-las e como proteger sua conta contra liquidações forçadas.",
            keywords: "Chamadas de Margem, O que é uma Chamada de Margem, Margem Excent Capital, Margem de Trading, Liquidação Forçada, Proteção da Conta, Trading com Margem, Gestão de Risco",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/chamadas-de-margem",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.test.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/chamadas-de-margem",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/trading-de-cfd/": {
            lang: "pt",
            title: "Trading de CFDs",
            description: "Aprenda como operar Contratos por Diferença (CFDs) com a Excent Capital. Acesse mercados globais, opere com alavancagem e posicione-se sobre movimentos de preço sem possuir os ativos.",
            keywords: "Trading de CFDs, Contratos por Diferença, Operar CFDs, CFDs da Excent Capital, Trading com Alavancagem, Trading de Derivativos, Mercados de CFD, Como Operar CFDs",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ordens-pendentes/": {
            lang: "pt",
            title: "Ordens Pendentes",
            description: "Descubra como funcionam as ordens pendentes na Excent Capital. Aprenda a definir pontos de entrada com antecedência e automatizar sua estratégia de trading com precisão.",
            keywords: "Ordens Pendentes, Ordens de Trading, Buy Stop, Sell Stop, Ordens Limitadas, Trading Automatizado, Ordens Excent Capital, Pontos de Entrada, Estratégia de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/ordens-pendentes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.test.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/ordens-pendentes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/spreads-oferecidos/": {
            lang: "pt",
            title: "Spreads Oferecidos",
            description: "Descubra a importância dos spreads e dos spreads de volatilidade nos mercados financeiros. Aprenda a minimizar custos e otimizar sua lucratividade como trader.",
            keywords: "Spreads, Spreads de Volatilidade, Mercados Financeiros, Spreads de Trading, Minimizar Custos de Trading, Otimizar Lucros, Estratégias de Trading, Análise de Spreads, Spreads de Forex, Spreads no Mercado de Ações",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/spreads-oferecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/spreads-oferecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/moedas-base/": {
            lang: "pt",
            title: "Moedas Base",
            description: "Descubra quais moedas base são aceitas na Excent Capital. Escolha a moeda certa para sua conta e simplifique sua experiência de trading e de financiamento.",
            keywords: "Moedas Base, Moedas Suportadas, Conta na Excent Capital, Opções de Moeda de Conta, Seleção de Moeda, Moeda para Trading, Moeda Base em Forex, Opções de Financiamento",
            canonical: "https://knowledgebase.test.excent.capital/pt/trading/moedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.test.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.test.excent.capital/pt/trading/moedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/recursos/dentro-de-recursos/": {
            lang: "pt",
            title: "Dentro de Recursos: O Que Você Vai Descobrir",
            description: "Explore o centro de recursos da Excent Capital com atualizações de mercado, calendários econômicos, ferramentas de trading e conteúdo educacional para apoiar sua jornada como trader.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Atualizações de Mercado, Calendário Econômico, Educação em Trading, Centro de Recursos, Aprenda a Operar, Materiais de Apoio ao Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.test.excent.capital/pt/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-basicos/": {
            lang: "pt",
            title: "Conceitos Básicos",
            description: "Aprenda os conceitos fundamentais do trading com a Excent Capital. Entenda os termos-chave, a mecânica do mercado e o conhecimento essencial para começar sua jornada no trading.",
            keywords: "Conceitos Básicos de Trading, Trading para Iniciantes, Fundamentos do Mercado, Educação Excent Capital, Terminologia de Trading, Guia para Iniciantes, Aprender a Operar, Conceitos Fundamentais",
            canonical: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-avancados/": {
            lang: "pt",
            title: "Conceitos Avançados",
            description: "Aprofunde seus conhecimentos de trading com os conceitos avançados da Excent Capital. Explore estratégias, indicadores e técnicas usadas por traders experientes.",
            keywords: "Conceitos Avançados de Trading, Estratégias de Trading, Indicadores Técnicos, Trading Avançado, Educação Excent Capital, Análise de Mercado, Ferramentas para Traders Profissionais, Técnicas de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-avancados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-avancados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/recursos-adicionais/": {
            lang: "pt",
            title: "Recursos Adicionais",
            description: "Acesse uma variedade de recursos adicionais na Excent Capital, incluindo glossários de trading, guias da plataforma e ferramentas de mercado para melhorar sua experiência de operação.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Glossário de Termos, Guias da Plataforma, Ajuda de Trading, Ferramentas de Mercado, Recursos Educacionais, Suporte ao Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/recursos/recursos-adicionais",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.test.excent.capital/pt/recursos/recursos-adicionais",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/minha-conta/dentro-da-minha-conta/": {
            lang: "pt",
            title: "Dentro da Minha Conta: O Que Você Vai Descobrir",
            description: "Gerencie sua conta de trading com facilidade na Excent Capital. Aprenda como atualizar seu perfil, acessar configurações da conta, monitorar atividades e manter a segurança.",
            keywords: "Minha Conta, Gestão de Conta, Perfil da Excent Capital, Configurações da Conta de Trading, Segurança da Conta, Painel do Usuário, Atualizações de Perfil, Gerenciar Conta de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/dentro-da-minha-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-demo/": {
            lang: "pt",
            title: "Posso Criar uma Conta Demo?",
            description: "Sim, a Excent Capital oferece contas demo para que você possa praticar trading em um ambiente sem riscos. Saiba como abrir uma e começar a explorar a plataforma.",
            keywords: "Conta Demo, Praticar Trading, Demo da Excent Capital, Trading Sem Risco, Criar Conta Demo, Simulador de Trading, Trading para Iniciantes, Aprender a Operar",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-real/": {
            lang: "pt",
            title: "Como Criar uma Conta Real?",
            description: "Abra sua conta de trading real na Excent Capital em apenas alguns passos. Siga nosso guia para começar a operar nos mercados reais com segurança e eficiência.",
            keywords: "Conta Real, Criar Conta de Trading, Registro na Excent Capital, Abrir Conta Real, Começar a Operar, Conta Real de Trading, Cadastro de Trading, Configuração de Conta",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta/": {
            lang: "pt",
            title: "Por Que Verificar Sua Conta?",
            description: "A verificação da conta na Excent Capital garante segurança, conformidade e acesso completo às funcionalidades de trading. Saiba por que é importante e como concluí-la.",
            keywords: "Verificação de Conta, Verificar Conta de Trading, KYC da Excent Capital, Segurança no Trading, Processo de Conformidade, Verificação de Identidade, Trading Seguro, Acesso Completo à Conta",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/acessar-a-plataforma/": {
            lang: "pt",
            title: "Como Acessar a Plataforma?",
            description: "Acesse a plataforma de trading da Excent Capital facilmente pelo navegador ou dispositivo móvel. Saiba como fazer login e começar a operar a qualquer hora e em qualquer lugar.",
            keywords: "Acessar Plataforma de Trading, Login Excent Capital, Aplicativo de Trading, Plataforma Web de Trading, Trading Móvel, Como Fazer Login, Começar a Operar, Guia de Acesso à Plataforma",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/acessar-a-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/acessar-a-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/tempo-para-criar-conta/": {
            lang: "pt",
            title: "Quanto Tempo Leva para Criar uma Conta?",
            description: "Criar uma conta na Excent Capital é rápido e simples. Descubra quanto tempo leva o processo e quais etapas são necessárias para começar.",
            keywords: "Tempo de Criação de Conta, Cadastro na Excent Capital, Como Criar Conta, Configuração de Conta de Trading, Processo de Registro, Abrir Conta Rápido, Onboarding de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/tempo-para-criar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/tempo-para-criar-contas",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/contas-corporativas/": {
            lang: "pt",
            title: "Vocês Oferecem Contas Corporativas?",
            description: "Sim, a Excent Capital oferece contas corporativas de trading para empresas e instituições. Descubra os benefícios e os requisitos para abrir uma conta corporativa.",
            keywords: "Conta Corporativa de Trading, Conta Empresarial, Corporativo na Excent Capital, Trading Institucional, Abrir Conta Corporativa, Trading para Empresas, Conta de Investimento Corporativa",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/contas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/contas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/varias-contas-mesmo-email/": {
            lang: "pt",
            title: "Posso Abrir Múltiplas Contas com Diferentes Funções Usando o Mesmo E-mail?",
            description: "Descubra se é possível registrar várias contas da Excent Capital com diferentes funções usando um único endereço de e-mail, e como funciona a gestão de funções na plataforma.",
            keywords: "Múltiplas Contas, Contas com o Mesmo E-mail, Funções na Excent Capital, Funções de Usuário, Gestão de Conta, Acesso à Conta de Trading, Acesso Baseado em Funções, Política de Registro de E-mail",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/atualizar-informacoes-da-conta/": {
            lang: "pt",
            title: "Como Atualizo as Informações da Minha Conta?",
            description: "Atualize facilmente seus dados pessoais e informações da conta na Excent Capital. Siga nosso guia passo a passo para manter suas informações precisas e atualizadas.",
            keywords: "Atualizar Informações da Conta, Editar Dados Pessoais, Perfil Excent Capital, Configurações da Conta, Alterar Informações da Conta, Atualização do Perfil de Trading, Informações do Usuário",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/esqueci-minha-senha/": {
            lang: "pt",
            title: "O Que Acontece se Eu Esquecer Minha Senha?",
            description: "Se você esquecer sua senha, a Excent Capital oferece um processo de recuperação simples e seguro. Aprenda como redefinir sua senha e recuperar o acesso à sua conta.",
            keywords: "Esqueci a Senha, Recuperação de Senha, Redefinir Senha de Trading, Ajuda para Login Excent Capital, Acesso à Conta, Recuperar Senha, Senha Perdida, Login na Conta de Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/esqueci-minha-senha",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/esqueci-minha-senha",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/documentos-para-verificacao/": {
            lang: "pt",
            title: "Quais Documentos São Necessários para Verificação de Conta?",
            description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
            keywords: "Documentos para Verificação de Conta, Requisitos KYC, Verificação na Excent Capital, Comprovante de Identidade, Comprovante de Endereço, Enviar Documentos, Verificação Segura, Conformidade no Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/documentos-para-verificacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/documentos-para-verificacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/amigos-familia-usar-conta/": {
            lang: "pt",
            title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
            description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
            keywords: "Compartilhamento de Conta, Política da Excent Capital, Uso Pessoal da Conta, Segurança da Conta de Trading, Acesso Compartilhado, Uso por Familiares, Segurança da Conta, Conformidade em Trading",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/cancelar-conta/": {
            lang: "pt",
            title: "Como Cancelo Minha Conta?",
            description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
            keywords: "Cancelar Conta de Trading, Encerrar Conta na Excent Capital, Cancelamento de Conta, Excluir Conta, Fechamento de Conta de Trading, Finalizar Conta, Suporte da Excent Capital, Processo de Cancelamento de Conta",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/cancelar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/cancelar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta-no-exterior/": {
            lang: "pt",
            title: "Posso Verificar Minha Conta Estando no Exterior?",
            description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
            keywords: "Verificar Conta no Exterior, Verificação Excent Capital, Conta em País Estrangeiro, KYC Internacional, Verificação Remota de Conta, Documentos para Conta, Verificação no Exterior",
            canonical: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                url: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/depositos-saques/dentro-depositos-retiradas/": {
            lang: "pt",
            title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
            description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
            keywords: "Depósitos e Saques, Fondeamento na Excent Capital, Sacar Lucros, Métodos de Pagamento, Opções de Depósito, Prazos de Saque, Fondeamento da Conta de Trading, Transações Financeiras",
            canonical: "https://knowledgebase.test.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                url: "https://knowledgebase.test.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/primeiro-deposito/": {
            lang: "pt",
            title: "Como Faço Meu Primeiro Depósito?",
            description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
            keywords: "Primeiro Depósito, Fazer um Depósito, Fondeamento Excent Capital, Depósito na Conta de Trading, Como Depositar, Métodos de Pagamento, Começar a Operar, Adicionar Fundos à Conta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.test.excent.capital/pt/depositos-saques/primeiro-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                url: "https://knowledgebase.test.excent.capital/pt/depositos-saques/primeiro-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-deposito/": {
            lang: "pt",
            title: "Como Faço um Depósito?",
            description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
            keywords: "Depositar Fundos, Como Depositar, Métodos de Pagamento Excent Capital, Fondeamento da Conta de Trading, Fazer um Depósito, Depósito Seguro, Recarga da Conta, Processo de Depósito",
            canonical: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                url: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-saque/": {
            lang: "pt",
            title: "Como Posso Fazer um Saque?",
            description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
            keywords: "Sacar Fundos, Saque na Excent Capital, Como Sacar, Pagamento da Conta de Trading, Processo de Saque, Saque Seguro, Acessar Ganhos, Métodos de Pagamento",
            canonical: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-saque",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                url: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-saque",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/saque-falhou/": {
            lang: "pt",
            title: "O Que Fazer se Meu Saque Falhar?",
            description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
            keywords: "Saque Falhou, Ajuda Excent Capital, Transação Falhada, Resolver Problemas de Saque, Problema no Saque, Erro de Pagamento, Suporte da Conta de Trading, Corrigir Problema de Saque",
            canonical: "https://knowledgebase.test.excent.capital/pt/depositos-saques/saque-falhou",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                url: "https://knowledgebase.test.excent.capital/pt/depositos-saques/saque-falhou",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/pagamentos/dentro-de-pagamentos/": {
            lang: "pt",
            title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
            description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
            keywords: "Pagamentos Excent Capital, Métodos de Pagamento Aceitos, Gestão de Transações, Tempo de Processamento de Pagamento, Moedas Suportadas, Pagamentos de Trading, Opções de Depósito e Saque, Fondeamento de Conta",
            canonical: "https://knowledgebase.test.excent.capital/pt/pagamentos/dentro-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.test.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                url: "https://knowledgebase.test.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/ver-historico-de-pagamentos/": {
            lang: "pt",
            title: "Como Vejo Meu Histórico de Pagamentos?",
            description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
            keywords: "Histórico de Pagamentos, Histórico de Transações, Ver Depósitos, Ver Saques, Pagamentos Excent Capital, Transações da Conta, Histórico da Conta de Trading, Registros Financeiros",
            canonical: "https://knowledgebase.test.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.test.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                url: "https://knowledgebase.test.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/tempo-de-transacao/": {
            lang: "pt",
            title: "Quanto Tempo Pode Levar uma Transação?",
            description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
            keywords: "Tempo de Transação, Tempo de Processamento, Duração do Depósito, Duração do Saque, Pagamentos Excent Capital, Velocidade de Pagamento, Transações da Conta de Trading, Atrasos em Transações",
            canonical: "https://knowledgebase.test.excent.capital/pt/pagamentos/tempo-de-transacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.test.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                url: "https://knowledgebase.test.excent.capital/pt/pagamentos/tempo-de-transacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        // Frances
        "fr/": {
            lang: "fr",
            title: "Base de connaissances | Excent Capital",
            description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
            keywords: "Centre d’aide Excent Capital, Support de plateforme de trading, FAQ Trading, Comment Trader, Tutoriels FX, Gestion de compte, Guides de Trading, Aide au dépôt, Aide au retrait",
            canonical: "https://knowledgebase.test.excent.capital/fr/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en",
                es: "https://knowledgebase.test.excent.capital/es",
                pt: "https://knowledgebase.test.excent.capital/pt",
                fr: "https://knowledgebase.test.excent.capital/fr",
                it: "https://knowledgebase.test.excent.capital/it",
                zh: "https://knowledgebase.test.excent.capital/zh",
            },
            openGraph: {
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                url: "https://knowledgebase.test.excent.capital/fr/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-de-nous/": {
            lang: "fr",
            title: "Dans la section À propos : Ce que vous allez découvrir",
            description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
            keywords: "À propos d’Excent Capital, Mission de l’entreprise, Valeurs d’une société de trading, Rencontrer l’équipe, Qui est Excent Capital, Notre histoire, Société de services financiers, Vue d’ensemble d’Excent Capital",
            canonical: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                url: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-d-excent-capital/": {
            lang: "fr",
            title: "À propos d’Excent Capital",
            description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
            keywords: "Excent Capital, À propos de nous, Présentation de l’entreprise, Société de trading, Services financiers, Société de courtage, Notre mission, Qui nous sommes, Support global au trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                url: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/construisez-votre-portefeuille/": {
            lang: "fr",
            title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
            description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
            keywords: "Construire un portefeuille, Instruments de trading, Trading Forex, Marché boursier, Trading d’indices, Trading de matières premières, Portefeuille diversifié, Actifs Excent Capital",
            canonical: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                url: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance/": {
            lang: "fr",
            title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
            description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
            keywords: "Excent Capital, Investissements internationaux, Diversifier son portefeuille, Marchés mondiaux, Partenaire de trading fiable, Trading Forex, Plateforme de trading internationale, Opportunités d’investissement",
            canonical: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                url: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/centre-educatif-excent-capital/": {
            lang: "fr",
            title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
            description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
            keywords: "Formation en Trading, Apprendre à Trader, Tutoriels de Trading, Cours de Trading, Formation Excent Capital, Guide de Trading Débutant, Stratégies de Trading Avancées, Ressources de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                url: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/investissez-en-confiance/": {
            lang: "fr",
            title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
            description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
            keywords: "Gestion des Risques, Outils de Risque en Trading, Protection des Investissements, Stratégies Excent Capital, Trading en Confiance, Volatilité du Marché, Outils de Trading, Gérer le Risque en Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                url: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/trading/a-linterieur-du-trading/": {
            lang: "fr",
            title: "Dans le monde du Trading : Ce que vous allez découvrir",
            description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
            keywords: "Guide de Trading, Perspectives de Marché, Concepts de Trading, Comment Trader, Plateforme Excent Capital, Fonctionnalités de Trading, Apprendre à Trader, Base de Connaissances en Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/a-linterieur-du-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/a-linterieur-du-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/instruments-chez-excent-capital/": {
            lang: "fr",
            title: "Instruments chez Excent Capital",
            description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
            keywords: "Instruments de Trading, Forex, Actions, Matières Premières, Indices, Actifs Excent Capital, Instruments Financiers, Options d’Investissement, Marchés de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/instruments-chez-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/instruments-chez-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/effet-de-levier-excent-capital/": {
            lang: "fr",
            title: "Effet de levier proposé par Excent Capital",
            description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
            keywords: "Trading avec Effet de Levier, Trading avec Levier, Levier Excent Capital, Trading sur Marge, Options de Levier, Amplifier le Trading, Levier Forex, Trading Responsable",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/effet-de-levier-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/effet-de-levier-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/micro-lots-at-excent-capital/": {
            lang: "fr",
            title: "Micro lots chez Excent Capital",
            description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
            keywords: "Trading en Micro Lots, Micro Lots Excent Capital, Trading en Petits Lots, Trading Débutant, Gestion des Risques, Trading Flexible, Micro Lots Forex, Trading à Faible Exposition",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/horaires-de-trading/": {
            lang: "fr",
            title: "Heures de Trading",
            description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
            keywords: "Heures de Trading, Horaires de Marché, Horaires de Trading Forex, Heures du Marché Boursier, Calendrier Excent Capital, Sessions de Trading, Périodes de Trading, Horaires des Marchés Financiers",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/horaires-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.test.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/horaires-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/outils-de-trading/": {
            lang: "fr",
            title: "Outils de Trading",
            description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
            keywords: "Outils de Trading, Outils d’Analyse de Marché, Calculateurs de Trading, Outils Forex, Plateforme Excent Capital, Ressources de Trading, Outils de Graphiques, Trading Informé",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "fr/trading/outils-de-trading-acuity/": {
            lang: "fr",
            title: "Outils de Trading Acuity",
            description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
            keywords: "Outils de Trading Acuity, Outils de Trading IA, Analyse du Sentiment de Marché, Insights de Marché en Temps Réel, Outils Excent Capital, Insights Acuity, Trading Intelligent, Analytique de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "fr/trading/appels-de-marge/": {
            lang: "fr",
            title: "Appels de Marge",
            description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
            keywords: "Appels de Marge, Qu’est-ce qu’un Appel de Marge, Marge Excent Capital, Trading sur Marge, Liquidation Forcée, Protection de Compte, Trading avec Marge, Gestion des Risques",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/appels-de-marge",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.test.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/appels-de-marge",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/trading-de-cfd/": {
            lang: "fr",
            title: "Trading de CFD",
            description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
            keywords: "Trading de CFD, Contrats sur la Différence, Trader les CFD, CFD Excent Capital, Trading avec Effet de Levier, Trading de Produits Dérivés, Marchés CFD, Comment Trader les CFD",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/ordres-en-attente/": {
            lang: "fr",
            title: "Ordres en Attente",
            description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
            keywords: "Ordres en Attente, Ordres de Trading, Buy Stop, Sell Stop, Ordres Limites, Trading Automatisé, Ordres Excent Capital, Points d’Entrée, Stratégie de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/ordres-en-attente",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.test.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/ordres-en-attente",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/spreads-offerts/": {
            lang: "fr",
            title: "Spreads Proposés",
            description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
            keywords: "Spreads, Spreads de Volatilité, Marchés Financiers, Spreads de Trading, Réduire les Coûts de Trading, Optimiser la Rentabilité, Stratégies de Trading, Analyse des Spreads, Spreads Forex, Spreads Boursiers",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/spreads-offerts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/spreads-offerts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/devises-de-base/": {
            lang: "fr",
            title: "Devises de Base",
            description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
            keywords: "Devises de Base, Devises Acceptées, Compte Excent Capital, Options de Devise de Compte, Sélection de Devise, Devise de Trading, Devise de Base Forex, Options de Financement",
            canonical: "https://knowledgebase.test.excent.capital/fr/trading/devises-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.test.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                url: "https://knowledgebase.test.excent.capital/fr/trading/devises-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/ressources/a-linterieur-des-ressources/": {
            lang: "fr",
            title: "Dans la section Ressources : Ce que vous allez découvrir",
            description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Mises à Jour du Marché, Calendrier Économique, Formation au Trading, Centre de Ressources, Apprendre à Trader, Supports de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/ressources/a-linterieur-des-ressources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                url: "https://knowledgebase.test.excent.capital/fr/ressources/a-linterieur-des-ressources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-de-base/": {
            lang: "fr",
            title: "Concepts de Base",
            description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
            keywords: "Concepts de Base en Trading, Trading pour Débutants, Bases du Marché, Formation Excent Capital, Terminologie du Trading, Guide Débutant, Apprendre à Trader, Concepts Fondamentaux",
            canonical: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                url: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-avances/": {
            lang: "fr",
            title: "Concepts Avancés",
            description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
            keywords: "Concepts Avancés en Trading, Stratégies de Trading, Indicateurs Techniques, Trading Expert, Formation Excent Capital, Analyse de Marché, Outils pour Traders Pros, Techniques de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-avances",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                url: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-avances",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/ressources-supplementaires/": {
            lang: "fr",
            title: "Ressources Supplémentaires",
            description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Glossaire de Termes, Guides de Plateforme, Aide au Trading, Outils de Marché, Ressources Éducatives, Support de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/ressources/ressources-supplementaires",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                url: "https://knowledgebase.test.excent.capital/fr/ressources/ressources-supplementaires",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/mon-compte/a-linterieur-de-mon-compte/": {
            lang: "fr",
            title: "Dans Mon Compte : Ce que vous allez découvrir",
            description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
            keywords: "Mon Compte, Gestion de Compte, Profil Excent Capital, Paramètres de Compte de Trading, Sécurité du Compte, Tableau de Bord Utilisateur, Mise à Jour de Profil, Gérer un Compte de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-demo/": {
            lang: "fr",
            title: "Puis-je Créer un Compte Démo ?",
            description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
            keywords: "Compte Démo, Pratique de Trading, Démo Excent Capital, Trading Sans Risque, Créer un Compte Démo, Simulateur de Trading, Trading Débutant, Apprendre à Trader",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-reel/": {
            lang: "fr",
            title: "Comment créer un compte réel ?",
            description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
            keywords: "Compte Réel, Créer un Compte de Trading, Inscription Excent Capital, Ouvrir un Compte Réel, Commencer à Trader, Compte de Trading Réel, Inscription au Trading, Configuration de Compte",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-reel",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-reel",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-votre-compte/": {
            lang: "fr",
            title: "Pourquoi vérifier votre compte ?",
            description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
            keywords: "Vérification de Compte, Vérifier un Compte de Trading, KYC Excent Capital, Sécurité du Trading, Processus de Conformité, Vérification d’Identité, Trading Sécurisé, Accès Complet au Compte",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-votre-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-votre-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/acceder-a-la-plateforme/": {
            lang: "fr",
            title: "Comment accéder à la plateforme ?",
            description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
            keywords: "Accès à la Plateforme de Trading, Connexion Excent Capital, Application de Trading, Plateforme Web de Trading, Trading Mobile, Comment Se Connecter, Commencer à Trader, Guide d’Accès à la Plateforme",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/delai-pour-creer-un-compte/": {
            lang: "fr",
            title: "Combien de temps faut-il pour créer un compte ?",
            description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
            keywords: "Temps de Création de Compte, Inscription Excent Capital, Comment Créer un Compte, Configuration du Compte de Trading, Processus d’Enregistrement, Ouvrir un Compte Rapidement, Intégration au Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/comptes-corporatifs/": {
            lang: "fr",
            title: "Proposez-vous des comptes professionnels ?",
            description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
            keywords: "Compte de Trading Professionnel, Compte Entreprise, Compte Corporate Excent Capital, Trading Institutionnel, Ouvrir un Compte Corporate, Trading pour Entreprises, Compte d’Investissement Professionnel",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/comptes-corporatifs",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/comptes-corporatifs",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/plusieurs-comptes-meme-email/": {
            lang: "fr",
            title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
            description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
            keywords: "Comptes Multiples, Comptes avec le Même E-mail, Rôles Excent Capital, Rôles Utilisateur, Gestion de Compte, Accès au Compte de Trading, Accès Basé sur les Rôles, Politique d’Enregistrement par E-mail",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mettre-a-jour-informations-compte/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mot-de-passe-oublie/": {
            lang: "fr",
            title: "Que se passe-t-il si j’oublie mon mot de passe ?",
            description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
            keywords: "Mot de Passe Oublié, Récupération de Mot de Passe, Réinitialiser Mot de Passe Trading, Aide Connexion Excent Capital, Accès au Compte, Récupérer Mot de Passe, Mot de Passe Perdu, Connexion Compte de Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/mot-de-passe-oublie",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/documents-pour-verification/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/documents-pour-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/documents-pour-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/amis-famille-utiliser-compte/": {
            lang: "fr",
            title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
            description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
            keywords: "Partage de Compte, Politique Excent Capital, Utilisation Personnelle du Compte, Sécurité du Compte de Trading, Accès Partagé, Utilisation Familiale du Compte, Sécurité du Compte, Conformité en Trading",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/annuler-mon-compte/": {
            lang: "fr",
            title: "Comment annuler mon compte",
            description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
            keywords: "Annuler Compte de Trading, Fermer Compte Excent Capital, Résiliation de Compte, Supprimer Compte, Clôture de Compte de Trading, Fermer Compte, Support Excent Capital, Processus d’Annulation de Compte",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/annuler-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/annuler-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-compte-depuis-etranger/": {
            lang: "fr",
            title: "Puis-je vérifier mon compte depuis un pays étranger ?",
            description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
            keywords: "Vérifier Compte à l’Étranger, Vérification Excent Capital, Création de Compte depuis l’Étranger, KYC International, Vérification de Compte à Distance, Documents de Compte, Vérification Hors Pays",
            canonical: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                url: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/depots-retraits/a-linterieur-depots-retraits/": {
            lang: "fr",
            title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
            description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
            keywords: "Dépôts et Retraits, Financement Excent Capital, Retirer des Gains, Méthodes de Paiement, Options de Dépôt, Délais de Retrait, Financement du Compte de Trading, Transactions Financières",
            canonical: "https://knowledgebase.test.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                url: "https://knowledgebase.test.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/premier-depot/": {
            lang: "fr",
            title: "Comment effectuer un premier dépôt ?",
            description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
            keywords: "Premier Dépôt, Effectuer un Dépôt, Financement Excent Capital, Dépôt Compte de Trading, Comment Déposer, Méthodes de Paiement, Commencer à Trader, Approvisionner Compte",
            canonical: "https://knowledgebase.test.excent.capital/fr/depots-retraits/premier-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                url: "https://knowledgebase.test.excent.capital/fr/depots-retraits/premier-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-depot/": {
            lang: "fr",
            title: "Comment effectuer un dépôt ?",
            description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
            keywords: "Déposer des Fonds, Comment Déposer, Méthodes de Paiement Excent Capital, Financement Compte de Trading, Effectuer un Dépôt, Dépôt Sécurisé, Recharger Compte, Processus de Dépôt",
            canonical: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                url: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-retrait/": {
            lang: "fr",
            title: "Comment effectuer un retrait ?",
            description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
            keywords: "Retirer des Fonds, Retrait Excent Capital, Comment Retirer, Paiement Compte de Trading, Processus de Retrait, Retrait Sécurisé, Accéder aux Gains, Méthodes de Paiement",
            canonical: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                url: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/echec-du-retrait/": {
            lang: "fr",
            title: "Que faire si mon retrait échoue ?",
            description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
            keywords: "Retrait Échoué, Aide Excent Capital, Transaction Échouée, Résoudre un Problème de Retrait, Problème de Retrait, Erreur de Paiement, Support Compte de Trading, Corriger un Problème de Retrait",
            canonical: "https://knowledgebase.test.excent.capital/fr/depots-retraits/echec-du-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                url: "https://knowledgebase.test.excent.capital/fr/depots-retraits/echec-du-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/paiements/a-linterieur-des-paiements/": {
            lang: "fr",
            title: "Dans la section Paiements : Ce que vous allez découvrir",
            description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
            keywords: "Paiements Excent Capital, Méthodes de Paiement Acceptées, Gestion des Transactions, Délai de Traitement des Paiements, Devises Supportées, Paiements de Trading, Options de Dépôt et de Retrait, Financement de Compte",
            canonical: "https://knowledgebase.test.excent.capital/fr/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.test.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                url: "https://knowledgebase.test.excent.capital/fr/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/voir-historique-paiements/": {
            lang: "fr",
            title: "Comment voir mon historique de paiements ?",
            description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
            keywords: "Historique des Paiements, Historique des Transactions, Voir les Dépôts, Voir les Retraits, Paiements Excent Capital, Transactions du Compte, Historique Compte de Trading, Relevés Financiers",
            canonical: "https://knowledgebase.test.excent.capital/fr/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.test.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                url: "https://knowledgebase.test.excent.capital/fr/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/delai-de-transaction/": {
            lang: "fr",
            title: "Combien de temps une transaction peut-elle prendre ?",
            description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
            keywords: "Délai de Transaction, Temps de Traitement, Durée du Dépôt, Durée du Retrait, Paiements Excent Capital, Vitesse de Paiement, Transactions Compte de Trading, Retard de Transactions",
            canonical: "https://knowledgebase.test.excent.capital/fr/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.test.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                url: "https://knowledgebase.test.excent.capital/fr/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Italiano
        "it/": {
            lang: "it",
            title: "Knowledgebase | Excent Capital",
            description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
            keywords: "Centro Assistenza Excent Capital, Supporto Piattaforma di Trading, FAQ Trading, Come Fare Trading, Tutorial FX, Gestione Account, Guide al Trading, Assistenza Depositi, Assistenza Prelievi",
            canonical: "https://knowledgebase.test.excent.capital/it/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en",
                es: "https://knowledgebase.test.excent.capital/es",
                pt: "https://knowledgebase.test.excent.capital/pt",
                fr: "https://knowledgebase.test.excent.capital/fr",
                it: "https://knowledgebase.test.excent.capital/it",
                zh: "https://knowledgebase.test.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                url: "https://knowledgebase.test.excent.capital/it/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/dentro-di-noi/": {
            lang: "it",
            title: "Dentro Chi Siamo: Cosa Scoprirai",
            description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
            keywords: "Chi è Excent Capital, Missione Aziendale, Valori Società di Trading, Conosci il Team, Chi è Excent Capital, La Nostra Storia, Società di Servizi Finanziari, Panoramica Excent Capital",
            canonical: "https://knowledgebase.test.excent.capital/it/chi-siamo/dentro-di-noi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                url: "https://knowledgebase.test.excent.capital/it/chi-siamo/dentro-di-noi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/su-excent-capital/": {
            lang: "it",
            title: "Chi è Excent Capital",
            description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
            keywords: "Excent Capital, Chi Siamo, Panoramica Aziendale, Società di Trading, Servizi Finanziari, Società di Investimenti, La Nostra Missione, Chi Siamo Noi, Supporto al Trading Globale",
            canonical: "https://knowledgebase.test.excent.capital/it/chi-siamo/su-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                url: "https://knowledgebase.test.excent.capital/it/chi-siamo/su-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/costruisci-il-tuo-portafoglio/": {
            lang: "it",
            title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
            description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
            keywords: "Costruire Portafoglio, Strumenti di Trading, Trading Forex, Mercato Azionario, Trading Indici, Trading Materie Prime, Portafoglio Diversificato, Asset di Excent Capital",
            canonical: "https://knowledgebase.test.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                url: "https://knowledgebase.test.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia/": {
            lang: "it",
            title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
            description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
            keywords: "Excent Capital, Investimenti Internazionali, Diversificare Portafoglio, Mercati Globali, Partner Affidabile per il Trading, Trading Forex, Piattaforma di Trading Internazionale, Opportunità di Investimento",
            canonical: "https://knowledgebase.test.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                url: "https://knowledgebase.test.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/centro-educativo-excent-capital/": {
            lang: "it",
            title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
            description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
            keywords: "Formazione sul Trading, Imparare a Fare Trading, Tutorial di Trading, Corsi di Trading, Formazione Excent Capital, Guida al Trading per Principianti, Strategie Avanzate di Trading, Risorse di Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                url: "https://knowledgebase.test.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/investi-con-fiducia/": {
            lang: "it",
            title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
            description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
            keywords: "Gestione del Rischio, Strumenti per il Rischio di Trading, Protezione degli Investimenti, Strategie Excent Capital, Trading con Fiducia, Volatilità di Mercato, Strumenti di Trading, Gestire il Rischio nel Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/chi-siamo/investi-con-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                url: "https://knowledgebase.test.excent.capital/it/chi-siamo/investi-con-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/trading/dentro-del-trading-it/": {
            lang: "it",
            title: "Dentro il Trading: Cosa Scoprirai",
            description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
            keywords: "Guida al Trading, Approfondimenti di Mercato, Concetti di Trading, Come Fare Trading, Piattaforma Excent Capital, Funzionalità di Trading, Imparare il Trading, Base di Conoscenza del Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/dentro-del-trading-it",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                url: "https://knowledgebase.test.excent.capital/it/trading/dentro-del-trading-it",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-excent-capital/": {
            lang: "it",
            title: "Strumenti su Excent Capital",
            description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
            keywords: "Strumenti di Trading, Forex, Azioni, Materie Prime, Indici, Asset Excent Capital, Strumenti Finanziari, Opzioni di Investimento, Mercati di Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/strumenti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                url: "https://knowledgebase.test.excent.capital/it/trading/strumenti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/leva-excent-capital/": {
            lang: "it",
            title: "Leva Finanziaria Offerta da Excent Capital",
            description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
            keywords: "Trading con Leva, Trading a Leva, Leva Excent Capital, Trading con Margine, Opzioni di Leva, Amplificare il Trading, Leva Forex, Trading Responsabile",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/leva-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                url: "https://knowledgebase.test.excent.capital/it/trading/leva-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/micro-lotti-excent-capital/": {
            lang: "it",
            title: "Micro Lotti su Excent Capital",
            description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
            keywords: "Trading con Micro Lotti, Micro Lotti Excent Capital, Trading con Lotti Piccoli, Trading per Principianti, Gestione del Rischio, Trading Flessibile, Micro Lotti Forex, Trading a Bassa Esposizione",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/micro-lotti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                url: "https://knowledgebase.test.excent.capital/it/trading/micro-lotti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/orari-di-trading/": {
            lang: "it",
            title: "Orari di Trading",
            description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
            keywords: "Orari di Trading, Orari di Mercato, Orari Forex, Orari Mercato Azionario, Calendario Excent Capital, Sessioni di Trading, Tempi di Trading, Orari Mercati Finanziari",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/orari-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.test.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                url: "https://knowledgebase.test.excent.capital/it/trading/orari-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-di-trading/": {
            lang: "it",
            title: "Strumenti di Trading",
            description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
            keywords: "Strumenti di Trading, Strumenti di Analisi di Mercato, Calcolatori di Trading, Strumenti Forex, Piattaforma Excent Capital, Risorse per il Trading, Strumenti di Analisi Grafica, Trading Informato",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                url: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "it/trading/strumenti-di-trading-acuity/": {
            lang: "it",
            title: "Strumenti Acuity per il Trading",
            description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
            keywords: "Strumenti Acuity per il Trading, Strumenti di Trading AI, Analisi del Sentiment di Mercato, Approfondimenti di Mercato in Tempo Reale, Strumenti Excent Capital, Approfondimenti Acuity, Trading Intelligente, Analisi di Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                url: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "it/trading/chiamate-di-margine/": {
            lang: "it",
            title: "Chiamate di Margine",
            description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
            keywords: "Chiamate di Margine, Cos’è una Chiamata di Margine, Margine Excent Capital, Margine di Trading, Liquidazione Forzata, Protezione dell’Account, Trading con Margine, Gestione del Rischio",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/chiamate-di-margine",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.test.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.test.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                url: "https://knowledgebase.test.excent.capital/it/trading/chiamate-di-margine",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/trading-di-cfd/": {
            lang: "it",
            title: "Trading CFD",
            description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
            keywords: "Trading CFD, Contratti per Differenza, Fare Trading con i CFD, CFD Excent Capital, Trading con Leva, Trading di Derivati, Mercati CFD, Come Fare Trading con i CFD",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/trading-di-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.test.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                url: "https://knowledgebase.test.excent.capital/it/trading/trading-di-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/ordini-pendenti/": {
            lang: "it",
            title: "Ordini Pendenti",
            description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
            keywords: "Ordini Pendenti, Ordini di Trading, Buy Stop, Sell Stop, Ordini Limit, Trading Automatizzato, Ordini Excent Capital, Punti di Ingresso, Strategia di Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/ordini-pendenti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.test.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.test.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                url: "https://knowledgebase.test.excent.capital/it/trading/ordini-pendenti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/spreads-offerti/": {
            lang: "it",
            title: "Spread Offerti",
            description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
            keywords: "Spread, Spread di Volatilità, Mercati Finanziari, Spread di Trading, Ridurre i Costi di Trading, Ottimizzare la Redditività, Strategie di Trading, Analisi degli Spread, Spread Forex, Spread Azionari",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/spreads-offerti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                url: "https://knowledgebase.test.excent.capital/it/trading/spreads-offerti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/valute-di-base/": {
            lang: "it",
            title: "Valute di Base",
            description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
            keywords: "Valute di Base, Valute Supportate, Conto Excent Capital, Opzioni di Valuta del Conto, Selezione della Valuta, Valuta di Trading, Valuta Base Forex, Opzioni di Finanziamento",
            canonical: "https://knowledgebase.test.excent.capital/it/trading/valute-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.test.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.test.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                url: "https://knowledgebase.test.excent.capital/it/trading/valute-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/risorse/dentro-dei-risorse/": {
            lang: "it",
            title: "Risorse Interne: Cosa Scoprirai",
            description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Aggiornamenti di Mercato, Calendario Economico, Formazione al Trading, Centro Risorse, Impara a Fare Trading, Materiali di Supporto al Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/risorse/dentro-dei-risorse",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.test.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                url: "https://knowledgebase.test.excent.capital/it/risorse/dentro-dei-risorse",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-di-base/": {
            lang: "it",
            title: "Concetti di Base",
            description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
            keywords: "Concetti Base di Trading, Trading per Principianti, Basi di Mercato, Formazione Excent Capital, Terminologia del Trading, Guida per Principianti, Imparare il Trading, Concetti Fondamentali",
            canonical: "https://knowledgebase.test.excent.capital/it/risorse/concetti-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.test.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.test.excent.capital/it/risorse/concetti-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-avanzati/": {
            lang: "it",
            title: "Concetti Avanzati",
            description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
            keywords: "Concetti Avanzati di Trading, Strategie di Trading, Indicatori Tecnici, Trading Esperto, Formazione Excent Capital, Analisi di Mercato, Strumenti per Trader Professionisti, Tecniche di Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/risorse/concetti-avanzati",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.test.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                url: "https://knowledgebase.test.excent.capital/it/risorse/concetti-avanzati",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/risorse-addizionali/": {
            lang: "it",
            title: "Risorse Aggiuntive",
            description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Glossario dei Termini, Guide alla Piattaforma, Aiuto Trading, Strumenti di Mercato, Risorse Educative, Supporto al Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/risorse/risorse-addizionali",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.test.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                url: "https://knowledgebase.test.excent.capital/it/risorse/risorse-addizionali",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/il-mio-conto/dentro-del-mio-conto/": {
            lang: "it",
            title: "Dentro il Mio Account: Cosa Scoprirai",
            description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
            keywords: "Il Mio Account, Gestione Account, Profilo Excent Capital, Impostazioni Account Trading, Sicurezza Account, Dashboard Utente, Aggiornamento Profilo, Gestire Account Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-demo/": {
            lang: "it",
            title: "Posso Creare un Account Demo?",
            description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
            keywords: "Account Demo, Trading di Prova, Demo Excent Capital, Trading Senza Rischi, Creare Account Demo, Simulatore di Trading, Trading per Principianti, Impara a Fare Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-reale/": {
            lang: "it",
            title: "Come Creare un Account Reale?",
            description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
            keywords: "Account Reale, Creare Account di Trading, Registrazione Excent Capital, Apri Account Reale, Inizia a Fare Trading, Account di Trading Reale, Iscrizione al Trading, Configurazione Account",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-reale",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/perche-verificare-il-conto/": {
            lang: "it",
            title: "Perché Verificare il Tuo Account?",
            description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
            keywords: "Verifica Account, Verificare Account di Trading, KYC Excent Capital, Sicurezza del Trading, Processo di Conformità, Verifica Identità, Trading Sicuro, Accesso Completo Account",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/accedere-alla-piattaforma/": {
            lang: "it",
            title: "Come Accedere alla Piattaforma?",
            description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
            keywords: "Accedere alla Piattaforma di Trading, Login Excent Capital, App di Trading, Piattaforma Web di Trading, Trading Mobile, Come Effettuare il Login, Inizia a Fare Trading, Guida Accesso Piattaforma",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/tempo-per-creare-un-conto/": {
            lang: "it",
            title: "Quanto Tempo Ci Vuole per Creare un Account?",
            description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
            keywords: "Tempo Creazione Account, Iscrizione Excent Capital, Come Creare un Account, Configurazione Account di Trading, Processo di Registrazione, Apri un Account Velocemente, Onboarding Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conti-corporativi/": {
            lang: "it",
            title: "Offrite Account Aziendali?",
            description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
            keywords: "Account di Trading Aziendale, Account Business, Corporate Excent Capital, Trading Istituzionale, Apri Account Aziendale, Trading per Aziende, Account Investimenti Aziendali",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conti-corporativi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conti-corporativi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/piu-conti-stessa-email/": {
            lang: "it",
            title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
            description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
            keywords: "Più Account, Account con Stessa Email, Ruoli Excent Capital, Ruoli Utente, Gestione Account, Accesso Account Trading, Accesso Basato su Ruoli, Politica di Registrazione Email",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/aggiornare-informazioni-del-conto/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/password-dimenticata/": {
            lang: "it",
            title: "Cosa Succede se Dimentico la Password?",
            description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
            keywords: "Password Dimenticata, Recupero Password, Reimposta Password Trading, Aiuto Accesso Excent Capital, Accesso Account, Recuperare Password, Password Persa, Login Account Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/password-dimenticata",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/password-dimenticata",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/documenti-per-verifica/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/documenti-per-verifica",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/documenti-per-verifica",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conto-utilizzato-da-terzi/": {
            lang: "it",
            title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
            description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
            keywords: "Condivisione Account, Politica Excent Capital, Uso Personale Account, Sicurezza Account Trading, Accesso Condiviso, Uso da Parte della Famiglia, Sicurezza Account, Conformità nel Trading",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/cancellare-il-conto/": {
            lang: "it",
            title: "Come Posso Cancellare il Mio Account?",
            description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
            keywords: "Cancellare Account Trading, Chiudere Account Excent Capital, Terminazione Account, Eliminare Account, Chiusura Account Trading, Disattivazione Account, Supporto Excent Capital, Processo di Cancellazione Account",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/cancellare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/cancellare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/verificare-conto-dall-estero/": {
            lang: "it",
            title: "Posso Verificare il Mio Account da un Paese Straniero?",
            description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
            keywords: "Verificare Account dall’Estero, Verifica Excent Capital, Configurazione Account da Paese Straniero, KYC Internazionale, Verifica Remota Account, Documenti Account, Verifica Estera",
            canonical: "https://knowledgebase.test.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                url: "https://knowledgebase.test.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/depositi-prelievi/dentro-depositi-prelievi/": {
            lang: "it",
            title: "Scopri Depositi e Prelievi: Cosa Troverai",
            description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
            keywords: "Depositi e Prelievi, Finanziamento Excent Capital, Prelevare Profitti, Metodi di Pagamento, Opzioni di Deposito, Tempi di Prelievo, Finanziamento Conto Trading, Transazioni Finanziarie",
            canonical: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                url: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/primo-deposito/": {
            lang: "it",
            title: "Come Effettuare un Primo Deposito?",
            description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
            keywords: "Primo Deposito, Effettuare un Deposito, Finanziamento Excent Capital, Deposito Conto Trading, Come Depositare, Metodi di Pagamento, Inizia a Fare Trading, Finanzia il Tuo Conto",
            canonical: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/primo-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/primo-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-deposito/": {
            lang: "it",
            title: "Come Effettuare un Deposito?",
            description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
            keywords: "Deposita Fondi, Come Depositare, Metodi di Pagamento Excent Capital, Finanziamento Conto Trading, Effettuare un Deposito, Deposito Sicuro, Ricarica Account, Processo di Deposito",
            canonical: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                url: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-prelievo/": {
            lang: "it",
            title: "Come Posso Effettuare un Prelievo?",
            description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
            keywords: "Preleva Fondi, Prelievo Excent Capital, Come Prelevare, Pagamento Conto Trading, Processo di Prelievo, Prelievo Sicuro, Accedere ai Guadagni, Metodi di Pagamento",
            canonical: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                url: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/prelievo-non-riuscito/": {
            lang: "it",
            title: "Cosa Fare se il Mio Prelievo Fallisce?",
            description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
            keywords: "Prelievo Fallito, Aiuto Excent Capital, Transazione Fallita, Risoluzione Problema Prelievo, Problemi di Prelievo, Errore di Pagamento, Supporto Conto Trading, Correggere Problema di Prelievo",
            canonical: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                url: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/paiements/a-linterieur-des-paiements/": {
            lang: "it",
            title: "Scopri i Pagamenti: Cosa Troverai",
            description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
            keywords: "Pagamenti Excent Capital, Metodi di Pagamento Accettati, Gestione Transazioni, Tempo di Elaborazione Pagamenti, Valute Supportate, Pagamenti di Trading, Opzioni di Deposito e Prelievo, Finanziamento Conto",
            canonical: "https://knowledgebase.test.excent.capital/it/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.test.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.test.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                url: "https://knowledgebase.test.excent.capital/it/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/voir-historique-paiements/": {
            lang: "it",
            title: "Come Vedo lo Storico dei Pagamenti?",
            description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
            keywords: "Storico Pagamenti, Storico Transazioni, Visualizza Depositi, Visualizza Prelievi, Pagamenti Excent Capital, Transazioni Conto, Storico Conto Trading, Registrazioni Finanziarie",
            canonical: "https://knowledgebase.test.excent.capital/it/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.test.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.test.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                url: "https://knowledgebase.test.excent.capital/it/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/delai-de-transaction/": {
            lang: "it",
            title: "Quanto Può Durare una Transazione?",
            description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
            keywords: "Tempo Transazione, Tempo di Elaborazione, Durata Deposito, Durata Prelievo, Pagamenti Excent Capital, Velocità di Pagamento, Transazioni Conto Trading, Ritardi nelle Transazioni",
            canonical: "https://knowledgebase.test.excent.capital/it/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.test.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.test.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.test.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                url: "https://knowledgebase.test.excent.capital/it/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Cantones
        //Italiano
        "zh/": {
            lang: "zh-HK",
            title: "知識庫 | Excent Capital",
            description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
            keywords: "Excent Capital 幫助中心, 交易平台支援, 交易常見問題, 如何交易, 外匯教學, 帳戶管理, 交易指南, 存款協助, 提款協助",
            canonical: "https://knowledgebase.test.excent.capital/zh/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en",
                es: "https://knowledgebase.test.excent.capital/es",
                pt: "https://knowledgebase.test.excent.capital/pt",
                fr: "https://knowledgebase.test.excent.capital/fr",
                it: "https://knowledgebase.test.excent.capital/it",
                zh: "https://knowledgebase.test.excent.capital/zh",
            },
            openGraph: {
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                url: "https://knowledgebase.test.excent.capital/zh/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/inside-about-us-zh/": {
            lang: "zh-HK",
            title: "關於我們：你將發現什麼",
            description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
            keywords: "關於 Excent Capital, 公司使命, 交易公司價值觀, 認識團隊, 誰是 Excent Capital, 我們的故事, 金融服務公司, Excent Capital 概覽",
            canonical: "https://knowledgebase.test.excent.capital/zh/about-us-zh/inside-about-us-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.test.excent.capital/zh/about-us-zh/inside-about-us-zh",
            },
            openGraph: {
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                url: "https://knowledgebase.test.excent.capital/zh/about-us-zh/inside-about-us-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/about-excent-capital-zh/": {
            lang: "zh-HK",
            title: "關於 Excent Capital",
            description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
            keywords: "Excent Capital, 關於我們, 公司概況, 交易公司, 金融服務, 交易機構, 我們的使命, 我們是誰, 全球交易支援",
            canonical: "https://knowledgebase.test.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            },
            openGraph: {
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                url: "https://knowledgebase.test.excent.capital/zh/about-us-zh/about-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/build-your-portfolio-zh/": {
            lang: "zh-HK",
            title: "建立您的投資組合：Excent Capital 的多樣化選擇",
            description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
            keywords: "建立投資組合, 交易工具, 外匯交易, 股市, 指數交易, 商品交易, 多元化投資組合, Excent Capital 資產",
            canonical: "https://knowledgebase.test.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.test.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            },
            openGraph: {
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                url: "https://knowledgebase.test.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-your-trusted-partner-zh/": {
            lang: "zh-HK",
            title: "Excent Capital：助您分散國際市場投資的可信伙伴",
            description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
            keywords: "Excent Capital, 國際投資, 分散投資組合, 全球市場, 可信交易伙伴, 外匯交易, 國際交易平台, 投資機會",
            canonical: "https://knowledgebase.test.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.test.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            },
            openGraph: {
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                url: "https://knowledgebase.test.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-education-center-zh/": {
            lang: "zh-HK",
            title: "提升你的交易能力：Excent Capital 教育中心",
            description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
            keywords: "交易教育, 學習交易, 交易教學, 交易課程, Excent Capital 教育, 初學者交易指南, 高級交易策略, 交易資源",
            canonical: "https://knowledgebase.test.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            },
            openGraph: {
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                url: "https://knowledgebase.test.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/invest-with-confidence-zh/": {
            lang: "zh-HK",
            title: "自信投資：Excent Capital 的風險管理策略與工具",
            description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
            keywords: "風險管理, 交易風險工具, 投資保護, Excent Capital 策略, 自信交易, 市場波動性, 交易工具, 管理交易風險",
            canonical: "https://knowledgebase.test.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.test.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.test.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.test.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.test.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.test.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            },
            openGraph: {
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                url: "https://knowledgebase.test.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/trading-zh/inside-trading-zh/": {
            lang: "zh-HK",
            title: "交易內幕：你將發現的內容",
            description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
            keywords: "交易指南, 市場見解, 交易概念, 如何交易, Excent Capital 平台, 交易功能, 學習交易, 交易知識庫",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/inside-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/inside-trading-zh",
            },
            openGraph: {
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/inside-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/instruments-in-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的交易工具",
            description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
            keywords: "交易工具, 外匯, 股票, 商品, 指數, Excent Capital 資產, 金融工具, 投資選項, 交易市場",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/leverage-offered-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的槓桿",
            description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
            keywords: "槓桿交易, 使用槓桿進行交易, Excent Capital 槓桿, 保證金交易, 槓桿選項, 放大交易, 外匯槓桿, 負責任交易",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/micro-lots-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 的微型手數交易",
            description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
            keywords: "微型手數交易, Excent Capital 微型手數, 小手數交易, 初學者交易, 風險管理, 靈活交易, 外匯微型手數, 低風險交易",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.test.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.test.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-hours-zh/": {
            lang: "zh-HK",
            title: "交易時間",
            description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
            keywords: "交易時間, 市場開市時間, 外匯交易時間, 股票市場時間, Excent Capital 時間表, 交易時段, 交易時機, 金融市場時間",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/trading-hours-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.test.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/trading-hours-zh",
            },
            openGraph: {
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/trading-hours-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-tools-zh/": {
            lang: "zh-HK",
            title: "交易工具",
            description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
            keywords: "交易工具, 市場分析工具, 交易計算機, 外匯工具, Excent Capital 平台, 交易資源, 繪圖工具, 明智交易",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/trading-tools-zh",
            },
            openGraph: {
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "zh/trading-zh/acuity-trading-tools-zh/": {
            lang: "zh-HK",
            title: "Acuity 交易工具",
            description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
            keywords: "Acuity 交易工具, AI 交易工具, 市場情緒分析, 即時市場洞察, Excent Capital 工具, Acuity 洞察, 智能交易, 交易分析",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.test.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.test.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            },
            openGraph: {
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "zh/trading-zh/margin-calls-zh/": {
            lang: "zh-HK",
            title: "追加保證金通知（Margin Calls）",
            description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
            keywords: "追加保證金通知, 什麼是追加保證金, Excent Capital 保證金, 交易保證金, 強制平倉, 帳戶保護, 保證金交易, 風險管理",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/margin-calls-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.test.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.test.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/margin-calls-zh",
            },
            openGraph: {
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/margin-calls-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/cfd-trading-zh/": {
            lang: "zh-HK",
            title: "差價合約（CFD）交易",
            description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
            keywords: "CFD 交易, 差價合約, 交易 CFD, Excent Capital CFD, 槓桿交易, 衍生工具交易, CFD 市場, 如何交易 CFD",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/cfd-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.test.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.test.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/cfd-trading-zh",
            },
            openGraph: {
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/cfd-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/pending-orders-zh/": {
            lang: "zh-HK",
            title: "掛單交易（Pending Orders）",
            description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
            keywords: "掛單交易, 交易指令, 買入止損, 賣出止損, 限價單, 自動化交易, Excent Capital 指令, 入市點, 交易策略",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/pending-orders-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.test.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.test.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/pending-orders-zh",
            },
            openGraph: {
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/pending-orders-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/spreads-offered-zh/": {
            lang: "zh-HK",
            title: "點差介紹",
            description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
            keywords: "點差, 波動點差, 金融市場, 交易點差, 降低交易成本, 提高盈利能力, 交易策略, 點差分析, 外匯點差, 股票市場點差",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/spreads-offered-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.test.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.test.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/spreads-offered-zh",
            },
            openGraph: {
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/spreads-offered-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/base-currencies-zh/": {
            lang: "zh-HK",
            title: "基礎貨幣",
            description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
            keywords: "基礎貨幣, 支援貨幣, Excent Capital 帳戶, 帳戶貨幣選項, 貨幣選擇, 交易貨幣, 外匯基礎貨幣, 資金選項",
            canonical: "https://knowledgebase.test.excent.capital/zh/trading-zh/base-currencies-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.test.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.test.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.test.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.test.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.test.excent.capital/zh/trading-zh/base-currencies-zh",
            },
            openGraph: {
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                url: "https://knowledgebase.test.excent.capital/zh/trading-zh/base-currencies-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/resources-zh/inside-resources-zh/": {
            lang: "zh-HK",
            title: "資源中心導覽",
            description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
            keywords: "交易資源, Excent Capital 工具, 市場更新, 經濟日曆, 交易教學, 資源中心, 學習交易, 交易輔助材料",
            canonical: "https://knowledgebase.test.excent.capital/zh/resources-zh/inside-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.test.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.test.excent.capital/zh/resources-zh/inside-resources-zh",
            },
            openGraph: {
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                url: "https://knowledgebase.test.excent.capital/zh/resources-zh/inside-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/basic-concepts-zh/": {
            lang: "zh-HK",
            title: "基礎概念",
            description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
            keywords: "交易基礎概念, 初學者交易, 市場基礎知識, Excent Capital 教育, 交易術語, 初學者指南, 學習交易, 基礎知識",
            canonical: "https://knowledgebase.test.excent.capital/zh/resources-zh/basic-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.test.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.test.excent.capital/zh/resources-zh/basic-concepts-zh",
            },
            openGraph: {
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                url: "https://knowledgebase.test.excent.capital/zh/resources-zh/basic-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/advanced-concepts-zh/": {
            lang: "zh-HK",
            title: "進階概念",
            description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
            keywords: "進階交易概念, 交易策略, 技術指標, 專業交易, Excent Capital 教育, 市場分析, 專業交易工具, 交易技巧",
            canonical: "https://knowledgebase.test.excent.capital/zh/resources-zh/advanced-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.test.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.test.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.test.excent.capital/zh/resources-zh/advanced-concepts-zh",
            },
            openGraph: {
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                url: "https://knowledgebase.test.excent.capital/zh/resources-zh/advanced-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/additional-resources-zh/": {
            lang: "zh-HK",
            title: "額外資源",
            description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
            keywords: "交易資源, Excent Capital 工具, 詞彙表, 平台指南, 交易協助, 市場工具, 教育資源, 交易支援",
            canonical: "https://knowledgebase.test.excent.capital/zh/resources-zh/additional-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.test.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.test.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.test.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.test.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.test.excent.capital/zh/resources-zh/additional-resources-zh",
            },
            openGraph: {
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                url: "https://knowledgebase.test.excent.capital/zh/resources-zh/additional-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/my-account-zh/inside-my-account-zh/": {
            lang: "zh-HK",
            title: "我的帳戶導覽",
            description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
            keywords: "我的帳戶, 帳戶管理, Excent Capital 個人資料, 交易帳戶設定, 帳戶安全, 使用者儀表板, 資料更新, 管理交易帳戶",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/inside-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/inside-my-account-zh",
            },
            openGraph: {
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/inside-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-to-create-a-demo-account-zh/": {
            lang: "zh-HK",
            title: "我可以開設模擬帳戶嗎？",
            description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
            keywords: "模擬帳戶, 練習交易, Excent Capital 模擬, 無風險交易, 建立模擬帳戶, 交易模擬器, 初學者交易, 學習交易",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            },
            openGraph: {
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-to-create-a-live-account-zh/": {
            lang: "zh-HK",
            title: "如何開立真實帳戶？",
            description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
            keywords: "真實帳戶, 建立交易帳戶, Excent Capital 註冊, 開立真實帳戶, 開始交易, 真實交易帳戶, 交易註冊, 帳戶設置",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            },
            openGraph: {
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/why-verify-your-account-zh/": {
            lang: "zh-HK",
            title: "為什麼要驗證你的帳戶？",
            description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
            keywords: "帳戶驗證, 驗證交易帳戶, Excent Capital KYC, 交易安全, 合規程序, 身份驗證, 安全交易, 完整帳戶訪問",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            },
            openGraph: {
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-access-the-platform-zh/": {
            lang: "zh-HK",
            title: "如何登入平台？",
            description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
            keywords: "登入交易平台, Excent Capital 登入, 交易應用程式, 網絡交易平台, 手機交易, 如何登入, 開始交易, 平台訪問指南",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            },
            openGraph: {
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh/": {
            lang: "zh-HK",
            title: "開立帳戶需時多久？",
            description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
            keywords: "帳戶建立時間, Excent Capital 註冊, 如何開立帳戶, 交易帳戶設置, 註冊流程, 快速開戶, 交易入門",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            },
            openGraph: {
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/do-you-offer-corporate-accounts-zh/": {
            lang: "zh-HK",
            title: "是否提供企業帳戶？",
            description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
            keywords: "企業交易帳戶, 商業帳戶, Excent Capital 企業服務, 機構交易, 開設企業帳戶, 公司交易, 商業投資帳戶",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            },
            openGraph: {
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-open-multiple-accounts-zh/": {
            lang: "zh-HK",
            title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
            description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
            keywords: "多個帳戶, 相同電郵帳戶, Excent Capital 角色, 使用者角色, 帳戶管理, 交易帳戶存取, 角色型訪問, 電郵註冊政策",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            },
            openGraph: {
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-update-my-account-information-zh/": {
            lang: "zh-HK",
            title: "如何更新我的帳戶資料？",
            description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 修改帳戶資訊, 更新交易檔案, 使用者資訊",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            },
            openGraph: {
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-happens-if-i-forget-my-password-zh/": {
            lang: "zh-HK",
            title: "如果我忘記密碼會發生什麼事？",
            description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
            keywords: "忘記密碼, 密碼恢復, 重設交易密碼, Excent Capital 登入幫助, 帳戶存取, 找回密碼, 密碼遺失, 交易帳戶登入",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            },
            openGraph: {
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-documents-are-required-for-account-verification-zh/": {
            lang: "zh-HK",
            title: "我如何更新我的帳戶資料？",
            description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 更改帳戶資料, 更新交易資料, 用戶資訊",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            },
            openGraph: {
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh/": {
            lang: "zh-HK",
            title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
            description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
            keywords: "共用帳戶, Excent Capital 政策, 個人帳戶使用, 交易帳戶安全, 帳戶共享, 家人使用帳戶, 帳戶安全, 交易合規",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            },
            openGraph: {
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-cancel-my-account-zh/": {
            lang: "zh-HK",
            title: "我如何取消我的帳戶",
            description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
            keywords: "取消交易帳戶, 關閉 Excent Capital 帳戶, 帳戶終止, 刪除帳戶, 結束帳戶, Excent Capital 支援, 帳戶取消程序",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            },
            openGraph: {
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh/": {
            lang: "zh-HK",
            title: "我可以從外國驗證我的帳戶嗎？",
            description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
            keywords: "海外驗證帳戶, Excent Capital 驗證, 外國帳戶設定, 國際 KYC, 遠程帳戶驗證, 驗證文件, 海外驗證",
            canonical: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.test.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.test.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.test.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.test.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            },
            openGraph: {
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                url: "https://knowledgebase.test.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh/": {
            lang: "zh-HK",
            title: "存款與提款：你將會發現什麼",
            description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
            keywords: "存款與提款, Excent Capital 資金, 提取利潤, 付款方式, 存款選項, 提款時間, 交易帳戶資金, 金融交易",
            canonical: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            },
            openGraph: {
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                url: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行首次存款？",
            description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
            keywords: "首次存款, 進行存款, Excent Capital 資金, 交易帳戶存款, 如何存款, 付款方式, 開始交易, 帳戶注資",
            canonical: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            },
            openGraph: {
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                url: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行存款？",
            description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
            keywords: "資金存入, 如何存款, Excent Capital 付款方式, 交易帳戶資金, 進行存款, 安全存款, 帳戶充值, 存款流程",
            canonical: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            },
            openGraph: {
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                url: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh/": {
            lang: "zh-HK",
            title: "我如何提取資金？",
            description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
            keywords: "提取資金, Excent Capital 提款, 如何提款, 交易帳戶提現, 提款流程, 安全提款, 提取收益, 付款方式",
            canonical: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            },
            openGraph: {
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                url: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh/": {
            lang: "zh-HK",
            title: "如果提款失敗，我應該怎麼辦？",
            description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
            keywords: "提款失敗, Excent Capital 幫助, 交易失敗, 排解提款問題, 提款錯誤, 付款失誤, 交易帳戶支援, 解決提款問題",
            canonical: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.test.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.test.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.test.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.test.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            },
            openGraph: {
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                url: "https://knowledgebase.test.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/payments-zh/inside-payments-zh/": {
            lang: "zh-HK",
            title: "付款詳情：你將會發現什麼",
            description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
            keywords: "Excent Capital 付款, 可接受的付款方式, 交易管理, 付款處理時間, 支援貨幣, 交易付款, 存款與提款選項, 帳戶注資",
            canonical: "https://knowledgebase.test.excent.capital/zh/payments-zh/inside-payments-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.test.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.test.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.test.excent.capital/zh/payments-zh/inside-payments-zh",
            },
            openGraph: {
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                url: "https://knowledgebase.test.excent.capital/zh/payments-zh/inside-payments-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-do-i-see-my-payment-history-zh/": {
            lang: "zh-HK",
            title: "我如何查看我的付款記錄？",
            description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
            keywords: "付款記錄, 交易歷史, 查看存款, 查看提款, Excent Capital 付款, 帳戶交易, 交易帳戶記錄, 財務紀錄",
            canonical: "https://knowledgebase.test.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.test.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.test.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.test.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            },
            openGraph: {
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                url: "https://knowledgebase.test.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-long-can-a-transaction-take-zh/": {
            lang: "zh-HK",
            title: "一筆交易需要多長時間？",
            description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
            keywords: "交易時間, 處理時間, 存款所需時間, 提款所需時間, Excent Capital 付款, 付款速度, 交易帳戶處理, 交易延誤",
            canonical: "https://knowledgebase.test.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.test.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.test.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.test.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.test.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.test.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.test.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            },
            openGraph: {
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                url: "https://knowledgebase.test.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
    },
    "support.excentcapital.tech": {
        // English 
        "/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://support.excentcapital.tech/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en",
                es: "https://support.excentcapital.tech/es",
                pt: "https://support.excentcapital.tech/pt",
                fr: "https://support.excentcapital.tech/fr",
                it: "https://support.excentcapital.tech/it",
                zh: "https://support.excentcapital.tech/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://support.excentcapital.tech/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://support.excentcapital.tech/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en",
                es: "https://support.excentcapital.tech/es",
                pt: "https://support.excentcapital.tech/pt",
                fr: "https://support.excentcapital.tech/fr",
                it: "https://support.excentcapital.tech/it",
                zh: "https://support.excentcapital.tech/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://support.excentcapital.tech/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/inside-about-us/": {
            lang: "en",
            title: "Inside About Us: What You'll Discover",
            description:
                "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
            keywords: "About Excent Capital, Company Mission, Trading Company Values, Meet the Team, Who is Excent Capital, Our Story, Financial Services Company, Excent Capital Overview",
            canonical: "https://support.excentcapital.tech/en/about-us/inside-about-us",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/inside-about-us",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                url: "https://support.excentcapital.tech/en/about-us/inside-about-us",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/about-excent-capital/": {
            lang: "en",
            title: "About Excent Capital",
            description:
                "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
            keywords: "Excent Capital, About Us, Company Overview, Trading Company, Financial Services, Trading Firm, Our Mission, Who We Are, Global Trading Support",
            canonical: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                url: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/build-your-portfolio/": {
            lang: "en",
            title: "Build Your Portfolio: Diverse Options on Excent Capital",
            description:
                "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
            keywords: "Build Portfolio, Trading Instruments, Forex Trading, Stock Market, Indices Trading, Commodities Trading, Diversified Portfolio, Excent Capital Assets",
            canonical: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                url: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-your-trusted-partner/": {
            lang: "en",
            title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
            description:
                "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
            keywords: "Excent Capital, International Investments, Diversify Portfolio, Global Markets, Trusted Trading Partner, Forex Trading, International Trading Platform, Investment Opportunities",

            canonical: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                url: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-education-center/": {
            lang: "en",
            title: "Level Up Your Trading: Excent Capital's Education Center",
            description:
                "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
            keywords: "Trading Education, Learn to Trade, Trading Tutorials, Trading Courses, Excent Capital Education, Beginner Trading Guide, Advanced Trading Strategies, Trading Resources",

            canonical: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                url: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/invest-with-confidence/": {
            lang: "en",
            title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
            description:
                "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
            keywords: "Risk Management, Trading Risk Tools, Investment Protection, Excent Capital Strategies, Confident Trading, Market Volatility, Trading Tools, Manage Risk in Trading",

            canonical: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                url: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/inside-trading/": {
            lang: "en",
            title: "Inside Trading: What You'll Discover",
            description:
                "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
            keywords: "Trading Guide, Market Insights, Trading Concepts, How to Trade, Excent Capital Platform, Trading Features, Learn Trading, Trading Knowledge Base",

            canonical: "https://support.excentcapital.tech/en/trading/inside-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/inside-trading",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                url: "https://support.excentcapital.tech/en/trading/inside-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/instruments-in-excent-capital/": {
            lang: "en",
            title: "Instruments in Excent Capital",
            description:
                "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
            keywords: "Trading Instruments, Forex, Stocks, Commodities, Indices, Excent Capital Assets, Financial Instruments, Investment Options, Trade Markets",

            canonical: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                url: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/leverage-offered-at-excent-capital/": {
            lang: "en",
            title: "Leverage Offered at Excent Capital",
            description:
                "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
            keywords: "Leverage Trading, Trading with Leverage, Excent Capital Leverage, Margin Trading, Leverage Options, Amplify Trading, Forex Leverage, Responsible Trading",

            canonical: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                url: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/micro-lots-at-excent-capital/": {
            lang: "en",
            title: "Micro Lots at Excent Capital",
            description:
                "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
            keywords: "Micro Lots Trading, Excent Capital Micro Lots, Small Lot Trading, Beginner Trading, Risk Management, Flexible Trading, Forex Micro Lots, Low Exposure Trading",

            canonical: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                url: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-hours/": {
            lang: "en",
            title: "Trading Hours",
            description:
                "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
            keywords: "Trading Hours, Market Hours, Forex Trading Times, Stock Market Hours, Excent Capital Schedule, Trading Sessions, Trading Times, Financial Market Hours",

            canonical: "https://support.excentcapital.tech/en/trading/trading-hours",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-hours",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                url: "https://support.excentcapital.tech/en/trading/trading-hours",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-tools/": {
            lang: "en",
            title: "Trading Tools",
            description:
                "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
            keywords: "Trading Tools, Market Analysis Tools, Trading Calculators, Forex Tools, Excent Capital Platform, Trading Resources, Charting Tools, Informed Trading",

            canonical: "https://support.excentcapital.tech/en/trading/trading-tools",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-tools",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                url: "https://support.excentcapital.tech/en/trading/trading-tools",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "en/trading/acuity-trading-tools/": {
            lang: "en",
            title: "Acuity Trading Tools",
            description:
                "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
            keywords: "Acuity Trading Tools, AI Trading Tools, Market Sentiment Analysis, Real-Time Market Insights, Excent Capital Tools, Acuity Insights, Smart Trading, Trading Analytics",

            canonical: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                url: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "en/trading/margin-calls/": {
            lang: "en",
            title: "Margin Calls",
            description:
                "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
            keywords: "Margin Calls, What is a Margin Call, Excent Capital Margin, Trading Margin, Forced Liquidation, Account Protection, Margin Trading, Risk Management",
            canonical: "https://support.excentcapital.tech/en/trading/margin-calls",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/margin-calls",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                url: "https://support.excentcapital.tech/en/trading/margin-calls",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/cfd-trading/": {
            lang: "en",
            title: "CFD Trading",
            description:
                "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
            keywords: "CFD Trading, Contracts for Difference, Trade CFDs, Excent Capital CFDs, Leverage Trading, Derivatives Trading, CFD Markets, How to Trade CFDs",
            canonical: "https://support.excentcapital.tech/en/trading/cfd-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/cfd-trading",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                url: "https://support.excentcapital.tech/en/trading/cfd-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/pending-orders/": {
            lang: "en",
            title: "Pending Orders",
            description:
                "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
            keywords: "Pending Orders, Trading Orders, Buy Stop, Sell Stop, Limit Orders, Automated Trading, Excent Capital Orders, Entry Points, Trading Strategy",
            canonical: "https://support.excentcapital.tech/en/trading/pending-orders",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/pending-orders",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                url: "https://support.excentcapital.tech/en/trading/pending-orders",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/spreads-offered/": {
            lang: "en",
            title: "Spreads Offered",
            description:
                "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://support.excentcapital.tech/en/trading/spreads-offered",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/spreads-offered",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                url: "https://support.excentcapital.tech/en/trading/spreads-offered",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/base-currencies/": {
            lang: "en",
            title: "Base Currencies",
            description:
                "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
            keywords: "Base Currencies, Supported Currencies, Excent Capital Account, Account Currency Options, Currency Selection, Trading Currency, Forex Base Currency, Funding Options",
            canonical: "https://support.excentcapital.tech/en/trading/base-currencies",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/base-currencies",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                url: "https://support.excentcapital.tech/en/trading/base-currencies",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/inside-resources/": {
            lang: "en",
            title: "Inside Resources: What You'll Discover",
            description:
                "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
            keywords: "Trading Resources, Excent Capital Tools, Market Updates, Economic Calendar, Trading Education, Resource Center, Learn to Trade, Trading Support Materials",
            canonical: "https://support.excentcapital.tech/en/resources/inside-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/inside-resources",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                url: "https://support.excentcapital.tech/en/resources/inside-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/basic-concepts/": {
            lang: "en",
            title: "Basic Concepts",
            description:
                "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
            keywords: "Basic Trading Concepts, Trading for Beginners, Market Basics, Excent Capital Education, Trading Terminology, Beginner Guide, Learn Trading, Fundamental Concepts",
            canonical: "https://support.excentcapital.tech/en/resources/basic-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/basic-concepts",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                url: "https://support.excentcapital.tech/en/resources/basic-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/advanced-concepts/": {
            lang: "en",
            title: "Advanced Concepts",
            description:
                "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
            keywords: "Advanced Trading Concepts, Trading Strategies, Technical Indicators, Expert Trading, Excent Capital Education, Market Analysis, Pro Trader Tools, Trading Techniques",
            canonical: "https://support.excentcapital.tech/en/resources/advanced-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/advanced-concepts",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                url: "https://support.excentcapital.tech/en/resources/advanced-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/additional-resources/": {
            lang: "en",
            title: "Additional Resources",
            description:
                "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
            keywords: "Trading Resources, Excent Capital Tools, Glossary of Terms, Platform Guides, Trading Help, Market Tools, Educational Resources, Trading Support",
            canonical: "https://support.excentcapital.tech/en/resources/additional-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/additional-resources",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                url: "https://support.excentcapital.tech/en/resources/additional-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/inside-my-account/": {
            lang: "en",
            title: "Inside My Account: What You'll Discover",
            description:
                "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
            keywords: "My Account, Account Management, Excent Capital Profile, Trading Account Settings, Account Security, User Dashboard, Profile Updates, Manage Trading Account",
            canonical: "https://support.excentcapital.tech/en/my-account/inside-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/inside-my-account",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                url: "https://support.excentcapital.tech/en/my-account/inside-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-to-create-a-demo-account/": {
            lang: "en",
            title: "Can I Create a Demo Account?",
            description:
                "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
            keywords: "Demo Account, Practice Trading, Excent Capital Demo, Risk-Free Trading, Create Demo Account, Trading Simulator, Beginner Trading, Learn to Trade",
            canonical: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                url: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-to-create-a-live-account/": {
            lang: "en",
            title: "How to Create a Live Account?",
            description:
                "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
            keywords: "Live Account, Create Trading Account, Excent Capital Registration, Open Live Account, Start Trading, Real Trading Account, Trading Signup, Account Setup",
            canonical: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                url: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/why-verify-your-account/": {
            lang: "en",
            title: "Why Verify Your Account?",
            description:
                "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
            keywords: "Account Verification, Verify Trading Account, Excent Capital KYC, Trading Security, Compliance Process, Identity Verification, Secure Trading, Full Account Access",
            canonical: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                url: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account.how-do-i-access-the-platform/": {
            lang: "en",
            title: "How Do I Access the Platform?",
            description:
                "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
            keywords: "Access Trading Platform, Excent Capital Login, Trading App, Web Trading Platform, Mobile Trading, How to Log In, Start Trading, Platform Access Guide",
            canonical: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                url: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-long-does-it-take-to-create-an-account/": {
            lang: "en",
            title: "How Long Does it Take to Create an Account?",
            description:
                "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
            keywords: "Account Creation Time, Excent Capital Signup, How to Create Account, Trading Account Setup, Registration Process, Open Account Fast, Trading Onboarding",
            canonical: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                url: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/do-you-offer-corporate-accounts/": {
            lang: "en",
            title: "Do You Offer Corporate Accounts?",
            description:
                "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
            keywords: "Corporate Trading Account, Business Account, Excent Capital Corporate, Institutional Trading, Open Corporate Account, Company Trading, Business Investment Account",
            canonical: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                url: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-open-multiple-accounts/": {
            lang: "en",
            title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
            description:
                "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
            keywords: "Multiple Accounts, Same Email Accounts, Excent Capital Roles, User Roles, Account Management, Trading Account Access, Role-Based Access, Email Registration Policy",
            canonical: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                url: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-update-my-account-information/": {
            lang: "en",
            title: "How Do I Update My Account Information?",
            description:
                "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
            keywords: "Update Account Info, Edit Personal Details, Excent Capital Profile, Account Settings, Change Account Information, Trading Profile Update, User Information",
            canonical: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                url: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-happens-if-i-forget-my-password/": {
            lang: "en",
            title: "What Happens If I Forget My Password?",
            description:
                "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
            keywords: "Forgot Password, Password Recovery, Reset Trading Password, Excent Capital Login Help, Account Access, Recover Password, Lost Password, Trading Account Login",
            canonical: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                url: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-documents-are-required-for-account-verification/": {
            lang: "en",
            title: "What Documents Are Required for Account Verification?",
            description:
                "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
            keywords: "Account Verification Documents, KYC Requirements, Excent Capital Verification, Proof of Identity, Proof of Address, Upload Documents, Secure Verification, Trading Compliance",
            canonical: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                url: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-my-friends-or-family-use-my-excent-capital-account/": {
            lang: "en",
            title: "Can My Friends or Family Use My Excent Capital Account?",
            description:
                "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
            keywords: "Account Sharing, Excent Capital Policy, Personal Account Use, Trading Account Security, Shared Access, Family Account Use, Account Safety, Trading Compliance",
            canonical: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                url: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-cancel-my-account/": {
            lang: "en",
            title: "How do I Cancel My Account",
            description:
                "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
            keywords: "Cancel Trading Account, Close Excent Capital Account, Account Termination, Delete Account, Trading Account Closure, End Account, Excent Capital Support, Account Cancellation Process",
            canonical: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                url: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-verify-my-account-from-a-foreign-country/": {
            lang: "en",
            title: "Can I Verify My Account From a Foreign Country?",
            description:
                "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
            keywords: "Verify Account Abroad, Excent Capital Verification, Foreign Country Account Setup, International KYC, Remote Account Verification, Account Documents, Overseas Verification",
            canonical: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                url: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/inside-deposits-withdrawals/": {
            lang: "en",
            title: "Inside Deposits & Withdrawals: What You'll Discover",
            description:
                "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
            keywords: "Deposits and Withdrawals, Excent Capital Funding, Withdraw Profits, Payment Methods, Deposit Options, Withdrawal Times, Trading Account Funding, Financial Transactions",
            canonical: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                url: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-do-a-first-time-deposit/": {
            lang: "en",
            title: "How Do I Make a First-Time Deposit?",
            description:
                "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                url: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-make-a-deposit/": {
            lang: "en",
            title: "How Do I Make a Deposit?",
            description:
                "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
            keywords: "Deposit Funds, How to Deposit, Excent Capital Payment Methods, Trading Account Funding, Make a Deposit, Secure Deposit, Account Top-Up, Deposit Process",
            canonical: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                url: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-can-i-make-a-withdrawal/": {
            lang: "en",
            title: "How Can I Make a Withdrawal?",
            description:
                "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
            keywords: "Withdraw Funds, Excent Capital Withdrawal, How to Withdraw, Trading Account Payout, Withdrawal Process, Secure Withdrawal, Access Earnings, Payment Methods",
            canonical: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                url: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails/": {
            lang: "en",
            title: "What Do I Do If My Withdrawal Fails?",
            description:
                "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
            keywords: "Withdrawal Failed, Excent Capital Help, Failed Transaction, Troubleshoot Withdrawal, Withdrawal Issue, Payment Error, Trading Account Support, Fix Withdrawal Problem",
            canonical: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                url: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/inside-payments/": {
            lang: "en",
            title: "Inside Payments: What You'll Discover",
            description:
                "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
            keywords: "Excent Capital Payments, Accepted Payment Methods, Transaction Management, Payment Processing Time, Supported Currencies, Trading Payments, Deposit and Withdrawal Options, Account Funding",
            canonical: "https://support.excentcapital.tech/en/payments/inside-payments",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/inside-payments",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                url: "https://support.excentcapital.tech/en/payments/inside-payments",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-do-i-see-my-payment-history/": {
            lang: "en",
            title: "How Do I See My Payment History?",
            description:
                "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
            keywords: "Payment History, Transaction History, View Deposits, View Withdrawals, Excent Capital Payments, Account Transactions, Trading Account History, Financial Records",
            canonical: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                url: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-long-can-a-transaction-take/": {
            lang: "en",
            title: "How Long Can a Transaction Take?",
            description:
                "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
            keywords: "Transaction Time, Processing Time, Deposit Duration, Withdrawal Duration, Excent Capital Payments, Payment Speed, Trading Account Transactions, Delay in Transactions",
            canonical: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
                es: "https://support.excentcapital.tech/es/trading/spreads",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                url: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Español
        "es/": {
            lang: "es",
            title: "Base de Conocimientos | Excent Capital",
            description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
            keywords: "Centro de Ayuda Excent Capital, Soporte de Plataforma de Trading, Preguntas Frecuentes sobre Trading, Cómo Operar, Tutoriales de FX, Gestión de Cuentas, Guías de Trading, Ayuda para Depósitos, Ayuda para Retiros",
            canonical: "https://support.excentcapital.tech/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en",
                es: "https://support.excentcapital.tech/es",
                pt: "https://support.excentcapital.tech/pt",
                fr: "https://support.excentcapital.tech/fr",
                it: "https://support.excentcapital.tech/it",
                zh: "https://support.excentcapital.tech/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://support.excentcapital.tech/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/dentro-de-acerca-de-nosotros/": {
            lang: "es",
            title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
            description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
            keywords: "Sobre Excent Capital, Misión de la Empresa, Valores de Empresa de Trading, Conoce al Equipo, Quién es Excent Capital, Nuestra Historia, Empresa de Servicios Financieros, Visión General de Excent Capital", canonical: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            canonical: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/inside-about-us",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/acerca-de-excent-capital/": {
            lang: "es",
            title: "Sobre Excent Capital",
            description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
            keywords: "Excent Capital, Sobre Nosotros, Visión General de la Empresa, Empresa de Trading, Servicios Financieros, Firma de Trading, Nuestra Misión, Quiénes Somos, Soporte Global de Trading",
            canonical: "https://support.excentcapital.tech/es/sobre-nosotros/acerca-de-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://support.excentcapital.tech/es/sobre-nosotros/acerca-de-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/construye-tu-portafolio/": {
            lang: "es",
            title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
            description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
            keywords: "Construir Portafolio, Instrumentos de Trading, Trading en Forex, Mercado de Acciones, Trading de Índices, Trading de Commodities, Portafolio Diversificado, Activos de Excent Capital",
            canonical: "https://support.excentcapital.tech/es/sobre-nosotros/construye-tu-portafolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://support.excentcapital.tech/es/sobre-nosotros/construye-tu-portafolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/excent-capital-tu-socio-de-confianza/": {
            lang: "es",
            title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
            description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
            keywords: "Excent Capital, Inversiones Internacionales, Diversificar Portafolio, Mercados Globales, Socio de Trading Confiable, Trading en Forex, Plataforma de Trading Internacional, Oportunidades de Inversión",

            canonical: "https://support.excentcapital.tech/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://support.excentcapital.tech/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/centro-educativo-excent-capital/": {
            lang: "es",
            title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
            description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
            keywords: "Educación en Trading, Aprender a Operar, Tutoriales de Trading, Cursos de Trading, Educación Excent Capital, Guía para Principiantes en Trading, Estrategias Avanzadas de Trading, Recursos de Trading",

            canonical: "https://support.excentcapital.tech/es/sobre-nosotros/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://support.excentcapital.tech/es/sobre-nosotros/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/invierte-con-confianza/": {
            lang: "es",
            title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
            description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
            keywords: "Gestión de Riesgo, Herramientas de Riesgo en Trading, Protección de Inversiones, Estrategias de Excent Capital, Trading con Confianza, Volatilidad del Mercado, Herramientas de Trading, Gestionar Riesgo en Trading",
            canonical: "https://support.excentcapital.tech/es/sobre-nosotros/invierte-con-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://support.excentcapital.tech/es/sobre-nosotros/invierte-con-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/trading/dentro-del-trading/": {
            lang: "es",
            title: "Dentro del Trading: Lo que Descubrirás",
            description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
            keywords: "Guía de Trading, Perspectivas del Mercado, Conceptos de Trading, Cómo Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conocimientos de Trading", canonical: "https://support.excentcapital.tech/es/trading/dentro-del-trading",
            canonical: "https://support.excentcapital.tech/es/trading/dentro-del-trading",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/inside-trading",
                es: "https://support.excentcapital.tech/es/trading/dentro-del-trading",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://support.excentcapital.tech/es/trading/dentro-del-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/instrumentos-en-excent-capital/": {
            lang: "es",
            title: "Instrumentos en Excent Capital",
            description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
            keywords: "Instrumentos de Trading, Forex, Acciones, Commodities, Índices, Activos de Excent Capital, Instrumentos Financieros, Opciones de Inversión, Mercados de Trading",
            canonical: "https://support.excentcapital.tech/es/trading/instrumentos-en-excent-capital",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/instrumentos-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://support.excentcapital.tech/es/trading/instrumentos-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/apalancamiento-en-excent-capital/": {
            lang: "es",
            title: "Apalancamiento Ofrecido en Excent Capital",
            description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
            keywords: "Trading con Apalancamiento, Operar con Apalancamiento, Apalancamiento en Excent Capital, Trading con Margen, Opciones de Apalancamiento, Potenciar el Trading, Apalancamiento en Forex, Trading Responsable",
            canonical: "https://support.excentcapital.tech/es/trading/apalancamiento-en-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/apalancamiento-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://support.excentcapital.tech/es/trading/apalancamiento-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/micro-lotes-excent-capital/": {
            lang: "es",
            title: "Micro Lotes en Excent Capital",
            description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
            keywords: "Trading con Micro Lotes, Micro Lotes Excent Capital, Trading con Lotes Pequeños, Trading para Principiantes, Gestión de Riesgo, Trading Flexible, Micro Lotes en Forex, Trading con Baja Exposición",
            canonical: "https://support.excentcapital.tech/es/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/micro-lotes-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://support.excentcapital.tech/es/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/horario-de-trading/": {
            lang: "es",
            title: "Horarios de Trading",
            description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
            keywords: "Horarios de Trading, Horarios de Mercado, Horarios de Forex, Horarios del Mercado de Acciones, Calendario Excent Capital, Sesiones de Trading, Tiempos de Trading, Horarios del Mercado Financiero",
            canonical: "https://support.excentcapital.tech/es/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-hours",
                es: "https://support.excentcapital.tech/es/trading/horario-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://support.excentcapital.tech/es/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/herramientas-de-trading/": {
            lang: "es",
            title: "Herramientas de Trading",
            description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
            keywords: "Herramientas de Trading, Herramientas de Análisis de Mercado, Calculadoras de Trading, Herramientas de Forex, Plataforma Excent Capital, Recursos de Trading, Herramientas de Gráficos, Trading Informado",
            canonical: "https://support.excentcapital.tech/es/trading/herramientas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-tools",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://support.excentcapital.tech/es/trading/herramientas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "es/trading/herramientas-de-trading-acuity/": {
            lang: "es",
            title: "Herramientas de Trading de Acuity",
            description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
            keywords: "Herramientas de Trading de Acuity, Herramientas de Trading con IA, Análisis de Sentimiento del Mercado, Perspectivas del Mercado en Tiempo Real, Herramientas de Excent Capital, Insights de Acuity, Trading Inteligente, Analítica de Trading",
            canonical: "https://support.excentcapital.tech/es/trading/herramientas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading-acuity",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://support.excentcapital.tech/es/trading/herramientas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "es/trading/llamadas-de-margen/": {
            lang: "es",
            title: "Llamadas de Margen",
            description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
            keywords: "Llamadas de Margen, Qué es una Llamada de Margen, Margen en Excent Capital, Trading con Margen, Liquidación Forzada, Protección de Cuenta, Trading con Margen, Gestión de Riesgo",
            canonical: "https://support.excentcapital.tech/es/trading/llamadas-de-margen",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/margin-calls",
                es: "https://support.excentcapital.tech/es/trading/llamadas-de-margen",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://support.excentcapital.tech/es/trading/llamadas-de-margen",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/trading-de-cfd/": {
            lang: "es",
            title: "Trading de CFDs",
            description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
            keywords: "Trading de CFDs, Contratos por Diferencia, Operar CFDs, CFDs en Excent Capital, Trading con Apalancamiento, Trading de Derivados, Mercados de CFD, Cómo Operar CFDs",
            canonical: "https://support.excentcapital.tech/es/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/cfd-trading",
                es: "https://support.excentcapital.tech/es/trading/trading-de-cfd",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://support.excentcapital.tech/es/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/ordenes-pendientes/": {
            lang: "es",
            title: "Órdenes Pendientes",
            description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
            keywords: "Órdenes Pendientes, Órdenes de Trading, Buy Stop, Sell Stop, Órdenes Limitadas, Trading Automatizado, Órdenes en Excent Capital, Puntos de Entrada, Estrategia de Trading",
            canonical: "https://support.excentcapital.tech/es/trading/ordenes-pendientes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/pending-orders",
                es: "https://support.excentcapital.tech/es/trading/ordenes-pendientes",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://support.excentcapital.tech/es/trading/ordenes-pendientes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/spreads-ofrecidos/": {
            lang: "es",
            title: "Spreads Ofrecidos",
            description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
            keywords: "Spreads, Spreads por Volatilidad, Mercados Financieros, Spreads de Trading, Minimizar Costos de Trading, Optimizar Rentabilidad, Estrategias de Trading, Análisis de Spreads, Spreads en Forex, Spreads en el Mercado de Acciones",
            canonical: "https://support.excentcapital.tech/es/trading/spreads-ofrecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/spreads-offered",
                es: "https://support.excentcapital.tech/es/trading/spreads-ofrecidos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://support.excentcapital.tech/es/trading/spreads-ofrecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/monedas-base/": {
            lang: "es",
            title: "Monedas Base",
            description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
            keywords: "Monedas Base, Divisas Compatibles, Cuenta en Excent Capital, Opciones de Divisa de Cuenta, Selección de Moneda, Moneda de Trading, Divisa Base en Forex, Opciones de Fondeo",
            canonical: "https://support.excentcapital.tech/es/trading/monedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/base-currencies",
                es: "https://support.excentcapital.tech/es/trading/monedas-base",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://support.excentcapital.tech/es/trading/monedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/recursos/dentro-de-recursos/": {
            lang: "es",
            title: "Dentro de Recursos: Lo que Descubrirás",
            description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Actualizaciones del Mercado, Calendario Económico, Educación en Trading, Centro de Recursos, Aprender a Operar, Material de Apoyo para Trading",
            canonical: "https://support.excentcapital.tech/es/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/inside-resources",
                es: "https://support.excentcapital.tech/es/recursos/dentro-de-recursos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://support.excentcapital.tech/es/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-basicos/": {
            lang: "es",
            title: "Conceptos Básicos",
            description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
            keywords: "Conceptos Básicos de Trading, Trading para Principiantes, Fundamentos del Mercado, Educación de Excent Capital, Terminología de Trading, Guía para Principiantes, Aprender a Operar, Conceptos Fundamentales",
            canonical: "https://support.excentcapital.tech/es/recursos/conceptos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/basic-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-basicos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://support.excentcapital.tech/es/recursos/conceptos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-avanzados/": {
            lang: "es",
            title: "Conceptos Avanzados",
            description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
            keywords: "Conceptos Avanzados de Trading, Estrategias de Trading, Indicadores Técnicos, Trading Experto, Educación de Excent Capital, Análisis de Mercado, Herramientas de Trader Profesional, Técnicas de Trading",
            canonical: "https://support.excentcapital.tech/es/recursos/conceptos-avanzados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/advanced-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-avanzados",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://support.excentcapital.tech/es/recursos/conceptos-avanzados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/recursos-adicionales/": {
            lang: "es",
            title: "Recursos Adicionales",
            description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Glosario de Términos, Guías de Plataforma, Ayuda para Trading, Herramientas de Mercado, Recursos Educativos, Soporte de Trading",
            canonical: "https://support.excentcapital.tech/es/recursos/recursos-adicionales",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/additional-resources",
                es: "https://support.excentcapital.tech/es/recursos/recursos-adicionales",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://support.excentcapital.tech/es/recursos/recursos-adicionales",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/mi-cuenta/dentro-de-mi-cuenta/": {
            lang: "es",
            title: "Dentro de Mi Cuenta: Lo que Descubrirás",
            description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
            keywords: "Mi Cuenta, Gestión de Cuenta, Perfil en Excent Capital, Configuración de Cuenta de Trading, Seguridad de Cuenta, Panel de Usuario, Actualización de Perfil, Administrar Cuenta de Trading",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/dentro-de-mi-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/inside-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/dentro-de-mi-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-demo/": {
            lang: "es",
            title: "¿Puedo Crear una Cuenta Demo?",
            description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
            keywords: "Cuenta Demo, Practicar Trading, Demo de Excent Capital, Trading sin Riesgo, Crear Cuenta Demo, Simulador de Trading, Trading para Principiantes, Aprender a Operar",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-real/": {
            lang: "es",
            title: "¿Cómo Crear una Cuenta Real?",
            description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
            keywords: "Cuenta Real, Crear Cuenta de Trading, Registro en Excent Capital, Abrir Cuenta Real, Comenzar a Operar, Cuenta de Trading Real, Registro de Trading, Configuración de Cuenta",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-real",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta/": {
            lang: "es",
            title: "¿Por Qué Verificar tu Cuenta?",
            description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
            keywords: "Verificación de Cuenta, Verificar Cuenta de Trading, KYC de Excent Capital, Seguridad en Trading, Proceso de Cumplimiento, Verificación de Identidad, Trading Seguro, Acceso Completo a la Cuenta",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/acceder-a-la-plataforma/": {
            lang: "es",
            title: "¿Cómo Accedo a la Plataforma?",
            description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
            keywords: "Acceder a la Plataforma de Trading, Inicio de Sesión en Excent Capital, App de Trading, Plataforma Web de Trading, Trading Móvil, Cómo Iniciar Sesión, Comenzar a Operar, Guía de Acceso a la Plataforma",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/acceder-a-la-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
                es: "https://support.excentcapital.tech/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/acceder-a-la-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/tiempo-para-crear-cuenta/": {
            lang: "es",
            title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
            description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
            keywords: "Tiempo de Creación de Cuenta, Registro en Excent Capital, Cómo Crear una Cuenta, Configuración de Cuenta de Trading, Proceso de Registro, Abrir Cuenta Rápidamente, Inicio en Trading",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/tiempo-para-crear-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/tiempo-para-crear-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuentas-corporativas/": {
            lang: "es",
            title: "¿Ofrecen Cuentas Corporativas?",
            description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
            keywords: "Cuenta Corporativa de Trading, Cuenta Empresarial, Corporativo en Excent Capital, Trading Institucional, Abrir Cuenta Corporativa, Trading Empresarial, Cuenta de Inversión para Empresas",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/cuentas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuentas-corporativas",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/cuentas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/varias-cuentas-mismo-correo/": {
            lang: "es",
            title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
            description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
            keywords: "Múltiples Cuentas, Cuentas con el Mismo Correo, Roles en Excent Capital, Roles de Usuario, Gestión de Cuentas, Acceso a Cuenta de Trading, Acceso Basado en Roles, Política de Registro de Correo",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/varias-cuentas-mismo-correo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/varias-cuentas-mismo-correo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/actualizar-informacion-cuenta/": {
            lang: "es",
            title: "¿Cómo Actualizo la Información de Mi Cuenta?",
            description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
            keywords: "Actualizar Información de Cuenta, Editar Datos Personales, Perfil de Excent Capital, Configuración de Cuenta, Cambiar Información de Cuenta, Actualización de Perfil de Trading, Información del Usuario",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/actualizar-informacion-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
                es: "https://support.excentcapital.tech/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/actualizar-informacion-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/olvide-mi-contrasena/": {
            lang: "es",
            title: "¿Qué Sucede si Olvido Mi Contraseña?",
            description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
            keywords: "Olvidé la Contraseña, Recuperación de Contraseña, Restablecer Contraseña de Trading, Ayuda para Iniciar Sesión en Excent Capital, Acceso a la Cuenta, Recuperar Contraseña, Contraseña Perdida, Inicio de Sesión en Cuenta de Trading",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/olvide-mi-contrasena",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://support.excentcapital.tech/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/olvide-mi-contrasena",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/documentos-para-verificacion/": {
            lang: "es",
            title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
            description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
            keywords: "Documentos para Verificación de Cuenta, Requisitos KYC, Verificación en Excent Capital, Comprobante de Identidad, Comprobante de Domicilio, Subir Documentos, Verificación Segura, Cumplimiento en Trading",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/documentos-para-verificacion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://support.excentcapital.tech/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/documentos-para-verificacion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuenta-usada-por-otros/": {
            lang: "es",
            title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
            description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
            keywords: "Compartir Cuenta, Política de Excent Capital, Uso Personal de Cuenta, Seguridad de Cuenta de Trading, Acceso Compartido, Uso Familiar de Cuenta, Seguridad de Cuenta, Cumplimiento en Trading",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/cuenta-usada-por-otros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/cuenta-usada-por-otros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cancelar-cuenta/": {
            lang: "es",
            title: "¿Cómo Cancelo Mi Cuenta?",
            description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
            keywords: "Cancelar Cuenta de Trading, Cerrar Cuenta de Excent Capital, Terminación de Cuenta, Eliminar Cuenta, Cierre de Cuenta de Trading, Finalizar Cuenta, Soporte de Excent Capital, Proceso de Cancelación de Cuenta",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/cancelar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cancelar-cuenta",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/cancelar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta-extranjero/": {
            lang: "es",
            title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
            description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
            keywords: "Verificar Cuenta en el Extranjero, Verificación en Excent Capital, Crear Cuenta Desde el Exterior, KYC Internacional, Verificación Remota de Cuenta, Documentos para Cuenta, Verificación Desde el Exterior",
            canonical: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta-extranjero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                url: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta-extranjero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/depositos-retiros/dentro-depositos-retiros/": {
            lang: "es",
            title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
            description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
            keywords: "Depósitos y Retiros, Fondeo en Excent Capital, Retirar Ganancias, Métodos de Pago, Opciones de Depósito, Tiempos de Retiro, Fondeo de Cuenta de Trading, Transacciones Financieras",
            canonical: "https://support.excentcapital.tech/es/depositos-retiros/dentro-depositos-retiros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://support.excentcapital.tech/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                url: "https://support.excentcapital.tech/es/depositos-retiros/dentro-depositos-retiros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/primer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito por Primera Vez?",
            description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
            keywords: "Primer Depósito, Hacer un Depósito, Fondeo en Excent Capital, Depósito en Cuenta de Trading, Cómo Depositar, Métodos de Pago, Comenzar a Operar, Fondear tu Cuenta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://support.excentcapital.tech/es/depositos-retiros/primer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/primer-deposito",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                url: "https://support.excentcapital.tech/es/depositos-retiros/primer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito?",
            description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
            keywords: "Depositar Fondos, Cómo Depositar, Métodos de Pago en Excent Capital, Fondeo de Cuenta de Trading, Realizar un Depósito, Depósito Seguro, Recargar Cuenta, Proceso de Depósito",
            canonical: "https://support.excentcapital.tech/es/depositos-retiros/hacer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-deposito",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                url: "https://support.excentcapital.tech/es/depositos-retiros/hacer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-retiro/": {
            lang: "es",
            title: "¿Cómo Puedo Hacer un Retiro?",
            description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
            keywords: "Retirar Fondos, Retiro en Excent Capital, Cómo Retirar, Pago de Cuenta de Trading, Proceso de Retiro, Retiro Seguro, Acceder a Ganancias, Métodos de Pago",
            canonical: "https://support.excentcapital.tech/es/depositos-retiros/hacer-retiro",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-retiro",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                url: "https://support.excentcapital.tech/es/depositos-retiros/hacer-retiro",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/retiro-fallido/": {
            lang: "es",
            title: "¿Qué Hago si Falla Mi Retiro?",
            description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
            keywords: "Retiro Fallido, Ayuda de Excent Capital, Transacción Fallida, Solución de Problemas de Retiro, Problema de Retiro, Error de Pago, Soporte de Cuenta de Trading, Corregir Problema de Retiro",
            canonical: "https://support.excentcapital.tech/es/depositos-retiros/retiro-fallido",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://support.excentcapital.tech/es/depositos-retiros/retiro-fallido",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                url: "https://support.excentcapital.tech/es/depositos-retiros/retiro-fallido",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/pagos/dentro-de-pagos/": {
            lang: "es",
            title: "Dentro de Pagos: Lo que Descubrirás",
            description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
            keywords: "Pagos en Excent Capital, Métodos de Pago Aceptados, Gestión de Transacciones, Tiempo de Procesamiento de Pagos, Divisas Soportadas, Pagos de Trading, Opciones de Depósito y Retiro, Fondeo de Cuenta",
            canonical: "https://support.excentcapital.tech/es/pagos/dentro-de-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/inside-payments",
                es: "https://support.excentcapital.tech/es/pagos/dentro-de-pagos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                url: "https://support.excentcapital.tech/es/pagos/dentro-de-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/ver-historial-pagos/": {
            lang: "es",
            title: "¿Cómo Veo Mi Historial de Pagos?",
            description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
            keywords: "Historial de Pagos, Historial de Transacciones, Ver Depósitos, Ver Retiros, Pagos en Excent Capital, Transacciones de Cuenta, Historial de Cuenta de Trading, Registros Financieros",
            canonical: "https://support.excentcapital.tech/es/pagos/ver-historial-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
                es: "https://support.excentcapital.tech/es/pagos/ver-historial-pagos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                url: "https://support.excentcapital.tech/es/pagos/ver-historial-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/tiempo-transaccion/": {
            lang: "es",
            title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
            description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
            keywords: "Tiempo de Transacción, Tiempo de Procesamiento, Duración del Depósito, Duración del Retiro, Pagos en Excent Capital, Velocidad de Pago, Transacciones de Cuenta de Trading, Retrasos en Transacciones",
            canonical: "https://support.excentcapital.tech/es/pagos/tiempo-transaccion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
                es: "https://support.excentcapital.tech/es/pagos/tiempo-transaccion",
                pt: "https://support.excentcapital.tech/pt/trading/spreads",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                url: "https://support.excentcapital.tech/es/pagos/tiempo-transaccion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Potugues
        "pt/": {
            lang: "pt",
            title: "Base de Conhecimento | Excent Capital",
            description: "Explore a Base de Conhecimento da Excent Capital com guias especializados, tutoriais da plataforma, perguntas frequentes sobre trading e recursos desenvolvidos para ajudá-lo a operar com confiança.",
            keywords: "Central de Ajuda Excent Capital, Suporte da Plataforma de Trading, Perguntas Frequentes de Trading, Como Operar, Tutoriais de FX, Gestão de Conta, Guias de Trading, Ajuda com Depósitos, Ajuda com Saques",
            canonical: "https://support.excentcapital.tech/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en",
                es: "https://support.excentcapital.tech/es",
                pt: "https://support.excentcapital.tech/pt",
                fr: "https://support.excentcapital.tech/fr",
                it: "https://support.excentcapital.tech/it",
                zh: "https://support.excentcapital.tech/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://support.excentcapital.tech/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/dentro-sobre-nos/": {
            lang: "pt",
            title: "Dentro de Sobre Nós: O Que Você Vai Descobrir",
            description: "Saiba mais sobre a missão, os valores e a presença global da Excent Capital. Descubra quem somos, o que nos motiva e como capacitamos traders ao redor do mundo.",
            keywords: "Sobre a Excent Capital, Missão da Empresa, Valores da Empresa de Trading, Conheça a Equipe, Quem é a Excent Capital, Nossa História, Empresa de Serviços Financeiros, Visão Geral da Excent Capital",
            canonical: "https://support.excentcapital.tech/pt/sobre-nos/dentro-sobre-nos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/inside-about-us",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://support.excentcapital.tech/pt/sobre-nos/dentro-sobre-nos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/sobre-a-excent-capital/": {
            lang: "pt",
            title: "Sobre a Excent Capital",
            description: "Conheça a Excent Capital — nossa história, missão e os princípios que orientam nossa abordagem para capacitar traders nos mercados globais.",
            keywords: "Excent Capital, Sobre Nós, Visão Geral da Empresa, Empresa de Trading, Serviços Financeiros, Firma de Trading, Nossa Missão, Quem Somos, Suporte Global de Trading",
            canonical: "https://support.excentcapital.tech/pt/sobre-nos/sobre-a-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://support.excentcapital.tech/pt/sobre-nos/sobre-a-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/construa-seu-portfolio/": {
            lang: "pt",
            title: "Construa Seu Portfólio: Opções Diversificadas na Excent Capital",
            description: "Descubra uma ampla variedade de instrumentos de trading na Excent Capital, incluindo Forex, ações, índices e commodities — tudo o que você precisa para montar um portfólio sólido e diversificado.",
            keywords: "Construir Portfólio, Instrumentos de Trading, Trading de Forex, Mercado de Ações, Trading de Índices, Trading de Commodities, Portfólio Diversificado, Ativos da Excent Capital",
            canonical: "https://support.excentcapital.tech/pt/sobre-nos/construa-seu-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://support.excentcapital.tech/pt/sobre-nos/construa-seu-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/excent-capital-seu-parceiro-de-confianca/": {
            lang: "pt",
            title: "Excent Capital: Seu Parceiro de Confiança para Diversificar Seus Investimentos nos Mercados Internacionais",
            description: "Associe-se à Excent Capital para expandir globalmente suas oportunidades de investimento. Acesse os mercados internacionais com confiança através de nossa plataforma de trading segura e profissional.",
            keywords: "Excent Capital, Investimentos Internacionais, Diversificar Portfólio, Mercados Globais, Parceiro Confiável de Trading, Trading de Forex, Plataforma Internacional de Trading, Oportunidades de Investimento",
            canonical: "https://support.excentcapital.tech/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://support.excentcapital.tech/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/centro-educacional-excent-capital/": {
            lang: "pt",
            title: "Eleve Seu Trading: Centro Educacional da Excent Capital",
            description: "Acesse cursos, tutoriais e recursos conduzidos por especialistas no Centro Educacional da Excent Capital. Aprenda estratégias de trading e desenvolva suas habilidades — seja você iniciante ou trader avançado.",
            keywords: "Educação em Trading, Aprenda a Operar, Tutoriais de Trading, Cursos de Trading, Educação Excent Capital, Guia de Trading para Iniciantes, Estratégias Avançadas de Trading, Recursos de Trading",
            canonical: "https://support.excentcapital.tech/pt/sobre-nos/centro-educacional-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://support.excentcapital.tech/pt/sobre-nos/centro-educacional-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/invista-com-confianca/": {
            lang: "pt",
            title: "Invista com Confiança: Estratégias e Ferramentas de Gestão de Risco na Excent Capital",
            description: "Domine a gestão de risco com a Excent Capital. Explore ferramentas e estratégias essenciais para proteger seus investimentos e operar com mais confiança em mercados voláteis.",
            keywords: "Gestão de Risco, Ferramentas de Risco em Trading, Proteção de Investimentos, Estratégias da Excent Capital, Trading com Confiança, Volatilidade do Mercado, Ferramentas de Trading, Gerenciar Risco no Trading",
            canonical: "https://support.excentcapital.tech/pt/sobre-nos/invista-com-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/invista-com-confianca",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://support.excentcapital.tech/pt/sobre-nos/invista-com-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/trading/dentro-do-trading/": {
            lang: "pt",
            title: "Dentro do Trading: O Que Você Vai Descobrir",
            description: "Explore conceitos-chave de trading, insights de mercado e funcionalidades da plataforma no centro de trading da Excent Capital. Obtenha o conhecimento necessário para tomar decisões informadas.",
            keywords: "Guia de Trading, Insights de Mercado, Conceitos de Trading, Como Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conhecimento de Trading",
            canonical: "https://support.excentcapital.tech/pt/trading/dentro-do-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/inside-trading",
                es: "https://support.excentcapital.tech/es/trading/dentro-del-trading",
                pt: "https://support.excentcapital.tech/pt/trading/dentro-do-trading",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://support.excentcapital.tech/pt/trading/dentro-do-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/instrumentos-na-excent-capital/": {
            lang: "pt",
            title: "Instrumentos na Excent Capital",
            description: "Explore toda a gama de instrumentos de trading oferecidos pela Excent Capital, incluindo FX, ações, commodities, índices e muito mais — desenvolvidos para atender aos seus objetivos de investimento.",
            keywords: "Instrumentos de Trading, Forex, Ações, Commodities, Índices, Ativos da Excent Capital, Instrumentos Financeiros, Opções de Investimento, Mercados de Trading",
            canonical: "https://support.excentcapital.tech/pt/trading/instrumentos-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/instrumentos-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/instrumentos-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://support.excentcapital.tech/pt/trading/instrumentos-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/alavancagem-na-excent-capital/": {
            lang: "pt",
            title: "Alavancagem Oferecida pela Excent Capital",
            description: "Entenda como funciona a alavancagem na Excent Capital e como ela pode ampliar seu potencial de trading. Conheça nossas opções de alavancagem flexíveis e práticas de operação responsável.",
            keywords: "Trading com Alavancagem, Operar com Alavancagem, Alavancagem na Excent Capital, Trading com Margem, Opções de Alavancagem, Ampliar Trading, Alavancagem em Forex, Trading Responsável",
            canonical: "https://support.excentcapital.tech/pt/trading/alavancagem-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/apalancamiento-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/alavancagem-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://support.excentcapital.tech/pt/trading/alavancagem-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/micro-lotes-excent-capital/": {
            lang: "pt",
            title: "Micro Lotes na Excent Capital",
            description: "Opere com mais flexibilidade utilizando micro lotes na Excent Capital. Ideal para iniciantes e traders cautelosos que buscam controlar a exposição e testar estratégias.",
            keywords: "Trading com Micro Lotes, Micro Lotes Excent Capital, Trading com Lotes Pequenos, Trading para Iniciantes, Gestão de Risco, Trading Flexível, Micro Lotes de Forex, Trading com Baixa Exposição",
            canonical: "https://support.excentcapital.techpt/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/micro-lotes-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/micro-lotes-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://support.excentcapital.tech/pt/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/horario-de-trading/": {
            lang: "pt",
            title: "Horários de Trading",
            description: "Fique informado sobre os horários oficiais de trading para todos os mercados disponíveis na Excent Capital. Saiba quando operar Forex, ações, índices e commodities.",
            keywords: "Horários de Trading, Horários de Mercado, Horários de Forex, Horário do Mercado de Ações, Agenda da Excent Capital, Sessões de Trading, Tempos de Trading, Horários do Mercado Financeiro",
            canonical: "https://support.excentcapital.tech/pt/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-hours",
                es: "https://support.excentcapital.tech/es/trading/horario-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/horario-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://support.excentcapital.tech/pt/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ferramentas-de-trading/": {
            lang: "pt",
            title: "Ferramentas de Trading",
            description: "Melhore sua experiência de trading com as poderosas ferramentas da Excent Capital. Acesse gráficos, calculadoras, análises de mercado e muito mais para tomar decisões informadas.",
            keywords: "Ferramentas de Trading, Ferramentas de Análise de Mercado, Calculadoras de Trading, Ferramentas de Forex, Plataforma Excent Capital, Recursos de Trading, Ferramentas de Gráficos, Trading Informado",
            canonical: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-tools",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "pt/trading/ferramentas-de-trading-acuity/": {
            lang: "pt",
            title: "Ferramentas de Trading da Acuity",
            description: "Aproveite as ferramentas com IA da Acuity na Excent Capital para obter insights de mercado, análise de sentimento e decisões de trading mais inteligentes com dados em tempo real.",
            keywords: "Ferramentas de Trading Acuity, Ferramentas de Trading com IA, Análise de Sentimento de Mercado, Insights de Mercado em Tempo Real, Ferramentas da Excent Capital, Insights da Acuity, Trading Inteligente, Análise de Trading",
            canonical: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading-acuity",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "pt/trading/chamadas-de-margem/": {
            lang: "pt",
            title: "Chamadas de Margem",
            description: "Entenda como funcionam as chamadas de margem na Excent Capital. Saiba quando elas ocorrem, como gerenciá-las e como proteger sua conta contra liquidações forçadas.",
            keywords: "Chamadas de Margem, O que é uma Chamada de Margem, Margem Excent Capital, Margem de Trading, Liquidação Forçada, Proteção da Conta, Trading com Margem, Gestão de Risco",
            canonical: "https://support.excentcapital.tech/pt/trading/chamadas-de-margem",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/margin-calls",
                es: "https://support.excentcapital.tech/es/trading/llamadas-de-margen",
                pt: "https://support.excentcapital.tech/pt/trading/chamadas-de-margem",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://support.excentcapital.tech/pt/trading/chamadas-de-margem",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/trading-de-cfd/": {
            lang: "pt",
            title: "Trading de CFDs",
            description: "Aprenda como operar Contratos por Diferença (CFDs) com a Excent Capital. Acesse mercados globais, opere com alavancagem e posicione-se sobre movimentos de preço sem possuir os ativos.",
            keywords: "Trading de CFDs, Contratos por Diferença, Operar CFDs, CFDs da Excent Capital, Trading com Alavancagem, Trading de Derivativos, Mercados de CFD, Como Operar CFDs",
            canonical: "https://support.excentcapital.tech/pt/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/cfd-trading",
                es: "https://support.excentcapital.tech/es/trading/trading-de-cfd",
                pt: "https://support.excentcapital.tech/pt/trading/trading-de-cfd",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://support.excentcapital.tech/pt/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ordens-pendentes/": {
            lang: "pt",
            title: "Ordens Pendentes",
            description: "Descubra como funcionam as ordens pendentes na Excent Capital. Aprenda a definir pontos de entrada com antecedência e automatizar sua estratégia de trading com precisão.",
            keywords: "Ordens Pendentes, Ordens de Trading, Buy Stop, Sell Stop, Ordens Limitadas, Trading Automatizado, Ordens Excent Capital, Pontos de Entrada, Estratégia de Trading",
            canonical: "https://support.excentcapital.tech/pt/trading/ordens-pendentes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/pending-orders",
                es: "https://support.excentcapital.tech/es/trading/ordenes-pendientes",
                pt: "https://support.excentcapital.tech/pt/trading/ordens-pendentes",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://support.excentcapital.tech/pt/trading/ordens-pendentes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/spreads-oferecidos/": {
            lang: "pt",
            title: "Spreads Oferecidos",
            description: "Descubra a importância dos spreads e dos spreads de volatilidade nos mercados financeiros. Aprenda a minimizar custos e otimizar sua lucratividade como trader.",
            keywords: "Spreads, Spreads de Volatilidade, Mercados Financeiros, Spreads de Trading, Minimizar Custos de Trading, Otimizar Lucros, Estratégias de Trading, Análise de Spreads, Spreads de Forex, Spreads no Mercado de Ações",
            canonical: "https://support.excentcapital.tech/pt/trading/spreads-oferecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/spreads-offered",
                es: "https://support.excentcapital.tech/es/trading/spreads-ofrecidos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads-oferecidos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://support.excentcapital.tech/pt/trading/spreads-oferecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/moedas-base/": {
            lang: "pt",
            title: "Moedas Base",
            description: "Descubra quais moedas base são aceitas na Excent Capital. Escolha a moeda certa para sua conta e simplifique sua experiência de trading e de financiamento.",
            keywords: "Moedas Base, Moedas Suportadas, Conta na Excent Capital, Opções de Moeda de Conta, Seleção de Moeda, Moeda para Trading, Moeda Base em Forex, Opções de Financiamento",
            canonical: "https://support.excentcapital.tech/pt/trading/moedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/base-currencies",
                es: "https://support.excentcapital.tech/es/trading/monedas-base",
                pt: "https://support.excentcapital.tech/pt/trading/moedas-base",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://support.excentcapital.tech/pt/trading/moedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/recursos/dentro-de-recursos/": {
            lang: "pt",
            title: "Dentro de Recursos: O Que Você Vai Descobrir",
            description: "Explore o centro de recursos da Excent Capital com atualizações de mercado, calendários econômicos, ferramentas de trading e conteúdo educacional para apoiar sua jornada como trader.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Atualizações de Mercado, Calendário Econômico, Educação em Trading, Centro de Recursos, Aprenda a Operar, Materiais de Apoio ao Trading",
            canonical: "https://support.excentcapital.tech/pt/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/inside-resources",
                es: "https://support.excentcapital.tech/es/recursos/dentro-de-recursos",
                pt: "https://support.excentcapital.tech/pt/recursos/dentro-de-recursos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://support.excentcapital.tech/pt/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-basicos/": {
            lang: "pt",
            title: "Conceitos Básicos",
            description: "Aprenda os conceitos fundamentais do trading com a Excent Capital. Entenda os termos-chave, a mecânica do mercado e o conhecimento essencial para começar sua jornada no trading.",
            keywords: "Conceitos Básicos de Trading, Trading para Iniciantes, Fundamentos do Mercado, Educação Excent Capital, Terminologia de Trading, Guia para Iniciantes, Aprender a Operar, Conceitos Fundamentais",
            canonical: "https://support.excentcapital.tech/pt/recursos/conceitos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/basic-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-basicos",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-basicos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://support.excentcapital.tech/pt/recursos/conceitos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-avancados/": {
            lang: "pt",
            title: "Conceitos Avançados",
            description: "Aprofunde seus conhecimentos de trading com os conceitos avançados da Excent Capital. Explore estratégias, indicadores e técnicas usadas por traders experientes.",
            keywords: "Conceitos Avançados de Trading, Estratégias de Trading, Indicadores Técnicos, Trading Avançado, Educação Excent Capital, Análise de Mercado, Ferramentas para Traders Profissionais, Técnicas de Trading",
            canonical: "https://support.excentcapital.tech/pt/recursos/conceitos-avancados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/advanced-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-avanzados",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-avancados",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://support.excentcapital.tech/pt/recursos/conceitos-avancados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/recursos-adicionais/": {
            lang: "pt",
            title: "Recursos Adicionais",
            description: "Acesse uma variedade de recursos adicionais na Excent Capital, incluindo glossários de trading, guias da plataforma e ferramentas de mercado para melhorar sua experiência de operação.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Glossário de Termos, Guias da Plataforma, Ajuda de Trading, Ferramentas de Mercado, Recursos Educacionais, Suporte ao Trading",
            canonical: "https://support.excentcapital.tech/pt/recursos/recursos-adicionais",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/additional-resources",
                es: "https://support.excentcapital.tech/es/recursos/recursos-adicionales",
                pt: "https://support.excentcapital.tech/pt/recursos/recursos-adicionais",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://support.excentcapital.tech/pt/recursos/recursos-adicionais",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/minha-conta/dentro-da-minha-conta/": {
            lang: "pt",
            title: "Dentro da Minha Conta: O Que Você Vai Descobrir",
            description: "Gerencie sua conta de trading com facilidade na Excent Capital. Aprenda como atualizar seu perfil, acessar configurações da conta, monitorar atividades e manter a segurança.",
            keywords: "Minha Conta, Gestão de Conta, Perfil da Excent Capital, Configurações da Conta de Trading, Segurança da Conta, Painel do Usuário, Atualizações de Perfil, Gerenciar Conta de Trading",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/dentro-da-minha-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/inside-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://support.excentcapital.tech/pt/minha-conta/dentro-da-minha-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-demo/": {
            lang: "pt",
            title: "Posso Criar uma Conta Demo?",
            description: "Sim, a Excent Capital oferece contas demo para que você possa praticar trading em um ambiente sem riscos. Saiba como abrir uma e começar a explorar a plataforma.",
            keywords: "Conta Demo, Praticar Trading, Demo da Excent Capital, Trading Sem Risco, Criar Conta Demo, Simulador de Trading, Trading para Iniciantes, Aprender a Operar",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-demo",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-real/": {
            lang: "pt",
            title: "Como Criar uma Conta Real?",
            description: "Abra sua conta de trading real na Excent Capital em apenas alguns passos. Siga nosso guia para começar a operar nos mercados reais com segurança e eficiência.",
            keywords: "Conta Real, Criar Conta de Trading, Registro na Excent Capital, Abrir Conta Real, Começar a Operar, Conta Real de Trading, Cadastro de Trading, Configuração de Conta",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-real",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-real",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta/": {
            lang: "pt",
            title: "Por Que Verificar Sua Conta?",
            description: "A verificação da conta na Excent Capital garante segurança, conformidade e acesso completo às funcionalidades de trading. Saiba por que é importante e como concluí-la.",
            keywords: "Verificação de Conta, Verificar Conta de Trading, KYC da Excent Capital, Segurança no Trading, Processo de Conformidade, Verificação de Identidade, Trading Seguro, Acesso Completo à Conta",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/acessar-a-plataforma/": {
            lang: "pt",
            title: "Como Acessar a Plataforma?",
            description: "Acesse a plataforma de trading da Excent Capital facilmente pelo navegador ou dispositivo móvel. Saiba como fazer login e começar a operar a qualquer hora e em qualquer lugar.",
            keywords: "Acessar Plataforma de Trading, Login Excent Capital, Aplicativo de Trading, Plataforma Web de Trading, Trading Móvel, Como Fazer Login, Começar a Operar, Guia de Acesso à Plataforma",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/acessar-a-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
                es: "https://support.excentcapital.tech/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://support.excentcapital.tech/pt/minha-conta/acessar-a-plataforma",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://support.excentcapital.tech/pt/minha-conta/acessar-a-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/tempo-para-criar-conta/": {
            lang: "pt",
            title: "Quanto Tempo Leva para Criar uma Conta?",
            description: "Criar uma conta na Excent Capital é rápido e simples. Descubra quanto tempo leva o processo e quais etapas são necessárias para começar.",
            keywords: "Tempo de Criação de Conta, Cadastro na Excent Capital, Como Criar Conta, Configuração de Conta de Trading, Processo de Registro, Abrir Conta Rápido, Onboarding de Trading",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/tempo-para-criar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/tempo-para-criar-contas",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://support.excentcapital.tech/pt/minha-conta/tempo-para-criar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/contas-corporativas/": {
            lang: "pt",
            title: "Vocês Oferecem Contas Corporativas?",
            description: "Sim, a Excent Capital oferece contas corporativas de trading para empresas e instituições. Descubra os benefícios e os requisitos para abrir uma conta corporativa.",
            keywords: "Conta Corporativa de Trading, Conta Empresarial, Corporativo na Excent Capital, Trading Institucional, Abrir Conta Corporativa, Trading para Empresas, Conta de Investimento Corporativa",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/contas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuentas-corporativas",
                pt: "https://support.excentcapital.tech/pt/minha-conta/contas-corporativas",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://support.excentcapital.tech/pt/minha-conta/contas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/varias-contas-mesmo-email/": {
            lang: "pt",
            title: "Posso Abrir Múltiplas Contas com Diferentes Funções Usando o Mesmo E-mail?",
            description: "Descubra se é possível registrar várias contas da Excent Capital com diferentes funções usando um único endereço de e-mail, e como funciona a gestão de funções na plataforma.",
            keywords: "Múltiplas Contas, Contas com o Mesmo E-mail, Funções na Excent Capital, Funções de Usuário, Gestão de Conta, Acesso à Conta de Trading, Acesso Baseado em Funções, Política de Registro de E-mail",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/varias-contas-mesmo-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://support.excentcapital.tech/pt/minha-conta/varias-contas-mesmo-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/atualizar-informacoes-da-conta/": {
            lang: "pt",
            title: "Como Atualizo as Informações da Minha Conta?",
            description: "Atualize facilmente seus dados pessoais e informações da conta na Excent Capital. Siga nosso guia passo a passo para manter suas informações precisas e atualizadas.",
            keywords: "Atualizar Informações da Conta, Editar Dados Pessoais, Perfil Excent Capital, Configurações da Conta, Alterar Informações da Conta, Atualização do Perfil de Trading, Informações do Usuário",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/atualizar-informacoes-da-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
                es: "https://support.excentcapital.tech/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://support.excentcapital.tech/pt/minha-conta/atualizar-informacoes-da-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/esqueci-minha-senha/": {
            lang: "pt",
            title: "O Que Acontece se Eu Esquecer Minha Senha?",
            description: "Se você esquecer sua senha, a Excent Capital oferece um processo de recuperação simples e seguro. Aprenda como redefinir sua senha e recuperar o acesso à sua conta.",
            keywords: "Esqueci a Senha, Recuperação de Senha, Redefinir Senha de Trading, Ajuda para Login Excent Capital, Acesso à Conta, Recuperar Senha, Senha Perdida, Login na Conta de Trading",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/esqueci-minha-senha",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://support.excentcapital.tech/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://support.excentcapital.tech/pt/minha-conta/esqueci-minha-senha",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://support.excentcapital.tech/pt/minha-conta/esqueci-minha-senha",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/documentos-para-verificacao/": {
            lang: "pt",
            title: "Quais Documentos São Necessários para Verificação de Conta?",
            description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
            keywords: "Documentos para Verificação de Conta, Requisitos KYC, Verificação na Excent Capital, Comprovante de Identidade, Comprovante de Endereço, Enviar Documentos, Verificação Segura, Conformidade no Trading",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/documentos-para-verificacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://support.excentcapital.tech/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://support.excentcapital.tech/pt/minha-conta/documentos-para-verificacao",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                url: "https://support.excentcapital.tech/pt/minha-conta/documentos-para-verificacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/amigos-familia-usar-conta/": {
            lang: "pt",
            title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
            description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
            keywords: "Compartilhamento de Conta, Política da Excent Capital, Uso Pessoal da Conta, Segurança da Conta de Trading, Acesso Compartilhado, Uso por Familiares, Segurança da Conta, Conformidade em Trading",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/amigos-familia-usar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://support.excentcapital.tech/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                url: "https://support.excentcapital.tech/pt/minha-conta/amigos-familia-usar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/cancelar-conta/": {
            lang: "pt",
            title: "Como Cancelo Minha Conta?",
            description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
            keywords: "Cancelar Conta de Trading, Encerrar Conta na Excent Capital, Cancelamento de Conta, Excluir Conta, Fechamento de Conta de Trading, Finalizar Conta, Suporte da Excent Capital, Processo de Cancelamento de Conta",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/cancelar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cancelar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/cancelar-conta",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                url: "https://support.excentcapital.tech/pt/minha-conta/cancelar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta-no-exterior/": {
            lang: "pt",
            title: "Posso Verificar Minha Conta Estando no Exterior?",
            description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
            keywords: "Verificar Conta no Exterior, Verificação Excent Capital, Conta em País Estrangeiro, KYC Internacional, Verificação Remota de Conta, Documentos para Conta, Verificação no Exterior",
            canonical: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta-no-exterior",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                url: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta-no-exterior",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/depositos-saques/dentro-depositos-retiradas/": {
            lang: "pt",
            title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
            description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
            keywords: "Depósitos e Saques, Fondeamento na Excent Capital, Sacar Lucros, Métodos de Pagamento, Opções de Depósito, Prazos de Saque, Fondeamento da Conta de Trading, Transações Financeiras",
            canonical: "https://support.excentcapital.tech/pt/depositos-saques/dentro-depositos-retiradas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://support.excentcapital.tech/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                url: "https://support.excentcapital.tech/pt/depositos-saques/dentro-depositos-retiradas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/primeiro-deposito/": {
            lang: "pt",
            title: "Como Faço Meu Primeiro Depósito?",
            description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
            keywords: "Primeiro Depósito, Fazer um Depósito, Fondeamento Excent Capital, Depósito na Conta de Trading, Como Depositar, Métodos de Pagamento, Começar a Operar, Adicionar Fundos à Conta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://support.excentcapital.tech/pt/depositos-saques/primeiro-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/primer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/primeiro-deposito",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                url: "https://support.excentcapital.tech/pt/depositos-saques/primeiro-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-deposito/": {
            lang: "pt",
            title: "Como Faço um Depósito?",
            description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
            keywords: "Depositar Fundos, Como Depositar, Métodos de Pagamento Excent Capital, Fondeamento da Conta de Trading, Fazer um Depósito, Depósito Seguro, Recarga da Conta, Processo de Depósito",
            canonical: "https://support.excentcapital.tech/pt/depositos-saques/fazer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-deposito",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                url: "https://support.excentcapital.tech/pt/depositos-saques/fazer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-saque/": {
            lang: "pt",
            title: "Como Posso Fazer um Saque?",
            description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
            keywords: "Sacar Fundos, Saque na Excent Capital, Como Sacar, Pagamento da Conta de Trading, Processo de Saque, Saque Seguro, Acessar Ganhos, Métodos de Pagamento",
            canonical: "https://support.excentcapital.tech/pt/depositos-saques/fazer-saque",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-retiro",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-saque",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                url: "https://support.excentcapital.tech/pt/depositos-saques/fazer-saque",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/saque-falhou/": {
            lang: "pt",
            title: "O Que Fazer se Meu Saque Falhar?",
            description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
            keywords: "Saque Falhou, Ajuda Excent Capital, Transação Falhada, Resolver Problemas de Saque, Problema no Saque, Erro de Pagamento, Suporte da Conta de Trading, Corrigir Problema de Saque",
            canonical: "https://support.excentcapital.tech/pt/depositos-saques/saque-falhou",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://support.excentcapital.tech/es/depositos-retiros/retiro-fallido",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/saque-falhou",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                url: "https://support.excentcapital.tech/pt/depositos-saques/saque-falhou",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/pagamentos/dentro-de-pagamentos/": {
            lang: "pt",
            title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
            description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
            keywords: "Pagamentos Excent Capital, Métodos de Pagamento Aceitos, Gestão de Transações, Tempo de Processamento de Pagamento, Moedas Suportadas, Pagamentos de Trading, Opções de Depósito e Saque, Fondeamento de Conta",
            canonical: "https://support.excentcapital.tech/pt/pagamentos/dentro-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/inside-payments",
                es: "https://support.excentcapital.tech/es/pagos/dentro-de-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                url: "https://support.excentcapital.tech/pt/pagamentos/dentro-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/ver-historico-de-pagamentos/": {
            lang: "pt",
            title: "Como Vejo Meu Histórico de Pagamentos?",
            description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
            keywords: "Histórico de Pagamentos, Histórico de Transações, Ver Depósitos, Ver Saques, Pagamentos Excent Capital, Transações da Conta, Histórico da Conta de Trading, Registros Financeiros",
            canonical: "https://support.excentcapital.tech/pt/pagamentos/ver-historico-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
                es: "https://support.excentcapital.tech/es/pagos/ver-historial-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                url: "https://support.excentcapital.tech/pt/pagamentos/ver-historico-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/tempo-de-transacao/": {
            lang: "pt",
            title: "Quanto Tempo Pode Levar uma Transação?",
            description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
            keywords: "Tempo de Transação, Tempo de Processamento, Duração do Depósito, Duração do Saque, Pagamentos Excent Capital, Velocidade de Pagamento, Transações da Conta de Trading, Atrasos em Transações",
            canonical: "https://support.excentcapital.tech/pt/pagamentos/tempo-de-transacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
                es: "https://support.excentcapital.tech/es/pagos/tiempo-transaccion",
                pt: "https://support.excentcapital.tech/pt/pagamentos/tempo-de-transacao",
                fr: "https://support.excentcapital.tech/fr/trading/spreads",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                url: "https://support.excentcapital.tech/pt/pagamentos/tempo-de-transacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        // Frances
        "fr/": {
            lang: "fr",
            title: "Base de connaissances | Excent Capital",
            description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
            keywords: "Centre d’aide Excent Capital, Support de plateforme de trading, FAQ Trading, Comment Trader, Tutoriels FX, Gestion de compte, Guides de Trading, Aide au dépôt, Aide au retrait",
            canonical: "https://support.excentcapital.tech/fr/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en",
                es: "https://support.excentcapital.tech/es",
                pt: "https://support.excentcapital.tech/pt",
                fr: "https://support.excentcapital.tech/fr",
                it: "https://support.excentcapital.tech/it",
                zh: "https://support.excentcapital.tech/zh",
            },
            openGraph: {
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                url: "https://support.excentcapital.tech/fr/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-de-nous/": {
            lang: "fr",
            title: "Dans la section À propos : Ce que vous allez découvrir",
            description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
            keywords: "À propos d’Excent Capital, Mission de l’entreprise, Valeurs d’une société de trading, Rencontrer l’équipe, Qui est Excent Capital, Notre histoire, Société de services financiers, Vue d’ensemble d’Excent Capital",
            canonical: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-de-nous",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/inside-about-us",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                url: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-de-nous",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-d-excent-capital/": {
            lang: "fr",
            title: "À propos d’Excent Capital",
            description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
            keywords: "Excent Capital, À propos de nous, Présentation de l’entreprise, Société de trading, Services financiers, Société de courtage, Notre mission, Qui nous sommes, Support global au trading",
            canonical: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-d-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                url: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-d-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/construisez-votre-portefeuille/": {
            lang: "fr",
            title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
            description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
            keywords: "Construire un portefeuille, Instruments de trading, Trading Forex, Marché boursier, Trading d’indices, Trading de matières premières, Portefeuille diversifié, Actifs Excent Capital",
            canonical: "https://support.excentcapital.tech/fr/a-propos-de-nous/construisez-votre-portefeuille",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                url: "https://support.excentcapital.tech/fr/a-propos-de-nous/construisez-votre-portefeuille",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance/": {
            lang: "fr",
            title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
            description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
            keywords: "Excent Capital, Investissements internationaux, Diversifier son portefeuille, Marchés mondiaux, Partenaire de trading fiable, Trading Forex, Plateforme de trading internationale, Opportunités d’investissement",
            canonical: "https://support.excentcapital.tech/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                url: "https://support.excentcapital.tech/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/centre-educatif-excent-capital/": {
            lang: "fr",
            title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
            description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
            keywords: "Formation en Trading, Apprendre à Trader, Tutoriels de Trading, Cours de Trading, Formation Excent Capital, Guide de Trading Débutant, Stratégies de Trading Avancées, Ressources de Trading",
            canonical: "https://support.excentcapital.tech/fr/a-propos-de-nous/centre-educatif-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                url: "https://support.excentcapital.tech/fr/a-propos-de-nous/centre-educatif-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/investissez-en-confiance/": {
            lang: "fr",
            title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
            description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
            keywords: "Gestion des Risques, Outils de Risque en Trading, Protection des Investissements, Stratégies Excent Capital, Trading en Confiance, Volatilité du Marché, Outils de Trading, Gérer le Risque en Trading",
            canonical: "https://support.excentcapital.tech/fr/a-propos-de-nous/investissez-en-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/invista-com-confianca",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                url: "https://support.excentcapital.tech/fr/a-propos-de-nous/investissez-en-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/trading/a-linterieur-du-trading/": {
            lang: "fr",
            title: "Dans le monde du Trading : Ce que vous allez découvrir",
            description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
            keywords: "Guide de Trading, Perspectives de Marché, Concepts de Trading, Comment Trader, Plateforme Excent Capital, Fonctionnalités de Trading, Apprendre à Trader, Base de Connaissances en Trading",
            canonical: "https://support.excentcapital.tech/fr/trading/a-linterieur-du-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/inside-trading",
                es: "https://support.excentcapital.tech/es/trading/dentro-del-trading",
                pt: "https://support.excentcapital.tech/pt/trading/dentro-do-trading",
                fr: "https://support.excentcapital.tech/fr/trading/a-linterieur-du-trading",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                url: "https://support.excentcapital.tech/fr/trading/a-linterieur-du-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/instruments-chez-excent-capital/": {
            lang: "fr",
            title: "Instruments chez Excent Capital",
            description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
            keywords: "Instruments de Trading, Forex, Actions, Matières Premières, Indices, Actifs Excent Capital, Instruments Financiers, Options d’Investissement, Marchés de Trading",
            canonical: "https://support.excentcapital.tech/fr/trading/instruments-chez-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/instrumentos-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/instrumentos-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/instruments-chez-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                url: "https://support.excentcapital.tech/fr/trading/instruments-chez-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/effet-de-levier-excent-capital/": {
            lang: "fr",
            title: "Effet de levier proposé par Excent Capital",
            description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
            keywords: "Trading avec Effet de Levier, Trading avec Levier, Levier Excent Capital, Trading sur Marge, Options de Levier, Amplifier le Trading, Levier Forex, Trading Responsable",
            canonical: "https://support.excentcapital.tech/fr/trading/effet-de-levier-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/apalancamiento-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/alavancagem-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/effet-de-levier-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                url: "https://support.excentcapital.tech/fr/trading/effet-de-levier-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/micro-lots-at-excent-capital/": {
            lang: "fr",
            title: "Micro lots chez Excent Capital",
            description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
            keywords: "Trading en Micro Lots, Micro Lots Excent Capital, Trading en Petits Lots, Trading Débutant, Gestion des Risques, Trading Flexible, Micro Lots Forex, Trading à Faible Exposition",
            canonical: "https://support.excentcapital.tech/fr/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/micro-lotes-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/micro-lotes-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/micro-lots-at-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                url: "https://support.excentcapital.tech/fr/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/horaires-de-trading/": {
            lang: "fr",
            title: "Heures de Trading",
            description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
            keywords: "Heures de Trading, Horaires de Marché, Horaires de Trading Forex, Heures du Marché Boursier, Calendrier Excent Capital, Sessions de Trading, Périodes de Trading, Horaires des Marchés Financiers",
            canonical: "https://support.excentcapital.tech/fr/trading/horaires-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-hours",
                es: "https://support.excentcapital.tech/es/trading/horario-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/horario-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/horaires-de-trading",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                url: "https://support.excentcapital.tech/fr/trading/horaires-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/outils-de-trading/": {
            lang: "fr",
            title: "Outils de Trading",
            description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
            keywords: "Outils de Trading, Outils d’Analyse de Marché, Calculateurs de Trading, Outils Forex, Plateforme Excent Capital, Ressources de Trading, Outils de Graphiques, Trading Informé",
            canonical: "https://support.excentcapital.tech/fr/trading/outils-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-tools",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/outils-de-trading",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                url: "https://support.excentcapital.tech/fr/trading/outils-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "fr/trading/outils-de-trading-acuity/": {
            lang: "fr",
            title: "Outils de Trading Acuity",
            description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
            keywords: "Outils de Trading Acuity, Outils de Trading IA, Analyse du Sentiment de Marché, Insights de Marché en Temps Réel, Outils Excent Capital, Insights Acuity, Trading Intelligent, Analytique de Trading",
            canonical: "https://support.excentcapital.tech/fr/trading/outils-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading-acuity",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://support.excentcapital.tech/fr/trading/outils-de-trading-acuity",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                url: "https://support.excentcapital.tech/fr/trading/outils-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "fr/trading/appels-de-marge/": {
            lang: "fr",
            title: "Appels de Marge",
            description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
            keywords: "Appels de Marge, Qu’est-ce qu’un Appel de Marge, Marge Excent Capital, Trading sur Marge, Liquidation Forcée, Protection de Compte, Trading avec Marge, Gestion des Risques",
            canonical: "https://support.excentcapital.tech/fr/trading/appels-de-marge",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/margin-calls",
                es: "https://support.excentcapital.tech/es/trading/llamadas-de-margen",
                pt: "https://support.excentcapital.tech/pt/trading/chamadas-de-margem",
                fr: "https://support.excentcapital.tech/fr/trading/appels-de-marge",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                url: "https://support.excentcapital.tech/fr/trading/appels-de-marge",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/trading-de-cfd/": {
            lang: "fr",
            title: "Trading de CFD",
            description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
            keywords: "Trading de CFD, Contrats sur la Différence, Trader les CFD, CFD Excent Capital, Trading avec Effet de Levier, Trading de Produits Dérivés, Marchés CFD, Comment Trader les CFD",
            canonical: "https://support.excentcapital.tech/fr/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/cfd-trading",
                es: "https://support.excentcapital.tech/es/trading/trading-de-cfd",
                pt: "https://support.excentcapital.tech/pt/trading/trading-de-cfd",
                fr: "https://support.excentcapital.tech/fr/trading/trading-de-cfd",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                url: "https://support.excentcapital.tech/fr/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/ordres-en-attente/": {
            lang: "fr",
            title: "Ordres en Attente",
            description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
            keywords: "Ordres en Attente, Ordres de Trading, Buy Stop, Sell Stop, Ordres Limites, Trading Automatisé, Ordres Excent Capital, Points d’Entrée, Stratégie de Trading",
            canonical: "https://support.excentcapital.tech/fr/trading/ordres-en-attente",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/pending-orders",
                es: "https://support.excentcapital.tech/es/trading/ordenes-pendientes",
                pt: "https://support.excentcapital.tech/pt/trading/ordens-pendentes",
                fr: "https://support.excentcapital.tech/fr/trading/ordres-en-attente",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                url: "https://support.excentcapital.tech/fr/trading/ordres-en-attente",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/spreads-offerts/": {
            lang: "fr",
            title: "Spreads Proposés",
            description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
            keywords: "Spreads, Spreads de Volatilité, Marchés Financiers, Spreads de Trading, Réduire les Coûts de Trading, Optimiser la Rentabilité, Stratégies de Trading, Analyse des Spreads, Spreads Forex, Spreads Boursiers",
            canonical: "https://support.excentcapital.tech/fr/trading/spreads-offerts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/spreads-offered",
                es: "https://support.excentcapital.tech/es/trading/spreads-ofrecidos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads-oferecidos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads-offerts",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                url: "https://support.excentcapital.tech/fr/trading/spreads-offerts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/devises-de-base/": {
            lang: "fr",
            title: "Devises de Base",
            description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
            keywords: "Devises de Base, Devises Acceptées, Compte Excent Capital, Options de Devise de Compte, Sélection de Devise, Devise de Trading, Devise de Base Forex, Options de Financement",
            canonical: "https://support.excentcapital.tech/fr/trading/devises-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/base-currencies",
                es: "https://support.excentcapital.tech/es/trading/monedas-base",
                pt: "https://support.excentcapital.tech/pt/trading/moedas-base",
                fr: "https://support.excentcapital.tech/fr/trading/devises-de-base",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                url: "https://support.excentcapital.tech/fr/trading/devises-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/ressources/a-linterieur-des-ressources/": {
            lang: "fr",
            title: "Dans la section Ressources : Ce que vous allez découvrir",
            description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Mises à Jour du Marché, Calendrier Économique, Formation au Trading, Centre de Ressources, Apprendre à Trader, Supports de Trading",
            canonical: "https://support.excentcapital.tech/fr/ressources/a-linterieur-des-ressources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/inside-resources",
                es: "https://support.excentcapital.tech/es/recursos/dentro-de-recursos",
                pt: "https://support.excentcapital.tech/pt/recursos/dentro-de-recursos",
                fr: "https://support.excentcapital.tech/fr/ressources/a-linterieur-des-ressources",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                url: "https://support.excentcapital.tech/fr/ressources/a-linterieur-des-ressources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-de-base/": {
            lang: "fr",
            title: "Concepts de Base",
            description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
            keywords: "Concepts de Base en Trading, Trading pour Débutants, Bases du Marché, Formation Excent Capital, Terminologie du Trading, Guide Débutant, Apprendre à Trader, Concepts Fondamentaux",
            canonical: "https://support.excentcapital.tech/fr/ressources/concepts-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/basic-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-basicos",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-basicos",
                fr: "https://support.excentcapital.tech/fr/ressources/concepts-de-base",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                url: "https://support.excentcapital.tech/fr/ressources/concepts-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-avances/": {
            lang: "fr",
            title: "Concepts Avancés",
            description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
            keywords: "Concepts Avancés en Trading, Stratégies de Trading, Indicateurs Techniques, Trading Expert, Formation Excent Capital, Analyse de Marché, Outils pour Traders Pros, Techniques de Trading",
            canonical: "https://support.excentcapital.tech/fr/ressources/concepts-avances",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/advanced-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-avanzados",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-avancados",
                fr: "https://support.excentcapital.tech/fr/ressources/concepts-avances",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                url: "https://support.excentcapital.tech/fr/ressources/concepts-avances",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/ressources-supplementaires/": {
            lang: "fr",
            title: "Ressources Supplémentaires",
            description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Glossaire de Termes, Guides de Plateforme, Aide au Trading, Outils de Marché, Ressources Éducatives, Support de Trading",
            canonical: "https://support.excentcapital.tech/fr/ressources/ressources-supplementaires",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/additional-resources",
                es: "https://support.excentcapital.tech/es/recursos/recursos-adicionales",
                pt: "https://support.excentcapital.tech/pt/recursos/recursos-adicionais",
                fr: "https://support.excentcapital.tech/fr/ressources/ressources-supplementaires",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                url: "https://support.excentcapital.tech/fr/ressources/ressources-supplementaires",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/mon-compte/a-linterieur-de-mon-compte/": {
            lang: "fr",
            title: "Dans Mon Compte : Ce que vous allez découvrir",
            description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
            keywords: "Mon Compte, Gestion de Compte, Profil Excent Capital, Paramètres de Compte de Trading, Sécurité du Compte, Tableau de Bord Utilisateur, Mise à Jour de Profil, Gérer un Compte de Trading",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/a-linterieur-de-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/inside-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                url: "https://support.excentcapital.tech/fr/mon-compte/a-linterieur-de-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-demo/": {
            lang: "fr",
            title: "Puis-je Créer un Compte Démo ?",
            description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
            keywords: "Compte Démo, Pratique de Trading, Démo Excent Capital, Trading Sans Risque, Créer un Compte Démo, Simulateur de Trading, Trading Débutant, Apprendre à Trader",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-demo",
                fr: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-demo",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                url: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-reel/": {
            lang: "fr",
            title: "Comment créer un compte réel ?",
            description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
            keywords: "Compte Réel, Créer un Compte de Trading, Inscription Excent Capital, Ouvrir un Compte Réel, Commencer à Trader, Compte de Trading Réel, Inscription au Trading, Configuration de Compte",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-reel",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-real",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-real",
                fr: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-reel",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                url: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-reel",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-votre-compte/": {
            lang: "fr",
            title: "Pourquoi vérifier votre compte ?",
            description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
            keywords: "Vérification de Compte, Vérifier un Compte de Trading, KYC Excent Capital, Sécurité du Trading, Processus de Conformité, Vérification d’Identité, Trading Sécurisé, Accès Complet au Compte",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/verifier-votre-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/verifier-votre-compte",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                url: "https://support.excentcapital.tech/fr/mon-compte/verifier-votre-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/acceder-a-la-plateforme/": {
            lang: "fr",
            title: "Comment accéder à la plateforme ?",
            description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
            keywords: "Accès à la Plateforme de Trading, Connexion Excent Capital, Application de Trading, Plateforme Web de Trading, Trading Mobile, Comment Se Connecter, Commencer à Trader, Guide d’Accès à la Plateforme",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/acceder-a-la-plateforme",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
                es: "https://support.excentcapital.tech/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://support.excentcapital.tech/pt/minha-conta/acessar-a-plataforma",
                fr: "https://support.excentcapital.tech/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                url: "https://support.excentcapital.tech/fr/mon-compte/acceder-a-la-plateforme",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/delai-pour-creer-un-compte/": {
            lang: "fr",
            title: "Combien de temps faut-il pour créer un compte ?",
            description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
            keywords: "Temps de Création de Compte, Inscription Excent Capital, Comment Créer un Compte, Configuration du Compte de Trading, Processus d’Enregistrement, Ouvrir un Compte Rapidement, Intégration au Trading",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/delai-pour-creer-un-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                url: "https://support.excentcapital.tech/fr/mon-compte/delai-pour-creer-un-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/comptes-corporatifs/": {
            lang: "fr",
            title: "Proposez-vous des comptes professionnels ?",
            description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
            keywords: "Compte de Trading Professionnel, Compte Entreprise, Compte Corporate Excent Capital, Trading Institutionnel, Ouvrir un Compte Corporate, Trading pour Entreprises, Compte d’Investissement Professionnel",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/comptes-corporatifs",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuentas-corporativas",
                pt: "https://support.excentcapital.tech/pt/minha-conta/contas-corporativas",
                fr: "https://support.excentcapital.tech/fr/mon-compte/comptes-corporatifs",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                url: "https://support.excentcapital.tech/fr/mon-compte/comptes-corporatifs",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/plusieurs-comptes-meme-email/": {
            lang: "fr",
            title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
            description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
            keywords: "Comptes Multiples, Comptes avec le Même E-mail, Rôles Excent Capital, Rôles Utilisateur, Gestion de Compte, Accès au Compte de Trading, Accès Basé sur les Rôles, Politique d’Enregistrement par E-mail",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/plusieurs-comptes-meme-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://support.excentcapital.tech/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                url: "https://support.excentcapital.tech/fr/mon-compte/plusieurs-comptes-meme-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mettre-a-jour-informations-compte/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/mettre-a-jour-informations-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
                es: "https://support.excentcapital.tech/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://support.excentcapital.tech/fr/mon-compte/mettre-a-jour-informations-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mot-de-passe-oublie/": {
            lang: "fr",
            title: "Que se passe-t-il si j’oublie mon mot de passe ?",
            description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
            keywords: "Mot de Passe Oublié, Récupération de Mot de Passe, Réinitialiser Mot de Passe Trading, Aide Connexion Excent Capital, Accès au Compte, Récupérer Mot de Passe, Mot de Passe Perdu, Connexion Compte de Trading",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/mot-de-passe-oublie",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://support.excentcapital.tech/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://support.excentcapital.tech/pt/minha-conta/esqueci-minha-senha",
                fr: "https://support.excentcapital.tech/fr/mon-compte/mot-de-passe-oublie",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                url: "https://support.excentcapital.tech/fr/mon-compte/mot-de-passe-oublie",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/documents-pour-verification/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/documents-pour-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://support.excentcapital.tech/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://support.excentcapital.tech/pt/minha-conta/documentos-para-verificacao",
                fr: "https://support.excentcapital.tech/fr/mon-compte/documents-pour-verification",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://support.excentcapital.tech/fr/mon-compte/documents-pour-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/amis-famille-utiliser-compte/": {
            lang: "fr",
            title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
            description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
            keywords: "Partage de Compte, Politique Excent Capital, Utilisation Personnelle du Compte, Sécurité du Compte de Trading, Accès Partagé, Utilisation Familiale du Compte, Sécurité du Compte, Conformité en Trading",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/amis-famille-utiliser-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://support.excentcapital.tech/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                url: "https://support.excentcapital.tech/fr/mon-compte/amis-famille-utiliser-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/annuler-mon-compte/": {
            lang: "fr",
            title: "Comment annuler mon compte",
            description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
            keywords: "Annuler Compte de Trading, Fermer Compte Excent Capital, Résiliation de Compte, Supprimer Compte, Clôture de Compte de Trading, Fermer Compte, Support Excent Capital, Processus d’Annulation de Compte",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/annuler-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cancelar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/cancelar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/annuler-mon-compte",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                url: "https://support.excentcapital.tech/fr/mon-compte/annuler-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-compte-depuis-etranger/": {
            lang: "fr",
            title: "Puis-je vérifier mon compte depuis un pays étranger ?",
            description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
            keywords: "Vérifier Compte à l’Étranger, Vérification Excent Capital, Création de Compte depuis l’Étranger, KYC International, Vérification de Compte à Distance, Documents de Compte, Vérification Hors Pays",
            canonical: "https://support.excentcapital.tech/fr/mon-compte/verifier-compte-depuis-etranger",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://support.excentcapital.tech/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                url: "https://support.excentcapital.tech/fr/mon-compte/verifier-compte-depuis-etranger",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/depots-retraits/a-linterieur-depots-retraits/": {
            lang: "fr",
            title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
            description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
            keywords: "Dépôts et Retraits, Financement Excent Capital, Retirer des Gains, Méthodes de Paiement, Options de Dépôt, Délais de Retrait, Financement du Compte de Trading, Transactions Financières",
            canonical: "https://support.excentcapital.tech/fr/depots-retraits/a-linterieur-depots-retraits",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://support.excentcapital.tech/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                url: "https://support.excentcapital.tech/fr/depots-retraits/a-linterieur-depots-retraits",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/premier-depot/": {
            lang: "fr",
            title: "Comment effectuer un premier dépôt ?",
            description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
            keywords: "Premier Dépôt, Effectuer un Dépôt, Financement Excent Capital, Dépôt Compte de Trading, Comment Déposer, Méthodes de Paiement, Commencer à Trader, Approvisionner Compte",
            canonical: "https://support.excentcapital.tech/fr/depots-retraits/premier-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/primer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/primeiro-deposito",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/premier-depot",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                url: "https://support.excentcapital.tech/fr/depots-retraits/premier-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-depot/": {
            lang: "fr",
            title: "Comment effectuer un dépôt ?",
            description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
            keywords: "Déposer des Fonds, Comment Déposer, Méthodes de Paiement Excent Capital, Financement Compte de Trading, Effectuer un Dépôt, Dépôt Sécurisé, Recharger Compte, Processus de Dépôt",
            canonical: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-deposito",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-depot",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                url: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-retrait/": {
            lang: "fr",
            title: "Comment effectuer un retrait ?",
            description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
            keywords: "Retirer des Fonds, Retrait Excent Capital, Comment Retirer, Paiement Compte de Trading, Processus de Retrait, Retrait Sécurisé, Accéder aux Gains, Méthodes de Paiement",
            canonical: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-retiro",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-saque",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-retrait",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                url: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/echec-du-retrait/": {
            lang: "fr",
            title: "Que faire si mon retrait échoue ?",
            description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
            keywords: "Retrait Échoué, Aide Excent Capital, Transaction Échouée, Résoudre un Problème de Retrait, Problème de Retrait, Erreur de Paiement, Support Compte de Trading, Corriger un Problème de Retrait",
            canonical: "https://support.excentcapital.tech/fr/depots-retraits/echec-du-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://support.excentcapital.tech/es/depositos-retiros/retiro-fallido",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/saque-falhou",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/echec-du-retrait",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                url: "https://support.excentcapital.tech/fr/depots-retraits/echec-du-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/paiements/a-linterieur-des-paiements/": {
            lang: "fr",
            title: "Dans la section Paiements : Ce que vous allez découvrir",
            description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
            keywords: "Paiements Excent Capital, Méthodes de Paiement Acceptées, Gestion des Transactions, Délai de Traitement des Paiements, Devises Supportées, Paiements de Trading, Options de Dépôt et de Retrait, Financement de Compte",
            canonical: "https://support.excentcapital.tech/fr/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/inside-payments",
                es: "https://support.excentcapital.tech/es/pagos/dentro-de-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/paiements/a-linterieur-des-paiements",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                url: "https://support.excentcapital.tech/fr/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/voir-historique-paiements/": {
            lang: "fr",
            title: "Comment voir mon historique de paiements ?",
            description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
            keywords: "Historique des Paiements, Historique des Transactions, Voir les Dépôts, Voir les Retraits, Paiements Excent Capital, Transactions du Compte, Historique Compte de Trading, Relevés Financiers",
            canonical: "https://support.excentcapital.tech/fr/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
                es: "https://support.excentcapital.tech/es/pagos/ver-historial-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/paiements/voir-historique-paiements",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                url: "https://support.excentcapital.tech/fr/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/delai-de-transaction/": {
            lang: "fr",
            title: "Combien de temps une transaction peut-elle prendre ?",
            description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
            keywords: "Délai de Transaction, Temps de Traitement, Durée du Dépôt, Durée du Retrait, Paiements Excent Capital, Vitesse de Paiement, Transactions Compte de Trading, Retard de Transactions",
            canonical: "https://support.excentcapital.tech/fr/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
                es: "https://support.excentcapital.tech/es/pagos/tiempo-transaccion",
                pt: "https://support.excentcapital.tech/pt/pagamentos/tempo-de-transacao",
                fr: "https://support.excentcapital.tech/fr/paiements/delai-de-transaction",
                it: "https://support.excentcapital.tech/it/trading/spreads",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                url: "https://support.excentcapital.tech/fr/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Italiano
        "it/": {
            lang: "it",
            title: "Knowledgebase | Excent Capital",
            description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
            keywords: "Centro Assistenza Excent Capital, Supporto Piattaforma di Trading, FAQ Trading, Come Fare Trading, Tutorial FX, Gestione Account, Guide al Trading, Assistenza Depositi, Assistenza Prelievi",
            canonical: "https://support.excentcapital.tech/it/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en",
                es: "https://support.excentcapital.tech/es",
                pt: "https://support.excentcapital.tech/pt",
                fr: "https://support.excentcapital.tech/fr",
                it: "https://support.excentcapital.tech/it",
                zh: "https://support.excentcapital.tech/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                url: "https://support.excentcapital.tech/it/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/dentro-di-noi/": {
            lang: "it",
            title: "Dentro Chi Siamo: Cosa Scoprirai",
            description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
            keywords: "Chi è Excent Capital, Missione Aziendale, Valori Società di Trading, Conosci il Team, Chi è Excent Capital, La Nostra Storia, Società di Servizi Finanziari, Panoramica Excent Capital",
            canonical: "https://support.excentcapital.tech/it/chi-siamo/dentro-di-noi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/inside-about-us",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://support.excentcapital.tech/it/chi-siamo/dentro-di-noi",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                url: "https://support.excentcapital.tech/it/chi-siamo/dentro-di-noi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/su-excent-capital/": {
            lang: "it",
            title: "Chi è Excent Capital",
            description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
            keywords: "Excent Capital, Chi Siamo, Panoramica Aziendale, Società di Trading, Servizi Finanziari, Società di Investimenti, La Nostra Missione, Chi Siamo Noi, Supporto al Trading Globale",
            canonical: "https://support.excentcapital.tech/it/chi-siamo/su-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://support.excentcapital.tech/it/chi-siamo/su-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                url: "https://support.excentcapital.tech/it/chi-siamo/su-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/costruisci-il-tuo-portafoglio/": {
            lang: "it",
            title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
            description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
            keywords: "Costruire Portafoglio, Strumenti di Trading, Trading Forex, Mercato Azionario, Trading Indici, Trading Materie Prime, Portafoglio Diversificato, Asset di Excent Capital",
            canonical: "https://support.excentcapital.tech/it/chi-siamo/costruisci-il-tuo-portafoglio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://support.excentcapital.tech/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                url: "https://support.excentcapital.tech/it/chi-siamo/costruisci-il-tuo-portafoglio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia/": {
            lang: "it",
            title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
            description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
            keywords: "Excent Capital, Investimenti Internazionali, Diversificare Portafoglio, Mercati Globali, Partner Affidabile per il Trading, Trading Forex, Piattaforma di Trading Internazionale, Opportunità di Investimento",
            canonical: "https://support.excentcapital.tech/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://support.excentcapital.tech/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                url: "https://support.excentcapital.tech/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/centro-educativo-excent-capital/": {
            lang: "it",
            title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
            description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
            keywords: "Formazione sul Trading, Imparare a Fare Trading, Tutorial di Trading, Corsi di Trading, Formazione Excent Capital, Guida al Trading per Principianti, Strategie Avanzate di Trading, Risorse di Trading",
            canonical: "https://support.excentcapital.tech/it/chi-siamo/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://support.excentcapital.tech/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                url: "https://support.excentcapital.tech/it/chi-siamo/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/investi-con-fiducia/": {
            lang: "it",
            title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
            description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
            keywords: "Gestione del Rischio, Strumenti per il Rischio di Trading, Protezione degli Investimenti, Strategie Excent Capital, Trading con Fiducia, Volatilità di Mercato, Strumenti di Trading, Gestire il Rischio nel Trading",
            canonical: "https://support.excentcapital.tech/it/chi-siamo/investi-con-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/invista-com-confianca",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://support.excentcapital.tech/it/chi-siamo/investi-con-fiducia",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                url: "https://support.excentcapital.tech/it/chi-siamo/investi-con-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/trading/dentro-del-trading-it/": {
            lang: "it",
            title: "Dentro il Trading: Cosa Scoprirai",
            description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
            keywords: "Guida al Trading, Approfondimenti di Mercato, Concetti di Trading, Come Fare Trading, Piattaforma Excent Capital, Funzionalità di Trading, Imparare il Trading, Base di Conoscenza del Trading",
            canonical: "https://support.excentcapital.tech/it/trading/dentro-del-trading-it",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/inside-trading",
                es: "https://support.excentcapital.tech/es/trading/dentro-del-trading",
                pt: "https://support.excentcapital.tech/pt/trading/dentro-do-trading",
                fr: "https://support.excentcapital.tech/fr/trading/a-linterieur-du-trading",
                it: "https://support.excentcapital.tech/it/trading/dentro-del-trading-it",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                url: "https://support.excentcapital.tech/it/trading/dentro-del-trading-it",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-excent-capital/": {
            lang: "it",
            title: "Strumenti su Excent Capital",
            description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
            keywords: "Strumenti di Trading, Forex, Azioni, Materie Prime, Indici, Asset Excent Capital, Strumenti Finanziari, Opzioni di Investimento, Mercati di Trading",
            canonical: "https://support.excentcapital.tech/it/trading/strumenti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/instrumentos-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/instrumentos-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/instruments-chez-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/strumenti-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                url: "https://support.excentcapital.tech/it/trading/strumenti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/leva-excent-capital/": {
            lang: "it",
            title: "Leva Finanziaria Offerta da Excent Capital",
            description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
            keywords: "Trading con Leva, Trading a Leva, Leva Excent Capital, Trading con Margine, Opzioni di Leva, Amplificare il Trading, Leva Forex, Trading Responsabile",
            canonical: "https://support.excentcapital.tech/it/trading/leva-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/apalancamiento-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/alavancagem-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/effet-de-levier-excent-capital",
                it: "https://support.excentcapital.tech/it/it/trading/leva-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                url: "https://support.excentcapital.tech/it/trading/leva-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/micro-lotti-excent-capital/": {
            lang: "it",
            title: "Micro Lotti su Excent Capital",
            description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
            keywords: "Trading con Micro Lotti, Micro Lotti Excent Capital, Trading con Lotti Piccoli, Trading per Principianti, Gestione del Rischio, Trading Flessibile, Micro Lotti Forex, Trading a Bassa Esposizione",
            canonical: "https://support.excentcapital.tech/it/trading/micro-lotti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/micro-lotes-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/micro-lotes-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/micro-lots-at-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/micro-lotti-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                url: "https://support.excentcapital.tech/it/trading/micro-lotti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/orari-di-trading/": {
            lang: "it",
            title: "Orari di Trading",
            description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
            keywords: "Orari di Trading, Orari di Mercato, Orari Forex, Orari Mercato Azionario, Calendario Excent Capital, Sessioni di Trading, Tempi di Trading, Orari Mercati Finanziari",
            canonical: "https://support.excentcapital.tech/it/trading/orari-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-hours",
                es: "https://support.excentcapital.tech/es/trading/horario-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/horario-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/horaires-de-trading",
                it: "https://support.excentcapital.tech/it/trading/orari-di-trading",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                url: "https://support.excentcapital.tech/it/trading/orari-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-di-trading/": {
            lang: "it",
            title: "Strumenti di Trading",
            description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
            keywords: "Strumenti di Trading, Strumenti di Analisi di Mercato, Calcolatori di Trading, Strumenti Forex, Piattaforma Excent Capital, Risorse per il Trading, Strumenti di Analisi Grafica, Trading Informato",
            canonical: "https://support.excentcapital.tech/it/trading/strumenti-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-tools",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/outils-de-trading",
                it: "https://support.excentcapital.tech/it/trading/strumenti-di-trading",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                url: "https://support.excentcapital.tech/it/trading/strumenti-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "it/trading/strumenti-di-trading-acuity/": {
            lang: "it",
            title: "Strumenti Acuity per il Trading",
            description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
            keywords: "Strumenti Acuity per il Trading, Strumenti di Trading AI, Analisi del Sentiment di Mercato, Approfondimenti di Mercato in Tempo Reale, Strumenti Excent Capital, Approfondimenti Acuity, Trading Intelligente, Analisi di Trading",
            canonical: "https://support.excentcapital.tech/it/trading/strumenti-di-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading-acuity",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://support.excentcapital.tech/fr/trading/outils-de-trading-acuity",
                it: "https://support.excentcapital.tech/it/trading/strumenti-di-trading-acuity",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                url: "https://support.excentcapital.tech/it/trading/strumenti-di-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "it/trading/chiamate-di-margine/": {
            lang: "it",
            title: "Chiamate di Margine",
            description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
            keywords: "Chiamate di Margine, Cos’è una Chiamata di Margine, Margine Excent Capital, Margine di Trading, Liquidazione Forzata, Protezione dell’Account, Trading con Margine, Gestione del Rischio",
            canonical: "https://support.excentcapital.tech/it/trading/chiamate-di-margine",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/margin-calls",
                es: "https://support.excentcapital.tech/es/trading/llamadas-de-margen",
                pt: "https://support.excentcapital.tech/pt/trading/chamadas-de-margem",
                fr: "https://support.excentcapital.tech/fr/trading/appels-de-marge",
                it: "https://support.excentcapital.tech/it/trading/chiamate-di-margine",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                url: "https://support.excentcapital.tech/it/trading/chiamate-di-margine",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/trading-di-cfd/": {
            lang: "it",
            title: "Trading CFD",
            description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
            keywords: "Trading CFD, Contratti per Differenza, Fare Trading con i CFD, CFD Excent Capital, Trading con Leva, Trading di Derivati, Mercati CFD, Come Fare Trading con i CFD",
            canonical: "https://support.excentcapital.tech/it/trading/trading-di-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/cfd-trading",
                es: "https://support.excentcapital.tech/es/trading/trading-de-cfd",
                pt: "https://support.excentcapital.tech/pt/trading/trading-de-cfd",
                fr: "https://support.excentcapital.tech/fr/trading/trading-de-cfd",
                it: "https://support.excentcapital.tech/it/trading/trading-di-cfd",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                url: "https://support.excentcapital.tech/it/trading/trading-di-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/ordini-pendenti/": {
            lang: "it",
            title: "Ordini Pendenti",
            description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
            keywords: "Ordini Pendenti, Ordini di Trading, Buy Stop, Sell Stop, Ordini Limit, Trading Automatizzato, Ordini Excent Capital, Punti di Ingresso, Strategia di Trading",
            canonical: "https://support.excentcapital.tech/it/trading/ordini-pendenti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/pending-orders",
                es: "https://support.excentcapital.tech/es/trading/ordenes-pendientes",
                pt: "https://support.excentcapital.tech/pt/trading/ordens-pendentes",
                fr: "https://support.excentcapital.tech/fr/trading/ordres-en-attente",
                it: "https://support.excentcapital.tech/it/trading/ordini-pendenti",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                url: "https://support.excentcapital.tech/it/trading/ordini-pendenti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/spreads-offerti/": {
            lang: "it",
            title: "Spread Offerti",
            description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
            keywords: "Spread, Spread di Volatilità, Mercati Finanziari, Spread di Trading, Ridurre i Costi di Trading, Ottimizzare la Redditività, Strategie di Trading, Analisi degli Spread, Spread Forex, Spread Azionari",
            canonical: "https://support.excentcapital.tech/it/trading/spreads-offerti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/spreads-offered",
                es: "https://support.excentcapital.tech/es/trading/spreads-ofrecidos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads-oferecidos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads-offerts",
                it: "https://support.excentcapital.tech/it/trading/spreads-offerti",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                url: "https://support.excentcapital.tech/it/trading/spreads-offerti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/valute-di-base/": {
            lang: "it",
            title: "Valute di Base",
            description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
            keywords: "Valute di Base, Valute Supportate, Conto Excent Capital, Opzioni di Valuta del Conto, Selezione della Valuta, Valuta di Trading, Valuta Base Forex, Opzioni di Finanziamento",
            canonical: "https://support.excentcapital.tech/it/trading/valute-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/base-currencies",
                es: "https://support.excentcapital.tech/es/trading/monedas-base",
                pt: "https://support.excentcapital.tech/pt/trading/moedas-base",
                fr: "https://support.excentcapital.tech/fr/trading/devises-de-base",
                it: "https://support.excentcapital.tech/it/trading/valute-di-base",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                url: "https://support.excentcapital.tech/it/trading/valute-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/risorse/dentro-dei-risorse/": {
            lang: "it",
            title: "Risorse Interne: Cosa Scoprirai",
            description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Aggiornamenti di Mercato, Calendario Economico, Formazione al Trading, Centro Risorse, Impara a Fare Trading, Materiali di Supporto al Trading",
            canonical: "https://support.excentcapital.tech/it/risorse/dentro-dei-risorse",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/inside-resources",
                es: "https://support.excentcapital.tech/es/recursos/dentro-de-recursos",
                pt: "https://support.excentcapital.tech/pt/recursos/dentro-de-recursos",
                fr: "https://support.excentcapital.tech/fr/ressources/a-linterieur-des-ressources",
                it: "https://support.excentcapital.tech/it/risorse/dentro-dei-risorse",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                url: "https://support.excentcapital.tech/it/risorse/dentro-dei-risorse",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-di-base/": {
            lang: "it",
            title: "Concetti di Base",
            description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
            keywords: "Concetti Base di Trading, Trading per Principianti, Basi di Mercato, Formazione Excent Capital, Terminologia del Trading, Guida per Principianti, Imparare il Trading, Concetti Fondamentali",
            canonical: "https://support.excentcapital.tech/it/risorse/concetti-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/basic-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-basicos",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-basicos",
                fr: "https://support.excentcapital.tech/fr/ressources/concepts-de-base",
                it: "https://support.excentcapital.tech/it/risorse/concetti-di-base",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                url: "https://support.excentcapital.tech/it/risorse/concetti-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-avanzati/": {
            lang: "it",
            title: "Concetti Avanzati",
            description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
            keywords: "Concetti Avanzati di Trading, Strategie di Trading, Indicatori Tecnici, Trading Esperto, Formazione Excent Capital, Analisi di Mercato, Strumenti per Trader Professionisti, Tecniche di Trading",
            canonical: "https://support.excentcapital.tech/it/risorse/concetti-avanzati",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/advanced-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-avanzados",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-avancados",
                fr: "https://support.excentcapital.tech/fr/ressources/concepts-avances",
                it: "https://support.excentcapital.tech/it/risorse/concetti-avanzati",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                url: "https://support.excentcapital.tech/it/risorse/concetti-avanzati",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/risorse-addizionali/": {
            lang: "it",
            title: "Risorse Aggiuntive",
            description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Glossario dei Termini, Guide alla Piattaforma, Aiuto Trading, Strumenti di Mercato, Risorse Educative, Supporto al Trading",
            canonical: "https://support.excentcapital.tech/it/risorse/risorse-addizionali",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/additional-resources",
                es: "https://support.excentcapital.tech/es/recursos/recursos-adicionales",
                pt: "https://support.excentcapital.tech/pt/recursos/recursos-adicionais",
                fr: "https://support.excentcapital.tech/fr/ressources/ressources-supplementaires",
                it: "https://support.excentcapital.tech/it/risorse/risorse-addizionali",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                url: "https://support.excentcapital.tech/it/risorse/risorse-addizionali",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/il-mio-conto/dentro-del-mio-conto/": {
            lang: "it",
            title: "Dentro il Mio Account: Cosa Scoprirai",
            description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
            keywords: "Il Mio Account, Gestione Account, Profilo Excent Capital, Impostazioni Account Trading, Sicurezza Account, Dashboard Utente, Aggiornamento Profilo, Gestire Account Trading",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/dentro-del-mio-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/inside-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/dentro-del-mio-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-demo/": {
            lang: "it",
            title: "Posso Creare un Account Demo?",
            description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
            keywords: "Account Demo, Trading di Prova, Demo Excent Capital, Trading Senza Rischi, Creare Account Demo, Simulatore di Trading, Trading per Principianti, Impara a Fare Trading",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-demo",
                fr: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-demo",
                it: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-reale/": {
            lang: "it",
            title: "Come Creare un Account Reale?",
            description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
            keywords: "Account Reale, Creare Account di Trading, Registrazione Excent Capital, Apri Account Reale, Inizia a Fare Trading, Account di Trading Reale, Iscrizione al Trading, Configurazione Account",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-reale",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-real",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-real",
                fr: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-reel",
                it: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-reale",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/perche-verificare-il-conto/": {
            lang: "it",
            title: "Perché Verificare il Tuo Account?",
            description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
            keywords: "Verifica Account, Verificare Account di Trading, KYC Excent Capital, Sicurezza del Trading, Processo di Conformità, Verifica Identità, Trading Sicuro, Accesso Completo Account",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/perche-verificare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/verifier-votre-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/perche-verificare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/accedere-alla-piattaforma/": {
            lang: "it",
            title: "Come Accedere alla Piattaforma?",
            description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
            keywords: "Accedere alla Piattaforma di Trading, Login Excent Capital, App di Trading, Piattaforma Web di Trading, Trading Mobile, Come Effettuare il Login, Inizia a Fare Trading, Guida Accesso Piattaforma",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/accedere-alla-piattaforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
                es: "https://support.excentcapital.tech/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://support.excentcapital.tech/pt/minha-conta/acessar-a-plataforma",
                fr: "https://support.excentcapital.tech/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://support.excentcapital.tech/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/accedere-alla-piattaforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/tempo-per-creare-un-conto/": {
            lang: "it",
            title: "Quanto Tempo Ci Vuole per Creare un Account?",
            description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
            keywords: "Tempo Creazione Account, Iscrizione Excent Capital, Come Creare un Account, Configurazione Account di Trading, Processo di Registrazione, Apri un Account Velocemente, Onboarding Trading",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/tempo-per-creare-un-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/tempo-per-creare-un-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conti-corporativi/": {
            lang: "it",
            title: "Offrite Account Aziendali?",
            description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
            keywords: "Account di Trading Aziendale, Account Business, Corporate Excent Capital, Trading Istituzionale, Apri Account Aziendale, Trading per Aziende, Account Investimenti Aziendali",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/conti-corporativi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuentas-corporativas",
                pt: "https://support.excentcapital.tech/pt/minha-conta/contas-corporativas",
                fr: "https://support.excentcapital.tech/fr/mon-compte/comptes-corporatifs",
                it: "https://support.excentcapital.tech/it/il-mio-conto/conti-corporativi",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/conti-corporativi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/piu-conti-stessa-email/": {
            lang: "it",
            title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
            description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
            keywords: "Più Account, Account con Stessa Email, Ruoli Excent Capital, Ruoli Utente, Gestione Account, Accesso Account Trading, Accesso Basato su Ruoli, Politica di Registrazione Email",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/piu-conti-stessa-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://support.excentcapital.tech/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://support.excentcapital.tech/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/piu-conti-stessa-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/aggiornare-informazioni-del-conto/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/aggiornare-informazioni-del-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
                es: "https://support.excentcapital.tech/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/aggiornare-informazioni-del-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/password-dimenticata/": {
            lang: "it",
            title: "Cosa Succede se Dimentico la Password?",
            description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
            keywords: "Password Dimenticata, Recupero Password, Reimposta Password Trading, Aiuto Accesso Excent Capital, Accesso Account, Recuperare Password, Password Persa, Login Account Trading",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/password-dimenticata",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://support.excentcapital.tech/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://support.excentcapital.tech/pt/minha-conta/esqueci-minha-senha",
                fr: "https://support.excentcapital.tech/fr/mon-compte/mot-de-passe-oublie",
                it: "https://support.excentcapital.tech/it/il-mio-conto/password-dimenticata",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/password-dimenticata",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/documenti-per-verifica/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/documenti-per-verifica",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://support.excentcapital.tech/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://support.excentcapital.tech/pt/minha-conta/documentos-para-verificacao",
                fr: "https://support.excentcapital.tech/fr/mon-compte/documents-pour-verification",
                it: "https://support.excentcapital.tech/it/il-mio-conto/documenti-per-verifica",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/documenti-per-verifica",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conto-utilizzato-da-terzi/": {
            lang: "it",
            title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
            description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
            keywords: "Condivisione Account, Politica Excent Capital, Uso Personale Account, Sicurezza Account Trading, Accesso Condiviso, Uso da Parte della Famiglia, Sicurezza Account, Conformità nel Trading",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/conto-utilizzato-da-terzi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://support.excentcapital.tech/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/conto-utilizzato-da-terzi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/cancellare-il-conto/": {
            lang: "it",
            title: "Come Posso Cancellare il Mio Account?",
            description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
            keywords: "Cancellare Account Trading, Chiudere Account Excent Capital, Terminazione Account, Eliminare Account, Chiusura Account Trading, Disattivazione Account, Supporto Excent Capital, Processo di Cancellazione Account",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/cancellare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cancelar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/cancelar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/annuler-mon-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/cancellare-il-conto",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/cancellare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/verificare-conto-dall-estero/": {
            lang: "it",
            title: "Posso Verificare il Mio Account da un Paese Straniero?",
            description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
            keywords: "Verificare Account dall’Estero, Verifica Excent Capital, Configurazione Account da Paese Straniero, KYC Internazionale, Verifica Remota Account, Documenti Account, Verifica Estera",
            canonical: "https://support.excentcapital.tech/it/il-mio-conto/verificare-conto-dall-estero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://support.excentcapital.tech/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://support.excentcapital.tech/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                url: "https://support.excentcapital.tech/it/il-mio-conto/verificare-conto-dall-estero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/depositi-prelievi/dentro-depositi-prelievi/": {
            lang: "it",
            title: "Scopri Depositi e Prelievi: Cosa Troverai",
            description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
            keywords: "Depositi e Prelievi, Finanziamento Excent Capital, Prelevare Profitti, Metodi di Pagamento, Opzioni di Deposito, Tempi di Prelievo, Finanziamento Conto Trading, Transazioni Finanziarie",
            canonical: "https://support.excentcapital.tech/it/depositi-prelievi/dentro-depositi-prelievi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://support.excentcapital.tech/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                url: "https://support.excentcapital.tech/it/depositi-prelievi/dentro-depositi-prelievi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/primo-deposito/": {
            lang: "it",
            title: "Come Effettuare un Primo Deposito?",
            description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
            keywords: "Primo Deposito, Effettuare un Deposito, Finanziamento Excent Capital, Deposito Conto Trading, Come Depositare, Metodi di Pagamento, Inizia a Fare Trading, Finanzia il Tuo Conto",
            canonical: "https://support.excentcapital.tech/it/depositi-prelievi/primo-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/primer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/primeiro-deposito",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/premier-depot",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/primo-deposito",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                url: "https://support.excentcapital.tech/it/depositi-prelievi/primo-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-deposito/": {
            lang: "it",
            title: "Come Effettuare un Deposito?",
            description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
            keywords: "Deposita Fondi, Come Depositare, Metodi di Pagamento Excent Capital, Finanziamento Conto Trading, Effettuare un Deposito, Deposito Sicuro, Ricarica Account, Processo di Deposito",
            canonical: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-deposito",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-depot",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                url: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-prelievo/": {
            lang: "it",
            title: "Come Posso Effettuare un Prelievo?",
            description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
            keywords: "Preleva Fondi, Prelievo Excent Capital, Come Prelevare, Pagamento Conto Trading, Processo di Prelievo, Prelievo Sicuro, Accedere ai Guadagni, Metodi di Pagamento",
            canonical: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-prelievo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-retiro",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-saque",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-retrait",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                url: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-prelievo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/prelievo-non-riuscito/": {
            lang: "it",
            title: "Cosa Fare se il Mio Prelievo Fallisce?",
            description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
            keywords: "Prelievo Fallito, Aiuto Excent Capital, Transazione Fallita, Risoluzione Problema Prelievo, Problemi di Prelievo, Errore di Pagamento, Supporto Conto Trading, Correggere Problema di Prelievo",
            canonical: "https://support.excentcapital.tech/it/depositi-prelievi/prelievo-non-riuscito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://support.excentcapital.tech/es/depositos-retiros/retiro-fallido",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/saque-falhou",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/echec-du-retrait",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                url: "https://support.excentcapital.tech/it/depositi-prelievi/prelievo-non-riuscito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/paiements/a-linterieur-des-paiements/": {
            lang: "it",
            title: "Scopri i Pagamenti: Cosa Troverai",
            description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
            keywords: "Pagamenti Excent Capital, Metodi di Pagamento Accettati, Gestione Transazioni, Tempo di Elaborazione Pagamenti, Valute Supportate, Pagamenti di Trading, Opzioni di Deposito e Prelievo, Finanziamento Conto",
            canonical: "https://support.excentcapital.tech/it/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/inside-payments",
                es: "https://support.excentcapital.tech/es/pagos/dentro-de-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/paiements/a-linterieur-des-paiements",
                it: "https://support.excentcapital.tech/it/paiements/a-linterieur-des-paiements",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                url: "https://support.excentcapital.tech/it/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/voir-historique-paiements/": {
            lang: "it",
            title: "Come Vedo lo Storico dei Pagamenti?",
            description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
            keywords: "Storico Pagamenti, Storico Transazioni, Visualizza Depositi, Visualizza Prelievi, Pagamenti Excent Capital, Transazioni Conto, Storico Conto Trading, Registrazioni Finanziarie",
            canonical: "https://support.excentcapital.tech/it/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
                es: "https://support.excentcapital.tech/es/pagos/ver-historial-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/paiements/voir-historique-paiements",
                it: "https://support.excentcapital.tech/it/paiements/voir-historique-paiements",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                url: "https://support.excentcapital.tech/it/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/delai-de-transaction/": {
            lang: "it",
            title: "Quanto Può Durare una Transazione?",
            description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
            keywords: "Tempo Transazione, Tempo di Elaborazione, Durata Deposito, Durata Prelievo, Pagamenti Excent Capital, Velocità di Pagamento, Transazioni Conto Trading, Ritardi nelle Transazioni",
            canonical: "https://support.excentcapital.tech/it/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
                es: "https://support.excentcapital.tech/es/pagos/tiempo-transaccion",
                pt: "https://support.excentcapital.tech/pt/pagamentos/tempo-de-transacao",
                fr: "https://support.excentcapital.tech/fr/paiements/delai-de-transaction",
                it: "https://support.excentcapital.tech/it/paiements/delai-de-transaction",
                zh: "https://support.excentcapital.tech/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                url: "https://support.excentcapital.tech/it/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Cantones
        //Italiano
        "zh/": {
            lang: "zh-HK",
            title: "知識庫 | Excent Capital",
            description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
            keywords: "Excent Capital 幫助中心, 交易平台支援, 交易常見問題, 如何交易, 外匯教學, 帳戶管理, 交易指南, 存款協助, 提款協助",
            canonical: "https://support.excentcapital.tech/zh/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en",
                es: "https://support.excentcapital.tech/es",
                pt: "https://support.excentcapital.tech/pt",
                fr: "https://support.excentcapital.tech/fr",
                it: "https://support.excentcapital.tech/it",
                zh: "https://support.excentcapital.tech/zh",
            },
            openGraph: {
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                url: "https://support.excentcapital.tech/zh/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/inside-about-us-zh/": {
            lang: "zh-HK",
            title: "關於我們：你將發現什麼",
            description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
            keywords: "關於 Excent Capital, 公司使命, 交易公司價值觀, 認識團隊, 誰是 Excent Capital, 我們的故事, 金融服務公司, Excent Capital 概覽",
            canonical: "https://support.excentcapital.tech/zh/about-us-zh/inside-about-us-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/inside-about-us",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://support.excentcapital.tech/it/chi-siamo/dentro-di-noi",
                zh: "https://support.excentcapital.tech/zh/about-us-zh/inside-about-us-zh",
            },
            openGraph: {
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                url: "https://support.excentcapital.tech/zh/about-us-zh/inside-about-us-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/about-excent-capital-zh/": {
            lang: "zh-HK",
            title: "關於 Excent Capital",
            description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
            keywords: "Excent Capital, 關於我們, 公司概況, 交易公司, 金融服務, 交易機構, 我們的使命, 我們是誰, 全球交易支援",
            canonical: "https://support.excentcapital.tech/zh/about-us-zh/about-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/about-excent-capital",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://support.excentcapital.tech/it/chi-siamo/su-excent-capital",
                zh: "https://support.excentcapital.tech/zh/about-us-zh/about-excent-capital-zh",
            },
            openGraph: {
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                url: "https://support.excentcapital.tech/zh/about-us-zh/about-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/build-your-portfolio-zh/": {
            lang: "zh-HK",
            title: "建立您的投資組合：Excent Capital 的多樣化選擇",
            description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
            keywords: "建立投資組合, 交易工具, 外匯交易, 股市, 指數交易, 商品交易, 多元化投資組合, Excent Capital 資產",
            canonical: "https://support.excentcapital.tech/zh/about-us-zh/build-your-portfolio-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/build-your-portfolio",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://support.excentcapital.tech/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://support.excentcapital.tech/zh/about-us-zh/build-your-portfolio-zh",
            },
            openGraph: {
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                url: "https://support.excentcapital.tech/zh/about-us-zh/build-your-portfolio-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-your-trusted-partner-zh/": {
            lang: "zh-HK",
            title: "Excent Capital：助您分散國際市場投資的可信伙伴",
            description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
            keywords: "Excent Capital, 國際投資, 分散投資組合, 全球市場, 可信交易伙伴, 外匯交易, 國際交易平台, 投資機會",
            canonical: "https://support.excentcapital.tech/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-your-trusted-partner",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://support.excentcapital.tech/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://support.excentcapital.tech/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            },
            openGraph: {
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                url: "https://support.excentcapital.tech/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-education-center-zh/": {
            lang: "zh-HK",
            title: "提升你的交易能力：Excent Capital 教育中心",
            description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
            keywords: "交易教育, 學習交易, 交易教學, 交易課程, Excent Capital 教育, 初學者交易指南, 高級交易策略, 交易資源",
            canonical: "https://support.excentcapital.tech/zh/about-us-zh/excent-capital-education-center-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/excent-capital-education-center",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://support.excentcapital.tech/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://support.excentcapital.tech/zh/about-us-zh/excent-capital-education-center-zh",
            },
            openGraph: {
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                url: "https://support.excentcapital.tech/zh/about-us-zh/excent-capital-education-center-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/invest-with-confidence-zh/": {
            lang: "zh-HK",
            title: "自信投資：Excent Capital 的風險管理策略與工具",
            description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
            keywords: "風險管理, 交易風險工具, 投資保護, Excent Capital 策略, 自信交易, 市場波動性, 交易工具, 管理交易風險",
            canonical: "https://support.excentcapital.tech/zh/about-us-zh/invest-with-confidence-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/about-us/invest-with-confidence",
                es: "https://support.excentcapital.tech/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://support.excentcapital.tech/pt/sobre-nos/invista-com-confianca",
                fr: "https://support.excentcapital.tech/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://support.excentcapital.tech/it/chi-siamo/investi-con-fiducia",
                zh: "https://support.excentcapital.tech/zh/about-us-zh/invest-with-confidence-zh",
            },
            openGraph: {
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                url: "https://support.excentcapital.tech/zh/about-us-zh/invest-with-confidence-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/trading-zh/inside-trading-zh/": {
            lang: "zh-HK",
            title: "交易內幕：你將發現的內容",
            description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
            keywords: "交易指南, 市場見解, 交易概念, 如何交易, Excent Capital 平台, 交易功能, 學習交易, 交易知識庫",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/inside-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/inside-trading",
                es: "https://support.excentcapital.tech/es/trading/dentro-del-trading",
                pt: "https://support.excentcapital.tech/pt/trading/dentro-do-trading",
                fr: "https://support.excentcapital.tech/fr/trading/a-linterieur-du-trading",
                it: "https://support.excentcapital.tech/it/trading/dentro-del-trading-it",
                zh: "https://support.excentcapital.tech/zh/trading-zh/inside-trading-zh",
            },
            openGraph: {
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                url: "https://support.excentcapital.tech/zh/trading-zh/inside-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/instruments-in-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的交易工具",
            description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
            keywords: "交易工具, 外匯, 股票, 商品, 指數, Excent Capital 資產, 金融工具, 投資選項, 交易市場",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/instruments-in-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/instruments-in-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/instrumentos-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/instrumentos-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/instruments-chez-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/strumenti-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading-zh/instruments-in-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                url: "https://support.excentcapital.tech/zh/trading-zh/instruments-in-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/leverage-offered-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的槓桿",
            description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
            keywords: "槓桿交易, 使用槓桿進行交易, Excent Capital 槓桿, 保證金交易, 槓桿選項, 放大交易, 外匯槓桿, 負責任交易",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/leverage-offered-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/apalancamiento-en-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/alavancagem-na-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/effet-de-levier-excent-capital",
                it: "https://support.excentcapital.tech/it/it/trading/leva-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                url: "https://support.excentcapital.tech/zh/trading-zh/leverage-offered-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/micro-lots-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 的微型手數交易",
            description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
            keywords: "微型手數交易, Excent Capital 微型手數, 小手數交易, 初學者交易, 風險管理, 靈活交易, 外匯微型手數, 低風險交易",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/micro-lots-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/micro-lots-at-excent-capital",
                es: "https://support.excentcapital.tech/es/trading/micro-lotes-excent-capital",
                pt: "https://support.excentcapital.tech/pt/trading/micro-lotes-excent-capital",
                fr: "https://support.excentcapital.tech/fr/trading/micro-lots-at-excent-capital",
                it: "https://support.excentcapital.tech/it/trading/micro-lotti-excent-capital",
                zh: "https://support.excentcapital.tech/zh/trading-zh/micro-lots-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                url: "https://support.excentcapital.tech/zh/trading-zh/micro-lots-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-hours-zh/": {
            lang: "zh-HK",
            title: "交易時間",
            description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
            keywords: "交易時間, 市場開市時間, 外匯交易時間, 股票市場時間, Excent Capital 時間表, 交易時段, 交易時機, 金融市場時間",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/trading-hours-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-hours",
                es: "https://support.excentcapital.tech/es/trading/horario-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/horario-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/horaires-de-trading",
                it: "https://support.excentcapital.tech/it/trading/orari-di-trading",
                zh: "https://support.excentcapital.tech/zh/trading-zh/trading-hours-zh",
            },
            openGraph: {
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                url: "https://support.excentcapital.tech/zh/trading-zh/trading-hours-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-tools-zh/": {
            lang: "zh-HK",
            title: "交易工具",
            description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
            keywords: "交易工具, 市場分析工具, 交易計算機, 外匯工具, Excent Capital 平台, 交易資源, 繪圖工具, 明智交易",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/trading-tools",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading",
                fr: "https://support.excentcapital.tech/fr/trading/outils-de-trading",
                it: "https://support.excentcapital.tech/it/trading/strumenti-di-trading",
                zh: "https://support.excentcapital.tech/zh/trading-zh/trading-tools-zh",
            },
            openGraph: {
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                url: "https://support.excentcapital.tech/zh/trading-zh/trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "zh/trading-zh/acuity-trading-tools-zh/": {
            lang: "zh-HK",
            title: "Acuity 交易工具",
            description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
            keywords: "Acuity 交易工具, AI 交易工具, 市場情緒分析, 即時市場洞察, Excent Capital 工具, Acuity 洞察, 智能交易, 交易分析",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/acuity-trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/acuity-trading-tool",
                es: "https://support.excentcapital.tech/es/trading/herramientas-de-trading-acuity",
                pt: "https://support.excentcapital.tech/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://support.excentcapital.tech/fr/trading/outils-de-trading-acuity",
                it: "https://support.excentcapital.tech/it/trading/strumenti-di-trading-acuity",
                zh: "https://support.excentcapital.tech/zh/trading-zh/acuity-trading-tools-zh",
            },
            openGraph: {
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                url: "https://support.excentcapital.tech/zh/trading-zh/acuity-trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "zh/trading-zh/margin-calls-zh/": {
            lang: "zh-HK",
            title: "追加保證金通知（Margin Calls）",
            description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
            keywords: "追加保證金通知, 什麼是追加保證金, Excent Capital 保證金, 交易保證金, 強制平倉, 帳戶保護, 保證金交易, 風險管理",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/margin-calls-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/margin-calls",
                es: "https://support.excentcapital.tech/es/trading/llamadas-de-margen",
                pt: "https://support.excentcapital.tech/pt/trading/chamadas-de-margem",
                fr: "https://support.excentcapital.tech/fr/trading/appels-de-marge",
                it: "https://support.excentcapital.tech/it/trading/chiamate-di-margine",
                zh: "https://support.excentcapital.tech/zh/trading-zh/margin-calls-zh",
            },
            openGraph: {
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                url: "https://support.excentcapital.tech/zh/trading-zh/margin-calls-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/cfd-trading-zh/": {
            lang: "zh-HK",
            title: "差價合約（CFD）交易",
            description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
            keywords: "CFD 交易, 差價合約, 交易 CFD, Excent Capital CFD, 槓桿交易, 衍生工具交易, CFD 市場, 如何交易 CFD",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/cfd-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/cfd-trading",
                es: "https://support.excentcapital.tech/es/trading/trading-de-cfd",
                pt: "https://support.excentcapital.tech/pt/trading/trading-de-cfd",
                fr: "https://support.excentcapital.tech/fr/trading/trading-de-cfd",
                it: "https://support.excentcapital.tech/it/trading/trading-di-cfd",
                zh: "https://support.excentcapital.tech/zh/trading-zh/cfd-trading-zh",
            },
            openGraph: {
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                url: "https://support.excentcapital.tech/zh/trading-zh/cfd-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/pending-orders-zh/": {
            lang: "zh-HK",
            title: "掛單交易（Pending Orders）",
            description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
            keywords: "掛單交易, 交易指令, 買入止損, 賣出止損, 限價單, 自動化交易, Excent Capital 指令, 入市點, 交易策略",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/pending-orders-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/pending-orders",
                es: "https://support.excentcapital.tech/es/trading/ordenes-pendientes",
                pt: "https://support.excentcapital.tech/pt/trading/ordens-pendentes",
                fr: "https://support.excentcapital.tech/fr/trading/ordres-en-attente",
                it: "https://support.excentcapital.tech/it/trading/ordini-pendenti",
                zh: "https://support.excentcapital.tech/zh/trading-zh/pending-orders-zh",
            },
            openGraph: {
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                url: "https://support.excentcapital.tech/zh/trading-zh/pending-orders-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/spreads-offered-zh/": {
            lang: "zh-HK",
            title: "點差介紹",
            description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
            keywords: "點差, 波動點差, 金融市場, 交易點差, 降低交易成本, 提高盈利能力, 交易策略, 點差分析, 外匯點差, 股票市場點差",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/spreads-offered-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/spreads-offered",
                es: "https://support.excentcapital.tech/es/trading/spreads-ofrecidos",
                pt: "https://support.excentcapital.tech/pt/trading/spreads-oferecidos",
                fr: "https://support.excentcapital.tech/fr/trading/spreads-offerts",
                it: "https://support.excentcapital.tech/it/trading/spreads-offerti",
                zh: "https://support.excentcapital.tech/zh/trading-zh/spreads-offered-zh",
            },
            openGraph: {
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                url: "https://support.excentcapital.tech/zh/trading-zh/spreads-offered-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/base-currencies-zh/": {
            lang: "zh-HK",
            title: "基礎貨幣",
            description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
            keywords: "基礎貨幣, 支援貨幣, Excent Capital 帳戶, 帳戶貨幣選項, 貨幣選擇, 交易貨幣, 外匯基礎貨幣, 資金選項",
            canonical: "https://support.excentcapital.tech/zh/trading-zh/base-currencies-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/trading/base-currencies",
                es: "https://support.excentcapital.tech/es/trading/monedas-base",
                pt: "https://support.excentcapital.tech/pt/trading/moedas-base",
                fr: "https://support.excentcapital.tech/fr/trading/devises-de-base",
                it: "https://support.excentcapital.tech/it/trading/valute-di-base",
                zh: "https://support.excentcapital.tech/zh/trading-zh/base-currencies-zh",
            },
            openGraph: {
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                url: "https://support.excentcapital.tech/zh/trading-zh/base-currencies-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/resources-zh/inside-resources-zh/": {
            lang: "zh-HK",
            title: "資源中心導覽",
            description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
            keywords: "交易資源, Excent Capital 工具, 市場更新, 經濟日曆, 交易教學, 資源中心, 學習交易, 交易輔助材料",
            canonical: "https://support.excentcapital.tech/zh/resources-zh/inside-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/inside-resources",
                es: "https://support.excentcapital.tech/es/recursos/dentro-de-recursos",
                pt: "https://support.excentcapital.tech/pt/recursos/dentro-de-recursos",
                fr: "https://support.excentcapital.tech/fr/ressources/a-linterieur-des-ressources",
                it: "https://support.excentcapital.tech/it/risorse/dentro-dei-risorse",
                zh: "https://support.excentcapital.tech/zh/resources-zh/inside-resources-zh",
            },
            openGraph: {
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                url: "https://support.excentcapital.tech/zh/resources-zh/inside-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/basic-concepts-zh/": {
            lang: "zh-HK",
            title: "基礎概念",
            description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
            keywords: "交易基礎概念, 初學者交易, 市場基礎知識, Excent Capital 教育, 交易術語, 初學者指南, 學習交易, 基礎知識",
            canonical: "https://support.excentcapital.tech/zh/resources-zh/basic-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/basic-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-basicos",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-basicos",
                fr: "https://support.excentcapital.tech/fr/ressources/concepts-de-base",
                it: "https://support.excentcapital.tech/it/risorse/concetti-di-base",
                zh: "https://support.excentcapital.tech/zh/resources-zh/basic-concepts-zh",
            },
            openGraph: {
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                url: "https://support.excentcapital.tech/zh/resources-zh/basic-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/advanced-concepts-zh/": {
            lang: "zh-HK",
            title: "進階概念",
            description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
            keywords: "進階交易概念, 交易策略, 技術指標, 專業交易, Excent Capital 教育, 市場分析, 專業交易工具, 交易技巧",
            canonical: "https://support.excentcapital.tech/zh/resources-zh/advanced-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/advanced-concepts",
                es: "https://support.excentcapital.tech/es/recursos/conceptos-avanzados",
                pt: "https://support.excentcapital.tech/pt/recursos/conceitos-avancados",
                fr: "https://support.excentcapital.tech/fr/ressources/concepts-avances",
                it: "https://support.excentcapital.tech/it/risorse/concetti-avanzati",
                zh: "https://support.excentcapital.tech/zh/resources-zh/advanced-concepts-zh",
            },
            openGraph: {
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                url: "https://support.excentcapital.tech/zh/resources-zh/advanced-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/additional-resources-zh/": {
            lang: "zh-HK",
            title: "額外資源",
            description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
            keywords: "交易資源, Excent Capital 工具, 詞彙表, 平台指南, 交易協助, 市場工具, 教育資源, 交易支援",
            canonical: "https://support.excentcapital.tech/zh/resources-zh/additional-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/resources/additional-resources",
                es: "https://support.excentcapital.tech/es/recursos/recursos-adicionales",
                pt: "https://support.excentcapital.tech/pt/recursos/recursos-adicionais",
                fr: "https://support.excentcapital.tech/fr/ressources/ressources-supplementaires",
                it: "https://support.excentcapital.tech/it/risorse/risorse-addizionali",
                zh: "https://support.excentcapital.tech/zh/resources-zh/additional-resources-zh",
            },
            openGraph: {
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                url: "https://support.excentcapital.tech/zh/resources-zh/additional-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/my-account-zh/inside-my-account-zh/": {
            lang: "zh-HK",
            title: "我的帳戶導覽",
            description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
            keywords: "我的帳戶, 帳戶管理, Excent Capital 個人資料, 交易帳戶設定, 帳戶安全, 使用者儀表板, 資料更新, 管理交易帳戶",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/inside-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/inside-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/inside-my-account-zh",
            },
            openGraph: {
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/inside-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-to-create-a-demo-account-zh/": {
            lang: "zh-HK",
            title: "我可以開設模擬帳戶嗎？",
            description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
            keywords: "模擬帳戶, 練習交易, Excent Capital 模擬, 無風險交易, 建立模擬帳戶, 交易模擬器, 初學者交易, 學習交易",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/can-to-create-a-demo-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-to-create-a-demo-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-demo",
                fr: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-demo",
                it: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/can-to-create-a-demo-account-zh",
            },
            openGraph: {
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/can-to-create-a-demo-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-to-create-a-live-account-zh/": {
            lang: "zh-HK",
            title: "如何開立真實帳戶？",
            description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
            keywords: "真實帳戶, 建立交易帳戶, Excent Capital 註冊, 開立真實帳戶, 開始交易, 真實交易帳戶, 交易註冊, 帳戶設置",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/how-to-create-a-live-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-to-create-a-live-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/crear-cuenta-real",
                pt: "https://support.excentcapital.tech/pt/minha-conta/criar-conta-real",
                fr: "https://support.excentcapital.tech/fr/mon-compte/creer-un-compte-reel",
                it: "https://support.excentcapital.tech/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/how-to-create-a-live-account-zh",
            },
            openGraph: {
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/how-to-create-a-live-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/why-verify-your-account-zh/": {
            lang: "zh-HK",
            title: "為什麼要驗證你的帳戶？",
            description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
            keywords: "帳戶驗證, 驗證交易帳戶, Excent Capital KYC, 交易安全, 合規程序, 身份驗證, 安全交易, 完整帳戶訪問",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/why-verify-your-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/why-verify-your-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/verifier-votre-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/why-verify-your-account-zh",
            },
            openGraph: {
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/why-verify-your-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-access-the-platform-zh/": {
            lang: "zh-HK",
            title: "如何登入平台？",
            description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
            keywords: "登入交易平台, Excent Capital 登入, 交易應用程式, 網絡交易平台, 手機交易, 如何登入, 開始交易, 平台訪問指南",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-access-the-platform-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account.how-do-i-access-the-platform",
                es: "https://support.excentcapital.tech/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://support.excentcapital.tech/pt/minha-conta/acessar-a-plataforma",
                fr: "https://support.excentcapital.tech/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://support.excentcapital.tech/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-access-the-platform-zh",
            },
            openGraph: {
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-access-the-platform-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh/": {
            lang: "zh-HK",
            title: "開立帳戶需時多久？",
            description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
            keywords: "帳戶建立時間, Excent Capital 註冊, 如何開立帳戶, 交易帳戶設置, 註冊流程, 快速開戶, 交易入門",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            },
            openGraph: {
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/do-you-offer-corporate-accounts-zh/": {
            lang: "zh-HK",
            title: "是否提供企業帳戶？",
            description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
            keywords: "企業交易帳戶, 商業帳戶, Excent Capital 企業服務, 機構交易, 開設企業帳戶, 公司交易, 商業投資帳戶",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/do-you-offer-corporate-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuentas-corporativas",
                pt: "https://support.excentcapital.tech/pt/minha-conta/contas-corporativas",
                fr: "https://support.excentcapital.tech/fr/mon-compte/comptes-corporatifs",
                it: "https://support.excentcapital.tech/it/il-mio-conto/conti-corporativi",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            },
            openGraph: {
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-open-multiple-accounts-zh/": {
            lang: "zh-HK",
            title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
            description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
            keywords: "多個帳戶, 相同電郵帳戶, Excent Capital 角色, 使用者角色, 帳戶管理, 交易帳戶存取, 角色型訪問, 電郵註冊政策",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-open-multiple-accounts",
                es: "https://support.excentcapital.tech/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://support.excentcapital.tech/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://support.excentcapital.tech/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://support.excentcapital.tech/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            },
            openGraph: {
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/can-i-open-multiple-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-update-my-account-information-zh/": {
            lang: "zh-HK",
            title: "如何更新我的帳戶資料？",
            description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 修改帳戶資訊, 更新交易檔案, 使用者資訊",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-update-my-account-information",
                es: "https://support.excentcapital.tech/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            },
            openGraph: {
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-update-my-account-information-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-happens-if-i-forget-my-password-zh/": {
            lang: "zh-HK",
            title: "如果我忘記密碼會發生什麼事？",
            description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
            keywords: "忘記密碼, 密碼恢復, 重設交易密碼, Excent Capital 登入幫助, 帳戶存取, 找回密碼, 密碼遺失, 交易帳戶登入",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://support.excentcapital.tech/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://support.excentcapital.tech/pt/minha-conta/esqueci-minha-senha",
                fr: "https://support.excentcapital.tech/fr/mon-compte/mot-de-passe-oublie",
                it: "https://support.excentcapital.tech/it/il-mio-conto/password-dimenticata",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            },
            openGraph: {
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-documents-are-required-for-account-verification-zh/": {
            lang: "zh-HK",
            title: "我如何更新我的帳戶資料？",
            description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 更改帳戶資料, 更新交易資料, 用戶資訊",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://support.excentcapital.tech/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://support.excentcapital.tech/pt/minha-conta/documentos-para-verificacao",
                fr: "https://support.excentcapital.tech/fr/mon-compte/documents-pour-verification",
                it: "https://support.excentcapital.tech/it/il-mio-conto/documenti-per-verifica",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            },
            openGraph: {
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh/": {
            lang: "zh-HK",
            title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
            description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
            keywords: "共用帳戶, Excent Capital 政策, 個人帳戶使用, 交易帳戶安全, 帳戶共享, 家人使用帳戶, 帳戶安全, 交易合規",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://support.excentcapital.tech/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            },
            openGraph: {
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-cancel-my-account-zh/": {
            lang: "zh-HK",
            title: "我如何取消我的帳戶",
            description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
            keywords: "取消交易帳戶, 關閉 Excent Capital 帳戶, 帳戶終止, 刪除帳戶, 結束帳戶, Excent Capital 支援, 帳戶取消程序",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/how-do-i-cancel-my-account",
                es: "https://support.excentcapital.tech/es/mi-cuenta/cancelar-cuenta",
                pt: "https://support.excentcapital.tech/pt/minha-conta/cancelar-conta",
                fr: "https://support.excentcapital.tech/fr/mon-compte/annuler-mon-compte",
                it: "https://support.excentcapital.tech/it/il-mio-conto/cancellare-il-conto",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            },
            openGraph: {
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/how-do-i-cancel-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh/": {
            lang: "zh-HK",
            title: "我可以從外國驗證我的帳戶嗎？",
            description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
            keywords: "海外驗證帳戶, Excent Capital 驗證, 外國帳戶設定, 國際 KYC, 遠程帳戶驗證, 驗證文件, 海外驗證",
            canonical: "https://support.excentcapital.tech/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://support.excentcapital.tech/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://support.excentcapital.tech/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://support.excentcapital.tech/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://support.excentcapital.tech/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://support.excentcapital.tech/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            },
            openGraph: {
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                url: "https://support.excentcapital.tech/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh/": {
            lang: "zh-HK",
            title: "存款與提款：你將會發現什麼",
            description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
            keywords: "存款與提款, Excent Capital 資金, 提取利潤, 付款方式, 存款選項, 提款時間, 交易帳戶資金, 金融交易",
            canonical: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://support.excentcapital.tech/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            },
            openGraph: {
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                url: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行首次存款？",
            description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
            keywords: "首次存款, 進行存款, Excent Capital 資金, 交易帳戶存款, 如何存款, 付款方式, 開始交易, 帳戶注資",
            canonical: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/primer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/primeiro-deposito",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/premier-depot",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/primo-deposito",
                zh: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            },
            openGraph: {
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                url: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行存款？",
            description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
            keywords: "資金存入, 如何存款, Excent Capital 付款方式, 交易帳戶資金, 進行存款, 安全存款, 帳戶充值, 存款流程",
            canonical: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-deposito",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-deposito",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-depot",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            },
            openGraph: {
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                url: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh/": {
            lang: "zh-HK",
            title: "我如何提取資金？",
            description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
            keywords: "提取資金, Excent Capital 提款, 如何提款, 交易帳戶提現, 提款流程, 安全提款, 提取收益, 付款方式",
            canonical: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://support.excentcapital.tech/es/depositos-retiros/hacer-retiro",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/fazer-saque",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/effectuer-un-retrait",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            },
            openGraph: {
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                url: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh/": {
            lang: "zh-HK",
            title: "如果提款失敗，我應該怎麼辦？",
            description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
            keywords: "提款失敗, Excent Capital 幫助, 交易失敗, 排解提款問題, 提款錯誤, 付款失誤, 交易帳戶支援, 解決提款問題",
            canonical: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://support.excentcapital.tech/es/depositos-retiros/retiro-fallido",
                pt: "https://support.excentcapital.tech/pt/depositos-saques/saque-falhou",
                fr: "https://support.excentcapital.tech/fr/depots-retraits/echec-du-retrait",
                it: "https://support.excentcapital.tech/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            },
            openGraph: {
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                url: "https://support.excentcapital.tech/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/payments-zh/inside-payments-zh/": {
            lang: "zh-HK",
            title: "付款詳情：你將會發現什麼",
            description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
            keywords: "Excent Capital 付款, 可接受的付款方式, 交易管理, 付款處理時間, 支援貨幣, 交易付款, 存款與提款選項, 帳戶注資",
            canonical: "https://support.excentcapital.tech/zh/payments-zh/inside-payments-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/inside-payments",
                es: "https://support.excentcapital.tech/es/pagos/dentro-de-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/paiements/a-linterieur-des-paiements",
                it: "https://support.excentcapital.tech/it/paiements/a-linterieur-des-paiements",
                zh: "https://support.excentcapital.tech/zh/payments-zh/inside-payments-zh",
            },
            openGraph: {
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                url: "https://support.excentcapital.tech/zh/payments-zh/inside-payments-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-do-i-see-my-payment-history-zh/": {
            lang: "zh-HK",
            title: "我如何查看我的付款記錄？",
            description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
            keywords: "付款記錄, 交易歷史, 查看存款, 查看提款, Excent Capital 付款, 帳戶交易, 交易帳戶記錄, 財務紀錄",
            canonical: "https://support.excentcapital.tech/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-do-i-see-my-payment-history",
                es: "https://support.excentcapital.tech/es/pagos/ver-historial-pagos",
                pt: "https://support.excentcapital.tech/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://support.excentcapital.tech/fr/paiements/voir-historique-paiements",
                it: "https://support.excentcapital.tech/it/paiements/voir-historique-paiements",
                zh: "https://support.excentcapital.tech/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            },
            openGraph: {
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                url: "https://support.excentcapital.tech/zh/payments-zh/how-do-i-see-my-payment-history-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-long-can-a-transaction-take-zh/": {
            lang: "zh-HK",
            title: "一筆交易需要多長時間？",
            description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
            keywords: "交易時間, 處理時間, 存款所需時間, 提款所需時間, Excent Capital 付款, 付款速度, 交易帳戶處理, 交易延誤",
            canonical: "https://support.excentcapital.tech/zh/payments-zh/how-long-can-a-transaction-take-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://support.excentcapital.tech/en/payments/how-long-can-a-transaction-take",
                es: "https://support.excentcapital.tech/es/pagos/tiempo-transaccion",
                pt: "https://support.excentcapital.tech/pt/pagamentos/tempo-de-transacao",
                fr: "https://support.excentcapital.tech/fr/paiements/delai-de-transaction",
                it: "https://support.excentcapital.tech/it/paiements/delai-de-transaction",
                zh: "https://support.excentcapital.tech/zh/payments-zh/how-long-can-a-transaction-take-zh",
            },
            openGraph: {
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                url: "https://support.excentcapital.tech/zh/payments-zh/how-long-can-a-transaction-take-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
    },
    "knowledgebase.demo.excent.capital": {
        // English 
        "/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.demo.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en",
                es: "https://knowledgebase.demo.excent.capital/es",
                pt: "https://knowledgebase.demo.excent.capital/pt",
                fr: "https://knowledgebase.demo.excent.capital/fr",
                it: "https://knowledgebase.demo.excent.capital/it",
                zh: "https://knowledgebase.demo.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.demo.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.demo.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en",
                es: "https://knowledgebase.demo.excent.capital/es",
                pt: "https://knowledgebase.demo.excent.capital/pt",
                fr: "https://knowledgebase.demo.excent.capital/fr",
                it: "https://knowledgebase.demo.excent.capital/it",
                zh: "https://knowledgebase.demo.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.demo.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/inside-about-us/": {
            lang: "en",
            title: "Inside About Us: What You'll Discover",
            description:
                "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
            keywords: "About Excent Capital, Company Mission, Trading Company Values, Meet the Team, Who is Excent Capital, Our Story, Financial Services Company, Excent Capital Overview",
            canonical: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                url: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/about-excent-capital/": {
            lang: "en",
            title: "About Excent Capital",
            description:
                "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
            keywords: "Excent Capital, About Us, Company Overview, Trading Company, Financial Services, Trading Firm, Our Mission, Who We Are, Global Trading Support",
            canonical: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                url: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/build-your-portfolio/": {
            lang: "en",
            title: "Build Your Portfolio: Diverse Options on Excent Capital",
            description:
                "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
            keywords: "Build Portfolio, Trading Instruments, Forex Trading, Stock Market, Indices Trading, Commodities Trading, Diversified Portfolio, Excent Capital Assets",
            canonical: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                url: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-your-trusted-partner/": {
            lang: "en",
            title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
            description:
                "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
            keywords: "Excent Capital, International Investments, Diversify Portfolio, Global Markets, Trusted Trading Partner, Forex Trading, International Trading Platform, Investment Opportunities",

            canonical: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                url: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-education-center/": {
            lang: "en",
            title: "Level Up Your Trading: Excent Capital's Education Center",
            description:
                "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
            keywords: "Trading Education, Learn to Trade, Trading Tutorials, Trading Courses, Excent Capital Education, Beginner Trading Guide, Advanced Trading Strategies, Trading Resources",

            canonical: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                url: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/invest-with-confidence/": {
            lang: "en",
            title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
            description:
                "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
            keywords: "Risk Management, Trading Risk Tools, Investment Protection, Excent Capital Strategies, Confident Trading, Market Volatility, Trading Tools, Manage Risk in Trading",

            canonical: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                url: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/inside-trading/": {
            lang: "en",
            title: "Inside Trading: What You'll Discover",
            description:
                "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
            keywords: "Trading Guide, Market Insights, Trading Concepts, How to Trade, Excent Capital Platform, Trading Features, Learn Trading, Trading Knowledge Base",

            canonical: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/instruments-in-excent-capital/": {
            lang: "en",
            title: "Instruments in Excent Capital",
            description:
                "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
            keywords: "Trading Instruments, Forex, Stocks, Commodities, Indices, Excent Capital Assets, Financial Instruments, Investment Options, Trade Markets",

            canonical: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/leverage-offered-at-excent-capital/": {
            lang: "en",
            title: "Leverage Offered at Excent Capital",
            description:
                "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
            keywords: "Leverage Trading, Trading with Leverage, Excent Capital Leverage, Margin Trading, Leverage Options, Amplify Trading, Forex Leverage, Responsible Trading",

            canonical: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/micro-lots-at-excent-capital/": {
            lang: "en",
            title: "Micro Lots at Excent Capital",
            description:
                "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
            keywords: "Micro Lots Trading, Excent Capital Micro Lots, Small Lot Trading, Beginner Trading, Risk Management, Flexible Trading, Forex Micro Lots, Low Exposure Trading",

            canonical: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-hours/": {
            lang: "en",
            title: "Trading Hours",
            description:
                "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
            keywords: "Trading Hours, Market Hours, Forex Trading Times, Stock Market Hours, Excent Capital Schedule, Trading Sessions, Trading Times, Financial Market Hours",

            canonical: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-tools/": {
            lang: "en",
            title: "Trading Tools",
            description:
                "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
            keywords: "Trading Tools, Market Analysis Tools, Trading Calculators, Forex Tools, Excent Capital Platform, Trading Resources, Charting Tools, Informed Trading",

            canonical: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "en/trading/acuity-trading-tools/": {
            lang: "en",
            title: "Acuity Trading Tools",
            description:
                "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
            keywords: "Acuity Trading Tools, AI Trading Tools, Market Sentiment Analysis, Real-Time Market Insights, Excent Capital Tools, Acuity Insights, Smart Trading, Trading Analytics",

            canonical: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "en/trading/margin-calls/": {
            lang: "en",
            title: "Margin Calls",
            description:
                "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
            keywords: "Margin Calls, What is a Margin Call, Excent Capital Margin, Trading Margin, Forced Liquidation, Account Protection, Margin Trading, Risk Management",
            canonical: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/cfd-trading/": {
            lang: "en",
            title: "CFD Trading",
            description:
                "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
            keywords: "CFD Trading, Contracts for Difference, Trade CFDs, Excent Capital CFDs, Leverage Trading, Derivatives Trading, CFD Markets, How to Trade CFDs",
            canonical: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/pending-orders/": {
            lang: "en",
            title: "Pending Orders",
            description:
                "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
            keywords: "Pending Orders, Trading Orders, Buy Stop, Sell Stop, Limit Orders, Automated Trading, Excent Capital Orders, Entry Points, Trading Strategy",
            canonical: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/spreads-offered/": {
            lang: "en",
            title: "Spreads Offered",
            description:
                "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/base-currencies/": {
            lang: "en",
            title: "Base Currencies",
            description:
                "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
            keywords: "Base Currencies, Supported Currencies, Excent Capital Account, Account Currency Options, Currency Selection, Trading Currency, Forex Base Currency, Funding Options",
            canonical: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                url: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/inside-resources/": {
            lang: "en",
            title: "Inside Resources: What You'll Discover",
            description:
                "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
            keywords: "Trading Resources, Excent Capital Tools, Market Updates, Economic Calendar, Trading Education, Resource Center, Learn to Trade, Trading Support Materials",
            canonical: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                url: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/basic-concepts/": {
            lang: "en",
            title: "Basic Concepts",
            description:
                "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
            keywords: "Basic Trading Concepts, Trading for Beginners, Market Basics, Excent Capital Education, Trading Terminology, Beginner Guide, Learn Trading, Fundamental Concepts",
            canonical: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                url: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/advanced-concepts/": {
            lang: "en",
            title: "Advanced Concepts",
            description:
                "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
            keywords: "Advanced Trading Concepts, Trading Strategies, Technical Indicators, Expert Trading, Excent Capital Education, Market Analysis, Pro Trader Tools, Trading Techniques",
            canonical: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                url: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/additional-resources/": {
            lang: "en",
            title: "Additional Resources",
            description:
                "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
            keywords: "Trading Resources, Excent Capital Tools, Glossary of Terms, Platform Guides, Trading Help, Market Tools, Educational Resources, Trading Support",
            canonical: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                url: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/inside-my-account/": {
            lang: "en",
            title: "Inside My Account: What You'll Discover",
            description:
                "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
            keywords: "My Account, Account Management, Excent Capital Profile, Trading Account Settings, Account Security, User Dashboard, Profile Updates, Manage Trading Account",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-to-create-a-demo-account/": {
            lang: "en",
            title: "Can I Create a Demo Account?",
            description:
                "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
            keywords: "Demo Account, Practice Trading, Excent Capital Demo, Risk-Free Trading, Create Demo Account, Trading Simulator, Beginner Trading, Learn to Trade",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-to-create-a-live-account/": {
            lang: "en",
            title: "How to Create a Live Account?",
            description:
                "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
            keywords: "Live Account, Create Trading Account, Excent Capital Registration, Open Live Account, Start Trading, Real Trading Account, Trading Signup, Account Setup",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/why-verify-your-account/": {
            lang: "en",
            title: "Why Verify Your Account?",
            description:
                "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
            keywords: "Account Verification, Verify Trading Account, Excent Capital KYC, Trading Security, Compliance Process, Identity Verification, Secure Trading, Full Account Access",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account.how-do-i-access-the-platform/": {
            lang: "en",
            title: "How Do I Access the Platform?",
            description:
                "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
            keywords: "Access Trading Platform, Excent Capital Login, Trading App, Web Trading Platform, Mobile Trading, How to Log In, Start Trading, Platform Access Guide",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-long-does-it-take-to-create-an-account/": {
            lang: "en",
            title: "How Long Does it Take to Create an Account?",
            description:
                "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
            keywords: "Account Creation Time, Excent Capital Signup, How to Create Account, Trading Account Setup, Registration Process, Open Account Fast, Trading Onboarding",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/do-you-offer-corporate-accounts/": {
            lang: "en",
            title: "Do You Offer Corporate Accounts?",
            description:
                "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
            keywords: "Corporate Trading Account, Business Account, Excent Capital Corporate, Institutional Trading, Open Corporate Account, Company Trading, Business Investment Account",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-open-multiple-accounts/": {
            lang: "en",
            title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
            description:
                "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
            keywords: "Multiple Accounts, Same Email Accounts, Excent Capital Roles, User Roles, Account Management, Trading Account Access, Role-Based Access, Email Registration Policy",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-update-my-account-information/": {
            lang: "en",
            title: "How Do I Update My Account Information?",
            description:
                "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
            keywords: "Update Account Info, Edit Personal Details, Excent Capital Profile, Account Settings, Change Account Information, Trading Profile Update, User Information",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-happens-if-i-forget-my-password/": {
            lang: "en",
            title: "What Happens If I Forget My Password?",
            description:
                "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
            keywords: "Forgot Password, Password Recovery, Reset Trading Password, Excent Capital Login Help, Account Access, Recover Password, Lost Password, Trading Account Login",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-documents-are-required-for-account-verification/": {
            lang: "en",
            title: "What Documents Are Required for Account Verification?",
            description:
                "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
            keywords: "Account Verification Documents, KYC Requirements, Excent Capital Verification, Proof of Identity, Proof of Address, Upload Documents, Secure Verification, Trading Compliance",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-my-friends-or-family-use-my-excent-capital-account/": {
            lang: "en",
            title: "Can My Friends or Family Use My Excent Capital Account?",
            description:
                "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
            keywords: "Account Sharing, Excent Capital Policy, Personal Account Use, Trading Account Security, Shared Access, Family Account Use, Account Safety, Trading Compliance",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-cancel-my-account/": {
            lang: "en",
            title: "How do I Cancel My Account",
            description:
                "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
            keywords: "Cancel Trading Account, Close Excent Capital Account, Account Termination, Delete Account, Trading Account Closure, End Account, Excent Capital Support, Account Cancellation Process",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-verify-my-account-from-a-foreign-country/": {
            lang: "en",
            title: "Can I Verify My Account From a Foreign Country?",
            description:
                "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
            keywords: "Verify Account Abroad, Excent Capital Verification, Foreign Country Account Setup, International KYC, Remote Account Verification, Account Documents, Overseas Verification",
            canonical: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                url: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/inside-deposits-withdrawals/": {
            lang: "en",
            title: "Inside Deposits & Withdrawals: What You'll Discover",
            description:
                "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
            keywords: "Deposits and Withdrawals, Excent Capital Funding, Withdraw Profits, Payment Methods, Deposit Options, Withdrawal Times, Trading Account Funding, Financial Transactions",
            canonical: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                url: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-do-a-first-time-deposit/": {
            lang: "en",
            title: "How Do I Make a First-Time Deposit?",
            description:
                "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                url: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-make-a-deposit/": {
            lang: "en",
            title: "How Do I Make a Deposit?",
            description:
                "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
            keywords: "Deposit Funds, How to Deposit, Excent Capital Payment Methods, Trading Account Funding, Make a Deposit, Secure Deposit, Account Top-Up, Deposit Process",
            canonical: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                url: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-can-i-make-a-withdrawal/": {
            lang: "en",
            title: "How Can I Make a Withdrawal?",
            description:
                "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
            keywords: "Withdraw Funds, Excent Capital Withdrawal, How to Withdraw, Trading Account Payout, Withdrawal Process, Secure Withdrawal, Access Earnings, Payment Methods",
            canonical: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                url: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails/": {
            lang: "en",
            title: "What Do I Do If My Withdrawal Fails?",
            description:
                "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
            keywords: "Withdrawal Failed, Excent Capital Help, Failed Transaction, Troubleshoot Withdrawal, Withdrawal Issue, Payment Error, Trading Account Support, Fix Withdrawal Problem",
            canonical: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                url: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/inside-payments/": {
            lang: "en",
            title: "Inside Payments: What You'll Discover",
            description:
                "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
            keywords: "Excent Capital Payments, Accepted Payment Methods, Transaction Management, Payment Processing Time, Supported Currencies, Trading Payments, Deposit and Withdrawal Options, Account Funding",
            canonical: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                url: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-do-i-see-my-payment-history/": {
            lang: "en",
            title: "How Do I See My Payment History?",
            description:
                "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
            keywords: "Payment History, Transaction History, View Deposits, View Withdrawals, Excent Capital Payments, Account Transactions, Trading Account History, Financial Records",
            canonical: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                url: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-long-can-a-transaction-take/": {
            lang: "en",
            title: "How Long Can a Transaction Take?",
            description:
                "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
            keywords: "Transaction Time, Processing Time, Deposit Duration, Withdrawal Duration, Excent Capital Payments, Payment Speed, Trading Account Transactions, Delay in Transactions",
            canonical: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                url: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Español
        "es/": {
            lang: "es",
            title: "Base de Conocimientos | Excent Capital",
            description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
            keywords: "Centro de Ayuda Excent Capital, Soporte de Plataforma de Trading, Preguntas Frecuentes sobre Trading, Cómo Operar, Tutoriales de FX, Gestión de Cuentas, Guías de Trading, Ayuda para Depósitos, Ayuda para Retiros",
            canonical: "https://knowledgebase.demo.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en",
                es: "https://knowledgebase.demo.excent.capital/es",
                pt: "https://knowledgebase.demo.excent.capital/pt",
                fr: "https://knowledgebase.demo.excent.capital/fr",
                it: "https://knowledgebase.demo.excent.capital/it",
                zh: "https://knowledgebase.demo.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.demo.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/dentro-de-acerca-de-nosotros/": {
            lang: "es",
            title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
            description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
            keywords: "Sobre Excent Capital, Misión de la Empresa, Valores de Empresa de Trading, Conoce al Equipo, Quién es Excent Capital, Nuestra Historia, Empresa de Servicios Financieros, Visión General de Excent Capital", canonical: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            canonical: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/acerca-de-excent-capital/": {
            lang: "es",
            title: "Sobre Excent Capital",
            description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
            keywords: "Excent Capital, Sobre Nosotros, Visión General de la Empresa, Empresa de Trading, Servicios Financieros, Firma de Trading, Nuestra Misión, Quiénes Somos, Soporte Global de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/construye-tu-portafolio/": {
            lang: "es",
            title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
            description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
            keywords: "Construir Portafolio, Instrumentos de Trading, Trading en Forex, Mercado de Acciones, Trading de Índices, Trading de Commodities, Portafolio Diversificado, Activos de Excent Capital",
            canonical: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/excent-capital-tu-socio-de-confianza/": {
            lang: "es",
            title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
            description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
            keywords: "Excent Capital, Inversiones Internacionales, Diversificar Portafolio, Mercados Globales, Socio de Trading Confiable, Trading en Forex, Plataforma de Trading Internacional, Oportunidades de Inversión",

            canonical: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/centro-educativo-excent-capital/": {
            lang: "es",
            title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
            description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
            keywords: "Educación en Trading, Aprender a Operar, Tutoriales de Trading, Cursos de Trading, Educación Excent Capital, Guía para Principiantes en Trading, Estrategias Avanzadas de Trading, Recursos de Trading",

            canonical: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/invierte-con-confianza/": {
            lang: "es",
            title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
            description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
            keywords: "Gestión de Riesgo, Herramientas de Riesgo en Trading, Protección de Inversiones, Estrategias de Excent Capital, Trading con Confianza, Volatilidad del Mercado, Herramientas de Trading, Gestionar Riesgo en Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/invierte-con-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/trading/dentro-del-trading/": {
            lang: "es",
            title: "Dentro del Trading: Lo que Descubrirás",
            description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
            keywords: "Guía de Trading, Perspectivas del Mercado, Conceptos de Trading, Cómo Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conocimientos de Trading", canonical: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/instrumentos-en-excent-capital/": {
            lang: "es",
            title: "Instrumentos en Excent Capital",
            description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
            keywords: "Instrumentos de Trading, Forex, Acciones, Commodities, Índices, Activos de Excent Capital, Instrumentos Financieros, Opciones de Inversión, Mercados de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/instrumentos-en-excent-capital",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/instrumentos-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/apalancamiento-en-excent-capital/": {
            lang: "es",
            title: "Apalancamiento Ofrecido en Excent Capital",
            description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
            keywords: "Trading con Apalancamiento, Operar con Apalancamiento, Apalancamiento en Excent Capital, Trading con Margen, Opciones de Apalancamiento, Potenciar el Trading, Apalancamiento en Forex, Trading Responsable",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/apalancamiento-en-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/apalancamiento-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/micro-lotes-excent-capital/": {
            lang: "es",
            title: "Micro Lotes en Excent Capital",
            description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
            keywords: "Trading con Micro Lotes, Micro Lotes Excent Capital, Trading con Lotes Pequeños, Trading para Principiantes, Gestión de Riesgo, Trading Flexible, Micro Lotes en Forex, Trading con Baja Exposición",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/horario-de-trading/": {
            lang: "es",
            title: "Horarios de Trading",
            description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
            keywords: "Horarios de Trading, Horarios de Mercado, Horarios de Forex, Horarios del Mercado de Acciones, Calendario Excent Capital, Sesiones de Trading, Tiempos de Trading, Horarios del Mercado Financiero",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.demo.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/herramientas-de-trading/": {
            lang: "es",
            title: "Herramientas de Trading",
            description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
            keywords: "Herramientas de Trading, Herramientas de Análisis de Mercado, Calculadoras de Trading, Herramientas de Forex, Plataforma Excent Capital, Recursos de Trading, Herramientas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "es/trading/herramientas-de-trading-acuity/": {
            lang: "es",
            title: "Herramientas de Trading de Acuity",
            description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
            keywords: "Herramientas de Trading de Acuity, Herramientas de Trading con IA, Análisis de Sentimiento del Mercado, Perspectivas del Mercado en Tiempo Real, Herramientas de Excent Capital, Insights de Acuity, Trading Inteligente, Analítica de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "es/trading/llamadas-de-margen/": {
            lang: "es",
            title: "Llamadas de Margen",
            description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
            keywords: "Llamadas de Margen, Qué es una Llamada de Margen, Margen en Excent Capital, Trading con Margen, Liquidación Forzada, Protección de Cuenta, Trading con Margen, Gestión de Riesgo",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/llamadas-de-margen",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.demo.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/llamadas-de-margen",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/trading-de-cfd/": {
            lang: "es",
            title: "Trading de CFDs",
            description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
            keywords: "Trading de CFDs, Contratos por Diferencia, Operar CFDs, CFDs en Excent Capital, Trading con Apalancamiento, Trading de Derivados, Mercados de CFD, Cómo Operar CFDs",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/ordenes-pendientes/": {
            lang: "es",
            title: "Órdenes Pendientes",
            description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
            keywords: "Órdenes Pendientes, Órdenes de Trading, Buy Stop, Sell Stop, Órdenes Limitadas, Trading Automatizado, Órdenes en Excent Capital, Puntos de Entrada, Estrategia de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/ordenes-pendientes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.demo.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/ordenes-pendientes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/spreads-ofrecidos/": {
            lang: "es",
            title: "Spreads Ofrecidos",
            description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
            keywords: "Spreads, Spreads por Volatilidad, Mercados Financieros, Spreads de Trading, Minimizar Costos de Trading, Optimizar Rentabilidad, Estrategias de Trading, Análisis de Spreads, Spreads en Forex, Spreads en el Mercado de Acciones",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/spreads-ofrecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/spreads-ofrecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/monedas-base/": {
            lang: "es",
            title: "Monedas Base",
            description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
            keywords: "Monedas Base, Divisas Compatibles, Cuenta en Excent Capital, Opciones de Divisa de Cuenta, Selección de Moneda, Moneda de Trading, Divisa Base en Forex, Opciones de Fondeo",
            canonical: "https://knowledgebase.demo.excent.capital/es/trading/monedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.demo.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.demo.excent.capital/es/trading/monedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/recursos/dentro-de-recursos/": {
            lang: "es",
            title: "Dentro de Recursos: Lo que Descubrirás",
            description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Actualizaciones del Mercado, Calendario Económico, Educación en Trading, Centro de Recursos, Aprender a Operar, Material de Apoyo para Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.demo.excent.capital/es/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-basicos/": {
            lang: "es",
            title: "Conceptos Básicos",
            description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
            keywords: "Conceptos Básicos de Trading, Trading para Principiantes, Fundamentos del Mercado, Educación de Excent Capital, Terminología de Trading, Guía para Principiantes, Aprender a Operar, Conceptos Fundamentales",
            canonical: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-avanzados/": {
            lang: "es",
            title: "Conceptos Avanzados",
            description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
            keywords: "Conceptos Avanzados de Trading, Estrategias de Trading, Indicadores Técnicos, Trading Experto, Educación de Excent Capital, Análisis de Mercado, Herramientas de Trader Profesional, Técnicas de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-avanzados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-avanzados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/recursos-adicionales/": {
            lang: "es",
            title: "Recursos Adicionales",
            description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Glosario de Términos, Guías de Plataforma, Ayuda para Trading, Herramientas de Mercado, Recursos Educativos, Soporte de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/recursos/recursos-adicionales",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.demo.excent.capital/es/recursos/recursos-adicionales",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/mi-cuenta/dentro-de-mi-cuenta/": {
            lang: "es",
            title: "Dentro de Mi Cuenta: Lo que Descubrirás",
            description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
            keywords: "Mi Cuenta, Gestión de Cuenta, Perfil en Excent Capital, Configuración de Cuenta de Trading, Seguridad de Cuenta, Panel de Usuario, Actualización de Perfil, Administrar Cuenta de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-demo/": {
            lang: "es",
            title: "¿Puedo Crear una Cuenta Demo?",
            description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
            keywords: "Cuenta Demo, Practicar Trading, Demo de Excent Capital, Trading sin Riesgo, Crear Cuenta Demo, Simulador de Trading, Trading para Principiantes, Aprender a Operar",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-real/": {
            lang: "es",
            title: "¿Cómo Crear una Cuenta Real?",
            description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
            keywords: "Cuenta Real, Crear Cuenta de Trading, Registro en Excent Capital, Abrir Cuenta Real, Comenzar a Operar, Cuenta de Trading Real, Registro de Trading, Configuración de Cuenta",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta/": {
            lang: "es",
            title: "¿Por Qué Verificar tu Cuenta?",
            description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
            keywords: "Verificación de Cuenta, Verificar Cuenta de Trading, KYC de Excent Capital, Seguridad en Trading, Proceso de Cumplimiento, Verificación de Identidad, Trading Seguro, Acceso Completo a la Cuenta",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/acceder-a-la-plataforma/": {
            lang: "es",
            title: "¿Cómo Accedo a la Plataforma?",
            description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
            keywords: "Acceder a la Plataforma de Trading, Inicio de Sesión en Excent Capital, App de Trading, Plataforma Web de Trading, Trading Móvil, Cómo Iniciar Sesión, Comenzar a Operar, Guía de Acceso a la Plataforma",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/tiempo-para-crear-cuenta/": {
            lang: "es",
            title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
            description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
            keywords: "Tiempo de Creación de Cuenta, Registro en Excent Capital, Cómo Crear una Cuenta, Configuración de Cuenta de Trading, Proceso de Registro, Abrir Cuenta Rápidamente, Inicio en Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuentas-corporativas/": {
            lang: "es",
            title: "¿Ofrecen Cuentas Corporativas?",
            description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
            keywords: "Cuenta Corporativa de Trading, Cuenta Empresarial, Corporativo en Excent Capital, Trading Institucional, Abrir Cuenta Corporativa, Trading Empresarial, Cuenta de Inversión para Empresas",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuentas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuentas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/varias-cuentas-mismo-correo/": {
            lang: "es",
            title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
            description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
            keywords: "Múltiples Cuentas, Cuentas con el Mismo Correo, Roles en Excent Capital, Roles de Usuario, Gestión de Cuentas, Acceso a Cuenta de Trading, Acceso Basado en Roles, Política de Registro de Correo",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/actualizar-informacion-cuenta/": {
            lang: "es",
            title: "¿Cómo Actualizo la Información de Mi Cuenta?",
            description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
            keywords: "Actualizar Información de Cuenta, Editar Datos Personales, Perfil de Excent Capital, Configuración de Cuenta, Cambiar Información de Cuenta, Actualización de Perfil de Trading, Información del Usuario",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/olvide-mi-contrasena/": {
            lang: "es",
            title: "¿Qué Sucede si Olvido Mi Contraseña?",
            description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
            keywords: "Olvidé la Contraseña, Recuperación de Contraseña, Restablecer Contraseña de Trading, Ayuda para Iniciar Sesión en Excent Capital, Acceso a la Cuenta, Recuperar Contraseña, Contraseña Perdida, Inicio de Sesión en Cuenta de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/documentos-para-verificacion/": {
            lang: "es",
            title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
            description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
            keywords: "Documentos para Verificación de Cuenta, Requisitos KYC, Verificación en Excent Capital, Comprobante de Identidad, Comprobante de Domicilio, Subir Documentos, Verificación Segura, Cumplimiento en Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/documentos-para-verificacion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuenta-usada-por-otros/": {
            lang: "es",
            title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
            description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
            keywords: "Compartir Cuenta, Política de Excent Capital, Uso Personal de Cuenta, Seguridad de Cuenta de Trading, Acceso Compartido, Uso Familiar de Cuenta, Seguridad de Cuenta, Cumplimiento en Trading",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cancelar-cuenta/": {
            lang: "es",
            title: "¿Cómo Cancelo Mi Cuenta?",
            description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
            keywords: "Cancelar Cuenta de Trading, Cerrar Cuenta de Excent Capital, Terminación de Cuenta, Eliminar Cuenta, Cierre de Cuenta de Trading, Finalizar Cuenta, Soporte de Excent Capital, Proceso de Cancelación de Cuenta",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cancelar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cancelar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta-extranjero/": {
            lang: "es",
            title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
            description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
            keywords: "Verificar Cuenta en el Extranjero, Verificación en Excent Capital, Crear Cuenta Desde el Exterior, KYC Internacional, Verificación Remota de Cuenta, Documentos para Cuenta, Verificación Desde el Exterior",
            canonical: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                url: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/depositos-retiros/dentro-depositos-retiros/": {
            lang: "es",
            title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
            description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
            keywords: "Depósitos y Retiros, Fondeo en Excent Capital, Retirar Ganancias, Métodos de Pago, Opciones de Depósito, Tiempos de Retiro, Fondeo de Cuenta de Trading, Transacciones Financieras",
            canonical: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                url: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/primer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito por Primera Vez?",
            description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
            keywords: "Primer Depósito, Hacer un Depósito, Fondeo en Excent Capital, Depósito en Cuenta de Trading, Cómo Depositar, Métodos de Pago, Comenzar a Operar, Fondear tu Cuenta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/primer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                url: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/primer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito?",
            description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
            keywords: "Depositar Fondos, Cómo Depositar, Métodos de Pago en Excent Capital, Fondeo de Cuenta de Trading, Realizar un Depósito, Depósito Seguro, Recargar Cuenta, Proceso de Depósito",
            canonical: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                url: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-retiro/": {
            lang: "es",
            title: "¿Cómo Puedo Hacer un Retiro?",
            description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
            keywords: "Retirar Fondos, Retiro en Excent Capital, Cómo Retirar, Pago de Cuenta de Trading, Proceso de Retiro, Retiro Seguro, Acceder a Ganancias, Métodos de Pago",
            canonical: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-retiro",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                url: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-retiro",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/retiro-fallido/": {
            lang: "es",
            title: "¿Qué Hago si Falla Mi Retiro?",
            description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
            keywords: "Retiro Fallido, Ayuda de Excent Capital, Transacción Fallida, Solución de Problemas de Retiro, Problema de Retiro, Error de Pago, Soporte de Cuenta de Trading, Corregir Problema de Retiro",
            canonical: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/retiro-fallido",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                url: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/retiro-fallido",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/pagos/dentro-de-pagos/": {
            lang: "es",
            title: "Dentro de Pagos: Lo que Descubrirás",
            description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
            keywords: "Pagos en Excent Capital, Métodos de Pago Aceptados, Gestión de Transacciones, Tiempo de Procesamiento de Pagos, Divisas Soportadas, Pagos de Trading, Opciones de Depósito y Retiro, Fondeo de Cuenta",
            canonical: "https://knowledgebase.demo.excent.capital/es/pagos/dentro-de-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                url: "https://knowledgebase.demo.excent.capital/es/pagos/dentro-de-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/ver-historial-pagos/": {
            lang: "es",
            title: "¿Cómo Veo Mi Historial de Pagos?",
            description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
            keywords: "Historial de Pagos, Historial de Transacciones, Ver Depósitos, Ver Retiros, Pagos en Excent Capital, Transacciones de Cuenta, Historial de Cuenta de Trading, Registros Financieros",
            canonical: "https://knowledgebase.demo.excent.capital/es/pagos/ver-historial-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                url: "https://knowledgebase.demo.excent.capital/es/pagos/ver-historial-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/tiempo-transaccion/": {
            lang: "es",
            title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
            description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
            keywords: "Tiempo de Transacción, Tiempo de Procesamiento, Duración del Depósito, Duración del Retiro, Pagos en Excent Capital, Velocidad de Pago, Transacciones de Cuenta de Trading, Retrasos en Transacciones",
            canonical: "https://knowledgebase.demo.excent.capital/es/pagos/tiempo-transaccion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                url: "https://knowledgebase.demo.excent.capital/es/pagos/tiempo-transaccion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Potugues
        "pt/": {
            lang: "pt",
            title: "Base de Conhecimento | Excent Capital",
            description: "Explore a Base de Conhecimento da Excent Capital com guias especializados, tutoriais da plataforma, perguntas frequentes sobre trading e recursos desenvolvidos para ajudá-lo a operar com confiança.",
            keywords: "Central de Ajuda Excent Capital, Suporte da Plataforma de Trading, Perguntas Frequentes de Trading, Como Operar, Tutoriais de FX, Gestão de Conta, Guias de Trading, Ajuda com Depósitos, Ajuda com Saques",
            canonical: "https://knowledgebase.demo.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en",
                es: "https://knowledgebase.demo.excent.capital/es",
                pt: "https://knowledgebase.demo.excent.capital/pt",
                fr: "https://knowledgebase.demo.excent.capital/fr",
                it: "https://knowledgebase.demo.excent.capital/it",
                zh: "https://knowledgebase.demo.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.demo.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/dentro-sobre-nos/": {
            lang: "pt",
            title: "Dentro de Sobre Nós: O Que Você Vai Descobrir",
            description: "Saiba mais sobre a missão, os valores e a presença global da Excent Capital. Descubra quem somos, o que nos motiva e como capacitamos traders ao redor do mundo.",
            keywords: "Sobre a Excent Capital, Missão da Empresa, Valores da Empresa de Trading, Conheça a Equipe, Quem é a Excent Capital, Nossa História, Empresa de Serviços Financeiros, Visão Geral da Excent Capital",
            canonical: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/dentro-sobre-nos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/sobre-a-excent-capital/": {
            lang: "pt",
            title: "Sobre a Excent Capital",
            description: "Conheça a Excent Capital — nossa história, missão e os princípios que orientam nossa abordagem para capacitar traders nos mercados globais.",
            keywords: "Excent Capital, Sobre Nós, Visão Geral da Empresa, Empresa de Trading, Serviços Financeiros, Firma de Trading, Nossa Missão, Quem Somos, Suporte Global de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/construa-seu-portfolio/": {
            lang: "pt",
            title: "Construa Seu Portfólio: Opções Diversificadas na Excent Capital",
            description: "Descubra uma ampla variedade de instrumentos de trading na Excent Capital, incluindo Forex, ações, índices e commodities — tudo o que você precisa para montar um portfólio sólido e diversificado.",
            keywords: "Construir Portfólio, Instrumentos de Trading, Trading de Forex, Mercado de Ações, Trading de Índices, Trading de Commodities, Portfólio Diversificado, Ativos da Excent Capital",
            canonical: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/construa-seu-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/excent-capital-seu-parceiro-de-confianca/": {
            lang: "pt",
            title: "Excent Capital: Seu Parceiro de Confiança para Diversificar Seus Investimentos nos Mercados Internacionais",
            description: "Associe-se à Excent Capital para expandir globalmente suas oportunidades de investimento. Acesse os mercados internacionais com confiança através de nossa plataforma de trading segura e profissional.",
            keywords: "Excent Capital, Investimentos Internacionais, Diversificar Portfólio, Mercados Globais, Parceiro Confiável de Trading, Trading de Forex, Plataforma Internacional de Trading, Oportunidades de Investimento",
            canonical: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/centro-educacional-excent-capital/": {
            lang: "pt",
            title: "Eleve Seu Trading: Centro Educacional da Excent Capital",
            description: "Acesse cursos, tutoriais e recursos conduzidos por especialistas no Centro Educacional da Excent Capital. Aprenda estratégias de trading e desenvolva suas habilidades — seja você iniciante ou trader avançado.",
            keywords: "Educação em Trading, Aprenda a Operar, Tutoriais de Trading, Cursos de Trading, Educação Excent Capital, Guia de Trading para Iniciantes, Estratégias Avançadas de Trading, Recursos de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/invista-com-confianca/": {
            lang: "pt",
            title: "Invista com Confiança: Estratégias e Ferramentas de Gestão de Risco na Excent Capital",
            description: "Domine a gestão de risco com a Excent Capital. Explore ferramentas e estratégias essenciais para proteger seus investimentos e operar com mais confiança em mercados voláteis.",
            keywords: "Gestão de Risco, Ferramentas de Risco em Trading, Proteção de Investimentos, Estratégias da Excent Capital, Trading com Confiança, Volatilidade do Mercado, Ferramentas de Trading, Gerenciar Risco no Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/invista-com-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/invista-com-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/trading/dentro-do-trading/": {
            lang: "pt",
            title: "Dentro do Trading: O Que Você Vai Descobrir",
            description: "Explore conceitos-chave de trading, insights de mercado e funcionalidades da plataforma no centro de trading da Excent Capital. Obtenha o conhecimento necessário para tomar decisões informadas.",
            keywords: "Guia de Trading, Insights de Mercado, Conceitos de Trading, Como Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conhecimento de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/dentro-do-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/dentro-do-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/instrumentos-na-excent-capital/": {
            lang: "pt",
            title: "Instrumentos na Excent Capital",
            description: "Explore toda a gama de instrumentos de trading oferecidos pela Excent Capital, incluindo FX, ações, commodities, índices e muito mais — desenvolvidos para atender aos seus objetivos de investimento.",
            keywords: "Instrumentos de Trading, Forex, Ações, Commodities, Índices, Ativos da Excent Capital, Instrumentos Financeiros, Opções de Investimento, Mercados de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/instrumentos-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/instrumentos-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/alavancagem-na-excent-capital/": {
            lang: "pt",
            title: "Alavancagem Oferecida pela Excent Capital",
            description: "Entenda como funciona a alavancagem na Excent Capital e como ela pode ampliar seu potencial de trading. Conheça nossas opções de alavancagem flexíveis e práticas de operação responsável.",
            keywords: "Trading com Alavancagem, Operar com Alavancagem, Alavancagem na Excent Capital, Trading com Margem, Opções de Alavancagem, Ampliar Trading, Alavancagem em Forex, Trading Responsável",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/alavancagem-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/alavancagem-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/micro-lotes-excent-capital/": {
            lang: "pt",
            title: "Micro Lotes na Excent Capital",
            description: "Opere com mais flexibilidade utilizando micro lotes na Excent Capital. Ideal para iniciantes e traders cautelosos que buscam controlar a exposição e testar estratégias.",
            keywords: "Trading com Micro Lotes, Micro Lotes Excent Capital, Trading com Lotes Pequenos, Trading para Iniciantes, Gestão de Risco, Trading Flexível, Micro Lotes de Forex, Trading com Baixa Exposição",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/horario-de-trading/": {
            lang: "pt",
            title: "Horários de Trading",
            description: "Fique informado sobre os horários oficiais de trading para todos os mercados disponíveis na Excent Capital. Saiba quando operar Forex, ações, índices e commodities.",
            keywords: "Horários de Trading, Horários de Mercado, Horários de Forex, Horário do Mercado de Ações, Agenda da Excent Capital, Sessões de Trading, Tempos de Trading, Horários do Mercado Financeiro",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.demo.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ferramentas-de-trading/": {
            lang: "pt",
            title: "Ferramentas de Trading",
            description: "Melhore sua experiência de trading com as poderosas ferramentas da Excent Capital. Acesse gráficos, calculadoras, análises de mercado e muito mais para tomar decisões informadas.",
            keywords: "Ferramentas de Trading, Ferramentas de Análise de Mercado, Calculadoras de Trading, Ferramentas de Forex, Plataforma Excent Capital, Recursos de Trading, Ferramentas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "pt/trading/ferramentas-de-trading-acuity/": {
            lang: "pt",
            title: "Ferramentas de Trading da Acuity",
            description: "Aproveite as ferramentas com IA da Acuity na Excent Capital para obter insights de mercado, análise de sentimento e decisões de trading mais inteligentes com dados em tempo real.",
            keywords: "Ferramentas de Trading Acuity, Ferramentas de Trading com IA, Análise de Sentimento de Mercado, Insights de Mercado em Tempo Real, Ferramentas da Excent Capital, Insights da Acuity, Trading Inteligente, Análise de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "pt/trading/chamadas-de-margem/": {
            lang: "pt",
            title: "Chamadas de Margem",
            description: "Entenda como funcionam as chamadas de margem na Excent Capital. Saiba quando elas ocorrem, como gerenciá-las e como proteger sua conta contra liquidações forçadas.",
            keywords: "Chamadas de Margem, O que é uma Chamada de Margem, Margem Excent Capital, Margem de Trading, Liquidação Forçada, Proteção da Conta, Trading com Margem, Gestão de Risco",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/chamadas-de-margem",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.demo.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/chamadas-de-margem",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/trading-de-cfd/": {
            lang: "pt",
            title: "Trading de CFDs",
            description: "Aprenda como operar Contratos por Diferença (CFDs) com a Excent Capital. Acesse mercados globais, opere com alavancagem e posicione-se sobre movimentos de preço sem possuir os ativos.",
            keywords: "Trading de CFDs, Contratos por Diferença, Operar CFDs, CFDs da Excent Capital, Trading com Alavancagem, Trading de Derivativos, Mercados de CFD, Como Operar CFDs",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ordens-pendentes/": {
            lang: "pt",
            title: "Ordens Pendentes",
            description: "Descubra como funcionam as ordens pendentes na Excent Capital. Aprenda a definir pontos de entrada com antecedência e automatizar sua estratégia de trading com precisão.",
            keywords: "Ordens Pendentes, Ordens de Trading, Buy Stop, Sell Stop, Ordens Limitadas, Trading Automatizado, Ordens Excent Capital, Pontos de Entrada, Estratégia de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/ordens-pendentes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.demo.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/ordens-pendentes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/spreads-oferecidos/": {
            lang: "pt",
            title: "Spreads Oferecidos",
            description: "Descubra a importância dos spreads e dos spreads de volatilidade nos mercados financeiros. Aprenda a minimizar custos e otimizar sua lucratividade como trader.",
            keywords: "Spreads, Spreads de Volatilidade, Mercados Financeiros, Spreads de Trading, Minimizar Custos de Trading, Otimizar Lucros, Estratégias de Trading, Análise de Spreads, Spreads de Forex, Spreads no Mercado de Ações",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/spreads-oferecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/spreads-oferecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/moedas-base/": {
            lang: "pt",
            title: "Moedas Base",
            description: "Descubra quais moedas base são aceitas na Excent Capital. Escolha a moeda certa para sua conta e simplifique sua experiência de trading e de financiamento.",
            keywords: "Moedas Base, Moedas Suportadas, Conta na Excent Capital, Opções de Moeda de Conta, Seleção de Moeda, Moeda para Trading, Moeda Base em Forex, Opções de Financiamento",
            canonical: "https://knowledgebase.demo.excent.capital/pt/trading/moedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.demo.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.demo.excent.capital/pt/trading/moedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/recursos/dentro-de-recursos/": {
            lang: "pt",
            title: "Dentro de Recursos: O Que Você Vai Descobrir",
            description: "Explore o centro de recursos da Excent Capital com atualizações de mercado, calendários econômicos, ferramentas de trading e conteúdo educacional para apoiar sua jornada como trader.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Atualizações de Mercado, Calendário Econômico, Educação em Trading, Centro de Recursos, Aprenda a Operar, Materiais de Apoio ao Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.demo.excent.capital/pt/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-basicos/": {
            lang: "pt",
            title: "Conceitos Básicos",
            description: "Aprenda os conceitos fundamentais do trading com a Excent Capital. Entenda os termos-chave, a mecânica do mercado e o conhecimento essencial para começar sua jornada no trading.",
            keywords: "Conceitos Básicos de Trading, Trading para Iniciantes, Fundamentos do Mercado, Educação Excent Capital, Terminologia de Trading, Guia para Iniciantes, Aprender a Operar, Conceitos Fundamentais",
            canonical: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-avancados/": {
            lang: "pt",
            title: "Conceitos Avançados",
            description: "Aprofunde seus conhecimentos de trading com os conceitos avançados da Excent Capital. Explore estratégias, indicadores e técnicas usadas por traders experientes.",
            keywords: "Conceitos Avançados de Trading, Estratégias de Trading, Indicadores Técnicos, Trading Avançado, Educação Excent Capital, Análise de Mercado, Ferramentas para Traders Profissionais, Técnicas de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-avancados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-avancados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/recursos-adicionais/": {
            lang: "pt",
            title: "Recursos Adicionais",
            description: "Acesse uma variedade de recursos adicionais na Excent Capital, incluindo glossários de trading, guias da plataforma e ferramentas de mercado para melhorar sua experiência de operação.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Glossário de Termos, Guias da Plataforma, Ajuda de Trading, Ferramentas de Mercado, Recursos Educacionais, Suporte ao Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/recursos/recursos-adicionais",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.demo.excent.capital/pt/recursos/recursos-adicionais",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/minha-conta/dentro-da-minha-conta/": {
            lang: "pt",
            title: "Dentro da Minha Conta: O Que Você Vai Descobrir",
            description: "Gerencie sua conta de trading com facilidade na Excent Capital. Aprenda como atualizar seu perfil, acessar configurações da conta, monitorar atividades e manter a segurança.",
            keywords: "Minha Conta, Gestão de Conta, Perfil da Excent Capital, Configurações da Conta de Trading, Segurança da Conta, Painel do Usuário, Atualizações de Perfil, Gerenciar Conta de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/dentro-da-minha-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-demo/": {
            lang: "pt",
            title: "Posso Criar uma Conta Demo?",
            description: "Sim, a Excent Capital oferece contas demo para que você possa praticar trading em um ambiente sem riscos. Saiba como abrir uma e começar a explorar a plataforma.",
            keywords: "Conta Demo, Praticar Trading, Demo da Excent Capital, Trading Sem Risco, Criar Conta Demo, Simulador de Trading, Trading para Iniciantes, Aprender a Operar",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-real/": {
            lang: "pt",
            title: "Como Criar uma Conta Real?",
            description: "Abra sua conta de trading real na Excent Capital em apenas alguns passos. Siga nosso guia para começar a operar nos mercados reais com segurança e eficiência.",
            keywords: "Conta Real, Criar Conta de Trading, Registro na Excent Capital, Abrir Conta Real, Começar a Operar, Conta Real de Trading, Cadastro de Trading, Configuração de Conta",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta/": {
            lang: "pt",
            title: "Por Que Verificar Sua Conta?",
            description: "A verificação da conta na Excent Capital garante segurança, conformidade e acesso completo às funcionalidades de trading. Saiba por que é importante e como concluí-la.",
            keywords: "Verificação de Conta, Verificar Conta de Trading, KYC da Excent Capital, Segurança no Trading, Processo de Conformidade, Verificação de Identidade, Trading Seguro, Acesso Completo à Conta",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/acessar-a-plataforma/": {
            lang: "pt",
            title: "Como Acessar a Plataforma?",
            description: "Acesse a plataforma de trading da Excent Capital facilmente pelo navegador ou dispositivo móvel. Saiba como fazer login e começar a operar a qualquer hora e em qualquer lugar.",
            keywords: "Acessar Plataforma de Trading, Login Excent Capital, Aplicativo de Trading, Plataforma Web de Trading, Trading Móvel, Como Fazer Login, Começar a Operar, Guia de Acesso à Plataforma",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/acessar-a-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/acessar-a-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/tempo-para-criar-conta/": {
            lang: "pt",
            title: "Quanto Tempo Leva para Criar uma Conta?",
            description: "Criar uma conta na Excent Capital é rápido e simples. Descubra quanto tempo leva o processo e quais etapas são necessárias para começar.",
            keywords: "Tempo de Criação de Conta, Cadastro na Excent Capital, Como Criar Conta, Configuração de Conta de Trading, Processo de Registro, Abrir Conta Rápido, Onboarding de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/tempo-para-criar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/tempo-para-criar-contas",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/contas-corporativas/": {
            lang: "pt",
            title: "Vocês Oferecem Contas Corporativas?",
            description: "Sim, a Excent Capital oferece contas corporativas de trading para empresas e instituições. Descubra os benefícios e os requisitos para abrir uma conta corporativa.",
            keywords: "Conta Corporativa de Trading, Conta Empresarial, Corporativo na Excent Capital, Trading Institucional, Abrir Conta Corporativa, Trading para Empresas, Conta de Investimento Corporativa",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/contas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/contas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/varias-contas-mesmo-email/": {
            lang: "pt",
            title: "Posso Abrir Múltiplas Contas com Diferentes Funções Usando o Mesmo E-mail?",
            description: "Descubra se é possível registrar várias contas da Excent Capital com diferentes funções usando um único endereço de e-mail, e como funciona a gestão de funções na plataforma.",
            keywords: "Múltiplas Contas, Contas com o Mesmo E-mail, Funções na Excent Capital, Funções de Usuário, Gestão de Conta, Acesso à Conta de Trading, Acesso Baseado em Funções, Política de Registro de E-mail",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/atualizar-informacoes-da-conta/": {
            lang: "pt",
            title: "Como Atualizo as Informações da Minha Conta?",
            description: "Atualize facilmente seus dados pessoais e informações da conta na Excent Capital. Siga nosso guia passo a passo para manter suas informações precisas e atualizadas.",
            keywords: "Atualizar Informações da Conta, Editar Dados Pessoais, Perfil Excent Capital, Configurações da Conta, Alterar Informações da Conta, Atualização do Perfil de Trading, Informações do Usuário",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/esqueci-minha-senha/": {
            lang: "pt",
            title: "O Que Acontece se Eu Esquecer Minha Senha?",
            description: "Se você esquecer sua senha, a Excent Capital oferece um processo de recuperação simples e seguro. Aprenda como redefinir sua senha e recuperar o acesso à sua conta.",
            keywords: "Esqueci a Senha, Recuperação de Senha, Redefinir Senha de Trading, Ajuda para Login Excent Capital, Acesso à Conta, Recuperar Senha, Senha Perdida, Login na Conta de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/esqueci-minha-senha",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/esqueci-minha-senha",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/documentos-para-verificacao/": {
            lang: "pt",
            title: "Quais Documentos São Necessários para Verificação de Conta?",
            description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
            keywords: "Documentos para Verificação de Conta, Requisitos KYC, Verificação na Excent Capital, Comprovante de Identidade, Comprovante de Endereço, Enviar Documentos, Verificação Segura, Conformidade no Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/documentos-para-verificacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/documentos-para-verificacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/amigos-familia-usar-conta/": {
            lang: "pt",
            title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
            description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
            keywords: "Compartilhamento de Conta, Política da Excent Capital, Uso Pessoal da Conta, Segurança da Conta de Trading, Acesso Compartilhado, Uso por Familiares, Segurança da Conta, Conformidade em Trading",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/cancelar-conta/": {
            lang: "pt",
            title: "Como Cancelo Minha Conta?",
            description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
            keywords: "Cancelar Conta de Trading, Encerrar Conta na Excent Capital, Cancelamento de Conta, Excluir Conta, Fechamento de Conta de Trading, Finalizar Conta, Suporte da Excent Capital, Processo de Cancelamento de Conta",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/cancelar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/cancelar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta-no-exterior/": {
            lang: "pt",
            title: "Posso Verificar Minha Conta Estando no Exterior?",
            description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
            keywords: "Verificar Conta no Exterior, Verificação Excent Capital, Conta em País Estrangeiro, KYC Internacional, Verificação Remota de Conta, Documentos para Conta, Verificação no Exterior",
            canonical: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                url: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/depositos-saques/dentro-depositos-retiradas/": {
            lang: "pt",
            title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
            description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
            keywords: "Depósitos e Saques, Fondeamento na Excent Capital, Sacar Lucros, Métodos de Pagamento, Opções de Depósito, Prazos de Saque, Fondeamento da Conta de Trading, Transações Financeiras",
            canonical: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                url: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/primeiro-deposito/": {
            lang: "pt",
            title: "Como Faço Meu Primeiro Depósito?",
            description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
            keywords: "Primeiro Depósito, Fazer um Depósito, Fondeamento Excent Capital, Depósito na Conta de Trading, Como Depositar, Métodos de Pagamento, Começar a Operar, Adicionar Fundos à Conta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/primeiro-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                url: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/primeiro-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-deposito/": {
            lang: "pt",
            title: "Como Faço um Depósito?",
            description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
            keywords: "Depositar Fundos, Como Depositar, Métodos de Pagamento Excent Capital, Fondeamento da Conta de Trading, Fazer um Depósito, Depósito Seguro, Recarga da Conta, Processo de Depósito",
            canonical: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                url: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-saque/": {
            lang: "pt",
            title: "Como Posso Fazer um Saque?",
            description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
            keywords: "Sacar Fundos, Saque na Excent Capital, Como Sacar, Pagamento da Conta de Trading, Processo de Saque, Saque Seguro, Acessar Ganhos, Métodos de Pagamento",
            canonical: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-saque",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                url: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-saque",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/saque-falhou/": {
            lang: "pt",
            title: "O Que Fazer se Meu Saque Falhar?",
            description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
            keywords: "Saque Falhou, Ajuda Excent Capital, Transação Falhada, Resolver Problemas de Saque, Problema no Saque, Erro de Pagamento, Suporte da Conta de Trading, Corrigir Problema de Saque",
            canonical: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/saque-falhou",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                url: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/saque-falhou",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/pagamentos/dentro-de-pagamentos/": {
            lang: "pt",
            title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
            description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
            keywords: "Pagamentos Excent Capital, Métodos de Pagamento Aceitos, Gestão de Transações, Tempo de Processamento de Pagamento, Moedas Suportadas, Pagamentos de Trading, Opções de Depósito e Saque, Fondeamento de Conta",
            canonical: "https://knowledgebase.demo.excent.capital/pt/pagamentos/dentro-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                url: "https://knowledgebase.demo.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/ver-historico-de-pagamentos/": {
            lang: "pt",
            title: "Como Vejo Meu Histórico de Pagamentos?",
            description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
            keywords: "Histórico de Pagamentos, Histórico de Transações, Ver Depósitos, Ver Saques, Pagamentos Excent Capital, Transações da Conta, Histórico da Conta de Trading, Registros Financeiros",
            canonical: "https://knowledgebase.demo.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                url: "https://knowledgebase.demo.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/tempo-de-transacao/": {
            lang: "pt",
            title: "Quanto Tempo Pode Levar uma Transação?",
            description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
            keywords: "Tempo de Transação, Tempo de Processamento, Duração do Depósito, Duração do Saque, Pagamentos Excent Capital, Velocidade de Pagamento, Transações da Conta de Trading, Atrasos em Transações",
            canonical: "https://knowledgebase.demo.excent.capital/pt/pagamentos/tempo-de-transacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                url: "https://knowledgebase.demo.excent.capital/pt/pagamentos/tempo-de-transacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        // Frances
        "fr/": {
            lang: "fr",
            title: "Base de connaissances | Excent Capital",
            description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
            keywords: "Centre d’aide Excent Capital, Support de plateforme de trading, FAQ Trading, Comment Trader, Tutoriels FX, Gestion de compte, Guides de Trading, Aide au dépôt, Aide au retrait",
            canonical: "https://knowledgebase.demo.excent.capital/fr/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en",
                es: "https://knowledgebase.demo.excent.capital/es",
                pt: "https://knowledgebase.demo.excent.capital/pt",
                fr: "https://knowledgebase.demo.excent.capital/fr",
                it: "https://knowledgebase.demo.excent.capital/it",
                zh: "https://knowledgebase.demo.excent.capital/zh",
            },
            openGraph: {
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                url: "https://knowledgebase.demo.excent.capital/fr/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-de-nous/": {
            lang: "fr",
            title: "Dans la section À propos : Ce que vous allez découvrir",
            description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
            keywords: "À propos d’Excent Capital, Mission de l’entreprise, Valeurs d’une société de trading, Rencontrer l’équipe, Qui est Excent Capital, Notre histoire, Société de services financiers, Vue d’ensemble d’Excent Capital",
            canonical: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                url: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-d-excent-capital/": {
            lang: "fr",
            title: "À propos d’Excent Capital",
            description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
            keywords: "Excent Capital, À propos de nous, Présentation de l’entreprise, Société de trading, Services financiers, Société de courtage, Notre mission, Qui nous sommes, Support global au trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                url: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/construisez-votre-portefeuille/": {
            lang: "fr",
            title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
            description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
            keywords: "Construire un portefeuille, Instruments de trading, Trading Forex, Marché boursier, Trading d’indices, Trading de matières premières, Portefeuille diversifié, Actifs Excent Capital",
            canonical: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                url: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance/": {
            lang: "fr",
            title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
            description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
            keywords: "Excent Capital, Investissements internationaux, Diversifier son portefeuille, Marchés mondiaux, Partenaire de trading fiable, Trading Forex, Plateforme de trading internationale, Opportunités d’investissement",
            canonical: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                url: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/centre-educatif-excent-capital/": {
            lang: "fr",
            title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
            description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
            keywords: "Formation en Trading, Apprendre à Trader, Tutoriels de Trading, Cours de Trading, Formation Excent Capital, Guide de Trading Débutant, Stratégies de Trading Avancées, Ressources de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                url: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/investissez-en-confiance/": {
            lang: "fr",
            title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
            description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
            keywords: "Gestion des Risques, Outils de Risque en Trading, Protection des Investissements, Stratégies Excent Capital, Trading en Confiance, Volatilité du Marché, Outils de Trading, Gérer le Risque en Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                url: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/trading/a-linterieur-du-trading/": {
            lang: "fr",
            title: "Dans le monde du Trading : Ce que vous allez découvrir",
            description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
            keywords: "Guide de Trading, Perspectives de Marché, Concepts de Trading, Comment Trader, Plateforme Excent Capital, Fonctionnalités de Trading, Apprendre à Trader, Base de Connaissances en Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/a-linterieur-du-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/a-linterieur-du-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/instruments-chez-excent-capital/": {
            lang: "fr",
            title: "Instruments chez Excent Capital",
            description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
            keywords: "Instruments de Trading, Forex, Actions, Matières Premières, Indices, Actifs Excent Capital, Instruments Financiers, Options d’Investissement, Marchés de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/instruments-chez-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/instruments-chez-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/effet-de-levier-excent-capital/": {
            lang: "fr",
            title: "Effet de levier proposé par Excent Capital",
            description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
            keywords: "Trading avec Effet de Levier, Trading avec Levier, Levier Excent Capital, Trading sur Marge, Options de Levier, Amplifier le Trading, Levier Forex, Trading Responsable",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/effet-de-levier-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/effet-de-levier-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/micro-lots-at-excent-capital/": {
            lang: "fr",
            title: "Micro lots chez Excent Capital",
            description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
            keywords: "Trading en Micro Lots, Micro Lots Excent Capital, Trading en Petits Lots, Trading Débutant, Gestion des Risques, Trading Flexible, Micro Lots Forex, Trading à Faible Exposition",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/horaires-de-trading/": {
            lang: "fr",
            title: "Heures de Trading",
            description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
            keywords: "Heures de Trading, Horaires de Marché, Horaires de Trading Forex, Heures du Marché Boursier, Calendrier Excent Capital, Sessions de Trading, Périodes de Trading, Horaires des Marchés Financiers",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/horaires-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.demo.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/horaires-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/outils-de-trading/": {
            lang: "fr",
            title: "Outils de Trading",
            description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
            keywords: "Outils de Trading, Outils d’Analyse de Marché, Calculateurs de Trading, Outils Forex, Plateforme Excent Capital, Ressources de Trading, Outils de Graphiques, Trading Informé",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "fr/trading/outils-de-trading-acuity/": {
            lang: "fr",
            title: "Outils de Trading Acuity",
            description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
            keywords: "Outils de Trading Acuity, Outils de Trading IA, Analyse du Sentiment de Marché, Insights de Marché en Temps Réel, Outils Excent Capital, Insights Acuity, Trading Intelligent, Analytique de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "fr/trading/appels-de-marge/": {
            lang: "fr",
            title: "Appels de Marge",
            description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
            keywords: "Appels de Marge, Qu’est-ce qu’un Appel de Marge, Marge Excent Capital, Trading sur Marge, Liquidation Forcée, Protection de Compte, Trading avec Marge, Gestion des Risques",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/appels-de-marge",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.demo.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/appels-de-marge",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/trading-de-cfd/": {
            lang: "fr",
            title: "Trading de CFD",
            description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
            keywords: "Trading de CFD, Contrats sur la Différence, Trader les CFD, CFD Excent Capital, Trading avec Effet de Levier, Trading de Produits Dérivés, Marchés CFD, Comment Trader les CFD",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/ordres-en-attente/": {
            lang: "fr",
            title: "Ordres en Attente",
            description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
            keywords: "Ordres en Attente, Ordres de Trading, Buy Stop, Sell Stop, Ordres Limites, Trading Automatisé, Ordres Excent Capital, Points d’Entrée, Stratégie de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/ordres-en-attente",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.demo.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/ordres-en-attente",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/spreads-offerts/": {
            lang: "fr",
            title: "Spreads Proposés",
            description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
            keywords: "Spreads, Spreads de Volatilité, Marchés Financiers, Spreads de Trading, Réduire les Coûts de Trading, Optimiser la Rentabilité, Stratégies de Trading, Analyse des Spreads, Spreads Forex, Spreads Boursiers",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/spreads-offerts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/spreads-offerts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/devises-de-base/": {
            lang: "fr",
            title: "Devises de Base",
            description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
            keywords: "Devises de Base, Devises Acceptées, Compte Excent Capital, Options de Devise de Compte, Sélection de Devise, Devise de Trading, Devise de Base Forex, Options de Financement",
            canonical: "https://knowledgebase.demo.excent.capital/fr/trading/devises-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.demo.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                url: "https://knowledgebase.demo.excent.capital/fr/trading/devises-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/ressources/a-linterieur-des-ressources/": {
            lang: "fr",
            title: "Dans la section Ressources : Ce que vous allez découvrir",
            description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Mises à Jour du Marché, Calendrier Économique, Formation au Trading, Centre de Ressources, Apprendre à Trader, Supports de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/ressources/a-linterieur-des-ressources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                url: "https://knowledgebase.demo.excent.capital/fr/ressources/a-linterieur-des-ressources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-de-base/": {
            lang: "fr",
            title: "Concepts de Base",
            description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
            keywords: "Concepts de Base en Trading, Trading pour Débutants, Bases du Marché, Formation Excent Capital, Terminologie du Trading, Guide Débutant, Apprendre à Trader, Concepts Fondamentaux",
            canonical: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                url: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-avances/": {
            lang: "fr",
            title: "Concepts Avancés",
            description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
            keywords: "Concepts Avancés en Trading, Stratégies de Trading, Indicateurs Techniques, Trading Expert, Formation Excent Capital, Analyse de Marché, Outils pour Traders Pros, Techniques de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-avances",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                url: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-avances",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/ressources-supplementaires/": {
            lang: "fr",
            title: "Ressources Supplémentaires",
            description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Glossaire de Termes, Guides de Plateforme, Aide au Trading, Outils de Marché, Ressources Éducatives, Support de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/ressources/ressources-supplementaires",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                url: "https://knowledgebase.demo.excent.capital/fr/ressources/ressources-supplementaires",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/mon-compte/a-linterieur-de-mon-compte/": {
            lang: "fr",
            title: "Dans Mon Compte : Ce que vous allez découvrir",
            description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
            keywords: "Mon Compte, Gestion de Compte, Profil Excent Capital, Paramètres de Compte de Trading, Sécurité du Compte, Tableau de Bord Utilisateur, Mise à Jour de Profil, Gérer un Compte de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-demo/": {
            lang: "fr",
            title: "Puis-je Créer un Compte Démo ?",
            description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
            keywords: "Compte Démo, Pratique de Trading, Démo Excent Capital, Trading Sans Risque, Créer un Compte Démo, Simulateur de Trading, Trading Débutant, Apprendre à Trader",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-reel/": {
            lang: "fr",
            title: "Comment créer un compte réel ?",
            description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
            keywords: "Compte Réel, Créer un Compte de Trading, Inscription Excent Capital, Ouvrir un Compte Réel, Commencer à Trader, Compte de Trading Réel, Inscription au Trading, Configuration de Compte",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-reel",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-reel",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-votre-compte/": {
            lang: "fr",
            title: "Pourquoi vérifier votre compte ?",
            description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
            keywords: "Vérification de Compte, Vérifier un Compte de Trading, KYC Excent Capital, Sécurité du Trading, Processus de Conformité, Vérification d’Identité, Trading Sécurisé, Accès Complet au Compte",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-votre-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-votre-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/acceder-a-la-plateforme/": {
            lang: "fr",
            title: "Comment accéder à la plateforme ?",
            description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
            keywords: "Accès à la Plateforme de Trading, Connexion Excent Capital, Application de Trading, Plateforme Web de Trading, Trading Mobile, Comment Se Connecter, Commencer à Trader, Guide d’Accès à la Plateforme",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/delai-pour-creer-un-compte/": {
            lang: "fr",
            title: "Combien de temps faut-il pour créer un compte ?",
            description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
            keywords: "Temps de Création de Compte, Inscription Excent Capital, Comment Créer un Compte, Configuration du Compte de Trading, Processus d’Enregistrement, Ouvrir un Compte Rapidement, Intégration au Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/comptes-corporatifs/": {
            lang: "fr",
            title: "Proposez-vous des comptes professionnels ?",
            description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
            keywords: "Compte de Trading Professionnel, Compte Entreprise, Compte Corporate Excent Capital, Trading Institutionnel, Ouvrir un Compte Corporate, Trading pour Entreprises, Compte d’Investissement Professionnel",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/comptes-corporatifs",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/comptes-corporatifs",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/plusieurs-comptes-meme-email/": {
            lang: "fr",
            title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
            description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
            keywords: "Comptes Multiples, Comptes avec le Même E-mail, Rôles Excent Capital, Rôles Utilisateur, Gestion de Compte, Accès au Compte de Trading, Accès Basé sur les Rôles, Politique d’Enregistrement par E-mail",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mettre-a-jour-informations-compte/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mot-de-passe-oublie/": {
            lang: "fr",
            title: "Que se passe-t-il si j’oublie mon mot de passe ?",
            description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
            keywords: "Mot de Passe Oublié, Récupération de Mot de Passe, Réinitialiser Mot de Passe Trading, Aide Connexion Excent Capital, Accès au Compte, Récupérer Mot de Passe, Mot de Passe Perdu, Connexion Compte de Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mot-de-passe-oublie",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/documents-pour-verification/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/documents-pour-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/documents-pour-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/amis-famille-utiliser-compte/": {
            lang: "fr",
            title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
            description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
            keywords: "Partage de Compte, Politique Excent Capital, Utilisation Personnelle du Compte, Sécurité du Compte de Trading, Accès Partagé, Utilisation Familiale du Compte, Sécurité du Compte, Conformité en Trading",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/annuler-mon-compte/": {
            lang: "fr",
            title: "Comment annuler mon compte",
            description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
            keywords: "Annuler Compte de Trading, Fermer Compte Excent Capital, Résiliation de Compte, Supprimer Compte, Clôture de Compte de Trading, Fermer Compte, Support Excent Capital, Processus d’Annulation de Compte",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/annuler-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/annuler-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-compte-depuis-etranger/": {
            lang: "fr",
            title: "Puis-je vérifier mon compte depuis un pays étranger ?",
            description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
            keywords: "Vérifier Compte à l’Étranger, Vérification Excent Capital, Création de Compte depuis l’Étranger, KYC International, Vérification de Compte à Distance, Documents de Compte, Vérification Hors Pays",
            canonical: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                url: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/depots-retraits/a-linterieur-depots-retraits/": {
            lang: "fr",
            title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
            description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
            keywords: "Dépôts et Retraits, Financement Excent Capital, Retirer des Gains, Méthodes de Paiement, Options de Dépôt, Délais de Retrait, Financement du Compte de Trading, Transactions Financières",
            canonical: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                url: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/premier-depot/": {
            lang: "fr",
            title: "Comment effectuer un premier dépôt ?",
            description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
            keywords: "Premier Dépôt, Effectuer un Dépôt, Financement Excent Capital, Dépôt Compte de Trading, Comment Déposer, Méthodes de Paiement, Commencer à Trader, Approvisionner Compte",
            canonical: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/premier-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                url: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/premier-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-depot/": {
            lang: "fr",
            title: "Comment effectuer un dépôt ?",
            description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
            keywords: "Déposer des Fonds, Comment Déposer, Méthodes de Paiement Excent Capital, Financement Compte de Trading, Effectuer un Dépôt, Dépôt Sécurisé, Recharger Compte, Processus de Dépôt",
            canonical: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                url: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-retrait/": {
            lang: "fr",
            title: "Comment effectuer un retrait ?",
            description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
            keywords: "Retirer des Fonds, Retrait Excent Capital, Comment Retirer, Paiement Compte de Trading, Processus de Retrait, Retrait Sécurisé, Accéder aux Gains, Méthodes de Paiement",
            canonical: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                url: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/echec-du-retrait/": {
            lang: "fr",
            title: "Que faire si mon retrait échoue ?",
            description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
            keywords: "Retrait Échoué, Aide Excent Capital, Transaction Échouée, Résoudre un Problème de Retrait, Problème de Retrait, Erreur de Paiement, Support Compte de Trading, Corriger un Problème de Retrait",
            canonical: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/echec-du-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                url: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/echec-du-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/paiements/a-linterieur-des-paiements/": {
            lang: "fr",
            title: "Dans la section Paiements : Ce que vous allez découvrir",
            description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
            keywords: "Paiements Excent Capital, Méthodes de Paiement Acceptées, Gestion des Transactions, Délai de Traitement des Paiements, Devises Supportées, Paiements de Trading, Options de Dépôt et de Retrait, Financement de Compte",
            canonical: "https://knowledgebase.demo.excent.capital/fr/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                url: "https://knowledgebase.demo.excent.capital/fr/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/voir-historique-paiements/": {
            lang: "fr",
            title: "Comment voir mon historique de paiements ?",
            description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
            keywords: "Historique des Paiements, Historique des Transactions, Voir les Dépôts, Voir les Retraits, Paiements Excent Capital, Transactions du Compte, Historique Compte de Trading, Relevés Financiers",
            canonical: "https://knowledgebase.demo.excent.capital/fr/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                url: "https://knowledgebase.demo.excent.capital/fr/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/delai-de-transaction/": {
            lang: "fr",
            title: "Combien de temps une transaction peut-elle prendre ?",
            description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
            keywords: "Délai de Transaction, Temps de Traitement, Durée du Dépôt, Durée du Retrait, Paiements Excent Capital, Vitesse de Paiement, Transactions Compte de Trading, Retard de Transactions",
            canonical: "https://knowledgebase.demo.excent.capital/fr/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                url: "https://knowledgebase.demo.excent.capital/fr/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Italiano
        "it/": {
            lang: "it",
            title: "Knowledgebase | Excent Capital",
            description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
            keywords: "Centro Assistenza Excent Capital, Supporto Piattaforma di Trading, FAQ Trading, Come Fare Trading, Tutorial FX, Gestione Account, Guide al Trading, Assistenza Depositi, Assistenza Prelievi",
            canonical: "https://knowledgebase.demo.excent.capital/it/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en",
                es: "https://knowledgebase.demo.excent.capital/es",
                pt: "https://knowledgebase.demo.excent.capital/pt",
                fr: "https://knowledgebase.demo.excent.capital/fr",
                it: "https://knowledgebase.demo.excent.capital/it",
                zh: "https://knowledgebase.demo.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                url: "https://knowledgebase.demo.excent.capital/it/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/dentro-di-noi/": {
            lang: "it",
            title: "Dentro Chi Siamo: Cosa Scoprirai",
            description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
            keywords: "Chi è Excent Capital, Missione Aziendale, Valori Società di Trading, Conosci il Team, Chi è Excent Capital, La Nostra Storia, Società di Servizi Finanziari, Panoramica Excent Capital",
            canonical: "https://knowledgebase.demo.excent.capital/it/chi-siamo/dentro-di-noi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                url: "https://knowledgebase.demo.excent.capital/it/chi-siamo/dentro-di-noi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/su-excent-capital/": {
            lang: "it",
            title: "Chi è Excent Capital",
            description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
            keywords: "Excent Capital, Chi Siamo, Panoramica Aziendale, Società di Trading, Servizi Finanziari, Società di Investimenti, La Nostra Missione, Chi Siamo Noi, Supporto al Trading Globale",
            canonical: "https://knowledgebase.demo.excent.capital/it/chi-siamo/su-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                url: "https://knowledgebase.demo.excent.capital/it/chi-siamo/su-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/costruisci-il-tuo-portafoglio/": {
            lang: "it",
            title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
            description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
            keywords: "Costruire Portafoglio, Strumenti di Trading, Trading Forex, Mercato Azionario, Trading Indici, Trading Materie Prime, Portafoglio Diversificato, Asset di Excent Capital",
            canonical: "https://knowledgebase.demo.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                url: "https://knowledgebase.demo.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia/": {
            lang: "it",
            title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
            description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
            keywords: "Excent Capital, Investimenti Internazionali, Diversificare Portafoglio, Mercati Globali, Partner Affidabile per il Trading, Trading Forex, Piattaforma di Trading Internazionale, Opportunità di Investimento",
            canonical: "https://knowledgebase.demo.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                url: "https://knowledgebase.demo.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/centro-educativo-excent-capital/": {
            lang: "it",
            title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
            description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
            keywords: "Formazione sul Trading, Imparare a Fare Trading, Tutorial di Trading, Corsi di Trading, Formazione Excent Capital, Guida al Trading per Principianti, Strategie Avanzate di Trading, Risorse di Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                url: "https://knowledgebase.demo.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/investi-con-fiducia/": {
            lang: "it",
            title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
            description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
            keywords: "Gestione del Rischio, Strumenti per il Rischio di Trading, Protezione degli Investimenti, Strategie Excent Capital, Trading con Fiducia, Volatilità di Mercato, Strumenti di Trading, Gestire il Rischio nel Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/chi-siamo/investi-con-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                url: "https://knowledgebase.demo.excent.capital/it/chi-siamo/investi-con-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/trading/dentro-del-trading-it/": {
            lang: "it",
            title: "Dentro il Trading: Cosa Scoprirai",
            description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
            keywords: "Guida al Trading, Approfondimenti di Mercato, Concetti di Trading, Come Fare Trading, Piattaforma Excent Capital, Funzionalità di Trading, Imparare il Trading, Base di Conoscenza del Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/dentro-del-trading-it",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/dentro-del-trading-it",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-excent-capital/": {
            lang: "it",
            title: "Strumenti su Excent Capital",
            description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
            keywords: "Strumenti di Trading, Forex, Azioni, Materie Prime, Indici, Asset Excent Capital, Strumenti Finanziari, Opzioni di Investimento, Mercati di Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/leva-excent-capital/": {
            lang: "it",
            title: "Leva Finanziaria Offerta da Excent Capital",
            description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
            keywords: "Trading con Leva, Trading a Leva, Leva Excent Capital, Trading con Margine, Opzioni di Leva, Amplificare il Trading, Leva Forex, Trading Responsabile",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/leva-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/leva-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/micro-lotti-excent-capital/": {
            lang: "it",
            title: "Micro Lotti su Excent Capital",
            description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
            keywords: "Trading con Micro Lotti, Micro Lotti Excent Capital, Trading con Lotti Piccoli, Trading per Principianti, Gestione del Rischio, Trading Flessibile, Micro Lotti Forex, Trading a Bassa Esposizione",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/micro-lotti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/micro-lotti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/orari-di-trading/": {
            lang: "it",
            title: "Orari di Trading",
            description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
            keywords: "Orari di Trading, Orari di Mercato, Orari Forex, Orari Mercato Azionario, Calendario Excent Capital, Sessioni di Trading, Tempi di Trading, Orari Mercati Finanziari",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/orari-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.demo.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/orari-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-di-trading/": {
            lang: "it",
            title: "Strumenti di Trading",
            description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
            keywords: "Strumenti di Trading, Strumenti di Analisi di Mercato, Calcolatori di Trading, Strumenti Forex, Piattaforma Excent Capital, Risorse per il Trading, Strumenti di Analisi Grafica, Trading Informato",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "it/trading/strumenti-di-trading-acuity/": {
            lang: "it",
            title: "Strumenti Acuity per il Trading",
            description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
            keywords: "Strumenti Acuity per il Trading, Strumenti di Trading AI, Analisi del Sentiment di Mercato, Approfondimenti di Mercato in Tempo Reale, Strumenti Excent Capital, Approfondimenti Acuity, Trading Intelligente, Analisi di Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "it/trading/chiamate-di-margine/": {
            lang: "it",
            title: "Chiamate di Margine",
            description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
            keywords: "Chiamate di Margine, Cos’è una Chiamata di Margine, Margine Excent Capital, Margine di Trading, Liquidazione Forzata, Protezione dell’Account, Trading con Margine, Gestione del Rischio",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/chiamate-di-margine",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.demo.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.demo.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/chiamate-di-margine",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/trading-di-cfd/": {
            lang: "it",
            title: "Trading CFD",
            description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
            keywords: "Trading CFD, Contratti per Differenza, Fare Trading con i CFD, CFD Excent Capital, Trading con Leva, Trading di Derivati, Mercati CFD, Come Fare Trading con i CFD",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/trading-di-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.demo.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/trading-di-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/ordini-pendenti/": {
            lang: "it",
            title: "Ordini Pendenti",
            description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
            keywords: "Ordini Pendenti, Ordini di Trading, Buy Stop, Sell Stop, Ordini Limit, Trading Automatizzato, Ordini Excent Capital, Punti di Ingresso, Strategia di Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/ordini-pendenti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.demo.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.demo.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/ordini-pendenti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/spreads-offerti/": {
            lang: "it",
            title: "Spread Offerti",
            description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
            keywords: "Spread, Spread di Volatilità, Mercati Finanziari, Spread di Trading, Ridurre i Costi di Trading, Ottimizzare la Redditività, Strategie di Trading, Analisi degli Spread, Spread Forex, Spread Azionari",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/spreads-offerti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/spreads-offerti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/valute-di-base/": {
            lang: "it",
            title: "Valute di Base",
            description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
            keywords: "Valute di Base, Valute Supportate, Conto Excent Capital, Opzioni di Valuta del Conto, Selezione della Valuta, Valuta di Trading, Valuta Base Forex, Opzioni di Finanziamento",
            canonical: "https://knowledgebase.demo.excent.capital/it/trading/valute-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.demo.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.demo.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                url: "https://knowledgebase.demo.excent.capital/it/trading/valute-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/risorse/dentro-dei-risorse/": {
            lang: "it",
            title: "Risorse Interne: Cosa Scoprirai",
            description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Aggiornamenti di Mercato, Calendario Economico, Formazione al Trading, Centro Risorse, Impara a Fare Trading, Materiali di Supporto al Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/risorse/dentro-dei-risorse",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                url: "https://knowledgebase.demo.excent.capital/it/risorse/dentro-dei-risorse",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-di-base/": {
            lang: "it",
            title: "Concetti di Base",
            description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
            keywords: "Concetti Base di Trading, Trading per Principianti, Basi di Mercato, Formazione Excent Capital, Terminologia del Trading, Guida per Principianti, Imparare il Trading, Concetti Fondamentali",
            canonical: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-avanzati/": {
            lang: "it",
            title: "Concetti Avanzati",
            description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
            keywords: "Concetti Avanzati di Trading, Strategie di Trading, Indicatori Tecnici, Trading Esperto, Formazione Excent Capital, Analisi di Mercato, Strumenti per Trader Professionisti, Tecniche di Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-avanzati",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                url: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-avanzati",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/risorse-addizionali/": {
            lang: "it",
            title: "Risorse Aggiuntive",
            description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Glossario dei Termini, Guide alla Piattaforma, Aiuto Trading, Strumenti di Mercato, Risorse Educative, Supporto al Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/risorse/risorse-addizionali",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                url: "https://knowledgebase.demo.excent.capital/it/risorse/risorse-addizionali",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/il-mio-conto/dentro-del-mio-conto/": {
            lang: "it",
            title: "Dentro il Mio Account: Cosa Scoprirai",
            description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
            keywords: "Il Mio Account, Gestione Account, Profilo Excent Capital, Impostazioni Account Trading, Sicurezza Account, Dashboard Utente, Aggiornamento Profilo, Gestire Account Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-demo/": {
            lang: "it",
            title: "Posso Creare un Account Demo?",
            description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
            keywords: "Account Demo, Trading di Prova, Demo Excent Capital, Trading Senza Rischi, Creare Account Demo, Simulatore di Trading, Trading per Principianti, Impara a Fare Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-reale/": {
            lang: "it",
            title: "Come Creare un Account Reale?",
            description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
            keywords: "Account Reale, Creare Account di Trading, Registrazione Excent Capital, Apri Account Reale, Inizia a Fare Trading, Account di Trading Reale, Iscrizione al Trading, Configurazione Account",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-reale",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/perche-verificare-il-conto/": {
            lang: "it",
            title: "Perché Verificare il Tuo Account?",
            description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
            keywords: "Verifica Account, Verificare Account di Trading, KYC Excent Capital, Sicurezza del Trading, Processo di Conformità, Verifica Identità, Trading Sicuro, Accesso Completo Account",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/accedere-alla-piattaforma/": {
            lang: "it",
            title: "Come Accedere alla Piattaforma?",
            description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
            keywords: "Accedere alla Piattaforma di Trading, Login Excent Capital, App di Trading, Piattaforma Web di Trading, Trading Mobile, Come Effettuare il Login, Inizia a Fare Trading, Guida Accesso Piattaforma",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/tempo-per-creare-un-conto/": {
            lang: "it",
            title: "Quanto Tempo Ci Vuole per Creare un Account?",
            description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
            keywords: "Tempo Creazione Account, Iscrizione Excent Capital, Come Creare un Account, Configurazione Account di Trading, Processo di Registrazione, Apri un Account Velocemente, Onboarding Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conti-corporativi/": {
            lang: "it",
            title: "Offrite Account Aziendali?",
            description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
            keywords: "Account di Trading Aziendale, Account Business, Corporate Excent Capital, Trading Istituzionale, Apri Account Aziendale, Trading per Aziende, Account Investimenti Aziendali",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conti-corporativi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conti-corporativi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/piu-conti-stessa-email/": {
            lang: "it",
            title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
            description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
            keywords: "Più Account, Account con Stessa Email, Ruoli Excent Capital, Ruoli Utente, Gestione Account, Accesso Account Trading, Accesso Basato su Ruoli, Politica di Registrazione Email",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/aggiornare-informazioni-del-conto/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/password-dimenticata/": {
            lang: "it",
            title: "Cosa Succede se Dimentico la Password?",
            description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
            keywords: "Password Dimenticata, Recupero Password, Reimposta Password Trading, Aiuto Accesso Excent Capital, Accesso Account, Recuperare Password, Password Persa, Login Account Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/password-dimenticata",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/password-dimenticata",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/documenti-per-verifica/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/documenti-per-verifica",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/documenti-per-verifica",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conto-utilizzato-da-terzi/": {
            lang: "it",
            title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
            description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
            keywords: "Condivisione Account, Politica Excent Capital, Uso Personale Account, Sicurezza Account Trading, Accesso Condiviso, Uso da Parte della Famiglia, Sicurezza Account, Conformità nel Trading",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/cancellare-il-conto/": {
            lang: "it",
            title: "Come Posso Cancellare il Mio Account?",
            description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
            keywords: "Cancellare Account Trading, Chiudere Account Excent Capital, Terminazione Account, Eliminare Account, Chiusura Account Trading, Disattivazione Account, Supporto Excent Capital, Processo di Cancellazione Account",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/cancellare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/cancellare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/verificare-conto-dall-estero/": {
            lang: "it",
            title: "Posso Verificare il Mio Account da un Paese Straniero?",
            description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
            keywords: "Verificare Account dall’Estero, Verifica Excent Capital, Configurazione Account da Paese Straniero, KYC Internazionale, Verifica Remota Account, Documenti Account, Verifica Estera",
            canonical: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                url: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/depositi-prelievi/dentro-depositi-prelievi/": {
            lang: "it",
            title: "Scopri Depositi e Prelievi: Cosa Troverai",
            description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
            keywords: "Depositi e Prelievi, Finanziamento Excent Capital, Prelevare Profitti, Metodi di Pagamento, Opzioni di Deposito, Tempi di Prelievo, Finanziamento Conto Trading, Transazioni Finanziarie",
            canonical: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                url: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/primo-deposito/": {
            lang: "it",
            title: "Come Effettuare un Primo Deposito?",
            description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
            keywords: "Primo Deposito, Effettuare un Deposito, Finanziamento Excent Capital, Deposito Conto Trading, Come Depositare, Metodi di Pagamento, Inizia a Fare Trading, Finanzia il Tuo Conto",
            canonical: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/primo-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/primo-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-deposito/": {
            lang: "it",
            title: "Come Effettuare un Deposito?",
            description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
            keywords: "Deposita Fondi, Come Depositare, Metodi di Pagamento Excent Capital, Finanziamento Conto Trading, Effettuare un Deposito, Deposito Sicuro, Ricarica Account, Processo di Deposito",
            canonical: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                url: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-prelievo/": {
            lang: "it",
            title: "Come Posso Effettuare un Prelievo?",
            description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
            keywords: "Preleva Fondi, Prelievo Excent Capital, Come Prelevare, Pagamento Conto Trading, Processo di Prelievo, Prelievo Sicuro, Accedere ai Guadagni, Metodi di Pagamento",
            canonical: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                url: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/prelievo-non-riuscito/": {
            lang: "it",
            title: "Cosa Fare se il Mio Prelievo Fallisce?",
            description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
            keywords: "Prelievo Fallito, Aiuto Excent Capital, Transazione Fallita, Risoluzione Problema Prelievo, Problemi di Prelievo, Errore di Pagamento, Supporto Conto Trading, Correggere Problema di Prelievo",
            canonical: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                url: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/paiements/a-linterieur-des-paiements/": {
            lang: "it",
            title: "Scopri i Pagamenti: Cosa Troverai",
            description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
            keywords: "Pagamenti Excent Capital, Metodi di Pagamento Accettati, Gestione Transazioni, Tempo di Elaborazione Pagamenti, Valute Supportate, Pagamenti di Trading, Opzioni di Deposito e Prelievo, Finanziamento Conto",
            canonical: "https://knowledgebase.demo.excent.capital/it/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.demo.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                url: "https://knowledgebase.demo.excent.capital/it/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/voir-historique-paiements/": {
            lang: "it",
            title: "Come Vedo lo Storico dei Pagamenti?",
            description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
            keywords: "Storico Pagamenti, Storico Transazioni, Visualizza Depositi, Visualizza Prelievi, Pagamenti Excent Capital, Transazioni Conto, Storico Conto Trading, Registrazioni Finanziarie",
            canonical: "https://knowledgebase.demo.excent.capital/it/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.demo.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                url: "https://knowledgebase.demo.excent.capital/it/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/delai-de-transaction/": {
            lang: "it",
            title: "Quanto Può Durare una Transazione?",
            description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
            keywords: "Tempo Transazione, Tempo di Elaborazione, Durata Deposito, Durata Prelievo, Pagamenti Excent Capital, Velocità di Pagamento, Transazioni Conto Trading, Ritardi nelle Transazioni",
            canonical: "https://knowledgebase.demo.excent.capital/it/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.demo.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                url: "https://knowledgebase.demo.excent.capital/it/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Cantones
        //Italiano
        "zh/": {
            lang: "zh-HK",
            title: "知識庫 | Excent Capital",
            description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
            keywords: "Excent Capital 幫助中心, 交易平台支援, 交易常見問題, 如何交易, 外匯教學, 帳戶管理, 交易指南, 存款協助, 提款協助",
            canonical: "https://knowledgebase.demo.excent.capital/zh/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en",
                es: "https://knowledgebase.demo.excent.capital/es",
                pt: "https://knowledgebase.demo.excent.capital/pt",
                fr: "https://knowledgebase.demo.excent.capital/fr",
                it: "https://knowledgebase.demo.excent.capital/it",
                zh: "https://knowledgebase.demo.excent.capital/zh",
            },
            openGraph: {
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                url: "https://knowledgebase.demo.excent.capital/zh/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/inside-about-us-zh/": {
            lang: "zh-HK",
            title: "關於我們：你將發現什麼",
            description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
            keywords: "關於 Excent Capital, 公司使命, 交易公司價值觀, 認識團隊, 誰是 Excent Capital, 我們的故事, 金融服務公司, Excent Capital 概覽",
            canonical: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/inside-about-us-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/inside-about-us-zh",
            },
            openGraph: {
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                url: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/inside-about-us-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/about-excent-capital-zh/": {
            lang: "zh-HK",
            title: "關於 Excent Capital",
            description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
            keywords: "Excent Capital, 關於我們, 公司概況, 交易公司, 金融服務, 交易機構, 我們的使命, 我們是誰, 全球交易支援",
            canonical: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            },
            openGraph: {
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                url: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/about-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/build-your-portfolio-zh/": {
            lang: "zh-HK",
            title: "建立您的投資組合：Excent Capital 的多樣化選擇",
            description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
            keywords: "建立投資組合, 交易工具, 外匯交易, 股市, 指數交易, 商品交易, 多元化投資組合, Excent Capital 資產",
            canonical: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            },
            openGraph: {
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                url: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-your-trusted-partner-zh/": {
            lang: "zh-HK",
            title: "Excent Capital：助您分散國際市場投資的可信伙伴",
            description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
            keywords: "Excent Capital, 國際投資, 分散投資組合, 全球市場, 可信交易伙伴, 外匯交易, 國際交易平台, 投資機會",
            canonical: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            },
            openGraph: {
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                url: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-education-center-zh/": {
            lang: "zh-HK",
            title: "提升你的交易能力：Excent Capital 教育中心",
            description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
            keywords: "交易教育, 學習交易, 交易教學, 交易課程, Excent Capital 教育, 初學者交易指南, 高級交易策略, 交易資源",
            canonical: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            },
            openGraph: {
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                url: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/invest-with-confidence-zh/": {
            lang: "zh-HK",
            title: "自信投資：Excent Capital 的風險管理策略與工具",
            description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
            keywords: "風險管理, 交易風險工具, 投資保護, Excent Capital 策略, 自信交易, 市場波動性, 交易工具, 管理交易風險",
            canonical: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.demo.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.demo.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.demo.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.demo.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            },
            openGraph: {
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                url: "https://knowledgebase.demo.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/trading-zh/inside-trading-zh/": {
            lang: "zh-HK",
            title: "交易內幕：你將發現的內容",
            description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
            keywords: "交易指南, 市場見解, 交易概念, 如何交易, Excent Capital 平台, 交易功能, 學習交易, 交易知識庫",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/inside-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/inside-trading-zh",
            },
            openGraph: {
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/inside-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/instruments-in-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的交易工具",
            description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
            keywords: "交易工具, 外匯, 股票, 商品, 指數, Excent Capital 資產, 金融工具, 投資選項, 交易市場",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/leverage-offered-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的槓桿",
            description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
            keywords: "槓桿交易, 使用槓桿進行交易, Excent Capital 槓桿, 保證金交易, 槓桿選項, 放大交易, 外匯槓桿, 負責任交易",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/micro-lots-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 的微型手數交易",
            description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
            keywords: "微型手數交易, Excent Capital 微型手數, 小手數交易, 初學者交易, 風險管理, 靈活交易, 外匯微型手數, 低風險交易",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.demo.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.demo.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-hours-zh/": {
            lang: "zh-HK",
            title: "交易時間",
            description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
            keywords: "交易時間, 市場開市時間, 外匯交易時間, 股票市場時間, Excent Capital 時間表, 交易時段, 交易時機, 金融市場時間",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/trading-hours-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.demo.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/trading-hours-zh",
            },
            openGraph: {
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/trading-hours-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-tools-zh/": {
            lang: "zh-HK",
            title: "交易工具",
            description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
            keywords: "交易工具, 市場分析工具, 交易計算機, 外匯工具, Excent Capital 平台, 交易資源, 繪圖工具, 明智交易",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/trading-tools-zh",
            },
            openGraph: {
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "zh/trading-zh/acuity-trading-tools-zh/": {
            lang: "zh-HK",
            title: "Acuity 交易工具",
            description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
            keywords: "Acuity 交易工具, AI 交易工具, 市場情緒分析, 即時市場洞察, Excent Capital 工具, Acuity 洞察, 智能交易, 交易分析",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.demo.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.demo.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            },
            openGraph: {
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "zh/trading-zh/margin-calls-zh/": {
            lang: "zh-HK",
            title: "追加保證金通知（Margin Calls）",
            description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
            keywords: "追加保證金通知, 什麼是追加保證金, Excent Capital 保證金, 交易保證金, 強制平倉, 帳戶保護, 保證金交易, 風險管理",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/margin-calls-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.demo.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.demo.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/margin-calls-zh",
            },
            openGraph: {
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/margin-calls-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/cfd-trading-zh/": {
            lang: "zh-HK",
            title: "差價合約（CFD）交易",
            description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
            keywords: "CFD 交易, 差價合約, 交易 CFD, Excent Capital CFD, 槓桿交易, 衍生工具交易, CFD 市場, 如何交易 CFD",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/cfd-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.demo.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.demo.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/cfd-trading-zh",
            },
            openGraph: {
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/cfd-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/pending-orders-zh/": {
            lang: "zh-HK",
            title: "掛單交易（Pending Orders）",
            description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
            keywords: "掛單交易, 交易指令, 買入止損, 賣出止損, 限價單, 自動化交易, Excent Capital 指令, 入市點, 交易策略",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/pending-orders-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.demo.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.demo.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/pending-orders-zh",
            },
            openGraph: {
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/pending-orders-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/spreads-offered-zh/": {
            lang: "zh-HK",
            title: "點差介紹",
            description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
            keywords: "點差, 波動點差, 金融市場, 交易點差, 降低交易成本, 提高盈利能力, 交易策略, 點差分析, 外匯點差, 股票市場點差",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/spreads-offered-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.demo.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.demo.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/spreads-offered-zh",
            },
            openGraph: {
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/spreads-offered-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/base-currencies-zh/": {
            lang: "zh-HK",
            title: "基礎貨幣",
            description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
            keywords: "基礎貨幣, 支援貨幣, Excent Capital 帳戶, 帳戶貨幣選項, 貨幣選擇, 交易貨幣, 外匯基礎貨幣, 資金選項",
            canonical: "https://knowledgebase.demo.excent.capital/zh/trading-zh/base-currencies-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.demo.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.demo.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.demo.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.demo.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.demo.excent.capital/zh/trading-zh/base-currencies-zh",
            },
            openGraph: {
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                url: "https://knowledgebase.demo.excent.capital/zh/trading-zh/base-currencies-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/resources-zh/inside-resources-zh/": {
            lang: "zh-HK",
            title: "資源中心導覽",
            description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
            keywords: "交易資源, Excent Capital 工具, 市場更新, 經濟日曆, 交易教學, 資源中心, 學習交易, 交易輔助材料",
            canonical: "https://knowledgebase.demo.excent.capital/zh/resources-zh/inside-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.demo.excent.capital/zh/resources-zh/inside-resources-zh",
            },
            openGraph: {
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                url: "https://knowledgebase.demo.excent.capital/zh/resources-zh/inside-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/basic-concepts-zh/": {
            lang: "zh-HK",
            title: "基礎概念",
            description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
            keywords: "交易基礎概念, 初學者交易, 市場基礎知識, Excent Capital 教育, 交易術語, 初學者指南, 學習交易, 基礎知識",
            canonical: "https://knowledgebase.demo.excent.capital/zh/resources-zh/basic-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.demo.excent.capital/zh/resources-zh/basic-concepts-zh",
            },
            openGraph: {
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                url: "https://knowledgebase.demo.excent.capital/zh/resources-zh/basic-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/advanced-concepts-zh/": {
            lang: "zh-HK",
            title: "進階概念",
            description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
            keywords: "進階交易概念, 交易策略, 技術指標, 專業交易, Excent Capital 教育, 市場分析, 專業交易工具, 交易技巧",
            canonical: "https://knowledgebase.demo.excent.capital/zh/resources-zh/advanced-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.demo.excent.capital/zh/resources-zh/advanced-concepts-zh",
            },
            openGraph: {
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                url: "https://knowledgebase.demo.excent.capital/zh/resources-zh/advanced-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/additional-resources-zh/": {
            lang: "zh-HK",
            title: "額外資源",
            description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
            keywords: "交易資源, Excent Capital 工具, 詞彙表, 平台指南, 交易協助, 市場工具, 教育資源, 交易支援",
            canonical: "https://knowledgebase.demo.excent.capital/zh/resources-zh/additional-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.demo.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.demo.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.demo.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.demo.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.demo.excent.capital/zh/resources-zh/additional-resources-zh",
            },
            openGraph: {
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                url: "https://knowledgebase.demo.excent.capital/zh/resources-zh/additional-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/my-account-zh/inside-my-account-zh/": {
            lang: "zh-HK",
            title: "我的帳戶導覽",
            description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
            keywords: "我的帳戶, 帳戶管理, Excent Capital 個人資料, 交易帳戶設定, 帳戶安全, 使用者儀表板, 資料更新, 管理交易帳戶",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/inside-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/inside-my-account-zh",
            },
            openGraph: {
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/inside-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-to-create-a-demo-account-zh/": {
            lang: "zh-HK",
            title: "我可以開設模擬帳戶嗎？",
            description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
            keywords: "模擬帳戶, 練習交易, Excent Capital 模擬, 無風險交易, 建立模擬帳戶, 交易模擬器, 初學者交易, 學習交易",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            },
            openGraph: {
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-to-create-a-live-account-zh/": {
            lang: "zh-HK",
            title: "如何開立真實帳戶？",
            description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
            keywords: "真實帳戶, 建立交易帳戶, Excent Capital 註冊, 開立真實帳戶, 開始交易, 真實交易帳戶, 交易註冊, 帳戶設置",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            },
            openGraph: {
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/why-verify-your-account-zh/": {
            lang: "zh-HK",
            title: "為什麼要驗證你的帳戶？",
            description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
            keywords: "帳戶驗證, 驗證交易帳戶, Excent Capital KYC, 交易安全, 合規程序, 身份驗證, 安全交易, 完整帳戶訪問",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            },
            openGraph: {
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-access-the-platform-zh/": {
            lang: "zh-HK",
            title: "如何登入平台？",
            description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
            keywords: "登入交易平台, Excent Capital 登入, 交易應用程式, 網絡交易平台, 手機交易, 如何登入, 開始交易, 平台訪問指南",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            },
            openGraph: {
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh/": {
            lang: "zh-HK",
            title: "開立帳戶需時多久？",
            description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
            keywords: "帳戶建立時間, Excent Capital 註冊, 如何開立帳戶, 交易帳戶設置, 註冊流程, 快速開戶, 交易入門",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            },
            openGraph: {
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/do-you-offer-corporate-accounts-zh/": {
            lang: "zh-HK",
            title: "是否提供企業帳戶？",
            description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
            keywords: "企業交易帳戶, 商業帳戶, Excent Capital 企業服務, 機構交易, 開設企業帳戶, 公司交易, 商業投資帳戶",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            },
            openGraph: {
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-open-multiple-accounts-zh/": {
            lang: "zh-HK",
            title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
            description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
            keywords: "多個帳戶, 相同電郵帳戶, Excent Capital 角色, 使用者角色, 帳戶管理, 交易帳戶存取, 角色型訪問, 電郵註冊政策",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            },
            openGraph: {
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-update-my-account-information-zh/": {
            lang: "zh-HK",
            title: "如何更新我的帳戶資料？",
            description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 修改帳戶資訊, 更新交易檔案, 使用者資訊",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            },
            openGraph: {
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-happens-if-i-forget-my-password-zh/": {
            lang: "zh-HK",
            title: "如果我忘記密碼會發生什麼事？",
            description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
            keywords: "忘記密碼, 密碼恢復, 重設交易密碼, Excent Capital 登入幫助, 帳戶存取, 找回密碼, 密碼遺失, 交易帳戶登入",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            },
            openGraph: {
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-documents-are-required-for-account-verification-zh/": {
            lang: "zh-HK",
            title: "我如何更新我的帳戶資料？",
            description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 更改帳戶資料, 更新交易資料, 用戶資訊",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            },
            openGraph: {
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh/": {
            lang: "zh-HK",
            title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
            description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
            keywords: "共用帳戶, Excent Capital 政策, 個人帳戶使用, 交易帳戶安全, 帳戶共享, 家人使用帳戶, 帳戶安全, 交易合規",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            },
            openGraph: {
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-cancel-my-account-zh/": {
            lang: "zh-HK",
            title: "我如何取消我的帳戶",
            description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
            keywords: "取消交易帳戶, 關閉 Excent Capital 帳戶, 帳戶終止, 刪除帳戶, 結束帳戶, Excent Capital 支援, 帳戶取消程序",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            },
            openGraph: {
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh/": {
            lang: "zh-HK",
            title: "我可以從外國驗證我的帳戶嗎？",
            description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
            keywords: "海外驗證帳戶, Excent Capital 驗證, 外國帳戶設定, 國際 KYC, 遠程帳戶驗證, 驗證文件, 海外驗證",
            canonical: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.demo.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.demo.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.demo.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.demo.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            },
            openGraph: {
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                url: "https://knowledgebase.demo.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh/": {
            lang: "zh-HK",
            title: "存款與提款：你將會發現什麼",
            description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
            keywords: "存款與提款, Excent Capital 資金, 提取利潤, 付款方式, 存款選項, 提款時間, 交易帳戶資金, 金融交易",
            canonical: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            },
            openGraph: {
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                url: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行首次存款？",
            description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
            keywords: "首次存款, 進行存款, Excent Capital 資金, 交易帳戶存款, 如何存款, 付款方式, 開始交易, 帳戶注資",
            canonical: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            },
            openGraph: {
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                url: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行存款？",
            description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
            keywords: "資金存入, 如何存款, Excent Capital 付款方式, 交易帳戶資金, 進行存款, 安全存款, 帳戶充值, 存款流程",
            canonical: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            },
            openGraph: {
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                url: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh/": {
            lang: "zh-HK",
            title: "我如何提取資金？",
            description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
            keywords: "提取資金, Excent Capital 提款, 如何提款, 交易帳戶提現, 提款流程, 安全提款, 提取收益, 付款方式",
            canonical: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            },
            openGraph: {
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                url: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh/": {
            lang: "zh-HK",
            title: "如果提款失敗，我應該怎麼辦？",
            description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
            keywords: "提款失敗, Excent Capital 幫助, 交易失敗, 排解提款問題, 提款錯誤, 付款失誤, 交易帳戶支援, 解決提款問題",
            canonical: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.demo.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.demo.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.demo.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.demo.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            },
            openGraph: {
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                url: "https://knowledgebase.demo.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/payments-zh/inside-payments-zh/": {
            lang: "zh-HK",
            title: "付款詳情：你將會發現什麼",
            description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
            keywords: "Excent Capital 付款, 可接受的付款方式, 交易管理, 付款處理時間, 支援貨幣, 交易付款, 存款與提款選項, 帳戶注資",
            canonical: "https://knowledgebase.demo.excent.capital/zh/payments-zh/inside-payments-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.demo.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.demo.excent.capital/zh/payments-zh/inside-payments-zh",
            },
            openGraph: {
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                url: "https://knowledgebase.demo.excent.capital/zh/payments-zh/inside-payments-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-do-i-see-my-payment-history-zh/": {
            lang: "zh-HK",
            title: "我如何查看我的付款記錄？",
            description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
            keywords: "付款記錄, 交易歷史, 查看存款, 查看提款, Excent Capital 付款, 帳戶交易, 交易帳戶記錄, 財務紀錄",
            canonical: "https://knowledgebase.demo.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.demo.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.demo.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            },
            openGraph: {
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                url: "https://knowledgebase.demo.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-long-can-a-transaction-take-zh/": {
            lang: "zh-HK",
            title: "一筆交易需要多長時間？",
            description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
            keywords: "交易時間, 處理時間, 存款所需時間, 提款所需時間, Excent Capital 付款, 付款速度, 交易帳戶處理, 交易延誤",
            canonical: "https://knowledgebase.demo.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.demo.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.demo.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.demo.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.demo.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.demo.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.demo.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            },
            openGraph: {
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                url: "https://knowledgebase.demo.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
    },
    "knowledgebase.excent.capital": {
        // English 
        "/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en",
                es: "https://knowledgebase.excent.capital/es",
                pt: "https://knowledgebase.excent.capital/pt",
                fr: "https://knowledgebase.excent.capital/fr",
                it: "https://knowledgebase.excent.capital/it",
                zh: "https://knowledgebase.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/": {
            lang: "en",
            title: "Knowledgebase | Excent Capital",
            description:
                "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
            keywords: "Excent Capital Help Center, Trading Platform Support, Trading FAQs, How to Trade, FX Tutorials, Account Management, Trading Guides, Deposit Help, Withdrawal Help",
            canonical: "https://knowledgebase.excent.capital/en/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en",
                es: "https://knowledgebase.excent.capital/es",
                pt: "https://knowledgebase.excent.capital/pt",
                fr: "https://knowledgebase.excent.capital/fr",
                it: "https://knowledgebase.excent.capital/it",
                zh: "https://knowledgebase.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                url: "https://knowledgebase.excent.capital/en/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description:
                    "Explore Excent Capital’s Knowledgebase for expert guides, platform tutorials, trading FAQs, and resources designed to help you trade with confidence.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/inside-about-us/": {
            lang: "en",
            title: "Inside About Us: What You'll Discover",
            description:
                "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
            keywords: "About Excent Capital, Company Mission, Trading Company Values, Meet the Team, Who is Excent Capital, Our Story, Financial Services Company, Excent Capital Overview",
            canonical: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                url: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside About Us: What You'll Discover",
                description:
                    "Learn more about Excent Capital’s mission, values, and global presence. Discover who we are, what drives us, and how we empower traders worldwide.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/about-excent-capital/": {
            lang: "en",
            title: "About Excent Capital",
            description:
                "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
            keywords: "Excent Capital, About Us, Company Overview, Trading Company, Financial Services, Trading Firm, Our Mission, Who We Are, Global Trading Support",
            canonical: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                url: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "About Excent Capital",
                description:
                    "Get to know Excent Capital—our history, mission, and the principles that guide our approach to empowering traders in global markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/build-your-portfolio/": {
            lang: "en",
            title: "Build Your Portfolio: Diverse Options on Excent Capital",
            description:
                "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
            keywords: "Build Portfolio, Trading Instruments, Forex Trading, Stock Market, Indices Trading, Commodities Trading, Diversified Portfolio, Excent Capital Assets",
            canonical: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                url: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Build Your Portfolio: Diverse Options on Excent Capital",
                description:
                    "Discover a wide range of trading instruments at Excent Capital, including Forex, stocks, indices, and commodities—everything you need to build a strong, diversified portfolio.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-your-trusted-partner/": {
            lang: "en",
            title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
            description:
                "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
            keywords: "Excent Capital, International Investments, Diversify Portfolio, Global Markets, Trusted Trading Partner, Forex Trading, International Trading Platform, Investment Opportunities",

            canonical: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                url: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Your Trusted Partner for Diversifying Your Investments in the International Markets",
                description:
                    "Partner with Excent Capital to expand your investment opportunities globally. Access international markets with confidence through our secure and professional trading platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/excent-capital-education-center/": {
            lang: "en",
            title: "Level Up Your Trading: Excent Capital's Education Center",
            description:
                "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
            keywords: "Trading Education, Learn to Trade, Trading Tutorials, Trading Courses, Excent Capital Education, Beginner Trading Guide, Advanced Trading Strategies, Trading Resources",

            canonical: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                url: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Level Up Your Trading: Excent Capital's Education Center",
                description:
                    "Access expert-led courses, tutorials, and resources at Excent Capital’s Education Center. Learn trading strategies and boost your skills—whether you're a beginner or advanced trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/about-us/invest-with-confidence/": {
            lang: "en",
            title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
            description:
                "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
            keywords: "Risk Management, Trading Risk Tools, Investment Protection, Excent Capital Strategies, Confident Trading, Market Volatility, Trading Tools, Manage Risk in Trading",

            canonical: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                url: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invest with Confidence: Risk Management Strategies and Tools at Excent Capital",
                description:
                    "Master risk management with Excent Capital. Explore essential tools and strategies to protect your investments and trade more confidently in volatile markets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/inside-trading/": {
            lang: "en",
            title: "Inside Trading: What You'll Discover",
            description:
                "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
            keywords: "Trading Guide, Market Insights, Trading Concepts, How to Trade, Excent Capital Platform, Trading Features, Learn Trading, Trading Knowledge Base",

            canonical: "https://knowledgebase.excent.capital/en/trading/inside-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                url: "https://knowledgebase.excent.capital/en/trading/inside-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Trading: What You'll Discover",
                description:
                    "Explore key trading concepts, market insights, and platform features inside Excent Capital’s trading hub. Get the knowledge you need to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/instruments-in-excent-capital/": {
            lang: "en",
            title: "Instruments in Excent Capital",
            description:
                "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
            keywords: "Trading Instruments, Forex, Stocks, Commodities, Indices, Excent Capital Assets, Financial Instruments, Investment Options, Trade Markets",

            canonical: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                url: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments in Excent Capital",
                description:
                    "Explore the full range of trading instruments offered by Excent Capital, including FX, stocks, commodities, indices, and more—designed to match your investment goals.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/leverage-offered-at-excent-capital/": {
            lang: "en",
            title: "Leverage Offered at Excent Capital",
            description:
                "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
            keywords: "Leverage Trading, Trading with Leverage, Excent Capital Leverage, Margin Trading, Leverage Options, Amplify Trading, Forex Leverage, Responsible Trading",

            canonical: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                url: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leverage Offered at Excent Capital",
                description:
                    "Understand how leverage works at Excent Capital and how it can amplify your trading potential. Learn about our flexible leverage options and responsible trading practices.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/micro-lots-at-excent-capital/": {
            lang: "en",
            title: "Micro Lots at Excent Capital",
            description:
                "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
            keywords: "Micro Lots Trading, Excent Capital Micro Lots, Small Lot Trading, Beginner Trading, Risk Management, Flexible Trading, Forex Micro Lots, Low Exposure Trading",

            canonical: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                url: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lots at Excent Capital",
                description:
                    "Trade with more flexibility using micro lots at Excent Capital. Ideal for beginners and risk-conscious traders looking to manage exposure and test strategies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-hours/": {
            lang: "en",
            title: "Trading Hours",
            description:
                "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
            keywords: "Trading Hours, Market Hours, Forex Trading Times, Stock Market Hours, Excent Capital Schedule, Trading Sessions, Trading Times, Financial Market Hours",

            canonical: "https://knowledgebase.excent.capital/en/trading/trading-hours",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                url: "https://knowledgebase.excent.capital/en/trading/trading-hours",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Hours",
                description:
                    "Stay informed with the official trading hours for all markets available on Excent Capital. Know when to trade Forex, stocks, indices, and commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/trading-tools/": {
            lang: "en",
            title: "Trading Tools",
            description:
                "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
            keywords: "Trading Tools, Market Analysis Tools, Trading Calculators, Forex Tools, Excent Capital Platform, Trading Resources, Charting Tools, Informed Trading",

            canonical: "https://knowledgebase.excent.capital/en/trading/trading-tools",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                url: "https://knowledgebase.excent.capital/en/trading/trading-tools",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading Tools",
                description:
                    "Enhance your trading experience with Excent Capital’s powerful tools. Access charts, calculators, market analysis, and more to make informed decisions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "en/trading/acuity-trading-tools/": {
            lang: "en",
            title: "Acuity Trading Tools",
            description:
                "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
            keywords: "Acuity Trading Tools, AI Trading Tools, Market Sentiment Analysis, Real-Time Market Insights, Excent Capital Tools, Acuity Insights, Smart Trading, Trading Analytics",

            canonical: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                url: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity Trading Tools",
                description:
                    "Leverage Acuity’s AI-powered tools on Excent Capital to gain market insights, sentiment analysis, and smarter trading decisions based on real-time data.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "en/trading/margin-calls/": {
            lang: "en",
            title: "Margin Calls",
            description:
                "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
            keywords: "Margin Calls, What is a Margin Call, Excent Capital Margin, Trading Margin, Forced Liquidation, Account Protection, Margin Trading, Risk Management",
            canonical: "https://knowledgebase.excent.capital/en/trading/margin-calls",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                url: "https://knowledgebase.excent.capital/en/trading/margin-calls",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Margin Calls",
                description:
                    "Understand how margin calls work on Excent Capital. Learn when they occur, how to manage them, and how to protect your account from forced liquidation.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/cfd-trading/": {
            lang: "en",
            title: "CFD Trading",
            description:
                "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
            keywords: "CFD Trading, Contracts for Difference, Trade CFDs, Excent Capital CFDs, Leverage Trading, Derivatives Trading, CFD Markets, How to Trade CFDs",
            canonical: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                url: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "CFD Trading",
                description:
                    "Learn how to trade Contracts for Difference (CFDs) with Excent Capital. Access global markets, trade with leverage, and take positions on price movements without owning the assets.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/pending-orders/": {
            lang: "en",
            title: "Pending Orders",
            description:
                "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
            keywords: "Pending Orders, Trading Orders, Buy Stop, Sell Stop, Limit Orders, Automated Trading, Excent Capital Orders, Entry Points, Trading Strategy",
            canonical: "https://knowledgebase.excent.capital/en/trading/pending-orders",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                url: "https://knowledgebase.excent.capital/en/trading/pending-orders",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pending Orders",
                description:
                    "Discover how pending orders work on Excent Capital. Learn to set entry points in advance and automate your trading strategy with precision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/spreads-offered/": {
            lang: "en",
            title: "Spreads Offered",
            description:
                "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                url: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Offered",
                description:
                    "Discover the importance of spreads and volatility spreads in financial markets. Learn how to minimize costs and optimize your profitability as a trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/trading/base-currencies/": {
            lang: "en",
            title: "Base Currencies",
            description:
                "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
            keywords: "Base Currencies, Supported Currencies, Excent Capital Account, Account Currency Options, Currency Selection, Trading Currency, Forex Base Currency, Funding Options",
            canonical: "https://knowledgebase.excent.capital/en/trading/base-currencies",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                url: "https://knowledgebase.excent.capital/en/trading/base-currencies",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base Currencies",
                description:
                    "Find out which base currencies are supported on Excent Capital. Choose the right currency for your account and simplify your trading and funding experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/inside-resources/": {
            lang: "en",
            title: "Inside Resources: What You'll Discover",
            description:
                "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
            keywords: "Trading Resources, Excent Capital Tools, Market Updates, Economic Calendar, Trading Education, Resource Center, Learn to Trade, Trading Support Materials",
            canonical: "https://knowledgebase.excent.capital/en/resources/inside-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                url: "https://knowledgebase.excent.capital/en/resources/inside-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Resources: What You'll Discover",
                description:
                    "Explore Excent Capital’s resource center for market updates, economic calendars, trading tools, and educational content to support your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/basic-concepts/": {
            lang: "en",
            title: "Basic Concepts",
            description:
                "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
            keywords: "Basic Trading Concepts, Trading for Beginners, Market Basics, Excent Capital Education, Trading Terminology, Beginner Guide, Learn Trading, Fundamental Concepts",
            canonical: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                url: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Basic Concepts",
                description:
                    "Learn the foundational concepts of trading with Excent Capital. Understand key terms, market mechanics, and essential knowledge to start your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/advanced-concepts/": {
            lang: "en",
            title: "Advanced Concepts",
            description:
                "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
            keywords: "Advanced Trading Concepts, Trading Strategies, Technical Indicators, Expert Trading, Excent Capital Education, Market Analysis, Pro Trader Tools, Trading Techniques",
            canonical: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                url: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Advanced Concepts",
                description:
                    "Deepen your trading knowledge with advanced concepts at Excent Capital. Explore strategies, indicators, and techniques used by experienced traders.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/resources/additional-resources/": {
            lang: "en",
            title: "Additional Resources",
            description:
                "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
            keywords: "Trading Resources, Excent Capital Tools, Glossary of Terms, Platform Guides, Trading Help, Market Tools, Educational Resources, Trading Support",
            canonical: "https://knowledgebase.excent.capital/en/resources/additional-resources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                url: "https://knowledgebase.excent.capital/en/resources/additional-resources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Additional Resources",
                description:
                    "Access a variety of additional resources at Excent Capital, including trading glossaries, platform guides, and market tools to enhance your trading experience.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/inside-my-account/": {
            lang: "en",
            title: "Inside My Account: What You'll Discover",
            description:
                "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
            keywords: "My Account, Account Management, Excent Capital Profile, Trading Account Settings, Account Security, User Dashboard, Profile Updates, Manage Trading Account",
            canonical: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                url: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside My Account: What You'll Discover",
                description:
                    "Manage your trading account with ease at Excent Capital. Learn how to update your profile, access account settings, monitor activity, and maintain security.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-to-create-a-demo-account/": {
            lang: "en",
            title: "Can I Create a Demo Account?",
            description:
                "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
            keywords: "Demo Account, Practice Trading, Excent Capital Demo, Risk-Free Trading, Create Demo Account, Trading Simulator, Beginner Trading, Learn to Trade",
            canonical: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                url: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Create a Demo Account?",
                description:
                    "Yes, Excent Capital offers demo accounts so you can practice trading in a risk-free environment. Learn how to open one and start exploring the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-to-create-a-live-account/": {
            lang: "en",
            title: "How to Create a Live Account?",
            description:
                "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
            keywords: "Live Account, Create Trading Account, Excent Capital Registration, Open Live Account, Start Trading, Real Trading Account, Trading Signup, Account Setup",
            canonical: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                url: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How to Create a Live Account?",
                description:
                    "Open your live trading account with Excent Capital in just a few steps. Follow our guide to start trading real markets securely and efficiently.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/why-verify-your-account/": {
            lang: "en",
            title: "Why Verify Your Account?",
            description:
                "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
            keywords: "Account Verification, Verify Trading Account, Excent Capital KYC, Trading Security, Compliance Process, Identity Verification, Secure Trading, Full Account Access",
            canonical: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                url: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Why Verify Your Account?",
                description:
                    "Account verification at Excent Capital ensures security, compliance, and full access to trading features. Learn why it's important and how to complete it.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account.how-do-i-access-the-platform/": {
            lang: "en",
            title: "How Do I Access the Platform?",
            description:
                "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
            keywords: "Access Trading Platform, Excent Capital Login, Trading App, Web Trading Platform, Mobile Trading, How to Log In, Start Trading, Platform Access Guide",
            canonical: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                url: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Access the Platform?",
                description:
                    "Access the Excent Capital trading platform easily from your browser or mobile device. Learn how to log in and start trading anytime, anywhere.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-long-does-it-take-to-create-an-account/": {
            lang: "en",
            title: "How Long Does it Take to Create an Account?",
            description:
                "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
            keywords: "Account Creation Time, Excent Capital Signup, How to Create Account, Trading Account Setup, Registration Process, Open Account Fast, Trading Onboarding",
            canonical: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                url: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Does it Take to Create an Account?",
                description:
                    "Creating an account with Excent Capital is quick and simple. Learn how long the process takes and what steps are required to get started.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/do-you-offer-corporate-accounts/": {
            lang: "en",
            title: "Do You Offer Corporate Accounts?",
            description:
                "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
            keywords: "Corporate Trading Account, Business Account, Excent Capital Corporate, Institutional Trading, Open Corporate Account, Company Trading, Business Investment Account",
            canonical: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                url: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Do You Offer Corporate Accounts?",
                description:
                    "Yes, Excent Capital provides corporate trading accounts for businesses and institutions. Discover the benefits and requirements to open a corporate account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-open-multiple-accounts/": {
            lang: "en",
            title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
            description:
                "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
            keywords: "Multiple Accounts, Same Email Accounts, Excent Capital Roles, User Roles, Account Management, Trading Account Access, Role-Based Access, Email Registration Policy",
            canonical: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                url: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Open Multiple Accounts with Different Roles Using the Same Email Address?",
                description:
                    "Learn whether you can register multiple Excent Capital accounts with different roles under a single email address, and how role management works on the platform.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-update-my-account-information/": {
            lang: "en",
            title: "How Do I Update My Account Information?",
            description:
                "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
            keywords: "Update Account Info, Edit Personal Details, Excent Capital Profile, Account Settings, Change Account Information, Trading Profile Update, User Information",
            canonical: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                url: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Update My Account Information?",
                description:
                    "Easily update your personal and account details on Excent Capital. Follow our step-by-step guide to keep your information accurate and up to date.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-happens-if-i-forget-my-password/": {
            lang: "en",
            title: "What Happens If I Forget My Password?",
            description:
                "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
            keywords: "Forgot Password, Password Recovery, Reset Trading Password, Excent Capital Login Help, Account Access, Recover Password, Lost Password, Trading Account Login",
            canonical: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                url: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Happens If I Forget My Password?",
                description:
                    "If you forget your password, Excent Capital provides a secure and simple recovery process. Learn how to reset your password and regain access to your account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/what-documents-are-required-for-account-verification/": {
            lang: "en",
            title: "What Documents Are Required for Account Verification?",
            description:
                "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
            keywords: "Account Verification Documents, KYC Requirements, Excent Capital Verification, Proof of Identity, Proof of Address, Upload Documents, Secure Verification, Trading Compliance",
            canonical: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                url: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Documents Are Required for Account Verification?",
                description:
                    "Verify your Excent Capital account by submitting valid identification and proof of address. Learn which documents are accepted and how to upload them securely.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-my-friends-or-family-use-my-excent-capital-account/": {
            lang: "en",
            title: "Can My Friends or Family Use My Excent Capital Account?",
            description:
                "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
            keywords: "Account Sharing, Excent Capital Policy, Personal Account Use, Trading Account Security, Shared Access, Family Account Use, Account Safety, Trading Compliance",
            canonical: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                url: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can My Friends or Family Use My Excent Capital Account?",
                description:
                    "For your security, Excent Capital accounts are strictly personal and may not be shared. Learn why sharing access is prohibited and how to keep your account safe.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/how-do-i-cancel-my-account/": {
            lang: "en",
            title: "How do I Cancel My Account",
            description:
                "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
            keywords: "Cancel Trading Account, Close Excent Capital Account, Account Termination, Delete Account, Trading Account Closure, End Account, Excent Capital Support, Account Cancellation Process",
            canonical: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                url: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How do I Cancel My Account",
                description:
                    "If you wish to close your Excent Capital account, follow our step-by-step guide to request cancellation and ensure your data is securely handled.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/my-account/can-i-verify-my-account-from-a-foreign-country/": {
            lang: "en",
            title: "Can I Verify My Account From a Foreign Country?",
            description:
                "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
            keywords: "Verify Account Abroad, Excent Capital Verification, Foreign Country Account Setup, International KYC, Remote Account Verification, Account Documents, Overseas Verification",
            canonical: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                url: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Can I Verify My Account From a Foreign Country?",
                description:
                    "Yes, you can verify your Excent Capital account from abroad. Learn what documents are required and how to complete the verification process while overseas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/inside-deposits-withdrawals/": {
            lang: "en",
            title: "Inside Deposits & Withdrawals: What You'll Discover",
            description:
                "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
            keywords: "Deposits and Withdrawals, Excent Capital Funding, Withdraw Profits, Payment Methods, Deposit Options, Withdrawal Times, Trading Account Funding, Financial Transactions",
            canonical: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                url: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Deposits & Withdrawals: What You'll Discover",
                description:
                    "Learn everything you need to know about funding your Excent Capital account and withdrawing profits. Explore available methods, processing times, and requirements.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-do-a-first-time-deposit/": {
            lang: "en",
            title: "How Do I Make a First-Time Deposit?",
            description:
                "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                url: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a First-Time Deposit?",
                description:
                    "Start trading by making your first deposit on Excent Capital. Follow our simple guide to choose a payment method, fund your account, and begin your trading journey.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-do-i-make-a-deposit/": {
            lang: "en",
            title: "How Do I Make a Deposit?",
            description:
                "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
            keywords: "Deposit Funds, How to Deposit, Excent Capital Payment Methods, Trading Account Funding, Make a Deposit, Secure Deposit, Account Top-Up, Deposit Process",
            canonical: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                url: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I Make a Deposit?",
                description:
                    "Easily deposit funds into your Excent Capital account using a variety of secure payment methods. Learn how to initiate and complete your deposit step by step.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/how-can-i-make-a-withdrawal/": {
            lang: "en",
            title: "How Can I Make a Withdrawal?",
            description:
                "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
            keywords: "Withdraw Funds, Excent Capital Withdrawal, How to Withdraw, Trading Account Payout, Withdrawal Process, Secure Withdrawal, Access Earnings, Payment Methods",
            canonical: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                url: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Can I Make a Withdrawal?",
                description:
                    "Withdraw your funds from Excent Capital quickly and securely. Learn the steps, requirements, and available methods to access your earnings with ease.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails/": {
            lang: "en",
            title: "What Do I Do If My Withdrawal Fails?",
            description:
                "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
            keywords: "Withdrawal Failed, Excent Capital Help, Failed Transaction, Troubleshoot Withdrawal, Withdrawal Issue, Payment Error, Trading Account Support, Fix Withdrawal Problem",
            canonical: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                url: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "What Do I Do If My Withdrawal Fails?",
                description:
                    "If your withdrawal fails on Excent Capital, learn what steps to take to resolve the issue. Find out common causes and how to ensure a successful transaction.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/inside-payments/": {
            lang: "en",
            title: "Inside Payments: What You'll Discover",
            description:
                "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
            keywords: "Excent Capital Payments, Accepted Payment Methods, Transaction Management, Payment Processing Time, Supported Currencies, Trading Payments, Deposit and Withdrawal Options, Account Funding",
            canonical: "https://knowledgebase.excent.capital/en/payments/inside-payments",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                url: "https://knowledgebase.excent.capital/en/payments/inside-payments",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Inside Payments: What You'll Discover",
                description:
                    "Explore everything about payments at Excent Capital, including accepted methods, processing times, currencies, and how to manage your transactions smoothly.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-do-i-see-my-payment-history/": {
            lang: "en",
            title: "How Do I See My Payment History?",
            description:
                "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
            keywords: "Payment History, Transaction History, View Deposits, View Withdrawals, Excent Capital Payments, Account Transactions, Trading Account History, Financial Records",
            canonical: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                url: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Do I See My Payment History?",
                description:
                    "Track all your transactions easily on Excent Capital. Learn how to view your payment history, including deposits, withdrawals, and processing status.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "en/payments/how-long-can-a-transaction-take/": {
            lang: "en",
            title: "How Long Can a Transaction Take?",
            description:
                "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
            keywords: "Transaction Time, Processing Time, Deposit Duration, Withdrawal Duration, Excent Capital Payments, Payment Speed, Trading Account Transactions, Delay in Transactions",
            canonical: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.excent.capital/es/trading/spreads",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                url: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "How Long Can a Transaction Take?",
                description:
                    "Understand the typical processing times for deposits and withdrawals on Excent Capital. Learn what factors can affect transaction speed and how to avoid delays.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Español
        "es/": {
            lang: "es",
            title: "Base de Conocimientos | Excent Capital",
            description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
            keywords: "Centro de Ayuda Excent Capital, Soporte de Plataforma de Trading, Preguntas Frecuentes sobre Trading, Cómo Operar, Tutoriales de FX, Gestión de Cuentas, Guías de Trading, Ayuda para Depósitos, Ayuda para Retiros",
            canonical: "https://knowledgebase.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en",
                es: "https://knowledgebase.excent.capital/es",
                pt: "https://knowledgebase.excent.capital/pt",
                fr: "https://knowledgebase.excent.capital/fr",
                it: "https://knowledgebase.excent.capital/it",
                zh: "https://knowledgebase.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/dentro-de-acerca-de-nosotros/": {
            lang: "es",
            title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
            description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
            keywords: "Sobre Excent Capital, Misión de la Empresa, Valores de Empresa de Trading, Conoce al Equipo, Quién es Excent Capital, Nuestra Historia, Empresa de Servicios Financieros, Visión General de Excent Capital", canonical: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            canonical: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/acerca-de-excent-capital/": {
            lang: "es",
            title: "Sobre Excent Capital",
            description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
            keywords: "Excent Capital, Sobre Nosotros, Visión General de la Empresa, Empresa de Trading, Servicios Financieros, Firma de Trading, Nuestra Misión, Quiénes Somos, Soporte Global de Trading",
            canonical: "https://knowledgebase.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/construye-tu-portafolio/": {
            lang: "es",
            title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
            description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
            keywords: "Construir Portafolio, Instrumentos de Trading, Trading en Forex, Mercado de Acciones, Trading de Índices, Trading de Commodities, Portafolio Diversificado, Activos de Excent Capital",
            canonical: "https://knowledgebase.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/excent-capital-tu-socio-de-confianza/": {
            lang: "es",
            title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
            description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
            keywords: "Excent Capital, Inversiones Internacionales, Diversificar Portafolio, Mercados Globales, Socio de Trading Confiable, Trading en Forex, Plataforma de Trading Internacional, Oportunidades de Inversión",

            canonical: "https://knowledgebase.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/centro-educativo-excent-capital/": {
            lang: "es",
            title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
            description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
            keywords: "Educación en Trading, Aprender a Operar, Tutoriales de Trading, Cursos de Trading, Educación Excent Capital, Guía para Principiantes en Trading, Estrategias Avanzadas de Trading, Recursos de Trading",

            canonical: "https://knowledgebase.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/sobre-nosotros/invierte-con-confianza/": {
            lang: "es",
            title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
            description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
            keywords: "Gestión de Riesgo, Herramientas de Riesgo en Trading, Protección de Inversiones, Estrategias de Excent Capital, Trading con Confianza, Volatilidad del Mercado, Herramientas de Trading, Gestionar Riesgo en Trading",
            canonical: "https://knowledgebase.excent.capital/es/sobre-nosotros/invierte-con-confianza",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/trading/dentro-del-trading/": {
            lang: "es",
            title: "Dentro del Trading: Lo que Descubrirás",
            description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
            keywords: "Guía de Trading, Perspectivas del Mercado, Conceptos de Trading, Cómo Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conocimientos de Trading", canonical: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",
            canonical: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/instrumentos-en-excent-capital/": {
            lang: "es",
            title: "Instrumentos en Excent Capital",
            description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
            keywords: "Instrumentos de Trading, Forex, Acciones, Commodities, Índices, Activos de Excent Capital, Instrumentos Financieros, Opciones de Inversión, Mercados de Trading",
            canonical: "https://knowledgebase.excent.capital/es/trading/instrumentos-en-excent-capital",

            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.excent.capital/es/trading/instrumentos-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/apalancamiento-en-excent-capital/": {
            lang: "es",
            title: "Apalancamiento Ofrecido en Excent Capital",
            description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
            keywords: "Trading con Apalancamiento, Operar con Apalancamiento, Apalancamiento en Excent Capital, Trading con Margen, Opciones de Apalancamiento, Potenciar el Trading, Apalancamiento en Forex, Trading Responsable",
            canonical: "https://knowledgebase.excent.capital/es/trading/apalancamiento-en-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.excent.capital/es/trading/apalancamiento-en-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/micro-lotes-excent-capital/": {
            lang: "es",
            title: "Micro Lotes en Excent Capital",
            description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
            keywords: "Trading con Micro Lotes, Micro Lotes Excent Capital, Trading con Lotes Pequeños, Trading para Principiantes, Gestión de Riesgo, Trading Flexible, Micro Lotes en Forex, Trading con Baja Exposición",
            canonical: "https://knowledgebase.excent.capital/es/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.excent.capital/es/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/horario-de-trading/": {
            lang: "es",
            title: "Horarios de Trading",
            description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
            keywords: "Horarios de Trading, Horarios de Mercado, Horarios de Forex, Horarios del Mercado de Acciones, Calendario Excent Capital, Sesiones de Trading, Tiempos de Trading, Horarios del Mercado Financiero",
            canonical: "https://knowledgebase.excent.capital/es/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.excent.capital/es/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/herramientas-de-trading/": {
            lang: "es",
            title: "Herramientas de Trading",
            description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
            keywords: "Herramientas de Trading, Herramientas de Análisis de Mercado, Calculadoras de Trading, Herramientas de Forex, Plataforma Excent Capital, Recursos de Trading, Herramientas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "es/trading/herramientas-de-trading-acuity/": {
            lang: "es",
            title: "Herramientas de Trading de Acuity",
            description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
            keywords: "Herramientas de Trading de Acuity, Herramientas de Trading con IA, Análisis de Sentimiento del Mercado, Perspectivas del Mercado en Tiempo Real, Herramientas de Excent Capital, Insights de Acuity, Trading Inteligente, Analítica de Trading",
            canonical: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "es/trading/llamadas-de-margen/": {
            lang: "es",
            title: "Llamadas de Margen",
            description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
            keywords: "Llamadas de Margen, Qué es una Llamada de Margen, Margen en Excent Capital, Trading con Margen, Liquidación Forzada, Protección de Cuenta, Trading con Margen, Gestión de Riesgo",
            canonical: "https://knowledgebase.excent.capital/es/trading/llamadas-de-margen",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.excent.capital/es/trading/llamadas-de-margen",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/trading-de-cfd/": {
            lang: "es",
            title: "Trading de CFDs",
            description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
            keywords: "Trading de CFDs, Contratos por Diferencia, Operar CFDs, CFDs en Excent Capital, Trading con Apalancamiento, Trading de Derivados, Mercados de CFD, Cómo Operar CFDs",
            canonical: "https://knowledgebase.excent.capital/es/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.excent.capital/es/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/ordenes-pendientes/": {
            lang: "es",
            title: "Órdenes Pendientes",
            description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
            keywords: "Órdenes Pendientes, Órdenes de Trading, Buy Stop, Sell Stop, Órdenes Limitadas, Trading Automatizado, Órdenes en Excent Capital, Puntos de Entrada, Estrategia de Trading",
            canonical: "https://knowledgebase.excent.capital/es/trading/ordenes-pendientes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.excent.capital/es/trading/ordenes-pendientes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/spreads-ofrecidos/": {
            lang: "es",
            title: "Spreads Ofrecidos",
            description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
            keywords: "Spreads, Spreads por Volatilidad, Mercados Financieros, Spreads de Trading, Minimizar Costos de Trading, Optimizar Rentabilidad, Estrategias de Trading, Análisis de Spreads, Spreads en Forex, Spreads en el Mercado de Acciones",
            canonical: "https://knowledgebase.excent.capital/es/trading/spreads-ofrecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.excent.capital/es/trading/spreads-ofrecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/trading/monedas-base/": {
            lang: "es",
            title: "Monedas Base",
            description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
            keywords: "Monedas Base, Divisas Compatibles, Cuenta en Excent Capital, Opciones de Divisa de Cuenta, Selección de Moneda, Moneda de Trading, Divisa Base en Forex, Opciones de Fondeo",
            canonical: "https://knowledgebase.excent.capital/es/trading/monedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.excent.capital/es/trading/monedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/recursos/dentro-de-recursos/": {
            lang: "es",
            title: "Dentro de Recursos: Lo que Descubrirás",
            description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Actualizaciones del Mercado, Calendario Económico, Educación en Trading, Centro de Recursos, Aprender a Operar, Material de Apoyo para Trading",
            canonical: "https://knowledgebase.excent.capital/es/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.excent.capital/es/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-basicos/": {
            lang: "es",
            title: "Conceptos Básicos",
            description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
            keywords: "Conceptos Básicos de Trading, Trading para Principiantes, Fundamentos del Mercado, Educación de Excent Capital, Terminología de Trading, Guía para Principiantes, Aprender a Operar, Conceptos Fundamentales",
            canonical: "https://knowledgebase.excent.capital/es/recursos/conceptos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.excent.capital/es/recursos/conceptos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/conceptos-avanzados/": {
            lang: "es",
            title: "Conceptos Avanzados",
            description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
            keywords: "Conceptos Avanzados de Trading, Estrategias de Trading, Indicadores Técnicos, Trading Experto, Educación de Excent Capital, Análisis de Mercado, Herramientas de Trader Profesional, Técnicas de Trading",
            canonical: "https://knowledgebase.excent.capital/es/recursos/conceptos-avanzados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.excent.capital/es/recursos/conceptos-avanzados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/recursos/recursos-adicionales/": {
            lang: "es",
            title: "Recursos Adicionales",
            description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
            keywords: "Recursos de Trading, Herramientas de Excent Capital, Glosario de Términos, Guías de Plataforma, Ayuda para Trading, Herramientas de Mercado, Recursos Educativos, Soporte de Trading",
            canonical: "https://knowledgebase.excent.capital/es/recursos/recursos-adicionales",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.excent.capital/es/recursos/recursos-adicionales",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/mi-cuenta/dentro-de-mi-cuenta/": {
            lang: "es",
            title: "Dentro de Mi Cuenta: Lo que Descubrirás",
            description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
            keywords: "Mi Cuenta, Gestión de Cuenta, Perfil en Excent Capital, Configuración de Cuenta de Trading, Seguridad de Cuenta, Panel de Usuario, Actualización de Perfil, Administrar Cuenta de Trading",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-demo/": {
            lang: "es",
            title: "¿Puedo Crear una Cuenta Demo?",
            description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
            keywords: "Cuenta Demo, Practicar Trading, Demo de Excent Capital, Trading sin Riesgo, Crear Cuenta Demo, Simulador de Trading, Trading para Principiantes, Aprender a Operar",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/crear-cuenta-real/": {
            lang: "es",
            title: "¿Cómo Crear una Cuenta Real?",
            description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
            keywords: "Cuenta Real, Crear Cuenta de Trading, Registro en Excent Capital, Abrir Cuenta Real, Comenzar a Operar, Cuenta de Trading Real, Registro de Trading, Configuración de Cuenta",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta/": {
            lang: "es",
            title: "¿Por Qué Verificar tu Cuenta?",
            description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
            keywords: "Verificación de Cuenta, Verificar Cuenta de Trading, KYC de Excent Capital, Seguridad en Trading, Proceso de Cumplimiento, Verificación de Identidad, Trading Seguro, Acceso Completo a la Cuenta",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/acceder-a-la-plataforma/": {
            lang: "es",
            title: "¿Cómo Accedo a la Plataforma?",
            description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
            keywords: "Acceder a la Plataforma de Trading, Inicio de Sesión en Excent Capital, App de Trading, Plataforma Web de Trading, Trading Móvil, Cómo Iniciar Sesión, Comenzar a Operar, Guía de Acceso a la Plataforma",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/tiempo-para-crear-cuenta/": {
            lang: "es",
            title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
            description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
            keywords: "Tiempo de Creación de Cuenta, Registro en Excent Capital, Cómo Crear una Cuenta, Configuración de Cuenta de Trading, Proceso de Registro, Abrir Cuenta Rápidamente, Inicio en Trading",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuentas-corporativas/": {
            lang: "es",
            title: "¿Ofrecen Cuentas Corporativas?",
            description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
            keywords: "Cuenta Corporativa de Trading, Cuenta Empresarial, Corporativo en Excent Capital, Trading Institucional, Abrir Cuenta Corporativa, Trading Empresarial, Cuenta de Inversión para Empresas",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/cuentas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/cuentas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/varias-cuentas-mismo-correo/": {
            lang: "es",
            title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
            description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
            keywords: "Múltiples Cuentas, Cuentas con el Mismo Correo, Roles en Excent Capital, Roles de Usuario, Gestión de Cuentas, Acceso a Cuenta de Trading, Acceso Basado en Roles, Política de Registro de Correo",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/actualizar-informacion-cuenta/": {
            lang: "es",
            title: "¿Cómo Actualizo la Información de Mi Cuenta?",
            description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
            keywords: "Actualizar Información de Cuenta, Editar Datos Personales, Perfil de Excent Capital, Configuración de Cuenta, Cambiar Información de Cuenta, Actualización de Perfil de Trading, Información del Usuario",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/olvide-mi-contrasena/": {
            lang: "es",
            title: "¿Qué Sucede si Olvido Mi Contraseña?",
            description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
            keywords: "Olvidé la Contraseña, Recuperación de Contraseña, Restablecer Contraseña de Trading, Ayuda para Iniciar Sesión en Excent Capital, Acceso a la Cuenta, Recuperar Contraseña, Contraseña Perdida, Inicio de Sesión en Cuenta de Trading",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/documentos-para-verificacion/": {
            lang: "es",
            title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
            description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
            keywords: "Documentos para Verificación de Cuenta, Requisitos KYC, Verificación en Excent Capital, Comprobante de Identidad, Comprobante de Domicilio, Subir Documentos, Verificación Segura, Cumplimiento en Trading",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/documentos-para-verificacion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Documentos se Requieren para la Verificación de Cuenta?",
                description: "Verifica tu cuenta de Excent Capital enviando una identificación válida y un comprobante de domicilio. Conoce qué documentos son aceptados y cómo subirlos de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cuenta-usada-por-otros/": {
            lang: "es",
            title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
            description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
            keywords: "Compartir Cuenta, Política de Excent Capital, Uso Personal de Cuenta, Seguridad de Cuenta de Trading, Acceso Compartido, Uso Familiar de Cuenta, Seguridad de Cuenta, Cumplimiento en Trading",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Pueden Mis Amigos o Familiares Usar Mi Cuenta de Excent Capital?",
                description: "Por tu seguridad, las cuentas de Excent Capital son estrictamente personales y no deben compartirse. Conoce por qué está prohibido compartir el acceso y cómo mantener tu cuenta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/cancelar-cuenta/": {
            lang: "es",
            title: "¿Cómo Cancelo Mi Cuenta?",
            description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
            keywords: "Cancelar Cuenta de Trading, Cerrar Cuenta de Excent Capital, Terminación de Cuenta, Eliminar Cuenta, Cierre de Cuenta de Trading, Finalizar Cuenta, Soporte de Excent Capital, Proceso de Cancelación de Cuenta",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/cancelar-cuenta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/cancelar-cuenta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Cancelo Mi Cuenta?",
                description: "Si deseas cerrar tu cuenta de Excent Capital, sigue nuestra guía paso a paso para solicitar la cancelación y asegurar que tus datos sean gestionados de forma segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/mi-cuenta/verificar-cuenta-extranjero/": {
            lang: "es",
            title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
            description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
            keywords: "Verificar Cuenta en el Extranjero, Verificación en Excent Capital, Crear Cuenta Desde el Exterior, KYC Internacional, Verificación Remota de Cuenta, Documentos para Cuenta, Verificación Desde el Exterior",
            canonical: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                url: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Verificar Mi Cuenta Desde el Extranjero?",
                description: "Sí, puedes verificar tu cuenta de Excent Capital desde el extranjero. Conoce qué documentos necesitas y cómo completar el proceso de verificación mientras estás fuera del país.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/depositos-retiros/dentro-depositos-retiros/": {
            lang: "es",
            title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
            description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
            keywords: "Depósitos y Retiros, Fondeo en Excent Capital, Retirar Ganancias, Métodos de Pago, Opciones de Depósito, Tiempos de Retiro, Fondeo de Cuenta de Trading, Transacciones Financieras",
            canonical: "https://knowledgebase.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                url: "https://knowledgebase.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos y Retiros: Lo que Descubrirás",
                description: "Conoce todo lo que necesitas saber sobre cómo fondear tu cuenta de Excent Capital y retirar tus ganancias. Explora los métodos disponibles, tiempos de procesamiento y requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/primer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito por Primera Vez?",
            description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
            keywords: "Primer Depósito, Hacer un Depósito, Fondeo en Excent Capital, Depósito en Cuenta de Trading, Cómo Depositar, Métodos de Pago, Comenzar a Operar, Fondear tu Cuenta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.excent.capital/es/depositos-retiros/primer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                url: "https://knowledgebase.excent.capital/es/depositos-retiros/primer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito por Primera Vez?",
                description: "Comienza a operar realizando tu primer depósito en Excent Capital. Sigue nuestra sencilla guía para elegir un método de pago, fondear tu cuenta y empezar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-deposito/": {
            lang: "es",
            title: "¿Cómo Hago un Depósito?",
            description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
            keywords: "Depositar Fondos, Cómo Depositar, Métodos de Pago en Excent Capital, Fondeo de Cuenta de Trading, Realizar un Depósito, Depósito Seguro, Recargar Cuenta, Proceso de Depósito",
            canonical: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                url: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Hago un Depósito?",
                description: "Deposita fondos fácilmente en tu cuenta de Excent Capital utilizando una variedad de métodos de pago seguros. Aprende cómo iniciar y completar tu depósito paso a paso.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/hacer-retiro/": {
            lang: "es",
            title: "¿Cómo Puedo Hacer un Retiro?",
            description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
            keywords: "Retirar Fondos, Retiro en Excent Capital, Cómo Retirar, Pago de Cuenta de Trading, Proceso de Retiro, Retiro Seguro, Acceder a Ganancias, Métodos de Pago",
            canonical: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-retiro",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                url: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-retiro",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Puedo Hacer un Retiro?",
                description: "Retira tus fondos de Excent Capital de forma rápida y segura. Conoce los pasos, requisitos y métodos disponibles para acceder a tus ganancias con facilidad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/depositos-retiros/retiro-fallido/": {
            lang: "es",
            title: "¿Qué Hago si Falla Mi Retiro?",
            description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
            keywords: "Retiro Fallido, Ayuda de Excent Capital, Transacción Fallida, Solución de Problemas de Retiro, Problema de Retiro, Error de Pago, Soporte de Cuenta de Trading, Corregir Problema de Retiro",
            canonical: "https://knowledgebase.excent.capital/es/depositos-retiros/retiro-fallido",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                url: "https://knowledgebase.excent.capital/es/depositos-retiros/retiro-fallido",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Hago si Falla Mi Retiro?",
                description: "Si tu retiro falla en Excent Capital, aprende qué pasos seguir para resolver el problema. Conoce las causas comunes y cómo asegurar una transacción exitosa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "es/pagos/dentro-de-pagos/": {
            lang: "es",
            title: "Dentro de Pagos: Lo que Descubrirás",
            description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
            keywords: "Pagos en Excent Capital, Métodos de Pago Aceptados, Gestión de Transacciones, Tiempo de Procesamiento de Pagos, Divisas Soportadas, Pagos de Trading, Opciones de Depósito y Retiro, Fondeo de Cuenta",
            canonical: "https://knowledgebase.excent.capital/es/pagos/dentro-de-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                url: "https://knowledgebase.excent.capital/es/pagos/dentro-de-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagos: Lo que Descubrirás",
                description: "Explora todo sobre los pagos en Excent Capital, incluyendo métodos aceptados, tiempos de procesamiento, divisas y cómo gestionar tus transacciones sin complicaciones.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/ver-historial-pagos/": {
            lang: "es",
            title: "¿Cómo Veo Mi Historial de Pagos?",
            description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
            keywords: "Historial de Pagos, Historial de Transacciones, Ver Depósitos, Ver Retiros, Pagos en Excent Capital, Transacciones de Cuenta, Historial de Cuenta de Trading, Registros Financieros",
            canonical: "https://knowledgebase.excent.capital/es/pagos/ver-historial-pagos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                url: "https://knowledgebase.excent.capital/es/pagos/ver-historial-pagos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Veo Mi Historial de Pagos?",
                description: "Consulta fácilmente todas tus transacciones en Excent Capital. Aprende cómo ver tu historial de pagos, incluidos depósitos, retiros y el estado de procesamiento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "es/pagos/tiempo-transaccion/": {
            lang: "es",
            title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
            description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
            keywords: "Tiempo de Transacción, Tiempo de Procesamiento, Duración del Depósito, Duración del Retiro, Pagos en Excent Capital, Velocidad de Pago, Transacciones de Cuenta de Trading, Retrasos en Transacciones",
            canonical: "https://knowledgebase.excent.capital/es/pagos/tiempo-transaccion",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                url: "https://knowledgebase.excent.capital/es/pagos/tiempo-transaccion",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Puede Tardar una Transacción?",
                description: "Conoce los tiempos de procesamiento habituales para depósitos y retiros en Excent Capital. Aprende qué factores pueden afectar la velocidad de la transacción y cómo evitar demoras.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        // Potugues
        "pt/": {
            lang: "pt",
            title: "Base de Conhecimento | Excent Capital",
            description: "Explore a Base de Conhecimento da Excent Capital com guias especializados, tutoriais da plataforma, perguntas frequentes sobre trading e recursos desenvolvidos para ajudá-lo a operar com confiança.",
            keywords: "Central de Ajuda Excent Capital, Suporte da Plataforma de Trading, Perguntas Frequentes de Trading, Como Operar, Tutoriais de FX, Gestão de Conta, Guias de Trading, Ajuda com Depósitos, Ajuda com Saques",
            canonical: "https://knowledgebase.excent.capital/es/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en",
                es: "https://knowledgebase.excent.capital/es",
                pt: "https://knowledgebase.excent.capital/pt",
                fr: "https://knowledgebase.excent.capital/fr",
                it: "https://knowledgebase.excent.capital/it",
                zh: "https://knowledgebase.excent.capital/zh",
            },
            openGraph: {
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                url: "https://knowledgebase.excent.capital/es/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de Conocimientos | Excent Capital",
                description: "Explora la Base de Conocimientos de Excent Capital para acceder a guías especializadas, tutoriales de la plataforma, preguntas frecuentes sobre trading y recursos diseñados para ayudarte a operar con confianza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/dentro-sobre-nos/": {
            lang: "pt",
            title: "Dentro de Sobre Nós: O Que Você Vai Descobrir",
            description: "Saiba mais sobre a missão, os valores e a presença global da Excent Capital. Descubra quem somos, o que nos motiva e como capacitamos traders ao redor do mundo.",
            keywords: "Sobre a Excent Capital, Missão da Empresa, Valores da Empresa de Trading, Conheça a Equipe, Quem é a Excent Capital, Nossa História, Empresa de Serviços Financeiros, Visão Geral da Excent Capital",
            canonical: "https://knowledgebase.excent.capital/pt/sobre-nos/dentro-sobre-nos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                url: "https://knowledgebase.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Sobre Nosotros: Lo que Descubrirás",
                description: "Conoce más sobre la misión, los valores y la presencia global de Excent Capital. Descubre quiénes somos, qué nos motiva y cómo empoderamos a los traders en todo el mundo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/sobre-a-excent-capital/": {
            lang: "pt",
            title: "Sobre a Excent Capital",
            description: "Conheça a Excent Capital — nossa história, missão e os princípios que orientam nossa abordagem para capacitar traders nos mercados globais.",
            keywords: "Excent Capital, Sobre Nós, Visão Geral da Empresa, Empresa de Trading, Serviços Financeiros, Firma de Trading, Nossa Missão, Quem Somos, Suporte Global de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                url: "https://knowledgebase.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Sobre Excent Capital",
                description: "Conoce Excent Capital: nuestra historia, misión y los principios que guían nuestro enfoque para empoderar a los traders en los mercados globales.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/construa-seu-portfolio/": {
            lang: "pt",
            title: "Construa Seu Portfólio: Opções Diversificadas na Excent Capital",
            description: "Descubra uma ampla variedade de instrumentos de trading na Excent Capital, incluindo Forex, ações, índices e commodities — tudo o que você precisa para montar um portfólio sólido e diversificado.",
            keywords: "Construir Portfólio, Instrumentos de Trading, Trading de Forex, Mercado de Ações, Trading de Índices, Trading de Commodities, Portfólio Diversificado, Ativos da Excent Capital",
            canonical: "https://knowledgebase.excent.capital/pt/sobre-nos/construa-seu-portfolio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                url: "https://knowledgebase.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construye tu Portafolio: Opciones Diversificadas en Excent Capital",
                description: "Descubre una amplia gama de instrumentos de trading en Excent Capital, incluyendo Forex, acciones, índices y commodities—todo lo que necesitas para construir un portafolio sólido y diversificado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/excent-capital-seu-parceiro-de-confianca/": {
            lang: "pt",
            title: "Excent Capital: Seu Parceiro de Confiança para Diversificar Seus Investimentos nos Mercados Internacionais",
            description: "Associe-se à Excent Capital para expandir globalmente suas oportunidades de investimento. Acesse os mercados internacionais com confiança através de nossa plataforma de trading segura e profissional.",
            keywords: "Excent Capital, Investimentos Internacionais, Diversificar Portfólio, Mercados Globais, Parceiro Confiável de Trading, Trading de Forex, Plataforma Internacional de Trading, Oportunidades de Investimento",
            canonical: "https://knowledgebase.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                url: "https://knowledgebase.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Tu Socio de Confianza para Diversificar tus Inversiones en los Mercados Internacionales",
                description: "Asóciate con Excent Capital para expandir tus oportunidades de inversión a nivel global. Accede a los mercados internacionales con confianza a través de nuestra plataforma de trading segura y profesional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/centro-educacional-excent-capital/": {
            lang: "pt",
            title: "Eleve Seu Trading: Centro Educacional da Excent Capital",
            description: "Acesse cursos, tutoriais e recursos conduzidos por especialistas no Centro Educacional da Excent Capital. Aprenda estratégias de trading e desenvolva suas habilidades — seja você iniciante ou trader avançado.",
            keywords: "Educação em Trading, Aprenda a Operar, Tutoriais de Trading, Cursos de Trading, Educação Excent Capital, Guia de Trading para Iniciantes, Estratégias Avançadas de Trading, Recursos de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                url: "https://knowledgebase.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Impulsa tu Trading: Centro Educativo de Excent Capital",
                description: "Accede a cursos dirigidos por expertos, tutoriales y recursos en el Centro Educativo de Excent Capital. Aprende estrategias de trading y mejora tus habilidades, seas principiante o trader avanzado.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/sobre-nos/invista-com-confianca/": {
            lang: "pt",
            title: "Invista com Confiança: Estratégias e Ferramentas de Gestão de Risco na Excent Capital",
            description: "Domine a gestão de risco com a Excent Capital. Explore ferramentas e estratégias essenciais para proteger seus investimentos e operar com mais confiança em mercados voláteis.",
            keywords: "Gestão de Risco, Ferramentas de Risco em Trading, Proteção de Investimentos, Estratégias da Excent Capital, Trading com Confiança, Volatilidade do Mercado, Ferramentas de Trading, Gerenciar Risco no Trading",
            canonical: "https://knowledgebase.excent.capital/pt/sobre-nos/invista-com-confianca",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                url: "https://knowledgebase.excent.capital/pt/sobre-nos/invista-com-confianca",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Invierte con Confianza: Estrategias y Herramientas de Gestión de Riesgo en Excent Capital",
                description: "Domina la gestión de riesgos con Excent Capital. Explora herramientas y estrategias esenciales para proteger tus inversiones y operar con mayor confianza en mercados volátiles.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/trading/dentro-do-trading/": {
            lang: "pt",
            title: "Dentro do Trading: O Que Você Vai Descobrir",
            description: "Explore conceitos-chave de trading, insights de mercado e funcionalidades da plataforma no centro de trading da Excent Capital. Obtenha o conhecimento necessário para tomar decisões informadas.",
            keywords: "Guia de Trading, Insights de Mercado, Conceitos de Trading, Como Operar, Plataforma Excent Capital, Funcionalidades de Trading, Aprender a Operar, Base de Conhecimento de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/trading/dentro-do-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                url: "https://knowledgebase.excent.capital/pt/trading/dentro-do-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro del Trading: Lo que Descubrirás",
                description: "Explora conceptos clave del trading, perspectivas del mercado y características de la plataforma dentro del centro de trading de Excent Capital. Obtén el conocimiento necesario para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/instrumentos-na-excent-capital/": {
            lang: "pt",
            title: "Instrumentos na Excent Capital",
            description: "Explore toda a gama de instrumentos de trading oferecidos pela Excent Capital, incluindo FX, ações, commodities, índices e muito mais — desenvolvidos para atender aos seus objetivos de investimento.",
            keywords: "Instrumentos de Trading, Forex, Ações, Commodities, Índices, Ativos da Excent Capital, Instrumentos Financeiros, Opções de Investimento, Mercados de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/trading/instrumentos-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                url: "https://knowledgebase.excent.capital/pt/trading/instrumentos-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instrumentos en Excent Capital",
                description: "Explora toda la gama de instrumentos de trading que ofrece Excent Capital, incluyendo FX, acciones, commodities, índices y más—diseñados para adaptarse a tus objetivos de inversión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/alavancagem-na-excent-capital/": {
            lang: "pt",
            title: "Alavancagem Oferecida pela Excent Capital",
            description: "Entenda como funciona a alavancagem na Excent Capital e como ela pode ampliar seu potencial de trading. Conheça nossas opções de alavancagem flexíveis e práticas de operação responsável.",
            keywords: "Trading com Alavancagem, Operar com Alavancagem, Alavancagem na Excent Capital, Trading com Margem, Opções de Alavancagem, Ampliar Trading, Alavancagem em Forex, Trading Responsável",
            canonical: "https://knowledgebase.excent.capital/pt/trading/alavancagem-na-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                url: "https://knowledgebase.excent.capital/pt/trading/alavancagem-na-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Apalancamiento Ofrecido en Excent Capital",
                description: "Entiende cómo funciona el apalancamiento en Excent Capital y cómo puede amplificar tu potencial de trading. Conoce nuestras opciones de apalancamiento flexibles y prácticas responsables de operación.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/micro-lotes-excent-capital/": {
            lang: "pt",
            title: "Micro Lotes na Excent Capital",
            description: "Opere com mais flexibilidade utilizando micro lotes na Excent Capital. Ideal para iniciantes e traders cautelosos que buscam controlar a exposição e testar estratégias.",
            keywords: "Trading com Micro Lotes, Micro Lotes Excent Capital, Trading com Lotes Pequenos, Trading para Iniciantes, Gestão de Risco, Trading Flexível, Micro Lotes de Forex, Trading com Baixa Exposição",
            canonical: "https://knowledgebase.excent.capital/pt/trading/micro-lotes-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                url: "https://knowledgebase.excent.capital/pt/trading/micro-lotes-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotes en Excent Capital",
                description: "Opera con mayor flexibilidad utilizando micro lotes en Excent Capital. Ideal para principiantes y traders que buscan controlar el riesgo y probar estrategias.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/horario-de-trading/": {
            lang: "pt",
            title: "Horários de Trading",
            description: "Fique informado sobre os horários oficiais de trading para todos os mercados disponíveis na Excent Capital. Saiba quando operar Forex, ações, índices e commodities.",
            keywords: "Horários de Trading, Horários de Mercado, Horários de Forex, Horário do Mercado de Ações, Agenda da Excent Capital, Sessões de Trading, Tempos de Trading, Horários do Mercado Financeiro",
            canonical: "https://knowledgebase.excent.capital/pt/trading/horario-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                url: "https://knowledgebase.excent.capital/pt/trading/horario-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Horarios de Trading",
                description: "Mantente informado sobre los horarios oficiales de trading de todos los mercados disponibles en Excent Capital. Conoce cuándo operar en Forex, acciones, índices y commodities.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ferramentas-de-trading/": {
            lang: "pt",
            title: "Ferramentas de Trading",
            description: "Melhore sua experiência de trading com as poderosas ferramentas da Excent Capital. Acesse gráficos, calculadoras, análises de mercado e muito mais para tomar decisões informadas.",
            keywords: "Ferramentas de Trading, Ferramentas de Análise de Mercado, Calculadoras de Trading, Ferramentas de Forex, Plataforma Excent Capital, Recursos de Trading, Ferramentas de Gráficos, Trading Informado",
            canonical: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                url: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading",
                description: "Mejora tu experiencia de trading con las potentes herramientas de Excent Capital. Accede a gráficos, calculadoras, análisis de mercado y más para tomar decisiones informadas.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "pt/trading/ferramentas-de-trading-acuity/": {
            lang: "pt",
            title: "Ferramentas de Trading da Acuity",
            description: "Aproveite as ferramentas com IA da Acuity na Excent Capital para obter insights de mercado, análise de sentimento e decisões de trading mais inteligentes com dados em tempo real.",
            keywords: "Ferramentas de Trading Acuity, Ferramentas de Trading com IA, Análise de Sentimento de Mercado, Insights de Mercado em Tempo Real, Ferramentas da Excent Capital, Insights da Acuity, Trading Inteligente, Análise de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                url: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Herramientas de Trading de Acuity",
                description: "Aprovecha las herramientas impulsadas por IA de Acuity en Excent Capital para obtener perspectivas del mercado, análisis de sentimiento y tomar decisiones de trading más inteligentes basadas en datos en tiempo real.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "pt/trading/chamadas-de-margem/": {
            lang: "pt",
            title: "Chamadas de Margem",
            description: "Entenda como funcionam as chamadas de margem na Excent Capital. Saiba quando elas ocorrem, como gerenciá-las e como proteger sua conta contra liquidações forçadas.",
            keywords: "Chamadas de Margem, O que é uma Chamada de Margem, Margem Excent Capital, Margem de Trading, Liquidação Forçada, Proteção da Conta, Trading com Margem, Gestão de Risco",
            canonical: "https://knowledgebase.excent.capital/pt/trading/chamadas-de-margem",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                url: "https://knowledgebase.excent.capital/pt/trading/chamadas-de-margem",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Llamadas de Margen",
                description: "Entiende cómo funcionan las llamadas de margen en Excent Capital. Aprende cuándo ocurren, cómo gestionarlas y cómo proteger tu cuenta de una liquidación forzada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/trading-de-cfd/": {
            lang: "pt",
            title: "Trading de CFDs",
            description: "Aprenda como operar Contratos por Diferença (CFDs) com a Excent Capital. Acesse mercados globais, opere com alavancagem e posicione-se sobre movimentos de preço sem possuir os ativos.",
            keywords: "Trading de CFDs, Contratos por Diferença, Operar CFDs, CFDs da Excent Capital, Trading com Alavancagem, Trading de Derivativos, Mercados de CFD, Como Operar CFDs",
            canonical: "https://knowledgebase.excent.capital/pt/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                url: "https://knowledgebase.excent.capital/pt/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFDs",
                description: "Aprende a operar Contratos por Diferencia (CFDs) con Excent Capital. Accede a mercados globales, opera con apalancamiento y toma posiciones sobre movimientos de precios sin poseer los activos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/ordens-pendentes/": {
            lang: "pt",
            title: "Ordens Pendentes",
            description: "Descubra como funcionam as ordens pendentes na Excent Capital. Aprenda a definir pontos de entrada com antecedência e automatizar sua estratégia de trading com precisão.",
            keywords: "Ordens Pendentes, Ordens de Trading, Buy Stop, Sell Stop, Ordens Limitadas, Trading Automatizado, Ordens Excent Capital, Pontos de Entrada, Estratégia de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/trading/ordens-pendentes",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                url: "https://knowledgebase.excent.capital/pt/trading/ordens-pendentes",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Órdenes Pendientes",
                description: "Descubre cómo funcionan las órdenes pendientes en Excent Capital. Aprende a establecer puntos de entrada por adelantado y automatiza tu estrategia de trading con precisión.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/spreads-oferecidos/": {
            lang: "pt",
            title: "Spreads Oferecidos",
            description: "Descubra a importância dos spreads e dos spreads de volatilidade nos mercados financeiros. Aprenda a minimizar custos e otimizar sua lucratividade como trader.",
            keywords: "Spreads, Spreads de Volatilidade, Mercados Financeiros, Spreads de Trading, Minimizar Custos de Trading, Otimizar Lucros, Estratégias de Trading, Análise de Spreads, Spreads de Forex, Spreads no Mercado de Ações",
            canonical: "https://knowledgebase.excent.capital/pt/trading/spreads-oferecidos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                url: "https://knowledgebase.excent.capital/pt/trading/spreads-oferecidos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Ofrecidos",
                description: "Descubre la importancia de los spreads y los spreads por volatilidad en los mercados financieros. Aprende a minimizar costos y optimizar tu rentabilidad como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/trading/moedas-base/": {
            lang: "pt",
            title: "Moedas Base",
            description: "Descubra quais moedas base são aceitas na Excent Capital. Escolha a moeda certa para sua conta e simplifique sua experiência de trading e de financiamento.",
            keywords: "Moedas Base, Moedas Suportadas, Conta na Excent Capital, Opções de Moeda de Conta, Seleção de Moeda, Moeda para Trading, Moeda Base em Forex, Opções de Financiamento",
            canonical: "https://knowledgebase.excent.capital/pt/trading/moedas-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                url: "https://knowledgebase.excent.capital/pt/trading/moedas-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Monedas Base",
                description: "Descubre qué monedas base son compatibles en Excent Capital. Elige la divisa adecuada para tu cuenta y simplifica tu experiencia de trading y fondeo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/recursos/dentro-de-recursos/": {
            lang: "pt",
            title: "Dentro de Recursos: O Que Você Vai Descobrir",
            description: "Explore o centro de recursos da Excent Capital com atualizações de mercado, calendários econômicos, ferramentas de trading e conteúdo educacional para apoiar sua jornada como trader.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Atualizações de Mercado, Calendário Econômico, Educação em Trading, Centro de Recursos, Aprenda a Operar, Materiais de Apoio ao Trading",
            canonical: "https://knowledgebase.excent.capital/pt/recursos/dentro-de-recursos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                url: "https://knowledgebase.excent.capital/pt/recursos/dentro-de-recursos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Recursos: Lo que Descubrirás",
                description: "Explora el centro de recursos de Excent Capital para obtener actualizaciones del mercado, calendarios económicos, herramientas de trading y contenido educativo que respalde tu trayectoria como trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-basicos/": {
            lang: "pt",
            title: "Conceitos Básicos",
            description: "Aprenda os conceitos fundamentais do trading com a Excent Capital. Entenda os termos-chave, a mecânica do mercado e o conhecimento essencial para começar sua jornada no trading.",
            keywords: "Conceitos Básicos de Trading, Trading para Iniciantes, Fundamentos do Mercado, Educação Excent Capital, Terminologia de Trading, Guia para Iniciantes, Aprender a Operar, Conceitos Fundamentais",
            canonical: "https://knowledgebase.excent.capital/pt/recursos/conceitos-basicos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                url: "https://knowledgebase.excent.capital/pt/recursos/conceitos-basicos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Básicos",
                description: "Aprende los conceptos fundamentales del trading con Excent Capital. Comprende términos clave, la mecánica del mercado y los conocimientos esenciales para comenzar tu camino en el trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/conceitos-avancados/": {
            lang: "pt",
            title: "Conceitos Avançados",
            description: "Aprofunde seus conhecimentos de trading com os conceitos avançados da Excent Capital. Explore estratégias, indicadores e técnicas usadas por traders experientes.",
            keywords: "Conceitos Avançados de Trading, Estratégias de Trading, Indicadores Técnicos, Trading Avançado, Educação Excent Capital, Análise de Mercado, Ferramentas para Traders Profissionais, Técnicas de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/recursos/conceitos-avancados",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                url: "https://knowledgebase.excent.capital/pt/recursos/conceitos-avancados",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Conceptos Avanzados",
                description: "Profundiza tus conocimientos de trading con los conceptos avanzados de Excent Capital. Explora estrategias, indicadores y técnicas utilizadas por traders experimentados.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/recursos/recursos-adicionais/": {
            lang: "pt",
            title: "Recursos Adicionais",
            description: "Acesse uma variedade de recursos adicionais na Excent Capital, incluindo glossários de trading, guias da plataforma e ferramentas de mercado para melhorar sua experiência de operação.",
            keywords: "Recursos de Trading, Ferramentas da Excent Capital, Glossário de Termos, Guias da Plataforma, Ajuda de Trading, Ferramentas de Mercado, Recursos Educacionais, Suporte ao Trading",
            canonical: "https://knowledgebase.excent.capital/pt/recursos/recursos-adicionais",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                url: "https://knowledgebase.excent.capital/pt/recursos/recursos-adicionais",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Recursos Adicionales",
                description: "Accede a una variedad de recursos adicionales en Excent Capital, incluyendo glosarios de trading, guías de la plataforma y herramientas de mercado para mejorar tu experiencia de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/minha-conta/dentro-da-minha-conta/": {
            lang: "pt",
            title: "Dentro da Minha Conta: O Que Você Vai Descobrir",
            description: "Gerencie sua conta de trading com facilidade na Excent Capital. Aprenda como atualizar seu perfil, acessar configurações da conta, monitorar atividades e manter a segurança.",
            keywords: "Minha Conta, Gestão de Conta, Perfil da Excent Capital, Configurações da Conta de Trading, Segurança da Conta, Painel do Usuário, Atualizações de Perfil, Gerenciar Conta de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/dentro-da-minha-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Mi Cuenta: Lo que Descubrirás",
                description: "Administra tu cuenta de trading fácilmente en Excent Capital. Aprende cómo actualizar tu perfil, acceder a la configuración de la cuenta, monitorear la actividad y mantener la seguridad.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-demo/": {
            lang: "pt",
            title: "Posso Criar uma Conta Demo?",
            description: "Sim, a Excent Capital oferece contas demo para que você possa praticar trading em um ambiente sem riscos. Saiba como abrir uma e começar a explorar a plataforma.",
            keywords: "Conta Demo, Praticar Trading, Demo da Excent Capital, Trading Sem Risco, Criar Conta Demo, Simulador de Trading, Trading para Iniciantes, Aprender a Operar",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Crear una Cuenta Demo?",
                description: "Sí, Excent Capital ofrece cuentas demo para que puedas practicar trading en un entorno sin riesgo. Aprende cómo abrir una y comenzar a explorar la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/criar-conta-real/": {
            lang: "pt",
            title: "Como Criar uma Conta Real?",
            description: "Abra sua conta de trading real na Excent Capital em apenas alguns passos. Siga nosso guia para começar a operar nos mercados reais com segurança e eficiência.",
            keywords: "Conta Real, Criar Conta de Trading, Registro na Excent Capital, Abrir Conta Real, Começar a Operar, Conta Real de Trading, Cadastro de Trading, Configuração de Conta",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-real",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-real",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Crear una Cuenta Real?",
                description: "Abre tu cuenta de trading real con Excent Capital en solo unos pasos. Sigue nuestra guía para comenzar a operar en los mercados reales de forma segura y eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta/": {
            lang: "pt",
            title: "Por Que Verificar Sua Conta?",
            description: "A verificação da conta na Excent Capital garante segurança, conformidade e acesso completo às funcionalidades de trading. Saiba por que é importante e como concluí-la.",
            keywords: "Verificação de Conta, Verificar Conta de Trading, KYC da Excent Capital, Segurança no Trading, Processo de Conformidade, Verificação de Identidade, Trading Seguro, Acesso Completo à Conta",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Por Qué Verificar tu Cuenta?",
                description: "La verificación de cuenta en Excent Capital garantiza seguridad, cumplimiento normativo y acceso completo a las funciones de trading. Conoce por qué es importante y cómo completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/acessar-a-plataforma/": {
            lang: "pt",
            title: "Como Acessar a Plataforma?",
            description: "Acesse a plataforma de trading da Excent Capital facilmente pelo navegador ou dispositivo móvel. Saiba como fazer login e começar a operar a qualquer hora e em qualquer lugar.",
            keywords: "Acessar Plataforma de Trading, Login Excent Capital, Aplicativo de Trading, Plataforma Web de Trading, Trading Móvel, Como Fazer Login, Começar a Operar, Guia de Acesso à Plataforma",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/acessar-a-plataforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/acessar-a-plataforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Accedo a la Plataforma?",
                description: "Accede fácilmente a la plataforma de trading de Excent Capital desde tu navegador o dispositivo móvil. Aprende cómo iniciar sesión y comenzar a operar en cualquier momento y lugar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/tempo-para-criar-conta/": {
            lang: "pt",
            title: "Quanto Tempo Leva para Criar uma Conta?",
            description: "Criar uma conta na Excent Capital é rápido e simples. Descubra quanto tempo leva o processo e quais etapas são necessárias para começar.",
            keywords: "Tempo de Criação de Conta, Cadastro na Excent Capital, Como Criar Conta, Configuração de Conta de Trading, Processo de Registro, Abrir Conta Rápido, Onboarding de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/tempo-para-criar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/tempo-para-criar-contas",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cuánto Tiempo Tarda Crear una Cuenta?",
                description: "Crear una cuenta con Excent Capital es rápido y sencillo. Conoce cuánto tiempo tarda el proceso y qué pasos necesitas seguir para comenzar.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/contas-corporativas/": {
            lang: "pt",
            title: "Vocês Oferecem Contas Corporativas?",
            description: "Sim, a Excent Capital oferece contas corporativas de trading para empresas e instituições. Descubra os benefícios e os requisitos para abrir uma conta corporativa.",
            keywords: "Conta Corporativa de Trading, Conta Empresarial, Corporativo na Excent Capital, Trading Institucional, Abrir Conta Corporativa, Trading para Empresas, Conta de Investimento Corporativa",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/contas-corporativas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/contas-corporativas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Ofrecen Cuentas Corporativas?",
                description: "Sí, Excent Capital ofrece cuentas corporativas de trading para empresas e instituciones. Descubre los beneficios y requisitos para abrir una cuenta corporativa.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/varias-contas-mesmo-email/": {
            lang: "pt",
            title: "Posso Abrir Múltiplas Contas com Diferentes Funções Usando o Mesmo E-mail?",
            description: "Descubra se é possível registrar várias contas da Excent Capital com diferentes funções usando um único endereço de e-mail, e como funciona a gestão de funções na plataforma.",
            keywords: "Múltiplas Contas, Contas com o Mesmo E-mail, Funções na Excent Capital, Funções de Usuário, Gestão de Conta, Acesso à Conta de Trading, Acesso Baseado em Funções, Política de Registro de E-mail",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Puedo Abrir Múltiples Cuentas con Diferentes Roles Usando el Mismo Correo Electrónico?",
                description: "Descubre si puedes registrar múltiples cuentas en Excent Capital con diferentes roles utilizando una sola dirección de correo electrónico y cómo funciona la gestión de roles en la plataforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/atualizar-informacoes-da-conta/": {
            lang: "pt",
            title: "Como Atualizo as Informações da Minha Conta?",
            description: "Atualize facilmente seus dados pessoais e informações da conta na Excent Capital. Siga nosso guia passo a passo para manter suas informações precisas e atualizadas.",
            keywords: "Atualizar Informações da Conta, Editar Dados Pessoais, Perfil Excent Capital, Configurações da Conta, Alterar Informações da Conta, Atualização do Perfil de Trading, Informações do Usuário",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Cómo Actualizo la Información de Mi Cuenta?",
                description: "Actualiza fácilmente tus datos personales y de cuenta en Excent Capital. Sigue nuestra guía paso a paso para mantener tu información precisa y actualizada.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/esqueci-minha-senha/": {
            lang: "pt",
            title: "O Que Acontece se Eu Esquecer Minha Senha?",
            description: "Se você esquecer sua senha, a Excent Capital oferece um processo de recuperação simples e seguro. Aprenda como redefinir sua senha e recuperar o acesso à sua conta.",
            keywords: "Esqueci a Senha, Recuperação de Senha, Redefinir Senha de Trading, Ajuda para Login Excent Capital, Acesso à Conta, Recuperar Senha, Senha Perdida, Login na Conta de Trading",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/esqueci-minha-senha",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/esqueci-minha-senha",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "¿Qué Sucede si Olvido Mi Contraseña?",
                description: "Si olvidas tu contraseña, Excent Capital ofrece un proceso de recuperación seguro y sencillo. Aprende cómo restablecer tu contraseña y recuperar el acceso a tu cuenta.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/documentos-para-verificacao/": {
            lang: "pt",
            title: "Quais Documentos São Necessários para Verificação de Conta?",
            description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
            keywords: "Documentos para Verificação de Conta, Requisitos KYC, Verificação na Excent Capital, Comprovante de Identidade, Comprovante de Endereço, Enviar Documentos, Verificação Segura, Conformidade no Trading",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/documentos-para-verificacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/documentos-para-verificacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quais Documentos São Necessários para Verificação de Conta?",
                description: "Verifique sua conta na Excent Capital enviando um documento de identidade válido e um comprovante de endereço. Saiba quais documentos são aceitos e como enviá-los com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/amigos-familia-usar-conta/": {
            lang: "pt",
            title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
            description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
            keywords: "Compartilhamento de Conta, Política da Excent Capital, Uso Pessoal da Conta, Segurança da Conta de Trading, Acesso Compartilhado, Uso por Familiares, Segurança da Conta, Conformidade em Trading",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Meus Amigos ou Familiares Podem Usar Minha Conta da Excent Capital?",
                description: "Para sua segurança, as contas da Excent Capital são estritamente pessoais e não devem ser compartilhadas. Entenda por que o compartilhamento de acesso é proibido e como manter sua conta segura.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/cancelar-conta/": {
            lang: "pt",
            title: "Como Cancelo Minha Conta?",
            description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
            keywords: "Cancelar Conta de Trading, Encerrar Conta na Excent Capital, Cancelamento de Conta, Excluir Conta, Fechamento de Conta de Trading, Finalizar Conta, Suporte da Excent Capital, Processo de Cancelamento de Conta",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/cancelar-conta",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/cancelar-conta",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Cancelo Minha Conta?",
                description: "Se você deseja encerrar sua conta da Excent Capital, siga nosso guia passo a passo para solicitar o cancelamento e garantir que seus dados sejam tratados com segurança.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/minha-conta/verificar-conta-no-exterior/": {
            lang: "pt",
            title: "Posso Verificar Minha Conta Estando no Exterior?",
            description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
            keywords: "Verificar Conta no Exterior, Verificação Excent Capital, Conta em País Estrangeiro, KYC Internacional, Verificação Remota de Conta, Documentos para Conta, Verificação no Exterior",
            canonical: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                url: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificar Minha Conta Estando no Exterior?",
                description: "Sim, é possível verificar sua conta da Excent Capital mesmo estando fora do país. Veja quais documentos são exigidos e como concluir o processo de verificação internacional.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/depositos-saques/dentro-depositos-retiradas/": {
            lang: "pt",
            title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
            description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
            keywords: "Depósitos e Saques, Fondeamento na Excent Capital, Sacar Lucros, Métodos de Pagamento, Opções de Depósito, Prazos de Saque, Fondeamento da Conta de Trading, Transações Financeiras",
            canonical: "https://knowledgebase.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                url: "https://knowledgebase.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Depósitos e Saques: O Que Você Vai Descobrir",
                description: "Saiba tudo o que você precisa sobre como depositar fundos na sua conta Excent Capital e sacar lucros. Explore os métodos disponíveis, prazos de processamento e requisitos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/primeiro-deposito/": {
            lang: "pt",
            title: "Como Faço Meu Primeiro Depósito?",
            description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
            keywords: "Primeiro Depósito, Fazer um Depósito, Fondeamento Excent Capital, Depósito na Conta de Trading, Como Depositar, Métodos de Pagamento, Começar a Operar, Adicionar Fundos à Conta",
            keywords: "First Deposit, Make a Deposit, Excent Capital Funding, Trading Account Deposit, How to Deposit, Payment Methods, Start Trading, Fund Your Account",
            keywords: "Spreads, Volatility Spreads, Financial Markets, Trading Spreads, Minimize Trading Costs, Optimize Profitability, Trading Strategies, Spread Analysis, Forex Spreads, Stock Market Spreads",
            canonical: "https://knowledgebase.excent.capital/pt/depositos-saques/primeiro-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                url: "https://knowledgebase.excent.capital/pt/depositos-saques/primeiro-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço Meu Primeiro Depósito?",
                description: "Comece a operar fazendo seu primeiro depósito na Excent Capital. Siga nosso guia simples para escolher um método de pagamento, adicionar fundos à sua conta e iniciar sua jornada no trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-deposito/": {
            lang: "pt",
            title: "Como Faço um Depósito?",
            description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
            keywords: "Depositar Fundos, Como Depositar, Métodos de Pagamento Excent Capital, Fondeamento da Conta de Trading, Fazer um Depósito, Depósito Seguro, Recarga da Conta, Processo de Depósito",
            canonical: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                url: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Faço um Depósito?",
                description: "Deposite fundos facilmente na sua conta Excent Capital utilizando uma variedade de métodos de pagamento seguros. Saiba como iniciar e concluir seu depósito passo a passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/fazer-saque/": {
            lang: "pt",
            title: "Como Posso Fazer um Saque?",
            description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
            keywords: "Sacar Fundos, Saque na Excent Capital, Como Sacar, Pagamento da Conta de Trading, Processo de Saque, Saque Seguro, Acessar Ganhos, Métodos de Pagamento",
            canonical: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-saque",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                url: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-saque",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Posso Fazer um Saque?",
                description: "Retire seus fundos da Excent Capital de forma rápida e segura. Aprenda os passos, requisitos e métodos disponíveis para acessar seus ganhos com facilidade.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/depositos-saques/saque-falhou/": {
            lang: "pt",
            title: "O Que Fazer se Meu Saque Falhar?",
            description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
            keywords: "Saque Falhou, Ajuda Excent Capital, Transação Falhada, Resolver Problemas de Saque, Problema no Saque, Erro de Pagamento, Suporte da Conta de Trading, Corrigir Problema de Saque",
            canonical: "https://knowledgebase.excent.capital/pt/depositos-saques/saque-falhou",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                url: "https://knowledgebase.excent.capital/pt/depositos-saques/saque-falhou",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "O Que Fazer se Meu Saque Falhar?",
                description: "Se seu saque falhar na Excent Capital, aprenda quais passos seguir para resolver o problema. Descubra as causas mais comuns e como garantir uma transação bem-sucedida.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "pt/pagamentos/dentro-de-pagamentos/": {
            lang: "pt",
            title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
            description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
            keywords: "Pagamentos Excent Capital, Métodos de Pagamento Aceitos, Gestão de Transações, Tempo de Processamento de Pagamento, Moedas Suportadas, Pagamentos de Trading, Opções de Depósito e Saque, Fondeamento de Conta",
            canonical: "https://knowledgebase.excent.capital/pt/pagamentos/dentro-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                url: "https://knowledgebase.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro de Pagamentos: O Que Você Vai Descobrir",
                description: "Explore tudo sobre pagamentos na Excent Capital, incluindo métodos aceitos, tempos de processamento, moedas suportadas e como gerenciar suas transações de forma eficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/ver-historico-de-pagamentos/": {
            lang: "pt",
            title: "Como Vejo Meu Histórico de Pagamentos?",
            description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
            keywords: "Histórico de Pagamentos, Histórico de Transações, Ver Depósitos, Ver Saques, Pagamentos Excent Capital, Transações da Conta, Histórico da Conta de Trading, Registros Financeiros",
            canonical: "https://knowledgebase.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                url: "https://knowledgebase.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Como Vejo Meu Histórico de Pagamentos?",
                description: "Acompanhe facilmente todas as suas transações na Excent Capital. Aprenda como visualizar seu histórico de pagamentos, incluindo depósitos, saques e status de processamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "pt/pagamentos/tempo-de-transacao/": {
            lang: "pt",
            title: "Quanto Tempo Pode Levar uma Transação?",
            description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
            keywords: "Tempo de Transação, Tempo de Processamento, Duração do Depósito, Duração do Saque, Pagamentos Excent Capital, Velocidade de Pagamento, Transações da Conta de Trading, Atrasos em Transações",
            canonical: "https://knowledgebase.excent.capital/pt/pagamentos/tempo-de-transacao",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                url: "https://knowledgebase.excent.capital/pt/pagamentos/tempo-de-transacao",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Pode Levar uma Transação?",
                description: "Entenda os tempos médios de processamento para depósitos e saques na Excent Capital. Descubra quais fatores podem afetar a velocidade da transação e como evitar atrasos.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        // Frances
        "fr/": {
            lang: "fr",
            title: "Base de connaissances | Excent Capital",
            description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
            keywords: "Centre d’aide Excent Capital, Support de plateforme de trading, FAQ Trading, Comment Trader, Tutoriels FX, Gestion de compte, Guides de Trading, Aide au dépôt, Aide au retrait",
            canonical: "https://knowledgebase.excent.capital/fr/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en",
                es: "https://knowledgebase.excent.capital/es",
                pt: "https://knowledgebase.excent.capital/pt",
                fr: "https://knowledgebase.excent.capital/fr",
                it: "https://knowledgebase.excent.capital/it",
                zh: "https://knowledgebase.excent.capital/zh",
            },
            openGraph: {
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                url: "https://knowledgebase.excent.capital/fr/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Base de connaissances | Excent Capital",
                description: "Explorez la base de connaissances d’Excent Capital pour accéder à des guides d’experts, des tutoriels de plateforme, des FAQ sur le trading et des ressources conçues pour vous aider à trader en toute confiance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-de-nous/": {
            lang: "fr",
            title: "Dans la section À propos : Ce que vous allez découvrir",
            description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
            keywords: "À propos d’Excent Capital, Mission de l’entreprise, Valeurs d’une société de trading, Rencontrer l’équipe, Qui est Excent Capital, Notre histoire, Société de services financiers, Vue d’ensemble d’Excent Capital",
            canonical: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                url: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section À propos : Ce que vous allez découvrir",
                description: "Apprenez-en davantage sur la mission, les valeurs et la présence mondiale d’Excent Capital. Découvrez qui nous sommes, ce qui nous motive et comment nous donnons du pouvoir aux traders dans le monde entier.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/a-propos-d-excent-capital/": {
            lang: "fr",
            title: "À propos d’Excent Capital",
            description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
            keywords: "Excent Capital, À propos de nous, Présentation de l’entreprise, Société de trading, Services financiers, Société de courtage, Notre mission, Qui nous sommes, Support global au trading",
            canonical: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                url: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "À propos d’Excent Capital",
                description: "Faites connaissance avec Excent Capital — notre histoire, notre mission et les principes qui guident notre approche pour accompagner les traders sur les marchés mondiaux.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/construisez-votre-portefeuille/": {
            lang: "fr",
            title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
            description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
            keywords: "Construire un portefeuille, Instruments de trading, Trading Forex, Marché boursier, Trading d’indices, Trading de matières premières, Portefeuille diversifié, Actifs Excent Capital",
            canonical: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                url: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Construisez votre portefeuille : des options diversifiées avec Excent Capital",
                description: "Découvrez une large gamme d’instruments de trading chez Excent Capital, notamment le Forex, les actions, les indices et les matières premières — tout ce qu’il vous faut pour bâtir un portefeuille solide et diversifié.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance/": {
            lang: "fr",
            title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
            description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
            keywords: "Excent Capital, Investissements internationaux, Diversifier son portefeuille, Marchés mondiaux, Partenaire de trading fiable, Trading Forex, Plateforme de trading internationale, Opportunités d’investissement",
            canonical: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                url: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital : votre partenaire de confiance pour diversifier vos investissements sur les marchés internationaux",
                description: "Associez-vous à Excent Capital pour élargir vos opportunités d’investissement à l’échelle mondiale. Accédez aux marchés internationaux en toute confiance grâce à notre plateforme de trading sécurisée et professionnelle.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/centre-educatif-excent-capital/": {
            lang: "fr",
            title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
            description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
            keywords: "Formation en Trading, Apprendre à Trader, Tutoriels de Trading, Cours de Trading, Formation Excent Capital, Guide de Trading Débutant, Stratégies de Trading Avancées, Ressources de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                url: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Améliorez votre trading : le Centre de formation d’Excent Capital",
                description: "Accédez à des cours, tutoriels et ressources dirigés par des experts dans le Centre de formation d’Excent Capital. Apprenez des stratégies de trading et développez vos compétences — que vous soyez débutant ou trader confirmé.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/a-propos-de-nous/investissez-en-confiance/": {
            lang: "fr",
            title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
            description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
            keywords: "Gestion des Risques, Outils de Risque en Trading, Protection des Investissements, Stratégies Excent Capital, Trading en Confiance, Volatilité du Marché, Outils de Trading, Gérer le Risque en Trading",
            canonical: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                url: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investissez en toute confiance : stratégies et outils de gestion des risques chez Excent Capital",
                description: "Maîtrisez la gestion des risques avec Excent Capital. Explorez des outils et des stratégies essentiels pour protéger vos investissements et trader avec plus de confiance dans des marchés volatils.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/trading/a-linterieur-du-trading/": {
            lang: "fr",
            title: "Dans le monde du Trading : Ce que vous allez découvrir",
            description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
            keywords: "Guide de Trading, Perspectives de Marché, Concepts de Trading, Comment Trader, Plateforme Excent Capital, Fonctionnalités de Trading, Apprendre à Trader, Base de Connaissances en Trading",
            canonical: "https://knowledgebase.excent.capital/fr/trading/a-linterieur-du-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                url: "https://knowledgebase.excent.capital/fr/trading/a-linterieur-du-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans le monde du Trading : Ce que vous allez découvrir",
                description: "Explorez les concepts clés du trading, les perspectives de marché et les fonctionnalités de la plateforme dans l’espace de trading d’Excent Capital. Obtenez les connaissances nécessaires pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/instruments-chez-excent-capital/": {
            lang: "fr",
            title: "Instruments chez Excent Capital",
            description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
            keywords: "Instruments de Trading, Forex, Actions, Matières Premières, Indices, Actifs Excent Capital, Instruments Financiers, Options d’Investissement, Marchés de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/trading/instruments-chez-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                url: "https://knowledgebase.excent.capital/fr/trading/instruments-chez-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Instruments chez Excent Capital",
                description: "Découvrez toute la gamme d’instruments de trading proposés par Excent Capital, y compris le Forex, les actions, les matières premières, les indices et bien plus — adaptés à vos objectifs d’investissement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/effet-de-levier-excent-capital/": {
            lang: "fr",
            title: "Effet de levier proposé par Excent Capital",
            description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
            keywords: "Trading avec Effet de Levier, Trading avec Levier, Levier Excent Capital, Trading sur Marge, Options de Levier, Amplifier le Trading, Levier Forex, Trading Responsable",
            canonical: "https://knowledgebase.excent.capital/fr/trading/effet-de-levier-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                url: "https://knowledgebase.excent.capital/fr/trading/effet-de-levier-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Effet de levier proposé par Excent Capital",
                description: "Comprenez comment fonctionne l’effet de levier chez Excent Capital et comment il peut amplifier votre potentiel de trading. Découvrez nos options de levier flexibles et nos pratiques de trading responsable.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/micro-lots-at-excent-capital/": {
            lang: "fr",
            title: "Micro lots chez Excent Capital",
            description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
            keywords: "Trading en Micro Lots, Micro Lots Excent Capital, Trading en Petits Lots, Trading Débutant, Gestion des Risques, Trading Flexible, Micro Lots Forex, Trading à Faible Exposition",
            canonical: "https://knowledgebase.excent.capital/fr/trading/micro-lots-at-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                url: "https://knowledgebase.excent.capital/fr/trading/micro-lots-at-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro lots chez Excent Capital",
                description: "Opérez avec plus de flexibilité grâce aux micro lots chez Excent Capital. Idéal pour les débutants et les traders prudents souhaitant gérer leur exposition et tester des stratégies.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/horaires-de-trading/": {
            lang: "fr",
            title: "Heures de Trading",
            description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
            keywords: "Heures de Trading, Horaires de Marché, Horaires de Trading Forex, Heures du Marché Boursier, Calendrier Excent Capital, Sessions de Trading, Périodes de Trading, Horaires des Marchés Financiers",
            canonical: "https://knowledgebase.excent.capital/fr/trading/horaires-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                url: "https://knowledgebase.excent.capital/fr/trading/horaires-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Heures de Trading",
                description: "Restez informé des heures de trading officielles pour tous les marchés disponibles sur Excent Capital. Sachez quand trader le Forex, les actions, les indices et les matières premières.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/outils-de-trading/": {
            lang: "fr",
            title: "Outils de Trading",
            description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
            keywords: "Outils de Trading, Outils d’Analyse de Marché, Calculateurs de Trading, Outils Forex, Plateforme Excent Capital, Ressources de Trading, Outils de Graphiques, Trading Informé",
            canonical: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                url: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading",
                description: "Améliorez votre expérience de trading avec les puissants outils d’Excent Capital. Accédez à des graphiques, des calculateurs, des analyses de marché et plus encore pour prendre des décisions éclairées.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "fr/trading/outils-de-trading-acuity/": {
            lang: "fr",
            title: "Outils de Trading Acuity",
            description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
            keywords: "Outils de Trading Acuity, Outils de Trading IA, Analyse du Sentiment de Marché, Insights de Marché en Temps Réel, Outils Excent Capital, Insights Acuity, Trading Intelligent, Analytique de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                url: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Outils de Trading Acuity",
                description: "Exploitez les outils basés sur l’IA d’Acuity sur Excent Capital pour obtenir des insights de marché, des analyses de sentiment et prendre des décisions de trading plus intelligentes grâce aux données en temps réel.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "fr/trading/appels-de-marge/": {
            lang: "fr",
            title: "Appels de Marge",
            description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
            keywords: "Appels de Marge, Qu’est-ce qu’un Appel de Marge, Marge Excent Capital, Trading sur Marge, Liquidation Forcée, Protection de Compte, Trading avec Marge, Gestion des Risques",
            canonical: "https://knowledgebase.excent.capital/fr/trading/appels-de-marge",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                url: "https://knowledgebase.excent.capital/fr/trading/appels-de-marge",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Appels de Marge",
                description: "Comprenez comment fonctionnent les appels de marge sur Excent Capital. Apprenez quand ils se produisent, comment les gérer et comment protéger votre compte contre la liquidation forcée.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/trading-de-cfd/": {
            lang: "fr",
            title: "Trading de CFD",
            description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
            keywords: "Trading de CFD, Contrats sur la Différence, Trader les CFD, CFD Excent Capital, Trading avec Effet de Levier, Trading de Produits Dérivés, Marchés CFD, Comment Trader les CFD",
            canonical: "https://knowledgebase.excent.capital/fr/trading/trading-de-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                url: "https://knowledgebase.excent.capital/fr/trading/trading-de-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading de CFD",
                description: "Apprenez à trader les Contrats sur la Différence (CFD) avec Excent Capital. Accédez aux marchés mondiaux, utilisez l’effet de levier et prenez position sur les mouvements de prix sans posséder les actifs.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/ordres-en-attente/": {
            lang: "fr",
            title: "Ordres en Attente",
            description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
            keywords: "Ordres en Attente, Ordres de Trading, Buy Stop, Sell Stop, Ordres Limites, Trading Automatisé, Ordres Excent Capital, Points d’Entrée, Stratégie de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/trading/ordres-en-attente",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                url: "https://knowledgebase.excent.capital/fr/trading/ordres-en-attente",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordres en Attente",
                description: "Découvrez comment fonctionnent les ordres en attente sur Excent Capital. Apprenez à définir vos points d’entrée à l’avance et à automatiser votre stratégie de trading avec précision.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/spreads-offerts/": {
            lang: "fr",
            title: "Spreads Proposés",
            description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
            keywords: "Spreads, Spreads de Volatilité, Marchés Financiers, Spreads de Trading, Réduire les Coûts de Trading, Optimiser la Rentabilité, Stratégies de Trading, Analyse des Spreads, Spreads Forex, Spreads Boursiers",
            canonical: "https://knowledgebase.excent.capital/fr/trading/spreads-offerts",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                url: "https://knowledgebase.excent.capital/fr/trading/spreads-offerts",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spreads Proposés",
                description: "Découvrez l’importance des spreads et des spreads de volatilité sur les marchés financiers. Apprenez à réduire les coûts et à optimiser votre rentabilité en tant que trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/trading/devises-de-base/": {
            lang: "fr",
            title: "Devises de Base",
            description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
            keywords: "Devises de Base, Devises Acceptées, Compte Excent Capital, Options de Devise de Compte, Sélection de Devise, Devise de Trading, Devise de Base Forex, Options de Financement",
            canonical: "https://knowledgebase.excent.capital/fr/trading/devises-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                url: "https://knowledgebase.excent.capital/fr/trading/devises-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Devises de Base",
                description: "Découvrez quelles devises de base sont prises en charge sur Excent Capital. Choisissez la devise adaptée à votre compte et simplifiez votre expérience de trading et de financement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/ressources/a-linterieur-des-ressources/": {
            lang: "fr",
            title: "Dans la section Ressources : Ce que vous allez découvrir",
            description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Mises à Jour du Marché, Calendrier Économique, Formation au Trading, Centre de Ressources, Apprendre à Trader, Supports de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/ressources/a-linterieur-des-ressources",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                url: "https://knowledgebase.excent.capital/fr/ressources/a-linterieur-des-ressources",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Ressources : Ce que vous allez découvrir",
                description: "Explorez le centre de ressources d’Excent Capital pour consulter les mises à jour du marché, les calendriers économiques, les outils de trading et les contenus éducatifs qui soutiendront votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-de-base/": {
            lang: "fr",
            title: "Concepts de Base",
            description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
            keywords: "Concepts de Base en Trading, Trading pour Débutants, Bases du Marché, Formation Excent Capital, Terminologie du Trading, Guide Débutant, Apprendre à Trader, Concepts Fondamentaux",
            canonical: "https://knowledgebase.excent.capital/fr/ressources/concepts-de-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                url: "https://knowledgebase.excent.capital/fr/ressources/concepts-de-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts de Base",
                description: "Apprenez les concepts fondamentaux du trading avec Excent Capital. Comprenez les termes clés, la mécanique des marchés et les connaissances essentielles pour démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/concepts-avances/": {
            lang: "fr",
            title: "Concepts Avancés",
            description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
            keywords: "Concepts Avancés en Trading, Stratégies de Trading, Indicateurs Techniques, Trading Expert, Formation Excent Capital, Analyse de Marché, Outils pour Traders Pros, Techniques de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/ressources/concepts-avances",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                url: "https://knowledgebase.excent.capital/fr/ressources/concepts-avances",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concepts Avancés",
                description: "Approfondissez vos connaissances en trading avec les concepts avancés d’Excent Capital. Explorez les stratégies, indicateurs et techniques utilisés par les traders expérimentés.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/ressources/ressources-supplementaires/": {
            lang: "fr",
            title: "Ressources Supplémentaires",
            description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
            keywords: "Ressources de Trading, Outils Excent Capital, Glossaire de Termes, Guides de Plateforme, Aide au Trading, Outils de Marché, Ressources Éducatives, Support de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/ressources/ressources-supplementaires",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                url: "https://knowledgebase.excent.capital/fr/ressources/ressources-supplementaires",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ressources Supplémentaires",
                description: "Accédez à une variété de ressources supplémentaires chez Excent Capital, y compris des glossaires de trading, des guides de plateforme et des outils de marché pour enrichir votre expérience de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/mon-compte/a-linterieur-de-mon-compte/": {
            lang: "fr",
            title: "Dans Mon Compte : Ce que vous allez découvrir",
            description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
            keywords: "Mon Compte, Gestion de Compte, Profil Excent Capital, Paramètres de Compte de Trading, Sécurité du Compte, Tableau de Bord Utilisateur, Mise à Jour de Profil, Gérer un Compte de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans Mon Compte : Ce que vous allez découvrir",
                description: "Gérez votre compte de trading facilement avec Excent Capital. Apprenez à mettre à jour votre profil, accéder aux paramètres du compte, suivre l’activité et garantir la sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-demo/": {
            lang: "fr",
            title: "Puis-je Créer un Compte Démo ?",
            description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
            keywords: "Compte Démo, Pratique de Trading, Démo Excent Capital, Trading Sans Risque, Créer un Compte Démo, Simulateur de Trading, Trading Débutant, Apprendre à Trader",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je Créer un Compte Démo ?",
                description: "Oui, Excent Capital propose des comptes démo pour vous permettre de pratiquer le trading dans un environnement sans risque. Apprenez comment en ouvrir un et explorer la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/creer-un-compte-reel/": {
            lang: "fr",
            title: "Comment créer un compte réel ?",
            description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
            keywords: "Compte Réel, Créer un Compte de Trading, Inscription Excent Capital, Ouvrir un Compte Réel, Commencer à Trader, Compte de Trading Réel, Inscription au Trading, Configuration de Compte",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-reel",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-reel",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment créer un compte réel ?",
                description: "Ouvrez votre compte de trading réel avec Excent Capital en quelques étapes seulement. Suivez notre guide pour commencer à trader sur les marchés réels de manière sécurisée et efficace.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-votre-compte/": {
            lang: "fr",
            title: "Pourquoi vérifier votre compte ?",
            description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
            keywords: "Vérification de Compte, Vérifier un Compte de Trading, KYC Excent Capital, Sécurité du Trading, Processus de Conformité, Vérification d’Identité, Trading Sécurisé, Accès Complet au Compte",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-votre-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-votre-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Pourquoi vérifier votre compte ?",
                description: "La vérification du compte chez Excent Capital garantit la sécurité, la conformité et l’accès complet à toutes les fonctionnalités de trading. Découvrez pourquoi c’est important et comment finaliser le processus.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/acceder-a-la-plateforme/": {
            lang: "fr",
            title: "Comment accéder à la plateforme ?",
            description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
            keywords: "Accès à la Plateforme de Trading, Connexion Excent Capital, Application de Trading, Plateforme Web de Trading, Trading Mobile, Comment Se Connecter, Commencer à Trader, Guide d’Accès à la Plateforme",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment accéder à la plateforme ?",
                description: "Accédez facilement à la plateforme de trading d’Excent Capital depuis votre navigateur ou appareil mobile. Découvrez comment vous connecter et commencer à trader à tout moment, où que vous soyez.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/delai-pour-creer-un-compte/": {
            lang: "fr",
            title: "Combien de temps faut-il pour créer un compte ?",
            description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
            keywords: "Temps de Création de Compte, Inscription Excent Capital, Comment Créer un Compte, Configuration du Compte de Trading, Processus d’Enregistrement, Ouvrir un Compte Rapidement, Intégration au Trading",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps faut-il pour créer un compte ?",
                description: "Créer un compte chez Excent Capital est rapide et simple. Découvrez combien de temps cela prend et quelles étapes suivre pour commencer.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/comptes-corporatifs/": {
            lang: "fr",
            title: "Proposez-vous des comptes professionnels ?",
            description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
            keywords: "Compte de Trading Professionnel, Compte Entreprise, Compte Corporate Excent Capital, Trading Institutionnel, Ouvrir un Compte Corporate, Trading pour Entreprises, Compte d’Investissement Professionnel",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/comptes-corporatifs",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/comptes-corporatifs",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Proposez-vous des comptes professionnels ?",
                description: "Oui, Excent Capital propose des comptes de trading professionnels pour les entreprises et les institutions. Découvrez les avantages et les exigences pour ouvrir un compte corporate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/plusieurs-comptes-meme-email/": {
            lang: "fr",
            title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
            description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
            keywords: "Comptes Multiples, Comptes avec le Même E-mail, Rôles Excent Capital, Rôles Utilisateur, Gestion de Compte, Accès au Compte de Trading, Accès Basé sur les Rôles, Politique d’Enregistrement par E-mail",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je ouvrir plusieurs comptes avec des rôles différents en utilisant la même adresse e-mail ?",
                description: "Découvrez s’il est possible d’enregistrer plusieurs comptes Excent Capital avec des rôles différents sous une seule adresse e-mail, et comment fonctionne la gestion des rôles sur la plateforme.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mettre-a-jour-informations-compte/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/mot-de-passe-oublie/": {
            lang: "fr",
            title: "Que se passe-t-il si j’oublie mon mot de passe ?",
            description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
            keywords: "Mot de Passe Oublié, Récupération de Mot de Passe, Réinitialiser Mot de Passe Trading, Aide Connexion Excent Capital, Accès au Compte, Récupérer Mot de Passe, Mot de Passe Perdu, Connexion Compte de Trading",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/mot-de-passe-oublie",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que se passe-t-il si j’oublie mon mot de passe ?",
                description: "Si vous oubliez votre mot de passe, Excent Capital propose un processus de récupération simple et sécurisé. Apprenez comment réinitialiser votre mot de passe et retrouver l’accès à votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/documents-pour-verification/": {
            lang: "fr",
            title: "Comment mettre à jour les informations de mon compte ?",
            description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
            keywords: "Mettre à Jour les Infos du Compte, Modifier les Données Personnelles, Profil Excent Capital, Paramètres du Compte, Changer les Informations du Compte, Mise à Jour du Profil de Trading, Informations Utilisateur",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/documents-pour-verification",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/documents-pour-verification",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment mettre à jour les informations de mon compte ?",
                description: "Mettez facilement à jour vos informations personnelles et celles de votre compte sur Excent Capital. Suivez notre guide étape par étape pour garder vos données exactes et à jour.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/amis-famille-utiliser-compte/": {
            lang: "fr",
            title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
            description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
            keywords: "Partage de Compte, Politique Excent Capital, Utilisation Personnelle du Compte, Sécurité du Compte de Trading, Accès Partagé, Utilisation Familiale du Compte, Sécurité du Compte, Conformité en Trading",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Mes amis ou ma famille peuvent-ils utiliser mon compte Excent Capital ?",
                description: "Pour votre sécurité, les comptes Excent Capital sont strictement personnels et ne doivent pas être partagés. Découvrez pourquoi le partage d’accès est interdit et comment sécuriser votre compte.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/annuler-mon-compte/": {
            lang: "fr",
            title: "Comment annuler mon compte",
            description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
            keywords: "Annuler Compte de Trading, Fermer Compte Excent Capital, Résiliation de Compte, Supprimer Compte, Clôture de Compte de Trading, Fermer Compte, Support Excent Capital, Processus d’Annulation de Compte",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/annuler-mon-compte",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/annuler-mon-compte",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment annuler mon compte",
                description: "Si vous souhaitez fermer votre compte Excent Capital, suivez notre guide étape par étape pour demander l’annulation et garantir que vos données soient traitées en toute sécurité.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/mon-compte/verifier-compte-depuis-etranger/": {
            lang: "fr",
            title: "Puis-je vérifier mon compte depuis un pays étranger ?",
            description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
            keywords: "Vérifier Compte à l’Étranger, Vérification Excent Capital, Création de Compte depuis l’Étranger, KYC International, Vérification de Compte à Distance, Documents de Compte, Vérification Hors Pays",
            canonical: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                url: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Puis-je vérifier mon compte depuis un pays étranger ?",
                description: "Oui, vous pouvez vérifier votre compte Excent Capital depuis l’étranger. Découvrez quels documents sont requis et comment finaliser le processus de vérification à distance.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/depots-retraits/a-linterieur-depots-retraits/": {
            lang: "fr",
            title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
            description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
            keywords: "Dépôts et Retraits, Financement Excent Capital, Retirer des Gains, Méthodes de Paiement, Options de Dépôt, Délais de Retrait, Financement du Compte de Trading, Transactions Financières",
            canonical: "https://knowledgebase.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                url: "https://knowledgebase.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Dépôts & Retraits : Ce que vous allez découvrir",
                description: "Découvrez tout ce qu’il faut savoir sur le financement de votre compte Excent Capital et le retrait de vos gains. Explorez les méthodes disponibles, les délais de traitement et les exigences.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/premier-depot/": {
            lang: "fr",
            title: "Comment effectuer un premier dépôt ?",
            description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
            keywords: "Premier Dépôt, Effectuer un Dépôt, Financement Excent Capital, Dépôt Compte de Trading, Comment Déposer, Méthodes de Paiement, Commencer à Trader, Approvisionner Compte",
            canonical: "https://knowledgebase.excent.capital/fr/depots-retraits/premier-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                url: "https://knowledgebase.excent.capital/fr/depots-retraits/premier-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un premier dépôt ?",
                description: "Commencez à trader en effectuant votre premier dépôt sur Excent Capital. Suivez notre guide simple pour choisir une méthode de paiement, approvisionner votre compte et démarrer votre parcours de trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-depot/": {
            lang: "fr",
            title: "Comment effectuer un dépôt ?",
            description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
            keywords: "Déposer des Fonds, Comment Déposer, Méthodes de Paiement Excent Capital, Financement Compte de Trading, Effectuer un Dépôt, Dépôt Sécurisé, Recharger Compte, Processus de Dépôt",
            canonical: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-depot",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                url: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-depot",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un dépôt ?",
                description: "Déposez facilement des fonds sur votre compte Excent Capital en utilisant une variété de méthodes de paiement sécurisées. Apprenez à initier et finaliser votre dépôt étape par étape.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/effectuer-un-retrait/": {
            lang: "fr",
            title: "Comment effectuer un retrait ?",
            description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
            keywords: "Retirer des Fonds, Retrait Excent Capital, Comment Retirer, Paiement Compte de Trading, Processus de Retrait, Retrait Sécurisé, Accéder aux Gains, Méthodes de Paiement",
            canonical: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                url: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment effectuer un retrait ?",
                description: "Retirez vos fonds depuis Excent Capital rapidement et en toute sécurité. Découvrez les étapes, les exigences et les méthodes disponibles pour accéder à vos gains facilement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/depots-retraits/echec-du-retrait/": {
            lang: "fr",
            title: "Que faire si mon retrait échoue ?",
            description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
            keywords: "Retrait Échoué, Aide Excent Capital, Transaction Échouée, Résoudre un Problème de Retrait, Problème de Retrait, Erreur de Paiement, Support Compte de Trading, Corriger un Problème de Retrait",
            canonical: "https://knowledgebase.excent.capital/fr/depots-retraits/echec-du-retrait",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                url: "https://knowledgebase.excent.capital/fr/depots-retraits/echec-du-retrait",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Que faire si mon retrait échoue ?",
                description: "Si votre retrait échoue sur Excent Capital, découvrez les étapes à suivre pour résoudre le problème. Identifiez les causes fréquentes et comment assurer une transaction réussie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "fr/paiements/a-linterieur-des-paiements/": {
            lang: "fr",
            title: "Dans la section Paiements : Ce que vous allez découvrir",
            description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
            keywords: "Paiements Excent Capital, Méthodes de Paiement Acceptées, Gestion des Transactions, Délai de Traitement des Paiements, Devises Supportées, Paiements de Trading, Options de Dépôt et de Retrait, Financement de Compte",
            canonical: "https://knowledgebase.excent.capital/fr/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                url: "https://knowledgebase.excent.capital/fr/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dans la section Paiements : Ce que vous allez découvrir",
                description: "Explorez tout ce qu’il faut savoir sur les paiements chez Excent Capital, y compris les méthodes acceptées, les délais de traitement, les devises supportées et la gestion des transactions.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/voir-historique-paiements/": {
            lang: "fr",
            title: "Comment voir mon historique de paiements ?",
            description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
            keywords: "Historique des Paiements, Historique des Transactions, Voir les Dépôts, Voir les Retraits, Paiements Excent Capital, Transactions du Compte, Historique Compte de Trading, Relevés Financiers",
            canonical: "https://knowledgebase.excent.capital/fr/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                url: "https://knowledgebase.excent.capital/fr/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Comment voir mon historique de paiements ?",
                description: "Suivez facilement toutes vos transactions sur Excent Capital. Apprenez à consulter votre historique de paiements, y compris les dépôts, les retraits et leur statut de traitement.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "fr/paiements/delai-de-transaction/": {
            lang: "fr",
            title: "Combien de temps une transaction peut-elle prendre ?",
            description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
            keywords: "Délai de Transaction, Temps de Traitement, Durée du Dépôt, Durée du Retrait, Paiements Excent Capital, Vitesse de Paiement, Transactions Compte de Trading, Retard de Transactions",
            canonical: "https://knowledgebase.excent.capital/fr/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.excent.capital/it/trading/spreads",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                url: "https://knowledgebase.excent.capital/fr/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Combien de temps une transaction peut-elle prendre ?",
                description: "Comprenez les délais de traitement typiques pour les dépôts et les retraits sur Excent Capital. Découvrez les facteurs qui influencent la rapidité des transactions et comment éviter les retards.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Italiano
        "it/": {
            lang: "it",
            title: "Knowledgebase | Excent Capital",
            description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
            keywords: "Centro Assistenza Excent Capital, Supporto Piattaforma di Trading, FAQ Trading, Come Fare Trading, Tutorial FX, Gestione Account, Guide al Trading, Assistenza Depositi, Assistenza Prelievi",
            canonical: "https://knowledgebase.excent.capital/it/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en",
                es: "https://knowledgebase.excent.capital/es",
                pt: "https://knowledgebase.excent.capital/pt",
                fr: "https://knowledgebase.excent.capital/fr",
                it: "https://knowledgebase.excent.capital/it",
                zh: "https://knowledgebase.excent.capital/zh",
            },
            openGraph: {
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                url: "https://knowledgebase.excent.capital/it/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Knowledgebase | Excent Capital",
                description: "Esplora la Knowledgebase di Excent Capital per accedere a guide esperte, tutorial sulla piattaforma, domande frequenti sul trading e risorse pensate per aiutarti a fare trading con fiducia.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/dentro-di-noi/": {
            lang: "it",
            title: "Dentro Chi Siamo: Cosa Scoprirai",
            description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
            keywords: "Chi è Excent Capital, Missione Aziendale, Valori Società di Trading, Conosci il Team, Chi è Excent Capital, La Nostra Storia, Società di Servizi Finanziari, Panoramica Excent Capital",
            canonical: "https://knowledgebase.excent.capital/it/chi-siamo/dentro-di-noi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                url: "https://knowledgebase.excent.capital/it/chi-siamo/dentro-di-noi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro Chi Siamo: Cosa Scoprirai",
                description: "Scopri di più sulla missione, i valori e la presenza globale di Excent Capital. Scopri chi siamo, cosa ci motiva e come diamo potere ai trader in tutto il mondo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/su-excent-capital/": {
            lang: "it",
            title: "Chi è Excent Capital",
            description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
            keywords: "Excent Capital, Chi Siamo, Panoramica Aziendale, Società di Trading, Servizi Finanziari, Società di Investimenti, La Nostra Missione, Chi Siamo Noi, Supporto al Trading Globale",
            canonical: "https://knowledgebase.excent.capital/it/chi-siamo/su-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                url: "https://knowledgebase.excent.capital/it/chi-siamo/su-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chi è Excent Capital",
                description: "Scopri Excent Capital: la nostra storia, la missione e i principi che guidano il nostro approccio per supportare i trader nei mercati globali.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/costruisci-il-tuo-portafoglio/": {
            lang: "it",
            title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
            description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
            keywords: "Costruire Portafoglio, Strumenti di Trading, Trading Forex, Mercato Azionario, Trading Indici, Trading Materie Prime, Portafoglio Diversificato, Asset di Excent Capital",
            canonical: "https://knowledgebase.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                url: "https://knowledgebase.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Costruisci il Tuo Portafoglio: Opzioni Diversificate con Excent Capital",
                description: "Scopri un’ampia gamma di strumenti di trading su Excent Capital, inclusi Forex, azioni, indici e materie prime — tutto ciò che ti serve per costruire un portafoglio forte e diversificato.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia/": {
            lang: "it",
            title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
            description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
            keywords: "Excent Capital, Investimenti Internazionali, Diversificare Portafoglio, Mercati Globali, Partner Affidabile per il Trading, Trading Forex, Piattaforma di Trading Internazionale, Opportunità di Investimento",
            canonical: "https://knowledgebase.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                url: "https://knowledgebase.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital: Il Tuo Partner Fidato per Diversificare i Tuoi Investimenti sui Mercati Internazionali",
                description: "Collabora con Excent Capital per ampliare le tue opportunità d’investimento a livello globale. Accedi ai mercati internazionali con fiducia tramite la nostra piattaforma di trading sicura e professionale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/centro-educativo-excent-capital/": {
            lang: "it",
            title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
            description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
            keywords: "Formazione sul Trading, Imparare a Fare Trading, Tutorial di Trading, Corsi di Trading, Formazione Excent Capital, Guida al Trading per Principianti, Strategie Avanzate di Trading, Risorse di Trading",
            canonical: "https://knowledgebase.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                url: "https://knowledgebase.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Migliora il Tuo Trading: Il Centro Educativo di Excent Capital",
                description: "Accedi a corsi guidati da esperti, tutorial e risorse nel Centro Educativo di Excent Capital. Impara strategie di trading e migliora le tue competenze — che tu sia un principiante o un trader esperto.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/chi-siamo/investi-con-fiducia/": {
            lang: "it",
            title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
            description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
            keywords: "Gestione del Rischio, Strumenti per il Rischio di Trading, Protezione degli Investimenti, Strategie Excent Capital, Trading con Fiducia, Volatilità di Mercato, Strumenti di Trading, Gestire il Rischio nel Trading",
            canonical: "https://knowledgebase.excent.capital/it/chi-siamo/investi-con-fiducia",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                url: "https://knowledgebase.excent.capital/it/chi-siamo/investi-con-fiducia",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Investi con Fiducia: Strategie e Strumenti per la Gestione del Rischio su Excent Capital",
                description: "Padroneggia la gestione del rischio con Excent Capital. Scopri strumenti e strategie essenziali per proteggere i tuoi investimenti e fare trading con maggiore fiducia in mercati volatili.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/trading/dentro-del-trading-it/": {
            lang: "it",
            title: "Dentro il Trading: Cosa Scoprirai",
            description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
            keywords: "Guida al Trading, Approfondimenti di Mercato, Concetti di Trading, Come Fare Trading, Piattaforma Excent Capital, Funzionalità di Trading, Imparare il Trading, Base di Conoscenza del Trading",
            canonical: "https://knowledgebase.excent.capital/it/trading/dentro-del-trading-it",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                url: "https://knowledgebase.excent.capital/it/trading/dentro-del-trading-it",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Trading: Cosa Scoprirai",
                description: "Esplora i concetti chiave del trading, approfondimenti di mercato e funzionalità della piattaforma all’interno dell’hub di trading di Excent Capital. Ottieni le conoscenze necessarie per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-excent-capital/": {
            lang: "it",
            title: "Strumenti su Excent Capital",
            description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
            keywords: "Strumenti di Trading, Forex, Azioni, Materie Prime, Indici, Asset Excent Capital, Strumenti Finanziari, Opzioni di Investimento, Mercati di Trading",
            canonical: "https://knowledgebase.excent.capital/it/trading/strumenti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                url: "https://knowledgebase.excent.capital/it/trading/strumenti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti su Excent Capital",
                description: "Scopri tutta la gamma di strumenti di trading offerti da Excent Capital, inclusi Forex, azioni, materie prime, indici e molto altro — progettati per soddisfare i tuoi obiettivi di investimento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/leva-excent-capital/": {
            lang: "it",
            title: "Leva Finanziaria Offerta da Excent Capital",
            description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
            keywords: "Trading con Leva, Trading a Leva, Leva Excent Capital, Trading con Margine, Opzioni di Leva, Amplificare il Trading, Leva Forex, Trading Responsabile",
            canonical: "https://knowledgebase.excent.capital/it/trading/leva-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                url: "https://knowledgebase.excent.capital/it/trading/leva-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Leva Finanziaria Offerta da Excent Capital",
                description: "Scopri come funziona la leva finanziaria su Excent Capital e come può amplificare il tuo potenziale nel trading. Esplora le nostre opzioni flessibili di leva e le pratiche di trading responsabile.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/micro-lotti-excent-capital/": {
            lang: "it",
            title: "Micro Lotti su Excent Capital",
            description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
            keywords: "Trading con Micro Lotti, Micro Lotti Excent Capital, Trading con Lotti Piccoli, Trading per Principianti, Gestione del Rischio, Trading Flessibile, Micro Lotti Forex, Trading a Bassa Esposizione",
            canonical: "https://knowledgebase.excent.capital/it/trading/micro-lotti-excent-capital",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                url: "https://knowledgebase.excent.capital/it/trading/micro-lotti-excent-capital",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Micro Lotti su Excent Capital",
                description: "Fai trading con maggiore flessibilità utilizzando i micro lotti su Excent Capital. Ideale per principianti e trader attenti al rischio che desiderano gestire l’esposizione e testare strategie.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/orari-di-trading/": {
            lang: "it",
            title: "Orari di Trading",
            description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
            keywords: "Orari di Trading, Orari di Mercato, Orari Forex, Orari Mercato Azionario, Calendario Excent Capital, Sessioni di Trading, Tempi di Trading, Orari Mercati Finanziari",
            canonical: "https://knowledgebase.excent.capital/it/trading/orari-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                url: "https://knowledgebase.excent.capital/it/trading/orari-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Orari di Trading",
                description: "Rimani aggiornato sugli orari ufficiali di trading per tutti i mercati disponibili su Excent Capital. Scopri quando fare trading su Forex, azioni, indici e materie prime.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/strumenti-di-trading/": {
            lang: "it",
            title: "Strumenti di Trading",
            description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
            keywords: "Strumenti di Trading, Strumenti di Analisi di Mercato, Calcolatori di Trading, Strumenti Forex, Piattaforma Excent Capital, Risorse per il Trading, Strumenti di Analisi Grafica, Trading Informato",
            canonical: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                url: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti di Trading",
                description: "Migliora la tua esperienza di trading con i potenti strumenti di Excent Capital. Accedi a grafici, calcolatori, analisi di mercato e molto altro per prendere decisioni informate.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "it/trading/strumenti-di-trading-acuity/": {
            lang: "it",
            title: "Strumenti Acuity per il Trading",
            description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
            keywords: "Strumenti Acuity per il Trading, Strumenti di Trading AI, Analisi del Sentiment di Mercato, Approfondimenti di Mercato in Tempo Reale, Strumenti Excent Capital, Approfondimenti Acuity, Trading Intelligente, Analisi di Trading",
            canonical: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading-acuity",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                url: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading-acuity",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Strumenti Acuity per il Trading",
                description: "Sfrutta gli strumenti basati sull’intelligenza artificiale di Acuity su Excent Capital per ottenere approfondimenti di mercato, analisi del sentiment e decisioni di trading più intelligenti basate su dati in tempo reale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "it/trading/chiamate-di-margine/": {
            lang: "it",
            title: "Chiamate di Margine",
            description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
            keywords: "Chiamate di Margine, Cos’è una Chiamata di Margine, Margine Excent Capital, Margine di Trading, Liquidazione Forzata, Protezione dell’Account, Trading con Margine, Gestione del Rischio",
            canonical: "https://knowledgebase.excent.capital/it/trading/chiamate-di-margine",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                url: "https://knowledgebase.excent.capital/it/trading/chiamate-di-margine",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Chiamate di Margine",
                description: "Scopri come funzionano le chiamate di margine su Excent Capital. Impara quando si verificano, come gestirle e come proteggere il tuo account dalla liquidazione forzata.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/trading-di-cfd/": {
            lang: "it",
            title: "Trading CFD",
            description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
            keywords: "Trading CFD, Contratti per Differenza, Fare Trading con i CFD, CFD Excent Capital, Trading con Leva, Trading di Derivati, Mercati CFD, Come Fare Trading con i CFD",
            canonical: "https://knowledgebase.excent.capital/it/trading/trading-di-cfd",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                url: "https://knowledgebase.excent.capital/it/trading/trading-di-cfd",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Trading CFD",
                description: "Scopri come fare trading con i Contratti per Differenza (CFD) su Excent Capital. Accedi ai mercati globali, utilizza la leva finanziaria e specula sui movimenti di prezzo senza possedere gli asset.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/ordini-pendenti/": {
            lang: "it",
            title: "Ordini Pendenti",
            description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
            keywords: "Ordini Pendenti, Ordini di Trading, Buy Stop, Sell Stop, Ordini Limit, Trading Automatizzato, Ordini Excent Capital, Punti di Ingresso, Strategia di Trading",
            canonical: "https://knowledgebase.excent.capital/it/trading/ordini-pendenti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                url: "https://knowledgebase.excent.capital/it/trading/ordini-pendenti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Ordini Pendenti",
                description: "Scopri come funzionano gli ordini pendenti su Excent Capital. Impara a impostare punti di ingresso in anticipo e automatizzare la tua strategia di trading con precisione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/spreads-offerti/": {
            lang: "it",
            title: "Spread Offerti",
            description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
            keywords: "Spread, Spread di Volatilità, Mercati Finanziari, Spread di Trading, Ridurre i Costi di Trading, Ottimizzare la Redditività, Strategie di Trading, Analisi degli Spread, Spread Forex, Spread Azionari",
            canonical: "https://knowledgebase.excent.capital/it/trading/spreads-offerti",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                url: "https://knowledgebase.excent.capital/it/trading/spreads-offerti",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Spread Offerti",
                description: "Scopri l’importanza degli spread e degli spread di volatilità nei mercati finanziari. Impara a ridurre i costi e ottimizzare la tua redditività come trader.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/trading/valute-di-base/": {
            lang: "it",
            title: "Valute di Base",
            description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
            keywords: "Valute di Base, Valute Supportate, Conto Excent Capital, Opzioni di Valuta del Conto, Selezione della Valuta, Valuta di Trading, Valuta Base Forex, Opzioni di Finanziamento",
            canonical: "https://knowledgebase.excent.capital/it/trading/valute-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                url: "https://knowledgebase.excent.capital/it/trading/valute-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Valute di Base",
                description: "Scopri quali valute di base sono supportate su Excent Capital. Scegli la valuta giusta per il tuo conto e semplifica l’esperienza di trading e finanziamento.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/risorse/dentro-dei-risorse/": {
            lang: "it",
            title: "Risorse Interne: Cosa Scoprirai",
            description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Aggiornamenti di Mercato, Calendario Economico, Formazione al Trading, Centro Risorse, Impara a Fare Trading, Materiali di Supporto al Trading",
            canonical: "https://knowledgebase.excent.capital/it/risorse/dentro-dei-risorse",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                url: "https://knowledgebase.excent.capital/it/risorse/dentro-dei-risorse",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Interne: Cosa Scoprirai",
                description: "Esplora il centro risorse di Excent Capital per aggiornamenti di mercato, calendari economici, strumenti di trading e contenuti educativi a supporto del tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-di-base/": {
            lang: "it",
            title: "Concetti di Base",
            description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
            keywords: "Concetti Base di Trading, Trading per Principianti, Basi di Mercato, Formazione Excent Capital, Terminologia del Trading, Guida per Principianti, Imparare il Trading, Concetti Fondamentali",
            canonical: "https://knowledgebase.excent.capital/it/risorse/concetti-di-base",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.excent.capital/it/risorse/concetti-di-base",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti di Base",
                description: "Impara i concetti fondamentali del trading con Excent Capital. Comprendi i termini chiave, le dinamiche del mercato e le conoscenze essenziali per iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/concetti-avanzati/": {
            lang: "it",
            title: "Concetti Avanzati",
            description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
            keywords: "Concetti Avanzati di Trading, Strategie di Trading, Indicatori Tecnici, Trading Esperto, Formazione Excent Capital, Analisi di Mercato, Strumenti per Trader Professionisti, Tecniche di Trading",
            canonical: "https://knowledgebase.excent.capital/it/risorse/concetti-avanzati",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                url: "https://knowledgebase.excent.capital/it/risorse/concetti-avanzati",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Concetti Avanzati",
                description: "Approfondisci le tue conoscenze di trading con i concetti avanzati di Excent Capital. Esplora strategie, indicatori e tecniche utilizzate dai trader esperti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/risorse/risorse-addizionali/": {
            lang: "it",
            title: "Risorse Aggiuntive",
            description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
            keywords: "Risorse di Trading, Strumenti Excent Capital, Glossario dei Termini, Guide alla Piattaforma, Aiuto Trading, Strumenti di Mercato, Risorse Educative, Supporto al Trading",
            canonical: "https://knowledgebase.excent.capital/it/risorse/risorse-addizionali",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                url: "https://knowledgebase.excent.capital/it/risorse/risorse-addizionali",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Risorse Aggiuntive",
                description: "Accedi a una varietà di risorse aggiuntive su Excent Capital, inclusi glossari di trading, guide alla piattaforma e strumenti di mercato per migliorare la tua esperienza di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/il-mio-conto/dentro-del-mio-conto/": {
            lang: "it",
            title: "Dentro il Mio Account: Cosa Scoprirai",
            description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
            keywords: "Il Mio Account, Gestione Account, Profilo Excent Capital, Impostazioni Account Trading, Sicurezza Account, Dashboard Utente, Aggiornamento Profilo, Gestire Account Trading",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Dentro il Mio Account: Cosa Scoprirai",
                description: "Gestisci facilmente il tuo account di trading su Excent Capital. Scopri come aggiornare il profilo, accedere alle impostazioni dell'account, monitorare l'attività e mantenere la sicurezza.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-demo/": {
            lang: "it",
            title: "Posso Creare un Account Demo?",
            description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
            keywords: "Account Demo, Trading di Prova, Demo Excent Capital, Trading Senza Rischi, Creare Account Demo, Simulatore di Trading, Trading per Principianti, Impara a Fare Trading",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-demo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Creare un Account Demo?",
                description: "Sì, Excent Capital offre account demo per esercitarti nel trading in un ambiente privo di rischi. Scopri come aprirne uno e iniziare a esplorare la piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/creare-un-conto-reale/": {
            lang: "it",
            title: "Come Creare un Account Reale?",
            description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
            keywords: "Account Reale, Creare Account di Trading, Registrazione Excent Capital, Apri Account Reale, Inizia a Fare Trading, Account di Trading Reale, Iscrizione al Trading, Configurazione Account",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-reale",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Creare un Account Reale?",
                description: "Apri il tuo account di trading reale con Excent Capital in pochi semplici passaggi. Segui la nostra guida per iniziare a fare trading sui mercati reali in modo sicuro ed efficiente.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/perche-verificare-il-conto/": {
            lang: "it",
            title: "Perché Verificare il Tuo Account?",
            description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
            keywords: "Verifica Account, Verificare Account di Trading, KYC Excent Capital, Sicurezza del Trading, Processo di Conformità, Verifica Identità, Trading Sicuro, Accesso Completo Account",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Perché Verificare il Tuo Account?",
                description: "La verifica dell’account su Excent Capital garantisce sicurezza, conformità e accesso completo alle funzionalità di trading. Scopri perché è importante e come completarla.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/accedere-alla-piattaforma/": {
            lang: "it",
            title: "Come Accedere alla Piattaforma?",
            description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
            keywords: "Accedere alla Piattaforma di Trading, Login Excent Capital, App di Trading, Piattaforma Web di Trading, Trading Mobile, Come Effettuare il Login, Inizia a Fare Trading, Guida Accesso Piattaforma",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Accedere alla Piattaforma?",
                description: "Accedi facilmente alla piattaforma di trading Excent Capital dal tuo browser o dispositivo mobile. Scopri come effettuare il login e iniziare a fare trading in qualsiasi momento, ovunque.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/tempo-per-creare-un-conto/": {
            lang: "it",
            title: "Quanto Tempo Ci Vuole per Creare un Account?",
            description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
            keywords: "Tempo Creazione Account, Iscrizione Excent Capital, Come Creare un Account, Configurazione Account di Trading, Processo di Registrazione, Apri un Account Velocemente, Onboarding Trading",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Tempo Ci Vuole per Creare un Account?",
                description: "Creare un account con Excent Capital è veloce e semplice. Scopri quanto dura il processo e quali passaggi sono necessari per iniziare.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conti-corporativi/": {
            lang: "it",
            title: "Offrite Account Aziendali?",
            description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
            keywords: "Account di Trading Aziendale, Account Business, Corporate Excent Capital, Trading Istituzionale, Apri Account Aziendale, Trading per Aziende, Account Investimenti Aziendali",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/conti-corporativi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/conti-corporativi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Offrite Account Aziendali?",
                description: "Sì, Excent Capital offre account di trading aziendali per imprese e istituzioni. Scopri i vantaggi e i requisiti per aprire un account aziendale.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/piu-conti-stessa-email/": {
            lang: "it",
            title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
            description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
            keywords: "Più Account, Account con Stessa Email, Ruoli Excent Capital, Ruoli Utente, Gestione Account, Accesso Account Trading, Accesso Basato su Ruoli, Politica di Registrazione Email",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Aprire Più Account con Ruoli Diversi Usando lo Stesso Indirizzo Email?",
                description: "Scopri se puoi registrare più account Excent Capital con ruoli diversi utilizzando un solo indirizzo email e come funziona la gestione dei ruoli sulla piattaforma.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/aggiornare-informazioni-del-conto/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/password-dimenticata/": {
            lang: "it",
            title: "Cosa Succede se Dimentico la Password?",
            description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
            keywords: "Password Dimenticata, Recupero Password, Reimposta Password Trading, Aiuto Accesso Excent Capital, Accesso Account, Recuperare Password, Password Persa, Login Account Trading",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/password-dimenticata",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/password-dimenticata",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Succede se Dimentico la Password?",
                description: "Se dimentichi la tua password, Excent Capital offre un processo sicuro e semplice per recuperarla. Scopri come reimpostare la password e accedere nuovamente al tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/documenti-per-verifica/": {
            lang: "it",
            title: "Come Posso Aggiornare le Informazioni del Mio Account?",
            description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
            keywords: "Aggiornare Info Account, Modificare Dati Personali, Profilo Excent Capital, Impostazioni Account, Cambiare Informazioni Account, Aggiornamento Profilo Trading, Informazioni Utente",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/documenti-per-verifica",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/documenti-per-verifica",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Aggiornare le Informazioni del Mio Account?",
                description: "Aggiorna facilmente i tuoi dati personali e le informazioni dell’account su Excent Capital. Segui la nostra guida passo passo per mantenere aggiornate le tue informazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/conto-utilizzato-da-terzi/": {
            lang: "it",
            title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
            description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
            keywords: "Condivisione Account, Politica Excent Capital, Uso Personale Account, Sicurezza Account Trading, Accesso Condiviso, Uso da Parte della Famiglia, Sicurezza Account, Conformità nel Trading",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "I Miei Amici o Familiari Possono Usare il Mio Account Excent Capital?",
                description: "Per la tua sicurezza, gli account Excent Capital sono strettamente personali e non possono essere condivisi. Scopri perché è vietato condividere l’accesso e come proteggere il tuo account.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/cancellare-il-conto/": {
            lang: "it",
            title: "Come Posso Cancellare il Mio Account?",
            description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
            keywords: "Cancellare Account Trading, Chiudere Account Excent Capital, Terminazione Account, Eliminare Account, Chiusura Account Trading, Disattivazione Account, Supporto Excent Capital, Processo di Cancellazione Account",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/cancellare-il-conto",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/cancellare-il-conto",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Cancellare il Mio Account?",
                description: "Se desideri chiudere il tuo account Excent Capital, segui la nostra guida passo passo per richiederne la cancellazione e garantire una gestione sicura dei tuoi dati.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/il-mio-conto/verificare-conto-dall-estero/": {
            lang: "it",
            title: "Posso Verificare il Mio Account da un Paese Straniero?",
            description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
            keywords: "Verificare Account dall’Estero, Verifica Excent Capital, Configurazione Account da Paese Straniero, KYC Internazionale, Verifica Remota Account, Documenti Account, Verifica Estera",
            canonical: "https://knowledgebase.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                url: "https://knowledgebase.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Posso Verificare il Mio Account da un Paese Straniero?",
                description: "Sì, puoi verificare il tuo account Excent Capital dall’estero. Scopri quali documenti sono richiesti e come completare il processo di verifica da fuori dal paese.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/depositi-prelievi/dentro-depositi-prelievi/": {
            lang: "it",
            title: "Scopri Depositi e Prelievi: Cosa Troverai",
            description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
            keywords: "Depositi e Prelievi, Finanziamento Excent Capital, Prelevare Profitti, Metodi di Pagamento, Opzioni di Deposito, Tempi di Prelievo, Finanziamento Conto Trading, Transazioni Finanziarie",
            canonical: "https://knowledgebase.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                url: "https://knowledgebase.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri Depositi e Prelievi: Cosa Troverai",
                description: "Scopri tutto ciò che devi sapere su come finanziare il tuo account Excent Capital e prelevare i profitti. Esplora i metodi disponibili, i tempi di elaborazione e i requisiti.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/primo-deposito/": {
            lang: "it",
            title: "Come Effettuare un Primo Deposito?",
            description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
            keywords: "Primo Deposito, Effettuare un Deposito, Finanziamento Excent Capital, Deposito Conto Trading, Come Depositare, Metodi di Pagamento, Inizia a Fare Trading, Finanzia il Tuo Conto",
            canonical: "https://knowledgebase.excent.capital/it/depositi-prelievi/primo-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                url: "https://knowledgebase.excent.capital/it/depositi-prelievi/primo-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Primo Deposito?",
                description: "Inizia a fare trading effettuando il tuo primo deposito su Excent Capital. Segui la nostra semplice guida per scegliere un metodo di pagamento, finanziare il tuo conto e iniziare il tuo percorso di trading.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-deposito/": {
            lang: "it",
            title: "Come Effettuare un Deposito?",
            description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
            keywords: "Deposita Fondi, Come Depositare, Metodi di Pagamento Excent Capital, Finanziamento Conto Trading, Effettuare un Deposito, Deposito Sicuro, Ricarica Account, Processo di Deposito",
            canonical: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                url: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Effettuare un Deposito?",
                description: "Deposita facilmente fondi sul tuo account Excent Capital utilizzando una varietà di metodi di pagamento sicuri. Scopri come iniziare e completare il deposito passo dopo passo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/effettuare-un-prelievo/": {
            lang: "it",
            title: "Come Posso Effettuare un Prelievo?",
            description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
            keywords: "Preleva Fondi, Prelievo Excent Capital, Come Prelevare, Pagamento Conto Trading, Processo di Prelievo, Prelievo Sicuro, Accedere ai Guadagni, Metodi di Pagamento",
            canonical: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                url: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Posso Effettuare un Prelievo?",
                description: "Preleva rapidamente e in modo sicuro i tuoi fondi da Excent Capital. Scopri i passaggi, i requisiti e i metodi disponibili per accedere ai tuoi guadagni con facilità.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/depositi-prelievi/prelievo-non-riuscito/": {
            lang: "it",
            title: "Cosa Fare se il Mio Prelievo Fallisce?",
            description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
            keywords: "Prelievo Fallito, Aiuto Excent Capital, Transazione Fallita, Risoluzione Problema Prelievo, Problemi di Prelievo, Errore di Pagamento, Supporto Conto Trading, Correggere Problema di Prelievo",
            canonical: "https://knowledgebase.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                url: "https://knowledgebase.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Cosa Fare se il Mio Prelievo Fallisce?",
                description: "Se il tuo prelievo fallisce su Excent Capital, scopri quali passaggi seguire per risolvere il problema. Scopri le cause comuni e come garantire una transazione di successo.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "it/paiements/a-linterieur-des-paiements/": {
            lang: "it",
            title: "Scopri i Pagamenti: Cosa Troverai",
            description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
            keywords: "Pagamenti Excent Capital, Metodi di Pagamento Accettati, Gestione Transazioni, Tempo di Elaborazione Pagamenti, Valute Supportate, Pagamenti di Trading, Opzioni di Deposito e Prelievo, Finanziamento Conto",
            canonical: "https://knowledgebase.excent.capital/it/paiements/a-linterieur-des-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                url: "https://knowledgebase.excent.capital/it/paiements/a-linterieur-des-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Scopri i Pagamenti: Cosa Troverai",
                description: "Esplora tutto sui pagamenti su Excent Capital, inclusi i metodi accettati, i tempi di elaborazione, le valute supportate e come gestire al meglio le tue transazioni.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/voir-historique-paiements/": {
            lang: "it",
            title: "Come Vedo lo Storico dei Pagamenti?",
            description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
            keywords: "Storico Pagamenti, Storico Transazioni, Visualizza Depositi, Visualizza Prelievi, Pagamenti Excent Capital, Transazioni Conto, Storico Conto Trading, Registrazioni Finanziarie",
            canonical: "https://knowledgebase.excent.capital/it/paiements/voir-historique-paiements",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                url: "https://knowledgebase.excent.capital/it/paiements/voir-historique-paiements",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Come Vedo lo Storico dei Pagamenti?",
                description: "Tieni traccia facilmente di tutte le tue transazioni su Excent Capital. Scopri come visualizzare lo storico dei pagamenti, inclusi depositi, prelievi e lo stato di elaborazione.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "it/paiements/delai-de-transaction/": {
            lang: "it",
            title: "Quanto Può Durare una Transazione?",
            description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
            keywords: "Tempo Transazione, Tempo di Elaborazione, Durata Deposito, Durata Prelievo, Pagamenti Excent Capital, Velocità di Pagamento, Transazioni Conto Trading, Ritardi nelle Transazioni",
            canonical: "https://knowledgebase.excent.capital/it/paiements/delai-de-transaction",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.excent.capital/zh/trading/spreads",
            },
            openGraph: {
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                url: "https://knowledgebase.excent.capital/it/paiements/delai-de-transaction",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Quanto Può Durare una Transazione?",
                description: "Scopri i tempi tipici di elaborazione per depositi e prelievi su Excent Capital. Scopri quali fattori possono influenzare la velocità delle transazioni e come evitare ritardi.",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        //Cantones
        //Italiano
        "zh/": {
            lang: "zh-HK",
            title: "知識庫 | Excent Capital",
            description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
            keywords: "Excent Capital 幫助中心, 交易平台支援, 交易常見問題, 如何交易, 外匯教學, 帳戶管理, 交易指南, 存款協助, 提款協助",
            canonical: "https://knowledgebase.excent.capital/zh/",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en",
                es: "https://knowledgebase.excent.capital/es",
                pt: "https://knowledgebase.excent.capital/pt",
                fr: "https://knowledgebase.excent.capital/fr",
                it: "https://knowledgebase.excent.capital/it",
                zh: "https://knowledgebase.excent.capital/zh",
            },
            openGraph: {
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                url: "https://knowledgebase.excent.capital/zh/",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "知識庫 | Excent Capital",
                description: "瀏覽 Excent Capital 的知識庫，獲取專家指引、平台教學、交易常見問題解答，以及幫助你有信心進行交易的資源。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/inside-about-us-zh/": {
            lang: "zh-HK",
            title: "關於我們：你將發現什麼",
            description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
            keywords: "關於 Excent Capital, 公司使命, 交易公司價值觀, 認識團隊, 誰是 Excent Capital, 我們的故事, 金融服務公司, Excent Capital 概覽",
            canonical: "https://knowledgebase.excent.capital/zh/about-us-zh/inside-about-us-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/inside-about-us",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/dentro-de-acerca-de-nosotros",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/dentro-sobre-nos",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-de-nous",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/dentro-di-noi",
                zh: "https://knowledgebase.excent.capital/zh/about-us-zh/inside-about-us-zh",
            },
            openGraph: {
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                url: "https://knowledgebase.excent.capital/zh/about-us-zh/inside-about-us-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於我們：你將發現什麼",
                description: "深入了解 Excent Capital 的使命、價值觀和全球佈局。發掘我們是誰、我們的動力來源，以及我們如何在全球範圍內賦能交易者。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/about-excent-capital-zh/": {
            lang: "zh-HK",
            title: "關於 Excent Capital",
            description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
            keywords: "Excent Capital, 關於我們, 公司概況, 交易公司, 金融服務, 交易機構, 我們的使命, 我們是誰, 全球交易支援",
            canonical: "https://knowledgebase.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/about-excent-capital",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/acerca-de-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/sobre-a-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/a-propos-d-excent-capital",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/su-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/about-us-zh/about-excent-capital-zh",
            },
            openGraph: {
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                url: "https://knowledgebase.excent.capital/zh/about-us-zh/about-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "關於 Excent Capital",
                description: "認識 Excent Capital —— 我們的歷史、使命，以及指導我們如何在全球市場賦能交易者的原則。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/build-your-portfolio-zh/": {
            lang: "zh-HK",
            title: "建立您的投資組合：Excent Capital 的多樣化選擇",
            description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
            keywords: "建立投資組合, 交易工具, 外匯交易, 股市, 指數交易, 商品交易, 多元化投資組合, Excent Capital 資產",
            canonical: "https://knowledgebase.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/build-your-portfolio",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/construye-tu-portafolio",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/construa-seu-portfolio",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/construisez-votre-portefeuille",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/costruisci-il-tuo-portafoglio",
                zh: "https://knowledgebase.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
            },
            openGraph: {
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                url: "https://knowledgebase.excent.capital/zh/about-us-zh/build-your-portfolio-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "建立您的投資組合：Excent Capital 的多樣化選擇",
                description: "探索 Excent Capital 提供的各種交易工具，包括外匯、股票、指數和商品——助你建立穩健且具多樣性的投資組合所需的一切。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-your-trusted-partner-zh/": {
            lang: "zh-HK",
            title: "Excent Capital：助您分散國際市場投資的可信伙伴",
            description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
            keywords: "Excent Capital, 國際投資, 分散投資組合, 全球市場, 可信交易伙伴, 外匯交易, 國際交易平台, 投資機會",
            canonical: "https://knowledgebase.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-your-trusted-partner",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/excent-capital-tu-socio-de-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/excent-capital-seu-parceiro-de-confianca",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/excent-capital-votre-partenaire-de-confiance",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/excent-capital-il-tuo-partner-di-fiducia",
                zh: "https://knowledgebase.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
            },
            openGraph: {
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                url: "https://knowledgebase.excent.capital/zh/about-us-zh/excent-capital-your-trusted-partner-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital：助您分散國際市場投資的可信伙伴",
                description: "與 Excent Capital 合作，擴展您的全球投資機會。透過我們安全且專業的交易平台，自信進入國際市場。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/excent-capital-education-center-zh/": {
            lang: "zh-HK",
            title: "提升你的交易能力：Excent Capital 教育中心",
            description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
            keywords: "交易教育, 學習交易, 交易教學, 交易課程, Excent Capital 教育, 初學者交易指南, 高級交易策略, 交易資源",
            canonical: "https://knowledgebase.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/excent-capital-education-center",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/centro-educativo-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/centro-educacional-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/centre-educatif-excent-capital",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/centro-educativo-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
            },
            openGraph: {
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                url: "https://knowledgebase.excent.capital/zh/about-us-zh/excent-capital-education-center-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "提升你的交易能力：Excent Capital 教育中心",
                description: "在 Excent Capital 的教育中心參加由專家主導的課程、教學及資源。不論你是初學者或進階交易者，學習交易策略並提升你的技能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/about-us-zh/invest-with-confidence-zh/": {
            lang: "zh-HK",
            title: "自信投資：Excent Capital 的風險管理策略與工具",
            description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
            keywords: "風險管理, 交易風險工具, 投資保護, Excent Capital 策略, 自信交易, 市場波動性, 交易工具, 管理交易風險",
            canonical: "https://knowledgebase.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/about-us/invest-with-confidence",
                es: "https://knowledgebase.excent.capital/es/sobre-nosotros/invierte-con-confianza",
                pt: "https://knowledgebase.excent.capital/pt/sobre-nos/invista-com-confianca",
                fr: "https://knowledgebase.excent.capital/fr/a-propos-de-nous/investissez-en-confiance",
                it: "https://knowledgebase.excent.capital/it/chi-siamo/investi-con-fiducia",
                zh: "https://knowledgebase.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
            },
            openGraph: {
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                url: "https://knowledgebase.excent.capital/zh/about-us-zh/invest-with-confidence-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "自信投資：Excent Capital 的風險管理策略與工具",
                description: "掌握 Excent Capital 的風險管理。探索保護投資並在波動市場中更有信心交易的關鍵工具與策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/trading-zh/inside-trading-zh/": {
            lang: "zh-HK",
            title: "交易內幕：你將發現的內容",
            description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
            keywords: "交易指南, 市場見解, 交易概念, 如何交易, Excent Capital 平台, 交易功能, 學習交易, 交易知識庫",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/inside-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/inside-trading",
                es: "https://knowledgebase.excent.capital/es/trading/dentro-del-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/dentro-do-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/a-linterieur-du-trading",
                it: "https://knowledgebase.excent.capital/it/trading/dentro-del-trading-it",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/inside-trading-zh",
            },
            openGraph: {
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/inside-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易內幕：你將發現的內容",
                description: "深入探索 Excent Capital 交易中心中的關鍵交易概念、市場見解與平台功能。獲得做出明智決策所需的知識。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/instruments-in-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的交易工具",
            description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
            keywords: "交易工具, 外匯, 股票, 商品, 指數, Excent Capital 資產, 金融工具, 投資選項, 交易市場",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/instruments-in-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/instrumentos-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/instrumentos-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/instruments-chez-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/strumenti-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/instruments-in-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的交易工具",
                description: "探索 Excent Capital 提供的完整交易工具，包括外匯、股票、商品、指數等，幫助你實現投資目標。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/leverage-offered-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 提供的槓桿",
            description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
            keywords: "槓桿交易, 使用槓桿進行交易, Excent Capital 槓桿, 保證金交易, 槓桿選項, 放大交易, 外匯槓桿, 負責任交易",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/leverage-offered-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/apalancamiento-en-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/alavancagem-na-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/effet-de-levier-excent-capital",
                it: "https://knowledgebase.excent.capital/it/it/trading/leva-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/leverage-offered-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 提供的槓桿",
                description: "了解 Excent Capital 的槓桿運作方式，以及如何放大你的交易潛力。認識我們靈活的槓桿選項與負責任的交易做法。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/micro-lots-at-excent-capital-zh/": {
            lang: "zh-HK",
            title: "Excent Capital 的微型手數交易",
            description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
            keywords: "微型手數交易, Excent Capital 微型手數, 小手數交易, 初學者交易, 風險管理, 靈活交易, 外匯微型手數, 低風險交易",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/micro-lots-at-excent-capital",
                es: "https://knowledgebase.excent.capital/es/trading/micro-lotes-excent-capital",
                pt: "https://knowledgebase.excent.capital/pt/trading/micro-lotes-excent-capital",
                fr: "https://knowledgebase.excent.capital/fr/trading/micro-lots-at-excent-capital",
                it: "https://knowledgebase.excent.capital/it/trading/micro-lotti-excent-capital",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
            },
            openGraph: {
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/micro-lots-at-excent-capital-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Excent Capital 的微型手數交易",
                description: "利用 Excent Capital 的微型手數進行更靈活的交易。適合初學者與風險意識高的交易者，便於控制風險與測試策略。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-hours-zh/": {
            lang: "zh-HK",
            title: "交易時間",
            description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
            keywords: "交易時間, 市場開市時間, 外匯交易時間, 股票市場時間, Excent Capital 時間表, 交易時段, 交易時機, 金融市場時間",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/trading-hours-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-hours",
                es: "https://knowledgebase.excent.capital/es/trading/horario-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/horario-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/horaires-de-trading",
                it: "https://knowledgebase.excent.capital/it/trading/orari-di-trading",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/trading-hours-zh",
            },
            openGraph: {
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/trading-hours-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易時間",
                description: "掌握 Excent Capital 提供的所有市場的官方交易時間。了解何時可交易外匯、股票、指數及商品。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/trading-tools-zh/": {
            lang: "zh-HK",
            title: "交易工具",
            description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
            keywords: "交易工具, 市場分析工具, 交易計算機, 外匯工具, Excent Capital 平台, 交易資源, 繪圖工具, 明智交易",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/trading-tools",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading",
                fr: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading",
                it: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/trading-tools-zh",
            },
            openGraph: {
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "交易工具",
                description: "透過 Excent Capital 提供的強大交易工具提升你的交易體驗。使用圖表、計算機、市場分析等功能，助你做出明智決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        /* [OCULTO 2026-08-01] Articulo "Acuity Trading Tools" deshabilitado: no genera HTML estatico ni entra en el <nav> de crawling.
        "zh/trading-zh/acuity-trading-tools-zh/": {
            lang: "zh-HK",
            title: "Acuity 交易工具",
            description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
            keywords: "Acuity 交易工具, AI 交易工具, 市場情緒分析, 即時市場洞察, Excent Capital 工具, Acuity 洞察, 智能交易, 交易分析",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/acuity-trading-tool",
                es: "https://knowledgebase.excent.capital/es/trading/herramientas-de-trading-acuity",
                pt: "https://knowledgebase.excent.capital/pt/trading/ferramentas-de-trading-acuity",
                fr: "https://knowledgebase.excent.capital/fr/trading/outils-de-trading-acuity",
                it: "https://knowledgebase.excent.capital/it/trading/strumenti-di-trading-acuity",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
            },
            openGraph: {
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/acuity-trading-tools-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "Acuity 交易工具",
                description: "利用 Acuity 的人工智能工具於 Excent Capital 獲取市場洞察、情緒分析，並根據即時數據作出更聰明的交易決策。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        */
        "zh/trading-zh/margin-calls-zh/": {
            lang: "zh-HK",
            title: "追加保證金通知（Margin Calls）",
            description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
            keywords: "追加保證金通知, 什麼是追加保證金, Excent Capital 保證金, 交易保證金, 強制平倉, 帳戶保護, 保證金交易, 風險管理",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/margin-calls-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/margin-calls",
                es: "https://knowledgebase.excent.capital/es/trading/llamadas-de-margen",
                pt: "https://knowledgebase.excent.capital/pt/trading/chamadas-de-margem",
                fr: "https://knowledgebase.excent.capital/fr/trading/appels-de-marge",
                it: "https://knowledgebase.excent.capital/it/trading/chiamate-di-margine",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/margin-calls-zh",
            },
            openGraph: {
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/margin-calls-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "追加保證金通知（Margin Calls）",
                description: "了解 Excent Capital 上的追加保證金機制。學習追加保證金何時出現、如何應對，及如何保護帳戶免受強制平倉影響。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/cfd-trading-zh/": {
            lang: "zh-HK",
            title: "差價合約（CFD）交易",
            description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
            keywords: "CFD 交易, 差價合約, 交易 CFD, Excent Capital CFD, 槓桿交易, 衍生工具交易, CFD 市場, 如何交易 CFD",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/cfd-trading-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/cfd-trading",
                es: "https://knowledgebase.excent.capital/es/trading/trading-de-cfd",
                pt: "https://knowledgebase.excent.capital/pt/trading/trading-de-cfd",
                fr: "https://knowledgebase.excent.capital/fr/trading/trading-de-cfd",
                it: "https://knowledgebase.excent.capital/it/trading/trading-di-cfd",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/cfd-trading-zh",
            },
            openGraph: {
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/cfd-trading-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "差價合約（CFD）交易",
                description: "學習如何在 Excent Capital 進行差價合約（CFD）交易。進入全球市場，利用槓桿進行交易，並捕捉價格變動而無需擁有資產。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/pending-orders-zh/": {
            lang: "zh-HK",
            title: "掛單交易（Pending Orders）",
            description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
            keywords: "掛單交易, 交易指令, 買入止損, 賣出止損, 限價單, 自動化交易, Excent Capital 指令, 入市點, 交易策略",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/pending-orders-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/pending-orders",
                es: "https://knowledgebase.excent.capital/es/trading/ordenes-pendientes",
                pt: "https://knowledgebase.excent.capital/pt/trading/ordens-pendentes",
                fr: "https://knowledgebase.excent.capital/fr/trading/ordres-en-attente",
                it: "https://knowledgebase.excent.capital/it/trading/ordini-pendenti",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/pending-orders-zh",
            },
            openGraph: {
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/pending-orders-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "掛單交易（Pending Orders）",
                description: "了解在 Excent Capital 如何使用掛單。提前設定入市點，自動化執行你的交易策略，提高交易效率與精準度。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/spreads-offered-zh/": {
            lang: "zh-HK",
            title: "點差介紹",
            description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
            keywords: "點差, 波動點差, 金融市場, 交易點差, 降低交易成本, 提高盈利能力, 交易策略, 點差分析, 外匯點差, 股票市場點差",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/spreads-offered-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/spreads-offered",
                es: "https://knowledgebase.excent.capital/es/trading/spreads-ofrecidos",
                pt: "https://knowledgebase.excent.capital/pt/trading/spreads-oferecidos",
                fr: "https://knowledgebase.excent.capital/fr/trading/spreads-offerts",
                it: "https://knowledgebase.excent.capital/it/trading/spreads-offerti",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/spreads-offered-zh",
            },
            openGraph: {
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/spreads-offered-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "點差介紹",
                description: "了解金融市場中點差與波動點差的重要性。學習如何降低成本並提升交易盈利能力。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/trading-zh/base-currencies-zh/": {
            lang: "zh-HK",
            title: "基礎貨幣",
            description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
            keywords: "基礎貨幣, 支援貨幣, Excent Capital 帳戶, 帳戶貨幣選項, 貨幣選擇, 交易貨幣, 外匯基礎貨幣, 資金選項",
            canonical: "https://knowledgebase.excent.capital/zh/trading-zh/base-currencies-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/trading/base-currencies",
                es: "https://knowledgebase.excent.capital/es/trading/monedas-base",
                pt: "https://knowledgebase.excent.capital/pt/trading/moedas-base",
                fr: "https://knowledgebase.excent.capital/fr/trading/devises-de-base",
                it: "https://knowledgebase.excent.capital/it/trading/valute-di-base",
                zh: "https://knowledgebase.excent.capital/zh/trading-zh/base-currencies-zh",
            },
            openGraph: {
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                url: "https://knowledgebase.excent.capital/zh/trading-zh/base-currencies-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎貨幣",
                description: "了解 Excent Capital 支援哪些基礎貨幣。選擇合適的帳戶貨幣，簡化你的交易與資金操作體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/resources-zh/inside-resources-zh/": {
            lang: "zh-HK",
            title: "資源中心導覽",
            description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
            keywords: "交易資源, Excent Capital 工具, 市場更新, 經濟日曆, 交易教學, 資源中心, 學習交易, 交易輔助材料",
            canonical: "https://knowledgebase.excent.capital/zh/resources-zh/inside-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/inside-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/dentro-de-recursos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/dentro-de-recursos",
                fr: "https://knowledgebase.excent.capital/fr/ressources/a-linterieur-des-ressources",
                it: "https://knowledgebase.excent.capital/it/risorse/dentro-dei-risorse",
                zh: "https://knowledgebase.excent.capital/zh/resources-zh/inside-resources-zh",
            },
            openGraph: {
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                url: "https://knowledgebase.excent.capital/zh/resources-zh/inside-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "資源中心導覽",
                description: "探索 Excent Capital 的資源中心，包括市場更新、經濟日曆、交易工具與教育內容，全面支持你的交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/basic-concepts-zh/": {
            lang: "zh-HK",
            title: "基礎概念",
            description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
            keywords: "交易基礎概念, 初學者交易, 市場基礎知識, Excent Capital 教育, 交易術語, 初學者指南, 學習交易, 基礎知識",
            canonical: "https://knowledgebase.excent.capital/zh/resources-zh/basic-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/basic-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-basicos",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-basicos",
                fr: "https://knowledgebase.excent.capital/fr/ressources/concepts-de-base",
                it: "https://knowledgebase.excent.capital/it/risorse/concetti-di-base",
                zh: "https://knowledgebase.excent.capital/zh/resources-zh/basic-concepts-zh",
            },
            openGraph: {
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                url: "https://knowledgebase.excent.capital/zh/resources-zh/basic-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "基礎概念",
                description: "學習 Excent Capital 的交易基礎概念。了解關鍵術語、市場運作機制，為你的交易旅程打下堅實基礎。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/advanced-concepts-zh/": {
            lang: "zh-HK",
            title: "進階概念",
            description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
            keywords: "進階交易概念, 交易策略, 技術指標, 專業交易, Excent Capital 教育, 市場分析, 專業交易工具, 交易技巧",
            canonical: "https://knowledgebase.excent.capital/zh/resources-zh/advanced-concepts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/advanced-concepts",
                es: "https://knowledgebase.excent.capital/es/recursos/conceptos-avanzados",
                pt: "https://knowledgebase.excent.capital/pt/recursos/conceitos-avancados",
                fr: "https://knowledgebase.excent.capital/fr/ressources/concepts-avances",
                it: "https://knowledgebase.excent.capital/it/risorse/concetti-avanzati",
                zh: "https://knowledgebase.excent.capital/zh/resources-zh/advanced-concepts-zh",
            },
            openGraph: {
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                url: "https://knowledgebase.excent.capital/zh/resources-zh/advanced-concepts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "進階概念",
                description: "透過 Excent Capital 深入了解進階交易概念。探索專業交易者使用的策略、指標與技巧。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/resources-zh/additional-resources-zh/": {
            lang: "zh-HK",
            title: "額外資源",
            description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
            keywords: "交易資源, Excent Capital 工具, 詞彙表, 平台指南, 交易協助, 市場工具, 教育資源, 交易支援",
            canonical: "https://knowledgebase.excent.capital/zh/resources-zh/additional-resources-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/resources/additional-resources",
                es: "https://knowledgebase.excent.capital/es/recursos/recursos-adicionales",
                pt: "https://knowledgebase.excent.capital/pt/recursos/recursos-adicionais",
                fr: "https://knowledgebase.excent.capital/fr/ressources/ressources-supplementaires",
                it: "https://knowledgebase.excent.capital/it/risorse/risorse-addizionali",
                zh: "https://knowledgebase.excent.capital/zh/resources-zh/additional-resources-zh",
            },
            openGraph: {
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                url: "https://knowledgebase.excent.capital/zh/resources-zh/additional-resources-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "額外資源",
                description: "使用 Excent Capital 的多元資源，包括交易詞彙表、平台指南與市場工具，提升你的交易體驗。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/my-account-zh/inside-my-account-zh/": {
            lang: "zh-HK",
            title: "我的帳戶導覽",
            description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
            keywords: "我的帳戶, 帳戶管理, Excent Capital 個人資料, 交易帳戶設定, 帳戶安全, 使用者儀表板, 資料更新, 管理交易帳戶",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/inside-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/inside-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/dentro-de-mi-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/dentro-da-minha-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/a-linterieur-de-mon-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/dentro-del-mio-conto",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/inside-my-account-zh",
            },
            openGraph: {
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/inside-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的帳戶導覽",
                description: "輕鬆管理你在 Excent Capital 的交易帳戶。學習如何更新個人資料、設定帳戶、監控活動並確保帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-to-create-a-demo-account-zh/": {
            lang: "zh-HK",
            title: "我可以開設模擬帳戶嗎？",
            description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
            keywords: "模擬帳戶, 練習交易, Excent Capital 模擬, 無風險交易, 建立模擬帳戶, 交易模擬器, 初學者交易, 學習交易",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-to-create-a-demo-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-demo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-demo",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-demo",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-demo",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
            },
            openGraph: {
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/can-to-create-a-demo-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以開設模擬帳戶嗎？",
                description: "可以，Excent Capital 提供模擬帳戶，讓你在無風險的環境下練習交易。了解如何開設並開始體驗平台功能。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-to-create-a-live-account-zh/": {
            lang: "zh-HK",
            title: "如何開立真實帳戶？",
            description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
            keywords: "真實帳戶, 建立交易帳戶, Excent Capital 註冊, 開立真實帳戶, 開始交易, 真實交易帳戶, 交易註冊, 帳戶設置",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-to-create-a-live-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/crear-cuenta-real",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/criar-conta-real",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/creer-un-compte-reel",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/creare-un-conto-reale",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
            },
            openGraph: {
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/how-to-create-a-live-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何開立真實帳戶？",
                description: "只需幾個簡單步驟，即可在 Excent Capital 開立你的真實交易帳戶。按照我們的指引，安全高效地開始進行真實市場交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/why-verify-your-account-zh/": {
            lang: "zh-HK",
            title: "為什麼要驗證你的帳戶？",
            description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
            keywords: "帳戶驗證, 驗證交易帳戶, Excent Capital KYC, 交易安全, 合規程序, 身份驗證, 安全交易, 完整帳戶訪問",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/why-verify-your-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-votre-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/perche-verificare-il-conto",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
            },
            openGraph: {
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/why-verify-your-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "為什麼要驗證你的帳戶？",
                description: "在 Excent Capital 進行帳戶驗證可確保安全性、合規性以及完整使用交易功能。了解驗證的重要性及完成步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-access-the-platform-zh/": {
            lang: "zh-HK",
            title: "如何登入平台？",
            description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
            keywords: "登入交易平台, Excent Capital 登入, 交易應用程式, 網絡交易平台, 手機交易, 如何登入, 開始交易, 平台訪問指南",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account.how-do-i-access-the-platform",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/acceder-a-la-plataforma",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/acessar-a-plataforma",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/acceder-a-la-plateforme",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/accedere-alla-piattaforma",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
            },
            openGraph: {
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-access-the-platform-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何登入平台？",
                description: "你可以輕鬆從瀏覽器或手機裝置登入 Excent Capital 交易平台。了解如何登入並隨時隨地開始交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh/": {
            lang: "zh-HK",
            title: "開立帳戶需時多久？",
            description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
            keywords: "帳戶建立時間, Excent Capital 註冊, 如何開立帳戶, 交易帳戶設置, 註冊流程, 快速開戶, 交易入門",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-long-does-it-take-to-create-an-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/tiempo-para-crear-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/tempo-para-criar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/delai-pour-creer-un-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/tempo-per-creare-un-conto",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
            },
            openGraph: {
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/how-long-does-it-take-to-create-an-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "開立帳戶需時多久？",
                description: "在 Excent Capital 開立帳戶快速且簡單。了解整個流程需時多久以及開始所需步驟。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/do-you-offer-corporate-accounts-zh/": {
            lang: "zh-HK",
            title: "是否提供企業帳戶？",
            description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
            keywords: "企業交易帳戶, 商業帳戶, Excent Capital 企業服務, 機構交易, 開設企業帳戶, 公司交易, 商業投資帳戶",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/do-you-offer-corporate-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuentas-corporativas",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/contas-corporativas",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/comptes-corporatifs",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/conti-corporativi",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
            },
            openGraph: {
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/do-you-offer-corporate-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "是否提供企業帳戶？",
                description: "是的，Excent Capital 為企業與機構提供專用的交易帳戶。了解開設企業帳戶的好處與申請條件。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-open-multiple-accounts-zh/": {
            lang: "zh-HK",
            title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
            description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
            keywords: "多個帳戶, 相同電郵帳戶, Excent Capital 角色, 使用者角色, 帳戶管理, 交易帳戶存取, 角色型訪問, 電郵註冊政策",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-open-multiple-accounts",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/varias-cuentas-mismo-correo",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/varias-contas-mesmo-email",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/plusieurs-comptes-meme-email",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/piu-conti-stessa-email",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
            },
            openGraph: {
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/can-i-open-multiple-accounts-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "可以使用同一電郵地址開設不同角色的多個帳戶嗎？",
                description: "了解是否可使用同一電郵註冊多個擁有不同角色的 Excent Capital 帳戶，以及平台上角色管理的運作方式。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-update-my-account-information-zh/": {
            lang: "zh-HK",
            title: "如何更新我的帳戶資料？",
            description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 修改帳戶資訊, 更新交易檔案, 使用者資訊",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-update-my-account-information",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/actualizar-informacion-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/atualizar-informacoes-da-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/mettre-a-jour-informations-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/aggiornare-informazioni-del-conto",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
            },
            openGraph: {
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-update-my-account-information-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如何更新我的帳戶資料？",
                description: "可輕鬆在 Excent Capital 更新個人及帳戶資訊。按照我們的分步指南，確保你的資料準確無誤並保持最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-happens-if-i-forget-my-password-zh/": {
            lang: "zh-HK",
            title: "如果我忘記密碼會發生什麼事？",
            description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
            keywords: "忘記密碼, 密碼恢復, 重設交易密碼, Excent Capital 登入幫助, 帳戶存取, 找回密碼, 密碼遺失, 交易帳戶登入",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-happens-if-i-forget-my-password",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/olvide-mi-contrasena",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/esqueci-minha-senha",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/mot-de-passe-oublie",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/password-dimenticata",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
            },
            openGraph: {
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/what-happens-if-i-forget-my-password-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果我忘記密碼會發生什麼事？",
                description: "如果你忘記密碼，Excent Capital 提供一個安全而簡單的恢復程序。了解如何重設密碼並重新登入你的帳戶。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/what-documents-are-required-for-account-verification-zh/": {
            lang: "zh-HK",
            title: "我如何更新我的帳戶資料？",
            description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
            keywords: "更新帳戶資料, 編輯個人資料, Excent Capital 個人檔案, 帳戶設定, 更改帳戶資料, 更新交易資料, 用戶資訊",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/what-documents-are-required-for-account-verification",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/documentos-para-verificacion",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/documentos-para-verificacao",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/documents-pour-verification",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/documenti-per-verifica",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
            },
            openGraph: {
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/what-documents-are-required-for-account-verification-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何更新我的帳戶資料？",
                description: "你可以輕鬆地更新在 Excent Capital 上的個人和帳戶資料。請按照我們的分步指引，保持你的資訊準確和最新。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh/": {
            lang: "zh-HK",
            title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
            description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
            keywords: "共用帳戶, Excent Capital 政策, 個人帳戶使用, 交易帳戶安全, 帳戶共享, 家人使用帳戶, 帳戶安全, 交易合規",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-my-friends-or-family-use-my-excent-capital-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cuenta-usada-por-otros",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/amigos-familia-usar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/amis-famille-utiliser-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/conto-utilizzato-da-terzi",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
            },
            openGraph: {
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/can-my-friends-or-family-use-my-excent-capital-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我的朋友或家人可以使用我的 Excent Capital 帳戶嗎？",
                description: "為了你的安全，Excent Capital 的帳戶是嚴格個人使用，不可共享。了解為何禁止共用帳戶，以及如何保障你的帳戶安全。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/how-do-i-cancel-my-account-zh/": {
            lang: "zh-HK",
            title: "我如何取消我的帳戶",
            description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
            keywords: "取消交易帳戶, 關閉 Excent Capital 帳戶, 帳戶終止, 刪除帳戶, 結束帳戶, Excent Capital 支援, 帳戶取消程序",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/how-do-i-cancel-my-account",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/cancelar-cuenta",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/cancelar-conta",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/annuler-mon-compte",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/cancellare-il-conto",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
            },
            openGraph: {
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/how-do-i-cancel-my-account-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何取消我的帳戶",
                description: "如果你希望關閉 Excent Capital 帳戶，請按照我們的步驟指引提出取消申請，並確保你的資料被安全處理。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh/": {
            lang: "zh-HK",
            title: "我可以從外國驗證我的帳戶嗎？",
            description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
            keywords: "海外驗證帳戶, Excent Capital 驗證, 外國帳戶設定, 國際 KYC, 遠程帳戶驗證, 驗證文件, 海外驗證",
            canonical: "https://knowledgebase.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/my-account/can-i-verify-my-account-from-a-foreign-country",
                es: "https://knowledgebase.excent.capital/es/mi-cuenta/verificar-cuenta-extranjero",
                pt: "https://knowledgebase.excent.capital/pt/minha-conta/verificar-conta-no-exterior",
                fr: "https://knowledgebase.excent.capital/fr/mon-compte/verifier-compte-depuis-etranger",
                it: "https://knowledgebase.excent.capital/it/il-mio-conto/verificare-conto-dall-estero",
                zh: "https://knowledgebase.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
            },
            openGraph: {
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                url: "https://knowledgebase.excent.capital/zh/my-account-zh/can-i-verify-my-account-from-a-foreign-country-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我可以從外國驗證我的帳戶嗎？",
                description: "可以，你可以從海外驗證你的 Excent Capital 帳戶。了解需要提交哪些文件，以及如何在海外完成驗證流程。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh/": {
            lang: "zh-HK",
            title: "存款與提款：你將會發現什麼",
            description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
            keywords: "存款與提款, Excent Capital 資金, 提取利潤, 付款方式, 存款選項, 提款時間, 交易帳戶資金, 金融交易",
            canonical: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/inside-deposits-withdrawals",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/dentro-depositos-retiros",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/dentro-depositos-retiradas",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/a-linterieur-depots-retraits",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/dentro-depositi-prelievi",
                zh: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
            },
            openGraph: {
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                url: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/inside-deposits-withdrawals-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "存款與提款：你將會發現什麼",
                description: "了解有關為你的 Excent Capital 帳戶注資及提取利潤的所有資訊。探索可用的方法、處理時間和相關要求。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行首次存款？",
            description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
            keywords: "首次存款, 進行存款, Excent Capital 資金, 交易帳戶存款, 如何存款, 付款方式, 開始交易, 帳戶注資",
            canonical: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-do-a-first-time-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/primer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/primeiro-deposito",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/premier-depot",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/primo-deposito",
                zh: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
            },
            openGraph: {
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                url: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-do-i-do-a-first-time-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行首次存款？",
                description: "通過在 Excent Capital 進行首次存款來開始交易。按照我們簡單的指引選擇付款方式，注資你的帳戶並展開交易之旅。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh/": {
            lang: "zh-HK",
            title: "我如何進行存款？",
            description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
            keywords: "資金存入, 如何存款, Excent Capital 付款方式, 交易帳戶資金, 進行存款, 安全存款, 帳戶充值, 存款流程",
            canonical: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-do-i-make-a-deposit",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-deposito",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-deposito",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-depot",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-deposito",
                zh: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
            },
            openGraph: {
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                url: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-do-i-make-a-deposit-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何進行存款？",
                description: "你可以使用多種安全的付款方式輕鬆為你的 Excent Capital 帳戶注資。了解如何逐步開始並完成存款程序。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh/": {
            lang: "zh-HK",
            title: "我如何提取資金？",
            description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
            keywords: "提取資金, Excent Capital 提款, 如何提款, 交易帳戶提現, 提款流程, 安全提款, 提取收益, 付款方式",
            canonical: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/how-can-i-make-a-withdrawal",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/hacer-retiro",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/fazer-saque",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/effectuer-un-retrait",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/effettuare-un-prelievo",
                zh: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
            },
            openGraph: {
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                url: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/how-can-i-make-a-withdrawal-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何提取資金？",
                description: "快速又安全地從 Excent Capital 提取資金。了解每個步驟、所需資料及可用的提款方式，輕鬆取出你的收益。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh/": {
            lang: "zh-HK",
            title: "如果提款失敗，我應該怎麼辦？",
            description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
            keywords: "提款失敗, Excent Capital 幫助, 交易失敗, 排解提款問題, 提款錯誤, 付款失誤, 交易帳戶支援, 解決提款問題",
            canonical: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/deposits-withdrawals/what-do-i-do-if-my-withdrawal-fails",
                es: "https://knowledgebase.excent.capital/es/depositos-retiros/retiro-fallido",
                pt: "https://knowledgebase.excent.capital/pt/depositos-saques/saque-falhou",
                fr: "https://knowledgebase.excent.capital/fr/depots-retraits/echec-du-retrait",
                it: "https://knowledgebase.excent.capital/it/depositi-prelievi/prelievo-non-riuscito",
                zh: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
            },
            openGraph: {
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                url: "https://knowledgebase.excent.capital/zh/deposits-withdrawals-zh/what-do-i-do-if-my-withdrawal-fails-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "如果提款失敗，我應該怎麼辦？",
                description: "如果你的提款在 Excent Capital 上失敗，請了解解決問題的步驟。找出常見原因，並學習如何確保成功交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },

        "zh/payments-zh/inside-payments-zh/": {
            lang: "zh-HK",
            title: "付款詳情：你將會發現什麼",
            description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
            keywords: "Excent Capital 付款, 可接受的付款方式, 交易管理, 付款處理時間, 支援貨幣, 交易付款, 存款與提款選項, 帳戶注資",
            canonical: "https://knowledgebase.excent.capital/zh/payments-zh/inside-payments-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/inside-payments",
                es: "https://knowledgebase.excent.capital/es/pagos/dentro-de-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/dentro-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/paiements/a-linterieur-des-paiements",
                it: "https://knowledgebase.excent.capital/it/paiements/a-linterieur-des-paiements",
                zh: "https://knowledgebase.excent.capital/zh/payments-zh/inside-payments-zh",
            },
            openGraph: {
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                url: "https://knowledgebase.excent.capital/zh/payments-zh/inside-payments-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "付款詳情：你將會發現什麼",
                description: "全面了解 Excent Capital 上的付款，包括接受的付款方式、處理時間、支援的貨幣及如何順利管理交易。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-do-i-see-my-payment-history-zh/": {
            lang: "zh-HK",
            title: "我如何查看我的付款記錄？",
            description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
            keywords: "付款記錄, 交易歷史, 查看存款, 查看提款, Excent Capital 付款, 帳戶交易, 交易帳戶記錄, 財務紀錄",
            canonical: "https://knowledgebase.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-do-i-see-my-payment-history",
                es: "https://knowledgebase.excent.capital/es/pagos/ver-historial-pagos",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/ver-historico-de-pagamentos",
                fr: "https://knowledgebase.excent.capital/fr/paiements/voir-historique-paiements",
                it: "https://knowledgebase.excent.capital/it/paiements/voir-historique-paiements",
                zh: "https://knowledgebase.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
            },
            openGraph: {
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                url: "https://knowledgebase.excent.capital/zh/payments-zh/how-do-i-see-my-payment-history-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "我如何查看我的付款記錄？",
                description: "你可以輕鬆在 Excent Capital 上追蹤所有交易。了解如何查看付款記錄，包括存款、提款及其處理狀態。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
        "zh/payments-zh/how-long-can-a-transaction-take-zh/": {
            lang: "zh-HK",
            title: "一筆交易需要多長時間？",
            description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
            keywords: "交易時間, 處理時間, 存款所需時間, 提款所需時間, Excent Capital 付款, 付款速度, 交易帳戶處理, 交易延誤",
            canonical: "https://knowledgebase.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
            alternates: {
                en: "https://knowledgebase.excent.capital/en/payments/how-long-can-a-transaction-take",
                es: "https://knowledgebase.excent.capital/es/pagos/tiempo-transaccion",
                pt: "https://knowledgebase.excent.capital/pt/pagamentos/tempo-de-transacao",
                fr: "https://knowledgebase.excent.capital/fr/paiements/delai-de-transaction",
                it: "https://knowledgebase.excent.capital/it/paiements/delai-de-transaction",
                zh: "https://knowledgebase.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
            },
            openGraph: {
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                url: "https://knowledgebase.excent.capital/zh/payments-zh/how-long-can-a-transaction-take-zh",
                type: "website",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
                imageWidth: 1200,
                imageHeight: 630,
            },
            twitter: {
                card: "summary_large_image",
                title: "一筆交易需要多長時間？",
                description: "了解在 Excent Capital 進行存款與提款的標準處理時間。認識影響速度的因素，並學會如何避免延誤。",
                image: "https://static.excent.capital/images/open-graph/open_graph_en.png",
            },
        },
    },
}

// Saint Vincent publica exactamente el mismo contenido que Seychelles bajo su propio
// dominio, así que su entrada se deriva de la de Seychelles en vez de mantener una copia
// a mano (la copia apuntaba entera a knowledgebase.excent.capital). Las imágenes de Open
// Graph se quedan en static.excent.capital: static.excentcapital.com no las sirve.
metadata["knowledgebase.excentcapital.com"] = JSON.parse(
    JSON.stringify(metadata["knowledgebase.excent.capital"]).replaceAll(
        "knowledgebase.excent.capital",
        "knowledgebase.excentcapital.com"
    )
);

export default metadata;
